window.Modernizr = (function(e, t2, n2) {
  function r2(e2) {
    b.cssText = e2;
  }
  function o(e2, t3) {
    return r2(S.join(e2 + ";") + (t3 || ""));
  }
  function a(e2, t3) {
    return typeof e2 === t3;
  }
  function i(e2, t3) {
    return !!~("" + e2).indexOf(t3);
  }
  function c(e2, t3) {
    for (var r3 in e2) {
      var o2 = e2[r3];
      if (!i(o2, "-") && b[o2] !== n2) return "pfx" == t3 ? o2 : true;
    }
    return false;
  }
  function s(e2, t3, r3) {
    for (var o2 in e2) {
      var i2 = t3[e2[o2]];
      if (i2 !== n2) return r3 === false ? e2[o2] : a(i2, "function") ? i2.bind(r3 || t3) : i2;
    }
    return false;
  }
  function u(e2, t3, n3) {
    var r3 = e2.charAt(0).toUpperCase() + e2.slice(1), o2 = (e2 + " " + k.join(r3 + " ") + r3).split(" ");
    return a(t3, "string") || a(t3, "undefined") ? c(o2, t3) : (o2 = (e2 + " " + T.join(r3 + " ") + r3).split(" "), s(o2, t3, n3));
  }
  function l() {
    p.input = (function(n3) {
      for (var r3 = 0, o2 = n3.length; o2 > r3; r3++) j[n3[r3]] = !!(n3[r3] in E);
      return j.list && (j.list = !(!t2.createElement("datalist") || !e.HTMLDataListElement)), j;
    })("autocomplete autofocus list placeholder max min multiple pattern required step".split(" ")), p.inputtypes = (function(e2) {
      for (var r3, o2, a2, i2 = 0, c2 = e2.length; c2 > i2; i2++) E.setAttribute("type", o2 = e2[i2]), r3 = "text" !== E.type, r3 && (E.value = x, E.style.cssText = "position:absolute;visibility:hidden;", /^range$/.test(o2) && E.style.WebkitAppearance !== n2 ? (g.appendChild(E), a2 = t2.defaultView, r3 = a2.getComputedStyle && "textfield" !== a2.getComputedStyle(E, null).WebkitAppearance && 0 !== E.offsetHeight, g.removeChild(E)) : /^(search|tel)$/.test(o2) || (r3 = /^(url|email)$/.test(o2) ? E.checkValidity && E.checkValidity() === false : E.value != x)), P[e2[i2]] = !!r3;
      return P;
    })("search tel url email datetime date month week time datetime-local number range color".split(" "));
  }
  var d, f, m = "2.8.3", p = {}, h = true, g = t2.documentElement, v = "modernizr", y = t2.createElement(v), b = y.style, E = t2.createElement("input"), x = ":)", w = {}.toString, S = " -webkit- -moz- -o- -ms- ".split(" "), C = "Webkit Moz O ms", k = C.split(" "), T = C.toLowerCase().split(" "), N = { svg: "http://www.w3.org/2000/svg" }, M = {}, P = {}, j = {}, $ = [], D = $.slice, F = function(e2, n3, r3, o2) {
    var a2, i2, c2, s2, u2 = t2.createElement("div"), l2 = t2.body, d2 = l2 || t2.createElement("body");
    if (parseInt(r3, 10)) for (; r3--; ) c2 = t2.createElement("div"), c2.id = o2 ? o2[r3] : v + (r3 + 1), u2.appendChild(c2);
    return a2 = ["&#173;", '<style id="s', v, '">', e2, "</style>"].join(""), u2.id = v, (l2 ? u2 : d2).innerHTML += a2, d2.appendChild(u2), l2 || (d2.style.background = "", d2.style.overflow = "hidden", s2 = g.style.overflow, g.style.overflow = "hidden", g.appendChild(d2)), i2 = n3(u2, e2), l2 ? u2.parentNode.removeChild(u2) : (d2.parentNode.removeChild(d2), g.style.overflow = s2), !!i2;
  }, z = function(t3) {
    var n3 = e.matchMedia || e.msMatchMedia;
    if (n3) return n3(t3) && n3(t3).matches || false;
    var r3;
    return F("@media " + t3 + " { #" + v + " { position: absolute; } }", function(t4) {
      r3 = "absolute" == (e.getComputedStyle ? getComputedStyle(t4, null) : t4.currentStyle).position;
    }), r3;
  }, A = /* @__PURE__ */ (function() {
    function e2(e3, o2) {
      o2 = o2 || t2.createElement(r3[e3] || "div"), e3 = "on" + e3;
      var i2 = e3 in o2;
      return i2 || (o2.setAttribute || (o2 = t2.createElement("div")), o2.setAttribute && o2.removeAttribute && (o2.setAttribute(e3, ""), i2 = a(o2[e3], "function"), a(o2[e3], "undefined") || (o2[e3] = n2), o2.removeAttribute(e3))), o2 = null, i2;
    }
    var r3 = { select: "input", change: "input", submit: "form", reset: "form", error: "img", load: "img", abort: "img" };
    return e2;
  })(), L = {}.hasOwnProperty;
  f = a(L, "undefined") || a(L.call, "undefined") ? function(e2, t3) {
    return t3 in e2 && a(e2.constructor.prototype[t3], "undefined");
  } : function(e2, t3) {
    return L.call(e2, t3);
  }, Function.prototype.bind || (Function.prototype.bind = function(e2) {
    var t3 = this;
    if ("function" != typeof t3) throw new TypeError();
    var n3 = D.call(arguments, 1), r3 = function() {
      if (this instanceof r3) {
        var o2 = function() {
        };
        o2.prototype = t3.prototype;
        var a2 = new o2(), i2 = t3.apply(a2, n3.concat(D.call(arguments)));
        return Object(i2) === i2 ? i2 : a2;
      }
      return t3.apply(e2, n3.concat(D.call(arguments)));
    };
    return r3;
  }), M.flexbox = function() {
    return u("flexWrap");
  }, M.flexboxlegacy = function() {
    return u("boxDirection");
  }, M.canvas = function() {
    var e2 = t2.createElement("canvas");
    return !(!e2.getContext || !e2.getContext("2d"));
  }, M.canvastext = function() {
    return !(!p.canvas || !a(t2.createElement("canvas").getContext("2d").fillText, "function"));
  }, M.webgl = function() {
    return !!e.WebGLRenderingContext;
  }, M.touch = function() {
    var n3;
    return "ontouchstart" in e || e.DocumentTouch && t2 instanceof DocumentTouch ? n3 = true : F(["@media (", S.join("touch-enabled),("), v, ")", "{#modernizr{top:9px;position:absolute}}"].join(""), function(e2) {
      n3 = 9 === e2.offsetTop;
    }), n3;
  }, M.geolocation = function() {
    return "geolocation" in navigator;
  }, M.postmessage = function() {
    return !!e.postMessage;
  }, M.websqldatabase = function() {
    return !!e.openDatabase;
  }, M.indexedDB = function() {
    return !!u("indexedDB", e);
  }, M.hashchange = function() {
    return A("hashchange", e) && (t2.documentMode === n2 || t2.documentMode > 7);
  }, M.history = function() {
    return !(!e.history || !history.pushState);
  }, M.draganddrop = function() {
    var e2 = t2.createElement("div");
    return "draggable" in e2 || "ondragstart" in e2 && "ondrop" in e2;
  }, M.websockets = function() {
    return "WebSocket" in e || "MozWebSocket" in e;
  }, M.rgba = function() {
    return r2("background-color:rgba(150,255,150,.5)"), i(b.backgroundColor, "rgba");
  }, M.hsla = function() {
    return r2("background-color:hsla(120,40%,100%,.5)"), i(b.backgroundColor, "rgba") || i(b.backgroundColor, "hsla");
  }, M.multiplebgs = function() {
    return r2("background:url(https://),url(https://),red url(https://)"), /(url\s*\(.*?){3}/.test(b.background);
  }, M.backgroundsize = function() {
    return u("backgroundSize");
  }, M.borderimage = function() {
    return u("borderImage");
  }, M.borderradius = function() {
    return u("borderRadius");
  }, M.boxshadow = function() {
    return u("boxShadow");
  }, M.textshadow = function() {
    return "" === t2.createElement("div").style.textShadow;
  }, M.opacity = function() {
    return o("opacity:.55"), /^0.55$/.test(b.opacity);
  }, M.cssanimations = function() {
    return u("animationName");
  }, M.csscolumns = function() {
    return u("columnCount");
  }, M.cssgradients = function() {
    var e2 = "background-image:", t3 = "gradient(linear,left top,right bottom,from(#9f9),to(white));", n3 = "linear-gradient(left top,#9f9, white);";
    return r2((e2 + "-webkit- ".split(" ").join(t3 + e2) + S.join(n3 + e2)).slice(0, -e2.length)), i(b.backgroundImage, "gradient");
  }, M.cssreflections = function() {
    return u("boxReflect");
  }, M.csstransforms = function() {
    return !!u("transform");
  }, M.csstransforms3d = function() {
    var e2 = !!u("perspective");
    return e2 && "webkitPerspective" in g.style && F("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function(t3) {
      e2 = 9 === t3.offsetLeft && 3 === t3.offsetHeight;
    }), e2;
  }, M.csstransitions = function() {
    return u("transition");
  }, M.fontface = function() {
    var e2;
    return F('@font-face {font-family:"font";src:url("https://")}', function(n3, r3) {
      var o2 = t2.getElementById("smodernizr"), a2 = o2.sheet || o2.styleSheet, i2 = a2 ? a2.cssRules && a2.cssRules[0] ? a2.cssRules[0].cssText : a2.cssText || "" : "";
      e2 = /src/i.test(i2) && 0 === i2.indexOf(r3.split(" ")[0]);
    }), e2;
  }, M.generatedcontent = function() {
    var e2;
    return F(["#", v, "{font:0/0 a}#", v, ':after{content:"', x, '";visibility:hidden;font:3px/1 a}'].join(""), function(t3) {
      e2 = t3.offsetHeight >= 3;
    }), e2;
  }, M.video = function() {
    var e2 = t2.createElement("video"), n3 = false;
    try {
      (n3 = !!e2.canPlayType) && (n3 = new Boolean(n3), n3.ogg = e2.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, ""), n3.h264 = e2.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, ""), n3.webm = e2.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, ""));
    } catch (r3) {
    }
    return n3;
  }, M.audio = function() {
    var e2 = t2.createElement("audio"), n3 = false;
    try {
      (n3 = !!e2.canPlayType) && (n3 = new Boolean(n3), n3.ogg = e2.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""), n3.mp3 = e2.canPlayType("audio/mpeg;").replace(/^no$/, ""), n3.wav = e2.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ""), n3.m4a = (e2.canPlayType("audio/x-m4a;") || e2.canPlayType("audio/aac;")).replace(/^no$/, ""));
    } catch (r3) {
    }
    return n3;
  }, M.localstorage = function() {
    try {
      return localStorage.setItem(v, v), localStorage.removeItem(v), true;
    } catch (e2) {
      return false;
    }
  }, M.sessionstorage = function() {
    try {
      return sessionStorage.setItem(v, v), sessionStorage.removeItem(v), true;
    } catch (e2) {
      return false;
    }
  }, M.webworkers = function() {
    return !!e.Worker;
  }, M.applicationcache = function() {
    return !!e.applicationCache;
  }, M.svg = function() {
    return !!t2.createElementNS && !!t2.createElementNS(N.svg, "svg").createSVGRect;
  }, M.inlinesvg = function() {
    var e2 = t2.createElement("div");
    return e2.innerHTML = "<svg/>", (e2.firstChild && e2.firstChild.namespaceURI) == N.svg;
  }, M.smil = function() {
    return !!t2.createElementNS && /SVGAnimate/.test(w.call(t2.createElementNS(N.svg, "animate")));
  }, M.svgclippaths = function() {
    return !!t2.createElementNS && /SVGClipPath/.test(w.call(t2.createElementNS(N.svg, "clipPath")));
  };
  for (var H in M) f(M, H) && (d = H.toLowerCase(), p[d] = M[H](), $.push((p[d] ? "" : "no-") + d));
  return p.input || l(), p.addTest = function(e2, t3) {
    if ("object" == typeof e2) for (var r3 in e2) f(e2, r3) && p.addTest(r3, e2[r3]);
    else {
      if (e2 = e2.toLowerCase(), p[e2] !== n2) return p;
      t3 = "function" == typeof t3 ? t3() : t3, "undefined" != typeof h && h && (g.className += " " + (t3 ? "" : "no-") + e2), p[e2] = t3;
    }
    return p;
  }, r2(""), y = E = null, (function(e2, t3) {
    function n3(e3, t4) {
      var n4 = e3.createElement("p"), r4 = e3.getElementsByTagName("head")[0] || e3.documentElement;
      return n4.innerHTML = "x<style>" + t4 + "</style>", r4.insertBefore(n4.lastChild, r4.firstChild);
    }
    function r3() {
      var e3 = y2.elements;
      return "string" == typeof e3 ? e3.split(" ") : e3;
    }
    function o2(e3) {
      var t4 = v2[e3[h2]];
      return t4 || (t4 = {}, g2++, e3[h2] = g2, v2[g2] = t4), t4;
    }
    function a2(e3, n4, r4) {
      if (n4 || (n4 = t3), l2) return n4.createElement(e3);
      r4 || (r4 = o2(n4));
      var a3;
      return a3 = r4.cache[e3] ? r4.cache[e3].cloneNode() : p2.test(e3) ? (r4.cache[e3] = r4.createElem(e3)).cloneNode() : r4.createElem(e3), !a3.canHaveChildren || m2.test(e3) || a3.tagUrn ? a3 : r4.frag.appendChild(a3);
    }
    function i2(e3, n4) {
      if (e3 || (e3 = t3), l2) return e3.createDocumentFragment();
      n4 = n4 || o2(e3);
      for (var a3 = n4.frag.cloneNode(), i3 = 0, c3 = r3(), s3 = c3.length; s3 > i3; i3++) a3.createElement(c3[i3]);
      return a3;
    }
    function c2(e3, t4) {
      t4.cache || (t4.cache = {}, t4.createElem = e3.createElement, t4.createFrag = e3.createDocumentFragment, t4.frag = t4.createFrag()), e3.createElement = function(n4) {
        return y2.shivMethods ? a2(n4, e3, t4) : t4.createElem(n4);
      }, e3.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + r3().join().replace(/[\w\-]+/g, function(e4) {
        return t4.createElem(e4), t4.frag.createElement(e4), 'c("' + e4 + '")';
      }) + ");return n}")(y2, t4.frag);
    }
    function s2(e3) {
      e3 || (e3 = t3);
      var r4 = o2(e3);
      return !y2.shivCSS || u2 || r4.hasCSS || (r4.hasCSS = !!n3(e3, "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")), l2 || c2(e3, r4), e3;
    }
    var u2, l2, d2 = "3.7.0", f2 = e2.html5 || {}, m2 = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i, p2 = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i, h2 = "_html5shiv", g2 = 0, v2 = {};
    !(function() {
      try {
        var e3 = t3.createElement("a");
        e3.innerHTML = "<xyz></xyz>", u2 = "hidden" in e3, l2 = 1 == e3.childNodes.length || (function() {
          t3.createElement("a");
          var e4 = t3.createDocumentFragment();
          return "undefined" == typeof e4.cloneNode || "undefined" == typeof e4.createDocumentFragment || "undefined" == typeof e4.createElement;
        })();
      } catch (n4) {
        u2 = true, l2 = true;
      }
    })();
    var y2 = { elements: f2.elements || "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video", version: d2, shivCSS: f2.shivCSS !== false, supportsUnknownElements: l2, shivMethods: f2.shivMethods !== false, type: "default", shivDocument: s2, createElement: a2, createDocumentFragment: i2 };
    e2.html5 = y2, s2(t3);
  })(this, t2), p._version = m, p._prefixes = S, p._domPrefixes = T, p._cssomPrefixes = k, p.mq = z, p.hasEvent = A, p.testProp = function(e2) {
    return c([e2]);
  }, p.testAllProps = u, p.testStyles = F, p.prefixed = function(e2, t3, n3) {
    return t3 ? u(e2, t3, n3) : u(e2, "pfx");
  }, g.className = g.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + (h ? " js " + $.join(" ") : ""), p;
})(this, this.document);
;
!(function(t2, n2) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n2() : "function" == typeof define && define.amd ? define(n2) : (t2 || self).barba = n2();
})(this, function() {
  function t2(t3, n3) {
    for (var r3 = 0; r3 < n3.length; r3++) {
      var i2 = n3[r3];
      i2.enumerable = i2.enumerable || false, i2.configurable = true, "value" in i2 && (i2.writable = true), Object.defineProperty(t3, "symbol" == typeof (e2 = (function(t4, n4) {
        if ("object" != typeof t4 || null === t4) return t4;
        var r4 = t4[Symbol.toPrimitive];
        if (void 0 !== r4) {
          var i3 = r4.call(t4, "string");
          if ("object" != typeof i3) return i3;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t4);
      })(i2.key)) ? e2 : String(e2), i2);
    }
    var e2;
  }
  function n2(n3, r3, i2) {
    return r3 && t2(n3.prototype, r3), i2 && t2(n3, i2), Object.defineProperty(n3, "prototype", { writable: false }), n3;
  }
  function r2() {
    return r2 = Object.assign ? Object.assign.bind() : function(t3) {
      for (var n3 = 1; n3 < arguments.length; n3++) {
        var r3 = arguments[n3];
        for (var i2 in r3) Object.prototype.hasOwnProperty.call(r3, i2) && (t3[i2] = r3[i2]);
      }
      return t3;
    }, r2.apply(this, arguments);
  }
  function i(t3, n3) {
    t3.prototype = Object.create(n3.prototype), t3.prototype.constructor = t3, o(t3, n3);
  }
  function e(t3) {
    return e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, e(t3);
  }
  function o(t3, n3) {
    return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, n4) {
      return t4.__proto__ = n4, t4;
    }, o(t3, n3);
  }
  function u() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" == typeof Proxy) return true;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), true;
    } catch (t3) {
      return false;
    }
  }
  function s(t3, n3, r3) {
    return s = u() ? Reflect.construct.bind() : function(t4, n4, r4) {
      var i2 = [null];
      i2.push.apply(i2, n4);
      var e2 = new (Function.bind.apply(t4, i2))();
      return r4 && o(e2, r4.prototype), e2;
    }, s.apply(null, arguments);
  }
  function f(t3) {
    var n3 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
    return f = function(t4) {
      if (null === t4 || -1 === Function.toString.call(t4).indexOf("[native code]")) return t4;
      if ("function" != typeof t4) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== n3) {
        if (n3.has(t4)) return n3.get(t4);
        n3.set(t4, r3);
      }
      function r3() {
        return s(t4, arguments, e(this).constructor);
      }
      return r3.prototype = Object.create(t4.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), o(r3, t4);
    }, f(t3);
  }
  function c(t3) {
    if (void 0 === t3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t3;
  }
  var a, h = function() {
    this.before = void 0, this.beforeLeave = void 0, this.leave = void 0, this.afterLeave = void 0, this.beforeEnter = void 0, this.enter = void 0, this.afterEnter = void 0, this.after = void 0;
  };
  !(function(t3) {
    t3[t3.off = 0] = "off", t3[t3.error = 1] = "error", t3[t3.warning = 2] = "warning", t3[t3.info = 3] = "info", t3[t3.debug = 4] = "debug";
  })(a || (a = {}));
  var v = a.off, d = /* @__PURE__ */ (function() {
    function t3(t4) {
      this.t = void 0, this.t = t4;
    }
    t3.getLevel = function() {
      return v;
    }, t3.setLevel = function(t4) {
      return v = a[t4];
    };
    var n3 = t3.prototype;
    return n3.error = function() {
      this.i(console.error, a.error, [].slice.call(arguments));
    }, n3.warn = function() {
      this.i(console.warn, a.warning, [].slice.call(arguments));
    }, n3.info = function() {
      this.i(console.info, a.info, [].slice.call(arguments));
    }, n3.debug = function() {
      this.i(console.log, a.debug, [].slice.call(arguments));
    }, n3.i = function(n4, r3, i2) {
      r3 <= t3.getLevel() && n4.apply(console, ["[" + this.t + "] "].concat(i2));
    }, t3;
  })();
  function l(t3) {
    return t3.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  }
  function p(t3) {
    return t3 && t3.sensitive ? "" : "i";
  }
  var m = { container: "container", history: "history", namespace: "namespace", prefix: "data-barba", prevent: "prevent", wrapper: "wrapper" }, w = /* @__PURE__ */ (function() {
    function t3() {
      this.o = m, this.u = void 0, this.h = { after: null, before: null, parent: null };
    }
    var n3 = t3.prototype;
    return n3.toString = function(t4) {
      return t4.outerHTML;
    }, n3.toDocument = function(t4) {
      return this.u || (this.u = new DOMParser()), this.u.parseFromString(t4, "text/html");
    }, n3.toElement = function(t4) {
      var n4 = document.createElement("div");
      return n4.innerHTML = t4, n4;
    }, n3.getHtml = function(t4) {
      return void 0 === t4 && (t4 = document), this.toString(t4.documentElement);
    }, n3.getWrapper = function(t4) {
      return void 0 === t4 && (t4 = document), t4.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]');
    }, n3.getContainer = function(t4) {
      return void 0 === t4 && (t4 = document), t4.querySelector("[" + this.o.prefix + '="' + this.o.container + '"]');
    }, n3.removeContainer = function(t4) {
      document.body.contains(t4) && (this.v(t4), t4.parentNode.removeChild(t4));
    }, n3.addContainer = function(t4, n4) {
      var r3 = this.getContainer() || this.h.before;
      r3 ? this.l(t4, r3) : this.h.after ? this.h.after.parentNode.insertBefore(t4, this.h.after) : this.h.parent ? this.h.parent.appendChild(t4) : n4.appendChild(t4);
    }, n3.getSibling = function() {
      return this.h;
    }, n3.getNamespace = function(t4) {
      void 0 === t4 && (t4 = document);
      var n4 = t4.querySelector("[" + this.o.prefix + "-" + this.o.namespace + "]");
      return n4 ? n4.getAttribute(this.o.prefix + "-" + this.o.namespace) : null;
    }, n3.getHref = function(t4) {
      if (t4.tagName && "a" === t4.tagName.toLowerCase()) {
        if ("string" == typeof t4.href) return t4.href;
        var n4 = t4.getAttribute("href") || t4.getAttribute("xlink:href");
        if (n4) return this.resolveUrl(n4.baseVal || n4);
      }
      return null;
    }, n3.resolveUrl = function() {
      var t4 = [].slice.call(arguments).length;
      if (0 === t4) throw new Error("resolveUrl requires at least one argument; got none.");
      var n4 = document.createElement("base");
      if (n4.href = arguments[0], 1 === t4) return n4.href;
      var r3 = document.getElementsByTagName("head")[0];
      r3.insertBefore(n4, r3.firstChild);
      for (var i2, e2 = document.createElement("a"), o2 = 1; o2 < t4; o2++) e2.href = arguments[o2], n4.href = i2 = e2.href;
      return r3.removeChild(n4), i2;
    }, n3.l = function(t4, n4) {
      n4.parentNode.insertBefore(t4, n4.nextSibling);
    }, n3.v = function(t4) {
      return this.h = { after: t4.nextElementSibling, before: t4.previousElementSibling, parent: t4.parentElement }, this.h;
    }, t3;
  })(), b = new w(), y = /* @__PURE__ */ (function() {
    function t3() {
      this.p = void 0, this.m = [], this.P = -1;
    }
    var i2 = t3.prototype;
    return i2.init = function(t4, n3) {
      this.p = "barba";
      var r3 = { data: {}, ns: n3, scroll: { x: window.scrollX, y: window.scrollY }, url: t4 };
      this.P = 0, this.m.push(r3);
      var i3 = { from: this.p, index: this.P, states: [].concat(this.m) };
      window.history && window.history.replaceState(i3, "", t4);
    }, i2.change = function(t4, n3, r3) {
      if (r3 && r3.state) {
        var i3 = r3.state, e2 = i3.index;
        n3 = this.g(this.P - e2), this.replace(i3.states), this.P = e2;
      } else this.add(t4, n3);
      return n3;
    }, i2.add = function(t4, n3, r3, i3) {
      var e2 = null != r3 ? r3 : this.R(n3), o2 = { data: null != i3 ? i3 : {}, ns: "tmp", scroll: { x: window.scrollX, y: window.scrollY }, url: t4 };
      switch (e2) {
        case "push":
          this.P = this.size, this.m.push(o2);
          break;
        case "replace":
          this.set(this.P, o2);
      }
      var u2 = { from: this.p, index: this.P, states: [].concat(this.m) };
      switch (e2) {
        case "push":
          window.history && window.history.pushState(u2, "", t4);
          break;
        case "replace":
          window.history && window.history.replaceState(u2, "", t4);
      }
    }, i2.store = function(t4, n3) {
      var i3 = n3 || this.P, e2 = this.get(i3);
      e2.data = r2({}, e2.data, t4), this.set(i3, e2);
      var o2 = { from: this.p, index: this.P, states: [].concat(this.m) };
      window.history.replaceState(o2, "");
    }, i2.update = function(t4, n3) {
      var i3 = n3 || this.P, e2 = r2({}, this.get(i3), t4);
      this.set(i3, e2);
    }, i2.remove = function(t4) {
      t4 ? this.m.splice(t4, 1) : this.m.pop(), this.P--;
    }, i2.clear = function() {
      this.m = [], this.P = -1;
    }, i2.replace = function(t4) {
      this.m = t4;
    }, i2.get = function(t4) {
      return this.m[t4];
    }, i2.set = function(t4, n3) {
      return this.m[t4] = n3;
    }, i2.R = function(t4) {
      var n3 = "push", r3 = t4, i3 = m.prefix + "-" + m.history;
      return r3.hasAttribute && r3.hasAttribute(i3) && (n3 = r3.getAttribute(i3)), n3;
    }, i2.g = function(t4) {
      return Math.abs(t4) > 1 ? t4 > 0 ? "forward" : "back" : 0 === t4 ? "popstate" : t4 > 0 ? "back" : "forward";
    }, n2(t3, [{ key: "current", get: function() {
      return this.m[this.P];
    } }, { key: "previous", get: function() {
      return this.P < 1 ? null : this.m[this.P - 1];
    } }, { key: "size", get: function() {
      return this.m.length;
    } }]), t3;
  })(), P = new y(), g = function(t3, n3) {
    try {
      var r3 = (function() {
        if (!n3.next.html) return Promise.resolve(t3).then(function(t4) {
          var r4 = n3.next;
          if (t4) {
            var i2 = b.toElement(t4.html);
            r4.namespace = b.getNamespace(i2), r4.container = b.getContainer(i2), r4.url = t4.url, r4.html = t4.html, P.update({ ns: r4.namespace });
            var e2 = b.toDocument(t4.html);
            document.title = e2.title;
          }
        });
      })();
      return Promise.resolve(r3 && r3.then ? r3.then(function() {
      }) : void 0);
    } catch (t4) {
      return Promise.reject(t4);
    }
  }, E = function t3(n3, r3, i2) {
    return n3 instanceof RegExp ? (function(t4, n4) {
      if (!n4) return t4;
      for (var r4 = /\((?:\?<(.*?)>)?(?!\?)/g, i3 = 0, e2 = r4.exec(t4.source); e2; ) n4.push({ name: e2[1] || i3++, prefix: "", suffix: "", modifier: "", pattern: "" }), e2 = r4.exec(t4.source);
      return t4;
    })(n3, r3) : Array.isArray(n3) ? (function(n4, r4, i3) {
      var e2 = n4.map(function(n5) {
        return t3(n5, r4, i3).source;
      });
      return new RegExp("(?:".concat(e2.join("|"), ")"), p(i3));
    })(n3, r3, i2) : (function(t4, n4, r4) {
      return (function(t5, n5, r5) {
        void 0 === r5 && (r5 = {});
        for (var i3 = r5.strict, e2 = void 0 !== i3 && i3, o2 = r5.start, u2 = void 0 === o2 || o2, s2 = r5.end, f2 = void 0 === s2 || s2, c2 = r5.encode, a2 = void 0 === c2 ? function(t6) {
          return t6;
        } : c2, h2 = r5.delimiter, v2 = void 0 === h2 ? "/#?" : h2, d2 = r5.endsWith, m2 = "[".concat(l(void 0 === d2 ? "" : d2), "]|$"), w2 = "[".concat(l(v2), "]"), b2 = u2 ? "^" : "", y2 = 0, P2 = t5; y2 < P2.length; y2++) {
          var g2 = P2[y2];
          if ("string" == typeof g2) b2 += l(a2(g2));
          else {
            var E2 = l(a2(g2.prefix)), x2 = l(a2(g2.suffix));
            if (g2.pattern) if (n5 && n5.push(g2), E2 || x2) if ("+" === g2.modifier || "*" === g2.modifier) {
              var R2 = "*" === g2.modifier ? "?" : "";
              b2 += "(?:".concat(E2, "((?:").concat(g2.pattern, ")(?:").concat(x2).concat(E2, "(?:").concat(g2.pattern, "))*)").concat(x2, ")").concat(R2);
            } else b2 += "(?:".concat(E2, "(").concat(g2.pattern, ")").concat(x2, ")").concat(g2.modifier);
            else b2 += "+" === g2.modifier || "*" === g2.modifier ? "((?:".concat(g2.pattern, ")").concat(g2.modifier, ")") : "(".concat(g2.pattern, ")").concat(g2.modifier);
            else b2 += "(?:".concat(E2).concat(x2, ")").concat(g2.modifier);
          }
        }
        if (f2) e2 || (b2 += "".concat(w2, "?")), b2 += r5.endsWith ? "(?=".concat(m2, ")") : "$";
        else {
          var k2 = t5[t5.length - 1], O2 = "string" == typeof k2 ? w2.indexOf(k2[k2.length - 1]) > -1 : void 0 === k2;
          e2 || (b2 += "(?:".concat(w2, "(?=").concat(m2, "))?")), O2 || (b2 += "(?=".concat(w2, "|").concat(m2, ")"));
        }
        return new RegExp(b2, p(r5));
      })((function(t5, n5) {
        void 0 === n5 && (n5 = {});
        for (var r5 = (function(t6) {
          for (var n6 = [], r6 = 0; r6 < t6.length; ) {
            var i4 = t6[r6];
            if ("*" !== i4 && "+" !== i4 && "?" !== i4) if ("\\" !== i4) if ("{" !== i4) if ("}" !== i4) if (":" !== i4) if ("(" !== i4) n6.push({ type: "CHAR", index: r6, value: t6[r6++] });
            else {
              var e3 = 1, o3 = "";
              if ("?" === t6[s3 = r6 + 1]) throw new TypeError('Pattern cannot start with "?" at '.concat(s3));
              for (; s3 < t6.length; ) if ("\\" !== t6[s3]) {
                if (")" === t6[s3]) {
                  if (0 == --e3) {
                    s3++;
                    break;
                  }
                } else if ("(" === t6[s3] && (e3++, "?" !== t6[s3 + 1])) throw new TypeError("Capturing groups are not allowed at ".concat(s3));
                o3 += t6[s3++];
              } else o3 += t6[s3++] + t6[s3++];
              if (e3) throw new TypeError("Unbalanced pattern at ".concat(r6));
              if (!o3) throw new TypeError("Missing pattern at ".concat(r6));
              n6.push({ type: "PATTERN", index: r6, value: o3 }), r6 = s3;
            }
            else {
              for (var u3 = "", s3 = r6 + 1; s3 < t6.length; ) {
                var f3 = t6.charCodeAt(s3);
                if (!(f3 >= 48 && f3 <= 57 || f3 >= 65 && f3 <= 90 || f3 >= 97 && f3 <= 122 || 95 === f3)) break;
                u3 += t6[s3++];
              }
              if (!u3) throw new TypeError("Missing parameter name at ".concat(r6));
              n6.push({ type: "NAME", index: r6, value: u3 }), r6 = s3;
            }
            else n6.push({ type: "CLOSE", index: r6, value: t6[r6++] });
            else n6.push({ type: "OPEN", index: r6, value: t6[r6++] });
            else n6.push({ type: "ESCAPED_CHAR", index: r6++, value: t6[r6++] });
            else n6.push({ type: "MODIFIER", index: r6, value: t6[r6++] });
          }
          return n6.push({ type: "END", index: r6, value: "" }), n6;
        })(t5), i3 = n5.prefixes, e2 = void 0 === i3 ? "./" : i3, o2 = "[^".concat(l(n5.delimiter || "/#?"), "]+?"), u2 = [], s2 = 0, f2 = 0, c2 = "", a2 = function(t6) {
          if (f2 < r5.length && r5[f2].type === t6) return r5[f2++].value;
        }, h2 = function(t6) {
          var n6 = a2(t6);
          if (void 0 !== n6) return n6;
          var i4 = r5[f2], e3 = i4.index;
          throw new TypeError("Unexpected ".concat(i4.type, " at ").concat(e3, ", expected ").concat(t6));
        }, v2 = function() {
          for (var t6, n6 = ""; t6 = a2("CHAR") || a2("ESCAPED_CHAR"); ) n6 += t6;
          return n6;
        }; f2 < r5.length; ) {
          var d2 = a2("CHAR"), p2 = a2("NAME"), m2 = a2("PATTERN");
          if (p2 || m2) -1 === e2.indexOf(b2 = d2 || "") && (c2 += b2, b2 = ""), c2 && (u2.push(c2), c2 = ""), u2.push({ name: p2 || s2++, prefix: b2, suffix: "", pattern: m2 || o2, modifier: a2("MODIFIER") || "" });
          else {
            var w2 = d2 || a2("ESCAPED_CHAR");
            if (w2) c2 += w2;
            else if (c2 && (u2.push(c2), c2 = ""), a2("OPEN")) {
              var b2 = v2(), y2 = a2("NAME") || "", P2 = a2("PATTERN") || "", g2 = v2();
              h2("CLOSE"), u2.push({ name: y2 || (P2 ? s2++ : ""), pattern: y2 && !P2 ? o2 : P2, prefix: b2, suffix: g2, modifier: a2("MODIFIER") || "" });
            } else h2("END");
          }
        }
        return u2;
      })(t4, r4), n4, r4);
    })(n3, r3, i2);
  }, x = { __proto__: null, update: g, nextTick: function() {
    return new Promise(function(t3) {
      window.requestAnimationFrame(t3);
    });
  }, pathToRegexp: E }, R = function() {
    return window.location.origin;
  }, k = function(t3) {
    return void 0 === t3 && (t3 = window.location.href), O(t3).port;
  }, O = function(t3) {
    var n3, r3 = t3.match(/:\d+/);
    if (null === r3) /^http/.test(t3) && (n3 = 80), /^https/.test(t3) && (n3 = 443);
    else {
      var i2 = r3[0].substring(1);
      n3 = parseInt(i2, 10);
    }
    var e2, o2 = t3.replace(R(), ""), u2 = {}, s2 = o2.indexOf("#");
    s2 >= 0 && (e2 = o2.slice(s2 + 1), o2 = o2.slice(0, s2));
    var f2 = o2.indexOf("?");
    return f2 >= 0 && (u2 = T(o2.slice(f2 + 1)), o2 = o2.slice(0, f2)), { hash: e2, path: o2, port: n3, query: u2 };
  }, T = function(t3) {
    return t3.split("&").reduce(function(t4, n3) {
      var r3 = n3.split("=");
      return t4[r3[0]] = r3[1], t4;
    }, {});
  }, A = function(t3) {
    return void 0 === t3 && (t3 = window.location.href), t3.replace(/(\/#.*|\/|#.*)$/, "");
  }, j = { __proto__: null, getHref: function() {
    return window.location.href;
  }, getAbsoluteHref: function(t3, n3) {
    return void 0 === n3 && (n3 = document.baseURI), new URL(t3, n3).href;
  }, getOrigin: R, getPort: k, getPath: function(t3) {
    return void 0 === t3 && (t3 = window.location.href), O(t3).path;
  }, getQuery: function(t3, n3) {
    return void 0 === n3 && (n3 = false), n3 ? JSON.stringify(O(t3).query) : O(t3).query;
  }, getHash: function(t3) {
    return O(t3).hash;
  }, parse: O, parseQuery: T, clean: A };
  function M(t3, n3, i2, e2, o2) {
    return void 0 === n3 && (n3 = 2e3), new Promise(function(u2, s2) {
      var f2 = new XMLHttpRequest();
      f2.onreadystatechange = function() {
        if (f2.readyState === XMLHttpRequest.DONE) {
          if (200 === f2.status) {
            var n4 = "" !== f2.responseURL && f2.responseURL !== t3 ? f2.responseURL : t3;
            u2({ html: f2.responseText, url: r2({ href: n4 }, O(n4)) }), e2.update(t3, { status: "fulfilled", target: n4 });
          } else if (f2.status) {
            var o3 = { status: f2.status, statusText: f2.statusText };
            i2(t3, o3), s2(o3), e2.update(t3, { status: "rejected" });
          }
        }
      }, f2.ontimeout = function() {
        var r3 = new Error("Timeout error [" + n3 + "]");
        i2(t3, r3), s2(r3), e2.update(t3, { status: "rejected" });
      }, f2.onerror = function() {
        var n4 = new Error("Fetch error");
        i2(t3, n4), s2(n4), e2.update(t3, { status: "rejected" });
      }, f2.open("GET", t3), f2.timeout = n3, f2.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml"), f2.setRequestHeader("x-barba", "yes"), o2.all().forEach(function(t4, n4) {
        f2.setRequestHeader(n4, t4);
      }), f2.send();
    });
  }
  function N(t3) {
    return !!t3 && ("object" == typeof t3 || "function" == typeof t3) && "function" == typeof t3.then;
  }
  function S(t3, n3) {
    return void 0 === n3 && (n3 = {}), function() {
      var r3 = arguments, i2 = false, e2 = new Promise(function(e3, o2) {
        n3.async = function() {
          return i2 = true, function(t4, n4) {
            t4 ? o2(t4) : e3(n4);
          };
        };
        var u2 = t3.apply(n3, [].slice.call(r3));
        i2 || (N(u2) ? u2.then(e3, o2) : e3(u2));
      });
      return e2;
    };
  }
  var C = /* @__PURE__ */ (function(t3) {
    function n3() {
      var n4;
      return (n4 = t3.call(this) || this).logger = new d("@barba/core"), n4.all = ["ready", "page", "reset", "currentAdded", "currentRemoved", "nextAdded", "nextRemoved", "beforeOnce", "once", "afterOnce", "before", "beforeLeave", "leave", "afterLeave", "beforeEnter", "enter", "afterEnter", "after"], n4.registered = /* @__PURE__ */ new Map(), n4.init(), n4;
    }
    i(n3, t3);
    var r3 = n3.prototype;
    return r3.init = function() {
      var t4 = this;
      this.registered.clear(), this.all.forEach(function(n4) {
        t4[n4] || (t4[n4] = function(r4, i2) {
          t4.registered.has(n4) || t4.registered.set(n4, /* @__PURE__ */ new Set()), t4.registered.get(n4).add({ ctx: i2 || {}, fn: r4 });
        });
      });
    }, r3.do = function(t4) {
      var n4 = arguments, r4 = this;
      if (this.registered.has(t4)) {
        var i2 = Promise.resolve();
        return this.registered.get(t4).forEach(function(t5) {
          i2 = i2.then(function() {
            return S(t5.fn, t5.ctx).apply(void 0, [].slice.call(n4, 1));
          });
        }), i2.catch(function(n5) {
          r4.logger.debug("Hook error [" + t4 + "]"), r4.logger.error(n5);
        });
      }
      return Promise.resolve();
    }, r3.clear = function() {
      var t4 = this;
      this.all.forEach(function(n4) {
        delete t4[n4];
      }), this.init();
    }, r3.help = function() {
      this.logger.info("Available hooks: " + this.all.join(","));
      var t4 = [];
      this.registered.forEach(function(n4, r4) {
        return t4.push(r4);
      }), this.logger.info("Registered hooks: " + t4.join(","));
    }, n3;
  })(h), L = new C(), H = /* @__PURE__ */ (function() {
    function t3(t4) {
      if (this.k = void 0, this.O = [], "boolean" == typeof t4) this.k = t4;
      else {
        var n3 = Array.isArray(t4) ? t4 : [t4];
        this.O = n3.map(function(t5) {
          return E(t5);
        });
      }
    }
    return t3.prototype.checkHref = function(t4) {
      if ("boolean" == typeof this.k) return this.k;
      var n3 = O(t4).path;
      return this.O.some(function(t5) {
        return null !== t5.exec(n3);
      });
    }, t3;
  })(), _ = /* @__PURE__ */ (function(t3) {
    function n3(n4) {
      var r3;
      return (r3 = t3.call(this, n4) || this).T = /* @__PURE__ */ new Map(), r3;
    }
    i(n3, t3);
    var e2 = n3.prototype;
    return e2.set = function(t4, n4, r3, i2, e3) {
      return this.T.set(t4, { action: r3, request: n4, status: i2, target: null != e3 ? e3 : t4 }), { action: r3, request: n4, status: i2, target: e3 };
    }, e2.get = function(t4) {
      return this.T.get(t4);
    }, e2.getRequest = function(t4) {
      return this.T.get(t4).request;
    }, e2.getAction = function(t4) {
      return this.T.get(t4).action;
    }, e2.getStatus = function(t4) {
      return this.T.get(t4).status;
    }, e2.getTarget = function(t4) {
      return this.T.get(t4).target;
    }, e2.has = function(t4) {
      return !this.checkHref(t4) && this.T.has(t4);
    }, e2.delete = function(t4) {
      return this.T.delete(t4);
    }, e2.update = function(t4, n4) {
      var i2 = r2({}, this.T.get(t4), n4);
      return this.T.set(t4, i2), i2;
    }, n3;
  })(H), D = /* @__PURE__ */ (function() {
    function t3() {
      this.A = /* @__PURE__ */ new Map();
    }
    var n3 = t3.prototype;
    return n3.set = function(t4, n4) {
      return this.A.set(t4, n4), { name: n4 };
    }, n3.get = function(t4) {
      return this.A.get(t4);
    }, n3.all = function() {
      return this.A;
    }, n3.has = function(t4) {
      return this.A.has(t4);
    }, n3.delete = function(t4) {
      return this.A.delete(t4);
    }, n3.clear = function() {
      return this.A.clear();
    }, t3;
  })(), B = function() {
    return !window.history.pushState;
  }, q = function(t3) {
    return !t3.el || !t3.href;
  }, F = function(t3) {
    var n3 = t3.event;
    return n3.which > 1 || n3.metaKey || n3.ctrlKey || n3.shiftKey || n3.altKey;
  }, I = function(t3) {
    var n3 = t3.el;
    return n3.hasAttribute("target") && "_blank" === n3.target;
  }, U = function(t3) {
    var n3 = t3.el;
    return void 0 !== n3.protocol && window.location.protocol !== n3.protocol || void 0 !== n3.hostname && window.location.hostname !== n3.hostname;
  }, $ = function(t3) {
    var n3 = t3.el;
    return void 0 !== n3.port && k() !== k(n3.href);
  }, Q = function(t3) {
    var n3 = t3.el;
    return n3.getAttribute && "string" == typeof n3.getAttribute("download");
  }, X = function(t3) {
    return t3.el.hasAttribute(m.prefix + "-" + m.prevent);
  }, z = function(t3) {
    return Boolean(t3.el.closest("[" + m.prefix + "-" + m.prevent + '="all"]'));
  }, G = function(t3) {
    var n3 = t3.href;
    return A(n3) === A() && k(n3) === k();
  }, J = /* @__PURE__ */ (function(t3) {
    function n3(n4) {
      var r4;
      return (r4 = t3.call(this, n4) || this).suite = [], r4.tests = /* @__PURE__ */ new Map(), r4.init(), r4;
    }
    i(n3, t3);
    var r3 = n3.prototype;
    return r3.init = function() {
      this.add("pushState", B), this.add("exists", q), this.add("newTab", F), this.add("blank", I), this.add("corsDomain", U), this.add("corsPort", $), this.add("download", Q), this.add("preventSelf", X), this.add("preventAll", z), this.add("sameUrl", G, false);
    }, r3.add = function(t4, n4, r4) {
      void 0 === r4 && (r4 = true), this.tests.set(t4, n4), r4 && this.suite.push(t4);
    }, r3.run = function(t4, n4, r4, i2) {
      return this.tests.get(t4)({ el: n4, event: r4, href: i2 });
    }, r3.checkLink = function(t4, n4, r4) {
      var i2 = this;
      return this.suite.some(function(e2) {
        return i2.run(e2, t4, n4, r4);
      });
    }, n3;
  })(H), W = /* @__PURE__ */ (function(t3) {
    function n3(r3, i2) {
      var e2;
      return void 0 === i2 && (i2 = "Barba error"), (e2 = t3.call.apply(t3, [this].concat([].slice.call(arguments, 2))) || this).error = void 0, e2.label = void 0, e2.error = r3, e2.label = i2, Error.captureStackTrace && Error.captureStackTrace(c(e2), n3), e2.name = "BarbaError", e2;
    }
    return i(n3, t3), n3;
  })(/* @__PURE__ */ f(Error)), K = /* @__PURE__ */ (function() {
    function t3(t4) {
      void 0 === t4 && (t4 = []), this.logger = new d("@barba/core"), this.all = [], this.page = [], this.once = [], this.j = [{ name: "namespace", type: "strings" }, { name: "custom", type: "function" }], t4 && (this.all = this.all.concat(t4)), this.update();
    }
    var n3 = t3.prototype;
    return n3.add = function(t4, n4) {
      "rule" === t4 ? this.j.splice(n4.position || 0, 0, n4.value) : this.all.push(n4), this.update();
    }, n3.resolve = function(t4, n4) {
      var r3 = this;
      void 0 === n4 && (n4 = {});
      var i2 = n4.once ? this.once : this.page;
      i2 = i2.filter(n4.self ? function(t5) {
        return t5.name && "self" === t5.name;
      } : function(t5) {
        return !t5.name || "self" !== t5.name;
      });
      var e2 = /* @__PURE__ */ new Map(), o2 = i2.find(function(i3) {
        var o3 = true, u3 = {};
        return n4.self && "self" === i3.name ? (e2.set(i3, u3), true) : (r3.j.reverse().forEach(function(n5) {
          o3 && (o3 = r3.M(i3, n5, t4, u3), i3.from && i3.to && (o3 = r3.M(i3, n5, t4, u3, "from") && r3.M(i3, n5, t4, u3, "to")), i3.from && !i3.to && (o3 = r3.M(i3, n5, t4, u3, "from")), !i3.from && i3.to && (o3 = r3.M(i3, n5, t4, u3, "to")));
        }), e2.set(i3, u3), o3);
      }), u2 = e2.get(o2), s2 = [];
      if (s2.push(n4.once ? "once" : "page"), n4.self && s2.push("self"), u2) {
        var f2, c2 = [o2];
        Object.keys(u2).length > 0 && c2.push(u2), (f2 = this.logger).info.apply(f2, ["Transition found [" + s2.join(",") + "]"].concat(c2));
      } else this.logger.info("No transition found [" + s2.join(",") + "]");
      return o2;
    }, n3.update = function() {
      var t4 = this;
      this.all = this.all.map(function(n4) {
        return t4.N(n4);
      }).sort(function(t5, n4) {
        return t5.priority - n4.priority;
      }).reverse().map(function(t5) {
        return delete t5.priority, t5;
      }), this.page = this.all.filter(function(t5) {
        return void 0 !== t5.leave || void 0 !== t5.enter;
      }), this.once = this.all.filter(function(t5) {
        return void 0 !== t5.once;
      });
    }, n3.M = function(t4, n4, r3, i2, e2) {
      var o2 = true, u2 = false, s2 = t4, f2 = n4.name, c2 = f2, a2 = f2, h2 = f2, v2 = e2 ? s2[e2] : s2, d2 = "to" === e2 ? r3.next : r3.current;
      if (e2 ? v2 && v2[f2] : v2[f2]) {
        switch (n4.type) {
          case "strings":
          default:
            var l2 = Array.isArray(v2[c2]) ? v2[c2] : [v2[c2]];
            d2[c2] && -1 !== l2.indexOf(d2[c2]) && (u2 = true), -1 === l2.indexOf(d2[c2]) && (o2 = false);
            break;
          case "object":
            var p2 = Array.isArray(v2[a2]) ? v2[a2] : [v2[a2]];
            d2[a2] ? (d2[a2].name && -1 !== p2.indexOf(d2[a2].name) && (u2 = true), -1 === p2.indexOf(d2[a2].name) && (o2 = false)) : o2 = false;
            break;
          case "function":
            v2[h2](r3) ? u2 = true : o2 = false;
        }
        u2 && (e2 ? (i2[e2] = i2[e2] || {}, i2[e2][f2] = s2[e2][f2]) : i2[f2] = s2[f2]);
      }
      return o2;
    }, n3.S = function(t4, n4, r3) {
      var i2 = 0;
      return (t4[n4] || t4.from && t4.from[n4] || t4.to && t4.to[n4]) && (i2 += Math.pow(10, r3), t4.from && t4.from[n4] && (i2 += 1), t4.to && t4.to[n4] && (i2 += 2)), i2;
    }, n3.N = function(t4) {
      var n4 = this;
      t4.priority = 0;
      var r3 = 0;
      return this.j.forEach(function(i2, e2) {
        r3 += n4.S(t4, i2.name, e2 + 1);
      }), t4.priority = r3, t4;
    }, t3;
  })();
  function V(t3, n3) {
    try {
      var r3 = t3();
    } catch (t4) {
      return n3(t4);
    }
    return r3 && r3.then ? r3.then(void 0, n3) : r3;
  }
  var Y = /* @__PURE__ */ (function() {
    function t3(t4) {
      void 0 === t4 && (t4 = []), this.logger = new d("@barba/core"), this.store = void 0, this.C = false, this.store = new K(t4);
    }
    var r3 = t3.prototype;
    return r3.get = function(t4, n3) {
      return this.store.resolve(t4, n3);
    }, r3.doOnce = function(t4) {
      var n3 = t4.data, r4 = t4.transition;
      try {
        var i2 = function() {
          e2.C = false;
        }, e2 = this, o2 = r4 || {};
        e2.C = true;
        var u2 = V(function() {
          return Promise.resolve(e2.L("beforeOnce", n3, o2)).then(function() {
            return Promise.resolve(e2.once(n3, o2)).then(function() {
              return Promise.resolve(e2.L("afterOnce", n3, o2)).then(function() {
              });
            });
          });
        }, function(t5) {
          e2.C = false, e2.logger.debug("Transition error [before/after/once]"), e2.logger.error(t5);
        });
        return Promise.resolve(u2 && u2.then ? u2.then(i2) : i2());
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, r3.doPage = function(t4) {
      var n3 = t4.data, r4 = t4.transition, i2 = t4.page, e2 = t4.wrapper;
      try {
        var o2 = function(t5) {
          u2.C = false;
        }, u2 = this, s2 = r4 || {}, f2 = true === s2.sync || false;
        u2.C = true;
        var c2 = V(function() {
          function t5() {
            return Promise.resolve(u2.L("before", n3, s2)).then(function() {
              function t6(t7) {
                return Promise.resolve(u2.remove(n3)).then(function() {
                  return Promise.resolve(u2.L("after", n3, s2)).then(function() {
                  });
                });
              }
              var r6 = (function() {
                if (f2) return V(function() {
                  return Promise.resolve(u2.add(n3, e2)).then(function() {
                    return Promise.resolve(u2.L("beforeLeave", n3, s2)).then(function() {
                      return Promise.resolve(u2.L("beforeEnter", n3, s2)).then(function() {
                        return Promise.resolve(Promise.all([u2.leave(n3, s2), u2.enter(n3, s2)])).then(function() {
                          return Promise.resolve(u2.L("afterLeave", n3, s2)).then(function() {
                            return Promise.resolve(u2.L("afterEnter", n3, s2)).then(function() {
                            });
                          });
                        });
                      });
                    });
                  });
                }, function(t8) {
                  if (u2.H(t8)) throw new W(t8, "Transition error [sync]");
                });
                var t7 = function(t8) {
                  return V(function() {
                    var t9 = (function() {
                      if (false !== r7) return Promise.resolve(u2.add(n3, e2)).then(function() {
                        return Promise.resolve(u2.L("beforeEnter", n3, s2)).then(function() {
                          return Promise.resolve(u2.enter(n3, s2, r7)).then(function() {
                            return Promise.resolve(u2.L("afterEnter", n3, s2)).then(function() {
                            });
                          });
                        });
                      });
                    })();
                    if (t9 && t9.then) return t9.then(function() {
                    });
                  }, function(t9) {
                    if (u2.H(t9)) throw new W(t9, "Transition error [before/after/enter]");
                  });
                }, r7 = false, o3 = V(function() {
                  return Promise.resolve(u2.L("beforeLeave", n3, s2)).then(function() {
                    return Promise.resolve(Promise.all([u2.leave(n3, s2), g(i2, n3)]).then(function(t8) {
                      return t8[0];
                    })).then(function(t8) {
                      return r7 = t8, Promise.resolve(u2.L("afterLeave", n3, s2)).then(function() {
                      });
                    });
                  });
                }, function(t8) {
                  if (u2.H(t8)) throw new W(t8, "Transition error [before/after/leave]");
                });
                return o3 && o3.then ? o3.then(t7) : t7();
              })();
              return r6 && r6.then ? r6.then(t6) : t6();
            });
          }
          var r5 = (function() {
            if (f2) return Promise.resolve(g(i2, n3)).then(function() {
            });
          })();
          return r5 && r5.then ? r5.then(t5) : t5();
        }, function(t5) {
          if (u2.C = false, t5.name && "BarbaError" === t5.name) throw u2.logger.debug(t5.label), u2.logger.error(t5.error), t5;
          throw u2.logger.debug("Transition error [page]"), u2.logger.error(t5), t5;
        });
        return Promise.resolve(c2 && c2.then ? c2.then(o2) : o2());
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, r3.once = function(t4, n3) {
      try {
        return Promise.resolve(L.do("once", t4, n3)).then(function() {
          return n3.once ? S(n3.once, n3)(t4) : Promise.resolve();
        });
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, r3.leave = function(t4, n3) {
      try {
        return Promise.resolve(L.do("leave", t4, n3)).then(function() {
          return n3.leave ? S(n3.leave, n3)(t4) : Promise.resolve();
        });
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, r3.enter = function(t4, n3, r4) {
      try {
        return Promise.resolve(L.do("enter", t4, n3)).then(function() {
          return n3.enter ? S(n3.enter, n3)(t4, r4) : Promise.resolve();
        });
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, r3.add = function(t4, n3) {
      try {
        return b.addContainer(t4.next.container, n3), L.do("nextAdded", t4), Promise.resolve();
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, r3.remove = function(t4) {
      try {
        return b.removeContainer(t4.current.container), L.do("currentRemoved", t4), Promise.resolve();
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, r3.H = function(t4) {
      return t4.message ? !/Timeout error|Fetch error/.test(t4.message) : !t4.status;
    }, r3.L = function(t4, n3, r4) {
      try {
        return Promise.resolve(L.do(t4, n3, r4)).then(function() {
          return r4[t4] ? S(r4[t4], r4)(n3) : Promise.resolve();
        });
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, n2(t3, [{ key: "isRunning", get: function() {
      return this.C;
    }, set: function(t4) {
      this.C = t4;
    } }, { key: "hasOnce", get: function() {
      return this.store.once.length > 0;
    } }, { key: "hasSelf", get: function() {
      return this.store.all.some(function(t4) {
        return "self" === t4.name;
      });
    } }, { key: "shouldWait", get: function() {
      return this.store.all.some(function(t4) {
        return t4.to && !t4.to.route || t4.sync;
      });
    } }]), t3;
  })(), Z = /* @__PURE__ */ (function() {
    function t3(t4) {
      var n3 = this;
      this.names = ["beforeLeave", "afterLeave", "beforeEnter", "afterEnter"], this.byNamespace = /* @__PURE__ */ new Map(), 0 !== t4.length && (t4.forEach(function(t5) {
        n3.byNamespace.set(t5.namespace, t5);
      }), this.names.forEach(function(t5) {
        L[t5](n3._(t5));
      }));
    }
    return t3.prototype._ = function(t4) {
      var n3 = this;
      return function(r3) {
        var i2 = t4.match(/enter/i) ? r3.next : r3.current, e2 = n3.byNamespace.get(i2.namespace);
        return e2 && e2[t4] ? S(e2[t4], e2)(r3) : Promise.resolve();
      };
    }, t3;
  })();
  Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function(t3) {
    var n3 = this;
    do {
      if (n3.matches(t3)) return n3;
      n3 = n3.parentElement || n3.parentNode;
    } while (null !== n3 && 1 === n3.nodeType);
    return null;
  });
  var tt = { container: null, html: "", namespace: "", url: { hash: "", href: "", path: "", port: null, query: {} } }, nt = /* @__PURE__ */ (function() {
    function t3() {
      this.version = "2.10.3", this.schemaPage = tt, this.Logger = d, this.logger = new d("@barba/core"), this.plugins = [], this.timeout = void 0, this.cacheIgnore = void 0, this.cacheFirstPage = void 0, this.prefetchIgnore = void 0, this.preventRunning = void 0, this.hooks = L, this.cache = void 0, this.headers = void 0, this.prevent = void 0, this.transitions = void 0, this.views = void 0, this.dom = b, this.helpers = x, this.history = P, this.request = M, this.url = j, this.D = void 0, this.B = void 0, this.q = void 0, this.F = void 0;
    }
    var i2 = t3.prototype;
    return i2.use = function(t4, n3) {
      var r3 = this.plugins;
      r3.indexOf(t4) > -1 ? this.logger.warn("Plugin [" + t4.name + "] already installed.") : "function" == typeof t4.install ? (t4.install(this, n3), r3.push(t4)) : this.logger.warn("Plugin [" + t4.name + '] has no "install" method.');
    }, i2.init = function(t4) {
      var n3 = void 0 === t4 ? {} : t4, i3 = n3.transitions, e2 = void 0 === i3 ? [] : i3, o2 = n3.views, u2 = void 0 === o2 ? [] : o2, s2 = n3.schema, f2 = void 0 === s2 ? m : s2, c2 = n3.requestError, a2 = n3.timeout, h2 = void 0 === a2 ? 2e3 : a2, v2 = n3.cacheIgnore, l2 = void 0 !== v2 && v2, p2 = n3.cacheFirstPage, w2 = void 0 !== p2 && p2, b2 = n3.prefetchIgnore, y2 = void 0 !== b2 && b2, P2 = n3.preventRunning, g2 = void 0 !== P2 && P2, E2 = n3.prevent, x2 = void 0 === E2 ? null : E2, R2 = n3.debug, k2 = n3.logLevel;
      if (d.setLevel(true === (void 0 !== R2 && R2) ? "debug" : void 0 === k2 ? "off" : k2), this.logger.info(this.version), Object.keys(f2).forEach(function(t5) {
        m[t5] && (m[t5] = f2[t5]);
      }), this.B = c2, this.timeout = h2, this.cacheIgnore = l2, this.cacheFirstPage = w2, this.prefetchIgnore = y2, this.preventRunning = g2, this.q = this.dom.getWrapper(), !this.q) throw new Error("[@barba/core] No Barba wrapper found");
      this.I();
      var O2 = this.data.current;
      if (!O2.container) throw new Error("[@barba/core] No Barba container found");
      if (this.cache = new _(l2), this.headers = new D(), this.prevent = new J(y2), this.transitions = new Y(e2), this.views = new Z(u2), null !== x2) {
        if ("function" != typeof x2) throw new Error("[@barba/core] Prevent should be a function");
        this.prevent.add("preventCustom", x2);
      }
      this.history.init(O2.url.href, O2.namespace), w2 && this.cache.set(O2.url.href, Promise.resolve({ html: O2.html, url: O2.url }), "init", "fulfilled"), this.U = this.U.bind(this), this.$ = this.$.bind(this), this.X = this.X.bind(this), this.G(), this.plugins.forEach(function(t5) {
        return t5.init();
      });
      var T2 = this.data;
      T2.trigger = "barba", T2.next = T2.current, T2.current = r2({}, this.schemaPage), this.hooks.do("ready", T2), this.once(T2), this.I();
    }, i2.destroy = function() {
      this.I(), this.J(), this.history.clear(), this.hooks.clear(), this.plugins = [];
    }, i2.force = function(t4) {
      window.location.assign(t4);
    }, i2.go = function(t4, n3, r3) {
      var i3;
      if (void 0 === n3 && (n3 = "barba"), this.F = null, this.transitions.isRunning) this.force(t4);
      else if (!(i3 = "popstate" === n3 ? this.history.current && this.url.getPath(this.history.current.url) === this.url.getPath(t4) && this.url.getQuery(this.history.current.url, true) === this.url.getQuery(t4, true) : this.prevent.run("sameUrl", null, null, t4)) || this.transitions.hasSelf) return n3 = this.history.change(this.cache.has(t4) ? this.cache.get(t4).target : t4, n3, r3), r3 && (r3.stopPropagation(), r3.preventDefault()), this.page(t4, n3, null != r3 ? r3 : void 0, i3);
    }, i2.once = function(t4) {
      try {
        var n3 = this;
        return Promise.resolve(n3.hooks.do("beforeEnter", t4)).then(function() {
          function r3() {
            return Promise.resolve(n3.hooks.do("afterEnter", t4)).then(function() {
            });
          }
          var i3 = (function() {
            if (n3.transitions.hasOnce) {
              var r4 = n3.transitions.get(t4, { once: true });
              return Promise.resolve(n3.transitions.doOnce({ transition: r4, data: t4 })).then(function() {
              });
            }
          })();
          return i3 && i3.then ? i3.then(r3) : r3();
        });
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, i2.page = function(t4, n3, i3, e2) {
      try {
        var o2, u2 = function() {
          var t5 = s2.data;
          return Promise.resolve(s2.hooks.do("page", t5)).then(function() {
            var n4 = (function(n5, r3) {
              try {
                var i4 = (u3 = s2.transitions.get(t5, { once: false, self: e2 }), Promise.resolve(s2.transitions.doPage({ data: t5, page: o2, transition: u3, wrapper: s2.q })).then(function() {
                  s2.I();
                }));
              } catch (t6) {
                return r3();
              }
              var u3;
              return i4 && i4.then ? i4.then(void 0, r3) : i4;
            })(0, function() {
              0 === d.getLevel() && s2.force(t5.next.url.href);
            });
            if (n4 && n4.then) return n4.then(function() {
            });
          });
        }, s2 = this;
        if (s2.data.next.url = r2({ href: t4 }, s2.url.parse(t4)), s2.data.trigger = n3, s2.data.event = i3, s2.cache.has(t4)) o2 = s2.cache.update(t4, { action: "click" }).request;
        else {
          var f2 = s2.request(t4, s2.timeout, s2.onRequestError.bind(s2, n3), s2.cache, s2.headers);
          f2.then(function(r3) {
            r3.url.href !== t4 && s2.history.add(r3.url.href, n3, "replace");
          }), o2 = s2.cache.set(t4, f2, "click", "pending").request;
        }
        var c2 = (function() {
          if (s2.transitions.shouldWait) return Promise.resolve(g(o2, s2.data)).then(function() {
          });
        })();
        return Promise.resolve(c2 && c2.then ? c2.then(u2) : u2());
      } catch (t5) {
        return Promise.reject(t5);
      }
    }, i2.onRequestError = function(t4) {
      this.transitions.isRunning = false;
      var n3 = [].slice.call(arguments, 1), r3 = n3[0], i3 = n3[1], e2 = this.cache.getAction(r3);
      return this.cache.delete(r3), this.B && false === this.B(t4, e2, r3, i3) || "click" === e2 && this.force(r3), false;
    }, i2.prefetch = function(t4) {
      var n3 = this;
      t4 = this.url.getAbsoluteHref(t4), this.cache.has(t4) || this.cache.set(t4, this.request(t4, this.timeout, this.onRequestError.bind(this, "barba"), this.cache, this.headers).catch(function(t5) {
        n3.logger.error(t5);
      }), "prefetch", "pending");
    }, i2.G = function() {
      true !== this.prefetchIgnore && (document.addEventListener("mouseover", this.U), document.addEventListener("touchstart", this.U)), document.addEventListener("click", this.$), window.addEventListener("popstate", this.X);
    }, i2.J = function() {
      true !== this.prefetchIgnore && (document.removeEventListener("mouseover", this.U), document.removeEventListener("touchstart", this.U)), document.removeEventListener("click", this.$), window.removeEventListener("popstate", this.X);
    }, i2.U = function(t4) {
      var n3 = this, r3 = this.W(t4);
      if (r3) {
        var i3 = this.url.getAbsoluteHref(this.dom.getHref(r3));
        this.prevent.checkHref(i3) || this.cache.has(i3) || this.cache.set(i3, this.request(i3, this.timeout, this.onRequestError.bind(this, r3), this.cache, this.headers).catch(function(t5) {
          n3.logger.error(t5);
        }), "enter", "pending");
      }
    }, i2.$ = function(t4) {
      var n3 = this.W(t4);
      if (n3) {
        if (this.transitions.isRunning && this.preventRunning) return t4.preventDefault(), void t4.stopPropagation();
        this.F = t4, this.go(this.dom.getHref(n3), n3, t4);
      }
    }, i2.X = function(t4) {
      this.go(this.url.getHref(), "popstate", t4);
    }, i2.W = function(t4) {
      for (var n3 = t4.target; n3 && !this.dom.getHref(n3); ) n3 = n3.parentNode;
      if (n3 && !this.prevent.checkLink(n3, t4, this.dom.getHref(n3))) return n3;
    }, i2.I = function() {
      var t4 = this.url.getHref(), n3 = { container: this.dom.getContainer(), html: this.dom.getHtml(), namespace: this.dom.getNamespace(), url: r2({ href: t4 }, this.url.parse(t4)) };
      this.D = { current: n3, event: void 0, next: r2({}, this.schemaPage), trigger: void 0 }, this.hooks.do("reset", this.data);
    }, n2(t3, [{ key: "data", get: function() {
      return this.D;
    } }, { key: "wrapper", get: function() {
      return this.q;
    } }]), t3;
  })();
  return new nt();
});
;
window.Detectizr = (function(a, b, c, d) {
  var e = {}, f = a.Modernizr, g = ["tv", "tablet", "mobile", "desktop"], h = { addAllFeaturesAsClass: false, detectDevice: true, detectDeviceModel: true, detectScreen: true, detectOS: true, detectBrowser: true, detectPlugins: true }, i = [{ name: "adobereader", substrs: ["Adobe", "Acrobat"], progIds: ["AcroPDF.PDF", "PDF.PDFCtrl.5"] }, { name: "flash", substrs: ["Shockwave Flash"], progIds: ["ShockwaveFlash.ShockwaveFlash.1"] }, { name: "wmplayer", substrs: ["Windows Media"], progIds: ["wmplayer.ocx"] }, { name: "silverlight", substrs: ["Silverlight"], progIds: ["AgControl.AgControl"] }, { name: "quicktime", substrs: ["QuickTime"], progIds: ["QuickTime.QuickTime"] }], j = /[\t\r\n]/g, k = c.documentElement, l, m;
  function n2(a2, b2) {
    var c2, d2, e2;
    if (arguments.length > 2) for (c2 = 1, d2 = arguments.length; d2 > c2; c2 += 1) n2(a2, arguments[c2]);
    else for (e2 in b2) b2.hasOwnProperty(e2) && (a2[e2] = b2[e2]);
    return a2;
  }
  function o(a2) {
    return e.browser.userAgent.indexOf(a2) > -1;
  }
  function p(a2) {
    return a2.test(e.browser.userAgent);
  }
  function q(a2) {
    return a2.exec(e.browser.userAgent);
  }
  function r2(a2) {
    return a2.replace(/^\s+|\s+$/g, "");
  }
  function s(a2) {
    return null === a2 || a2 === d ? "" : String(a2).replace(/((\s|\-|\.)+[a-z0-9])/g, function(a3) {
      return a3.toUpperCase().replace(/(\s|\-|\.)/g, "");
    });
  }
  function t2(a2, b2) {
    var c2 = b2 || "", d2 = 1 === a2.nodeType && (a2.className ? (" " + a2.className + " ").replace(j, " ") : "");
    if (d2) {
      while (d2.indexOf(" " + c2 + " ") >= 0) d2 = d2.replace(" " + c2 + " ", " ");
      a2.className = b2 ? r2(d2) : "";
    }
  }
  function u(a2, b2, c2) {
    a2 && (a2 = s(a2), b2 && (b2 = s(b2), v(a2 + b2, true), c2 && v(a2 + b2 + "_" + c2, true)));
  }
  function v(a2, b2) {
    a2 && f && (h.addAllFeaturesAsClass ? f.addTest(a2, b2) : (b2 = "function" == typeof b2 ? b2() : b2, b2 ? f.addTest(a2, true) : (delete f[a2], t2(k, a2))));
  }
  function w(a2, b2) {
    a2.version = b2;
    var c2 = b2.split(".");
    c2.length > 0 ? (c2 = c2.reverse(), a2.major = c2.pop(), c2.length > 0 ? (a2.minor = c2.pop(), c2.length > 0 ? (c2 = c2.reverse(), a2.patch = c2.join(".")) : a2.patch = "0") : a2.minor = "0") : a2.major = "0";
  }
  function x() {
    a.clearTimeout(l), l = a.setTimeout(function() {
      m = e.device.orientation, a.innerHeight > a.innerWidth ? e.device.orientation = "portrait" : e.device.orientation = "landscape", v(e.device.orientation, true), m !== e.device.orientation && v(m, false);
    }, 10);
  }
  function y(a2) {
    var c2 = b.plugins, d2, e2, f2, g2, h2;
    for (g2 = c2.length - 1; g2 >= 0; g2--) {
      for (d2 = c2[g2], e2 = d2.name + d2.description, f2 = 0, h2 = a2.length; h2 >= 0; h2--) -1 !== e2.indexOf(a2[h2]) && (f2 += 1);
      if (f2 === a2.length) return true;
    }
    return false;
  }
  function z(a2) {
    var b2;
    for (b2 = a2.length - 1; b2 >= 0; b2--) try {
      new ActiveXObject(a2[b2]);
    } catch (c2) {
    }
    return false;
  }
  function A(d2) {
    var j2, k2, l2, m2, r3, t3, A2;
    if (h = n2({}, h, d2 || {}), h.detectDevice) {
      for (e.device = { type: "", model: "", orientation: "" }, l2 = e.device, p(/googletv|smarttv|smart-tv|internet.tv|netcast|nettv|appletv|boxee|kylo|roku|dlnadoc|roku|pov_tv|hbbtv|ce\-html/) ? (l2.type = g[0], l2.model = "smartTv") : p(/xbox|playstation.3|wii/) ? (l2.type = g[0], l2.model = "gameConsole") : p(/ip(a|ro)d/) ? (l2.type = g[1], l2.model = "ipad") : p(/tablet/) && !p(/rx-34/) || p(/folio/) ? (l2.type = g[1], l2.model = String(q(/playbook/) || "")) : p(/linux/) && p(/android/) && !p(/fennec|mobi|htc.magic|htcX06ht|nexus.one|sc-02b|fone.945/) ? (l2.type = g[1], l2.model = "android") : p(/kindle/) || p(/mac.os/) && p(/silk/) ? (l2.type = g[1], l2.model = "kindle") : p(/gt-p10|sc-01c|shw-m180s|sgh-t849|sch-i800|shw-m180l|sph-p100|sgh-i987|zt180|htc(.flyer|\_flyer)|sprint.atp51|viewpad7|pandigital(sprnova|nova)|ideos.s7|dell.streak.7|advent.vega|a101it|a70bht|mid7015|next2|nook/) || p(/mb511/) && p(/rutem/) ? (l2.type = g[1], l2.model = "android") : p(/bb10/) ? (l2.type = g[1], l2.model = "blackberry") : (l2.model = q(/iphone|ipod|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec|j2me/), null !== l2.model ? (l2.type = g[2], l2.model = String(l2.model)) : (l2.model = "", p(/bolt|fennec|iris|maemo|minimo|mobi|mowser|netfront|novarra|prism|rx-34|skyfire|tear|xv6875|xv6975|google.wireless.transcoder/) ? l2.type = g[2] : p(/opera/) && p(/windows.nt.5/) && p(/htc|xda|mini|vario|samsung\-gt\-i8000|samsung\-sgh\-i9/) ? l2.type = g[2] : p(/windows.(nt|xp|me|9)/) && !p(/phone/) || p(/win(9|.9|nt)/) || p(/\(windows 8\)/) ? l2.type = g[3] : p(/macintosh|powerpc/) && !p(/silk/) ? (l2.type = g[3], l2.model = "mac") : p(/linux/) && p(/x11/) ? l2.type = g[3] : p(/solaris|sunos|bsd/) ? l2.type = g[3] : p(/cros/) ? l2.type = g[3] : p(/bot|crawler|spider|yahoo|ia_archiver|covario-ids|findlinks|dataparksearch|larbin|mediapartners-google|ng-search|snappy|teoma|jeeves|tineye/) && !p(/mobile/) ? (l2.type = g[3], l2.model = "crawler") : l2.type = g[2])), j2 = 0, k2 = g.length; k2 > j2; j2 += 1) v(g[j2], l2.type === g[j2]);
      h.detectDeviceModel && v(s(l2.model), true);
    }
    if (h.detectScreen && (l2.screen = {}, f && f.mq && (f.mq("only screen and (max-width: 240px)") ? (l2.screen.size = "veryVerySmall", v("veryVerySmallScreen", true)) : f.mq("only screen and (max-width: 320px)") ? (l2.screen.size = "verySmall", v("verySmallScreen", true)) : f.mq("only screen and (max-width: 480px)") && (l2.screen.size = "small", v("smallScreen", true)), (l2.type === g[1] || l2.type === g[2]) && f.mq("only screen and (-moz-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)") && (l2.screen.resolution = "high", v("highresolution", true))), l2.type === g[1] || l2.type === g[2] ? (a.onresize = function(a2) {
      x(a2);
    }, x()) : (l2.orientation = "landscape", v(l2.orientation, true))), h.detectOS && (e.os = {}, m2 = e.os, "" !== l2.model && ("ipad" === l2.model || "iphone" === l2.model || "ipod" === l2.model ? (m2.name = "ios", w(m2, (p(/os\s([\d_]+)/) ? RegExp.$1 : "").replace(/_/g, "."))) : "android" === l2.model ? (m2.name = "android", w(m2, p(/android\s([\d\.]+)/) ? RegExp.$1 : "")) : "blackberry" === l2.model ? (m2.name = "blackberry", w(m2, p(/version\/([^\s]+)/) ? RegExp.$1 : "")) : "playbook" === l2.model && (m2.name = "blackberry", w(m2, p(/os ([^\s]+)/) ? RegExp.$1.replace(";", "") : ""))), m2.name || (o("win") || o("16bit") ? (m2.name = "windows", o("windows nt 10") ? w(m2, "10") : o("windows nt 6.3") ? w(m2, "8.1") : o("windows nt 6.2") || p(/\(windows 8\)/) ? w(m2, "8") : o("windows nt 6.1") ? w(m2, "7") : o("windows nt 6.0") ? w(m2, "vista") : o("windows nt 5.2") || o("windows nt 5.1") || o("windows xp") ? w(m2, "xp") : o("windows nt 5.0") || o("windows 2000") ? w(m2, "2k") : o("winnt") || o("windows nt") ? w(m2, "nt") : o("win98") || o("windows 98") ? w(m2, "98") : (o("win95") || o("windows 95")) && w(m2, "95")) : o("mac") || o("darwin") ? (m2.name = "mac os", o("68k") || o("68000") ? w(m2, "68k") : o("ppc") || o("powerpc") ? w(m2, "ppc") : o("os x") && w(m2, (p(/os\sx\s([\d_]+)/) ? RegExp.$1 : "os x").replace(/_/g, "."))) : o("webtv") ? m2.name = "webtv" : o("x11") || o("inux") ? m2.name = "linux" : o("sunos") ? m2.name = "sun" : o("irix") ? m2.name = "irix" : o("freebsd") ? m2.name = "freebsd" : o("bsd") && (m2.name = "bsd")), m2.name && (v(m2.name, true), m2.major && (u(m2.name, m2.major), m2.minor && u(m2.name, m2.major, m2.minor))), p(/\sx64|\sx86|\swin64|\swow64|\samd64/) ? m2.addressRegisterSize = "64bit" : m2.addressRegisterSize = "32bit", v(m2.addressRegisterSize, true)), h.detectBrowser && (r3 = e.browser, p(/opera|webtv/) || !p(/msie\s([\d\w\.]+)/) && !o("trident") ? o("firefox") ? (r3.engine = "gecko", r3.name = "firefox", w(r3, p(/firefox\/([\d\w\.]+)/) ? RegExp.$1 : "")) : o("gecko/") ? r3.engine = "gecko" : o("opera") ? (r3.name = "opera", r3.engine = "presto", w(r3, p(/version\/([\d\.]+)/) ? RegExp.$1 : p(/opera(\s|\/)([\d\.]+)/) ? RegExp.$2 : "")) : o("konqueror") ? r3.name = "konqueror" : o("edge") ? (r3.engine = "webkit", r3.name = "edge", w(r3, p(/edge\/([\d\.]+)/) ? RegExp.$1 : "")) : o("chrome") ? (r3.engine = "webkit", r3.name = "chrome", w(r3, p(/chrome\/([\d\.]+)/) ? RegExp.$1 : "")) : o("iron") ? (r3.engine = "webkit", r3.name = "iron") : o("crios") ? (r3.name = "chrome", r3.engine = "webkit", w(r3, p(/crios\/([\d\.]+)/) ? RegExp.$1 : "")) : o("applewebkit/") ? (r3.name = "safari", r3.engine = "webkit", w(r3, p(/version\/([\d\.]+)/) ? RegExp.$1 : "")) : o("mozilla/") && (r3.engine = "gecko") : (r3.engine = "trident", r3.name = "ie", !a.addEventListener && c.documentMode && 7 === c.documentMode ? w(r3, "8.compat") : p(/trident.*rv[ :](\d+)\./) ? w(r3, RegExp.$1) : w(r3, p(/trident\/4\.0/) ? "8" : RegExp.$1)), r3.name && (v(r3.name, true), r3.major && (u(r3.name, r3.major), r3.minor && u(r3.name, r3.major, r3.minor))), v(r3.engine, true), r3.language = b.userLanguage || b.language, v(r3.language, true)), h.detectPlugins) {
      for (r3.plugins = [], j2 = i.length - 1; j2 >= 0; j2--) t3 = i[j2], A2 = false, a.ActiveXObject ? A2 = z(t3.progIds) : b.plugins && (A2 = y(t3.substrs)), A2 && (r3.plugins.push(t3.name), v(t3.name, true));
      b.javaEnabled() && (r3.plugins.push("java"), v("java", true));
    }
  }
  return e.detect = function(a2) {
    return A(a2);
  }, e.init = function() {
    e !== d && (e.browser = { userAgent: (b.userAgent || b.vendor || a.opera).toLowerCase() }, e.detect());
  }, e.init(), e;
})(this, this.navigator, this.document);
!(function(a, b) {
  var c = b(a, a.document, Date);
  a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c);
})("undefined" != typeof window ? window : {}, function(a, b, c) {
  "use strict";
  var d, e;
  if ((function() {
    var b2, c2 = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: true, expFactor: 1.5, hFac: 0.8, loadMode: 2, loadHidden: true, ricTimeout: 0, throttleDelay: 125 };
    e = a.lazySizesConfig || a.lazysizesConfig || {};
    for (b2 in c2) b2 in e || (e[b2] = c2[b2]);
  })(), !b || !b.getElementsByClassName) return { init: function() {
  }, cfg: e, noSupport: true };
  var f = b.documentElement, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h].bind(a), k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n2 = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r2 = function(a2, b2) {
    return p[b2] || (p[b2] = new RegExp("(\\s|^)" + b2 + "(\\s|$)")), p[b2].test(a2[i]("class") || "") && p[b2];
  }, s = function(a2, b2) {
    r2(a2, b2) || a2.setAttribute("class", (a2[i]("class") || "").trim() + " " + b2);
  }, t2 = function(a2, b2) {
    var c2;
    (c2 = r2(a2, b2)) && a2.setAttribute("class", (a2[i]("class") || "").replace(c2, " "));
  }, u = function(a2, b2, c2) {
    var d2 = c2 ? h : "removeEventListener";
    c2 && u(a2, b2), o.forEach(function(c3) {
      a2[d2](c3, b2);
    });
  }, v = function(a2, c2, e2, f2, g2) {
    var h2 = b.createEvent("Event");
    return e2 || (e2 = {}), e2.instance = d, h2.initEvent(c2, !f2, !g2), h2.detail = e2, a2.dispatchEvent(h2), h2;
  }, w = function(b2, c2) {
    var d2;
    !g && (d2 = a.picturefill || e.pf) ? (c2 && c2.src && !b2[i]("srcset") && b2.setAttribute("srcset", c2.src), d2({ reevaluate: true, elements: [b2] })) : c2 && c2.src && (b2.src = c2.src);
  }, x = function(a2, b2) {
    return (getComputedStyle(a2, null) || {})[b2];
  }, y = function(a2, b2, c2) {
    for (c2 = c2 || a2.offsetWidth; c2 < e.minSize && b2 && !a2._lazysizesWidth; ) c2 = b2.offsetWidth, b2 = b2.parentNode;
    return c2;
  }, z = (function() {
    var a2, c2, d2 = [], e2 = [], f2 = d2, g2 = function() {
      var b2 = f2;
      for (f2 = d2.length ? e2 : d2, a2 = true, c2 = false; b2.length; ) b2.shift()();
      a2 = false;
    }, h2 = function(d3, e3) {
      a2 && !e3 ? d3.apply(this, arguments) : (f2.push(d3), c2 || (c2 = true, (b.hidden ? k : l)(g2)));
    };
    return h2._lsFlush = g2, h2;
  })(), A = function(a2, b2) {
    return b2 ? function() {
      z(a2);
    } : function() {
      var b3 = this, c2 = arguments;
      z(function() {
        a2.apply(b3, c2);
      });
    };
  }, B = function(a2) {
    var b2, d2 = 0, f2 = e.throttleDelay, g2 = e.ricTimeout, h2 = function() {
      b2 = false, d2 = c.now(), a2();
    }, i2 = m && g2 > 49 ? function() {
      m(h2, { timeout: g2 }), g2 !== e.ricTimeout && (g2 = e.ricTimeout);
    } : A(function() {
      k(h2);
    }, true);
    return function(a3) {
      var e2;
      (a3 = true === a3) && (g2 = 33), b2 || (b2 = true, e2 = f2 - (c.now() - d2), e2 < 0 && (e2 = 0), a3 || e2 < 9 ? i2() : k(i2, e2));
    };
  }, C = function(a2) {
    var b2, d2, e2 = 99, f2 = function() {
      b2 = null, a2();
    }, g2 = function() {
      var a3 = c.now() - d2;
      a3 < e2 ? k(g2, e2 - a3) : (m || f2)(f2);
    };
    return function() {
      d2 = c.now(), b2 || (b2 = k(g2, e2));
    };
  }, D = (function() {
    var g2, m2, o2, p2, y2, D2, F2, G, H, I, J, K, L = /^img$/i, M = /^iframe$/i, N = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), O = 0, P = 0, Q = 0, R = -1, S = function(a2) {
      Q--, (!a2 || Q < 0 || !a2.target) && (Q = 0);
    }, T = function(a2) {
      return null == K && (K = "hidden" == x(b.body, "visibility")), K || !("hidden" == x(a2.parentNode, "visibility") && "hidden" == x(a2, "visibility"));
    }, U = function(a2, c2) {
      var d2, e2 = a2, g3 = T(a2);
      for (G -= c2, J += c2, H -= c2, I += c2; g3 && (e2 = e2.offsetParent) && e2 != b.body && e2 != f; ) (g3 = (x(e2, "opacity") || 1) > 0) && "visible" != x(e2, "overflow") && (d2 = e2.getBoundingClientRect(), g3 = I > d2.left && H < d2.right && J > d2.top - 1 && G < d2.bottom + 1);
      return g3;
    }, V = function() {
      var a2, c2, h2, j2, k2, l2, n3, o3, q2, r3, s2, t3, u2 = d.elements;
      if ((p2 = e.loadMode) && Q < 8 && (a2 = u2.length)) {
        for (c2 = 0, R++; c2 < a2; c2++) if (u2[c2] && !u2[c2]._lazyRace) if (!N || d.prematureUnveil && d.prematureUnveil(u2[c2])) ba(u2[c2]);
        else if ((o3 = u2[c2][i]("data-expand")) && (l2 = 1 * o3) || (l2 = P), r3 || (r3 = !e.expand || e.expand < 1 ? f.clientHeight > 500 && f.clientWidth > 500 ? 500 : 370 : e.expand, d._defEx = r3, s2 = r3 * e.expFactor, t3 = e.hFac, K = null, P < s2 && Q < 1 && R > 2 && p2 > 2 && !b.hidden ? (P = s2, R = 0) : P = p2 > 1 && R > 1 && Q < 6 ? r3 : O), q2 !== l2 && (D2 = innerWidth + l2 * t3, F2 = innerHeight + l2, n3 = -1 * l2, q2 = l2), h2 = u2[c2].getBoundingClientRect(), (J = h2.bottom) >= n3 && (G = h2.top) <= F2 && (I = h2.right) >= n3 * t3 && (H = h2.left) <= D2 && (J || I || H || G) && (e.loadHidden || T(u2[c2])) && (m2 && Q < 3 && !o3 && (p2 < 3 || R < 4) || U(u2[c2], l2))) {
          if (ba(u2[c2]), k2 = true, Q > 9) break;
        } else !k2 && m2 && !j2 && Q < 4 && R < 4 && p2 > 2 && (g2[0] || e.preloadAfterLoad) && (g2[0] || !o3 && (J || I || H || G || "auto" != u2[c2][i](e.sizesAttr))) && (j2 = g2[0] || u2[c2]);
        j2 && !k2 && ba(j2);
      }
    }, W = B(V), X = function(a2) {
      var b2 = a2.target;
      if (b2._lazyCache) return void delete b2._lazyCache;
      S(a2), s(b2, e.loadedClass), t2(b2, e.loadingClass), u(b2, Z), v(b2, "lazyloaded");
    }, Y = A(X), Z = function(a2) {
      Y({ target: a2.target });
    }, $ = function(a2, b2) {
      try {
        a2.contentWindow.location.replace(b2);
      } catch (c2) {
        a2.src = b2;
      }
    }, _ = function(a2) {
      var b2, c2 = a2[i](e.srcsetAttr);
      (b2 = e.customMedia[a2[i]("data-media") || a2[i]("media")]) && a2.setAttribute("media", b2), c2 && a2.setAttribute("srcset", c2);
    }, aa = A(function(a2, b2, c2, d2, f2) {
      var g3, h2, j2, l2, m3, p3;
      (m3 = v(a2, "lazybeforeunveil", b2)).defaultPrevented || (d2 && (c2 ? s(a2, e.autosizesClass) : a2.setAttribute("sizes", d2)), h2 = a2[i](e.srcsetAttr), g3 = a2[i](e.srcAttr), f2 && (j2 = a2.parentNode, l2 = j2 && n2.test(j2.nodeName || "")), p3 = b2.firesLoad || "src" in a2 && (h2 || g3 || l2), m3 = { target: a2 }, s(a2, e.loadingClass), p3 && (clearTimeout(o2), o2 = k(S, 2500), u(a2, Z, true)), l2 && q.call(j2.getElementsByTagName("source"), _), h2 ? a2.setAttribute("srcset", h2) : g3 && !l2 && (M.test(a2.nodeName) ? $(a2, g3) : a2.src = g3), f2 && (h2 || l2) && w(a2, { src: g3 })), a2._lazyRace && delete a2._lazyRace, t2(a2, e.lazyClass), z(function() {
        var b3 = a2.complete && a2.naturalWidth > 1;
        p3 && !b3 || (b3 && s(a2, "ls-is-cached"), X(m3), a2._lazyCache = true, k(function() {
          "_lazyCache" in a2 && delete a2._lazyCache;
        }, 9)), "lazy" == a2.loading && Q--;
      }, true);
    }), ba = function(a2) {
      if (!a2._lazyRace) {
        var b2, c2 = L.test(a2.nodeName), d2 = c2 && (a2[i](e.sizesAttr) || a2[i]("sizes")), f2 = "auto" == d2;
        (!f2 && m2 || !c2 || !a2[i]("src") && !a2.srcset || a2.complete || r2(a2, e.errorClass) || !r2(a2, e.lazyClass)) && (b2 = v(a2, "lazyunveilread").detail, f2 && E.updateElem(a2, true, a2.offsetWidth), a2._lazyRace = true, Q++, aa(a2, b2, f2, d2, c2));
      }
    }, ca = C(function() {
      e.loadMode = 3, W();
    }), da = function() {
      3 == e.loadMode && (e.loadMode = 2), ca();
    }, ea = function() {
      if (!m2) {
        if (c.now() - y2 < 999) return void k(ea, 999);
        m2 = true, e.loadMode = 3, W(), j("scroll", da, true);
      }
    };
    return { _: function() {
      y2 = c.now(), d.elements = b.getElementsByClassName(e.lazyClass), g2 = b.getElementsByClassName(e.lazyClass + " " + e.preloadClass), j("scroll", W, true), j("resize", W, true), j("pageshow", function(a2) {
        if (a2.persisted) {
          var c2 = b.querySelectorAll("." + e.loadingClass);
          c2.length && c2.forEach && l(function() {
            c2.forEach(function(a3) {
              a3.complete && ba(a3);
            });
          });
        }
      }), a.MutationObserver ? new MutationObserver(W).observe(f, { childList: true, subtree: true, attributes: true }) : (f[h]("DOMNodeInserted", W, true), f[h]("DOMAttrModified", W, true), setInterval(W, 999)), j("hashchange", W, true), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(a2) {
        b[h](a2, W, true);
      }), /d$|^c/.test(b.readyState) ? ea() : (j("load", ea), b[h]("DOMContentLoaded", W), k(ea, 2e4)), d.elements.length ? (V(), z._lsFlush()) : W();
    }, checkElems: W, unveil: ba, _aLSL: da };
  })(), E = (function() {
    var a2, c2 = A(function(a3, b2, c3, d3) {
      var e2, f3, g3;
      if (a3._lazysizesWidth = d3, d3 += "px", a3.setAttribute("sizes", d3), n2.test(b2.nodeName || "")) for (e2 = b2.getElementsByTagName("source"), f3 = 0, g3 = e2.length; f3 < g3; f3++) e2[f3].setAttribute("sizes", d3);
      c3.detail.dataAttr || w(a3, c3.detail);
    }), d2 = function(a3, b2, d3) {
      var e2, f3 = a3.parentNode;
      f3 && (d3 = y(a3, f3, d3), e2 = v(a3, "lazybeforesizes", { width: d3, dataAttr: !!b2 }), e2.defaultPrevented || (d3 = e2.detail.width) && d3 !== a3._lazysizesWidth && c2(a3, f3, e2, d3));
    }, f2 = function() {
      var b2, c3 = a2.length;
      if (c3) for (b2 = 0; b2 < c3; b2++) d2(a2[b2]);
    }, g2 = C(f2);
    return { _: function() {
      a2 = b.getElementsByClassName(e.autosizesClass), j("resize", g2);
    }, checkElems: g2, updateElem: d2 };
  })(), F = function() {
    !F.i && b.getElementsByClassName && (F.i = true, E._(), D._());
  };
  return k(function() {
    e.init && F();
  }), d = { cfg: e, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t2, hC: r2, fire: v, gW: y, rAF: z };
});
;
!(function(a, b) {
  var c = function() {
    b(a.lazySizes), a.removeEventListener("lazyunveilread", c, true);
  };
  b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, true);
})(window, function(a, b, c) {
  "use strict";
  if (a.addEventListener) {
    var d = c.cfg, e = /\s+/g, f = /\s*\|\s+|\s+\|\s*/g, g = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/, h = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/, i = /\(|\)|'/, j = { contain: 1, cover: 1 }, k = function(a2) {
      var b2 = c.gW(a2, a2.parentNode);
      return (!a2._lazysizesWidth || b2 > a2._lazysizesWidth) && (a2._lazysizesWidth = b2), a2._lazysizesWidth;
    }, l = function(a2) {
      var b2;
      return b2 = (getComputedStyle(a2) || { getPropertyValue: function() {
      } }).getPropertyValue("background-size"), !j[b2] && j[a2.style.backgroundSize] && (b2 = a2.style.backgroundSize), b2;
    }, m = function(a2, b2) {
      if (b2) {
        var c2 = b2.match(h);
        c2 && c2[1] ? a2.setAttribute("type", c2[1]) : a2.setAttribute("media", d.customMedia[b2] || b2);
      }
    }, n2 = function(a2, c2, h2) {
      var i2 = b.createElement("picture"), j2 = c2.getAttribute(d.sizesAttr), k2 = c2.getAttribute("data-ratio"), l2 = c2.getAttribute("data-optimumx");
      c2._lazybgset && c2._lazybgset.parentNode == c2 && c2.removeChild(c2._lazybgset), Object.defineProperty(h2, "_lazybgset", { value: c2, writable: true }), Object.defineProperty(c2, "_lazybgset", { value: i2, writable: true }), a2 = a2.replace(e, " ").split(f), i2.style.display = "none", h2.className = d.lazyClass, 1 != a2.length || j2 || (j2 = "auto"), a2.forEach(function(a3) {
        var c3, e2 = b.createElement("source");
        j2 && "auto" != j2 && e2.setAttribute("sizes", j2), (c3 = a3.match(g)) ? (e2.setAttribute(d.srcsetAttr, c3[1]), m(e2, c3[2]), m(e2, c3[3])) : e2.setAttribute(d.srcsetAttr, a3), i2.appendChild(e2);
      }), j2 && (h2.setAttribute(d.sizesAttr, j2), c2.removeAttribute(d.sizesAttr), c2.removeAttribute("sizes")), l2 && h2.setAttribute("data-optimumx", l2), k2 && h2.setAttribute("data-ratio", k2), i2.appendChild(h2), c2.appendChild(i2);
    }, o = function(a2) {
      if (a2.target._lazybgset) {
        var b2 = a2.target, d2 = b2._lazybgset, e2 = b2.currentSrc || b2.src;
        if (e2) {
          var f2 = c.fire(d2, "bgsetproxy", { src: e2, useSrc: i.test(e2) ? JSON.stringify(e2) : e2 });
          f2.defaultPrevented || (d2.style.backgroundImage = "url(" + f2.detail.useSrc + ")");
        }
        b2._lazybgsetLoading && (c.fire(d2, "_lazyloaded", {}, false, true), delete b2._lazybgsetLoading);
      }
    };
    addEventListener("lazybeforeunveil", function(a2) {
      var d2, e2, f2;
      !a2.defaultPrevented && (d2 = a2.target.getAttribute("data-bgset")) && (f2 = a2.target, e2 = b.createElement("img"), e2.alt = "", e2._lazybgsetLoading = true, a2.detail.firesLoad = true, n2(d2, f2, e2), setTimeout(function() {
        c.loader.unveil(e2), c.rAF(function() {
          c.fire(e2, "_lazyloaded", {}, true, true), e2.complete && o({ target: e2 });
        });
      }));
    }), b.addEventListener("load", o, true), a.addEventListener("lazybeforesizes", function(a2) {
      if (a2.detail.instance == c && a2.target._lazybgset && a2.detail.dataAttr) {
        var b2 = a2.target._lazybgset, d2 = l(b2);
        j[d2] && (a2.target._lazysizesParentFit = d2, c.rAF(function() {
          a2.target.setAttribute("data-parent-fit", d2), a2.target._lazysizesParentFit && delete a2.target._lazysizesParentFit;
        }));
      }
    }, true), b.documentElement.addEventListener("lazybeforesizes", function(a2) {
      !a2.defaultPrevented && a2.target._lazybgset && a2.detail.instance == c && (a2.detail.width = k(a2.target._lazybgset));
    });
  }
});
;
!(function(a, b) {
  if (a) {
    var c = function(d) {
      b(a.lazySizes, d), a.removeEventListener("lazyunveilread", c, true);
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, true);
  }
})("undefined" != typeof window ? window : 0, function(a, b, c, d) {
  "use strict";
  function e(a2) {
    var b2 = getComputedStyle(a2, null) || {}, c2 = b2.fontFamily || "", d2 = c2.match(m) || "", e2 = d2 && c2.match(n2) || "";
    return e2 && (e2 = e2[1]), { fit: d2 && d2[1] || "", position: q[e2] || e2 || "center" };
  }
  function f() {
    if (!i) {
      var a2 = b.createElement("style");
      i = c.cfg.objectFitClass || "lazysizes-display-clone", b.querySelector("head").appendChild(a2);
    }
  }
  function g(a2) {
    var b2 = a2.previousElementSibling;
    b2 && c.hC(b2, i) && (b2.parentNode.removeChild(b2), a2.style.position = b2.getAttribute("data-position") || "", a2.style.visibility = b2.getAttribute("data-visibility") || "");
  }
  function h(a2, b2) {
    var d2, e2, h2, j2, k2 = c.cfg, l2 = function() {
      var b3 = a2.currentSrc || a2.src;
      b3 && e2 !== b3 && (e2 = b3, j2.backgroundImage = "url(" + (p.test(b3) ? JSON.stringify(b3) : b3) + ")", d2 || (d2 = true, c.rC(h2, k2.loadingClass), c.aC(h2, k2.loadedClass)));
    }, m2 = function() {
      c.rAF(l2);
    };
    a2._lazysizesParentFit = b2.fit, a2.addEventListener("lazyloaded", m2, true), a2.addEventListener("load", m2, true), c.rAF(function() {
      var d3 = a2, e3 = a2.parentNode;
      "PICTURE" == e3.nodeName.toUpperCase() && (d3 = e3, e3 = e3.parentNode), g(d3), i || f(), h2 = a2.cloneNode(false), j2 = h2.style, h2.addEventListener("load", function() {
        var a3 = h2.currentSrc || h2.src;
        a3 && a3 != o && (h2.src = o, h2.srcset = "");
      }), c.rC(h2, k2.loadedClass), c.rC(h2, k2.lazyClass), c.rC(h2, k2.autosizesClass), c.aC(h2, k2.loadingClass), c.aC(h2, i), ["data-parent-fit", "data-parent-container", "data-object-fit-polyfilled", k2.srcsetAttr, k2.srcAttr].forEach(function(a3) {
        h2.removeAttribute(a3);
      }), h2.src = o, h2.srcset = "", j2.backgroundRepeat = "no-repeat", j2.backgroundPosition = b2.position, j2.backgroundSize = b2.fit, h2.setAttribute("data-position", d3.style.position), h2.setAttribute("data-visibility", d3.style.visibility), d3.style.visibility = "hidden", d3.style.position = "absolute", a2.setAttribute("data-parent-fit", b2.fit), a2.setAttribute("data-parent-container", "prev"), a2.setAttribute("data-object-fit-polyfilled", ""), a2._objectFitPolyfilledDisplay = h2, e3.insertBefore(h2, d3), a2._lazysizesParentFit && delete a2._lazysizesParentFit, a2.complete && l2();
    });
  }
  var i, j = b.createElement("a").style, k = "objectFit" in j, l = k && "objectPosition" in j, m = /object-fit["']*\s*:\s*["']*(contain|cover)/, n2 = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/, o = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", p = /\(|\)|'/, q = { center: "center", "50% 50%": "center" };
  if (!k || !l) {
    var r2 = function(a2) {
      if (a2.detail.instance == c) {
        var b2 = a2.target, d2 = e(b2);
        return !(!d2.fit || k && "center" == d2.position) && (h(b2, d2), true);
      }
    };
    a.addEventListener("lazybeforesizes", function(a2) {
      if (a2.detail.instance == c) {
        var b2 = a2.target;
        null == b2.getAttribute("data-object-fit-polyfilled") || b2._objectFitPolyfilledDisplay || r2(a2) || c.rAF(function() {
          b2.removeAttribute("data-object-fit-polyfilled");
        });
      }
    }), a.addEventListener("lazyunveilread", r2, true), d && d.detail && r2(d);
  }
});
;
!(function(a, b) {
  if (a) {
    var c = function() {
      b(a.lazySizes), a.removeEventListener("lazyunveilread", c, true);
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, true);
  }
})("undefined" != typeof window ? window : 0, function(a, b, c) {
  "use strict";
  if (a.addEventListener) {
    var d = /\s+(\d+)(w|h)\s+(\d+)(w|h)/, e = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/, f = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/, g = /^picture$/i, h = c.cfg, i = function(a2) {
      return getComputedStyle(a2, null) || {};
    }, j = { getParent: function(b2, c2) {
      var d2 = b2, e2 = b2.parentNode;
      return c2 && "prev" != c2 || !e2 || !g.test(e2.nodeName || "") || (e2 = e2.parentNode), "self" != c2 && (d2 = "prev" == c2 ? b2.previousElementSibling : c2 && (e2.closest || a.jQuery) ? (e2.closest ? e2.closest(c2) : jQuery(e2).closest(c2)[0]) || e2 : e2), d2;
    }, getFit: function(a2) {
      var b2, c2, d2 = i(a2), g2 = d2.content || d2.fontFamily, h2 = { fit: a2._lazysizesParentFit || a2.getAttribute("data-parent-fit") };
      return !h2.fit && g2 && (b2 = g2.match(e)) && (h2.fit = b2[1]), h2.fit ? (c2 = a2._lazysizesParentContainer || a2.getAttribute("data-parent-container"), !c2 && g2 && (b2 = g2.match(f)) && (c2 = b2[1]), h2.parent = j.getParent(a2, c2)) : h2.fit = d2.objectFit, h2;
    }, getImageRatio: function(b2) {
      var c2, e2, f2, i2, j2, k, l, m = b2.parentNode, n2 = m && g.test(m.nodeName || "") ? m.querySelectorAll("source, img") : [b2];
      for (c2 = 0; c2 < n2.length; c2++) if (b2 = n2[c2], e2 = b2.getAttribute(h.srcsetAttr) || b2.getAttribute("srcset") || b2.getAttribute("data-pfsrcset") || b2.getAttribute("data-risrcset") || "", f2 = b2._lsMedia || b2.getAttribute("media"), f2 = h.customMedia[b2.getAttribute("data-media") || f2] || f2, e2 && (!f2 || (a.matchMedia && matchMedia(f2) || {}).matches)) {
        i2 = parseFloat(b2.getAttribute("data-aspectratio")), i2 || (j2 = e2.match(d), j2 ? "w" == j2[2] ? (k = j2[1], l = j2[3]) : (k = j2[3], l = j2[1]) : (k = b2.getAttribute("width"), l = b2.getAttribute("height")), i2 = k / l);
        break;
      }
      return i2;
    }, calculateSize: function(a2, b2) {
      var c2, d2, e2, f2, g2 = this.getFit(a2), h2 = g2.fit, i2 = g2.parent;
      return "width" == h2 || ("contain" == h2 || "cover" == h2) && (e2 = this.getImageRatio(a2)) ? (i2 ? b2 = i2.clientWidth : i2 = a2, f2 = b2, "width" == h2 ? f2 = b2 : (d2 = i2.clientHeight, (c2 = b2 / d2) && ("cover" == h2 && c2 < e2 || "contain" == h2 && c2 > e2) && (f2 = b2 * (e2 / c2))), f2) : b2;
    } };
    c.parentFit = j, b.addEventListener("lazybeforesizes", function(a2) {
      if (!a2.defaultPrevented && a2.detail.instance == c) {
        var b2 = a2.target;
        a2.detail.width = j.calculateSize(b2, a2.detail.width);
      }
    });
  }
});
;
!(function(a, b) {
  if (a) {
    var c = function() {
      b(a.lazySizes), a.removeEventListener("lazyunveilread", c, true);
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, true);
  }
})("undefined" != typeof window ? window : 0, function(a, b, c) {
  "use strict";
  var d, e = c.cfg, f = b.createElement("img"), g = "sizes" in f && "srcset" in f, h = /\s+\d+h/g, i = (function() {
    var a2 = /\s+(\d+)(w|h)\s+(\d+)(w|h)/, d2 = Array.prototype.forEach;
    return function() {
      var f2 = b.createElement("img"), g2 = function(b2) {
        var c2, d3, f3 = b2.getAttribute(e.srcsetAttr);
        f3 && (d3 = f3.match(a2)) && (c2 = "w" == d3[2] ? d3[1] / d3[3] : d3[3] / d3[1], c2 && b2.setAttribute("data-aspectratio", c2), b2.setAttribute(e.srcsetAttr, f3.replace(h, "")));
      }, i2 = function(a3) {
        if (a3.detail.instance == c) {
          var b2 = a3.target.parentNode;
          b2 && "PICTURE" == b2.nodeName && d2.call(b2.getElementsByTagName("source"), g2), g2(a3.target);
        }
      }, j = function() {
        f2.currentSrc && b.removeEventListener("lazybeforeunveil", i2);
      };
      b.addEventListener("lazybeforeunveil", i2), f2.onload = j, f2.onerror = j, f2.srcset = "data:,a 1w 1h", f2.complete && j();
    };
  })();
  if (e.supportsType || (e.supportsType = function(a2) {
    return !a2;
  }), a.HTMLPictureElement && g) return void (!c.hasHDescriptorFix && b.msElementsFromPoint && (c.hasHDescriptorFix = true, i()));
  a.picturefill || e.pf || (e.pf = function(b2) {
    var c2, e2;
    if (!a.picturefill) for (c2 = 0, e2 = b2.elements.length; c2 < e2; c2++) d(b2.elements[c2]);
  }, d = (function() {
    var f2 = function(a2, b2) {
      return a2.w - b2.w;
    }, i2 = /^\s*\d+\.*\d*px\s*$/, j = function(a2) {
      var b2, c2, d2 = a2.length, e2 = a2[d2 - 1], f3 = 0;
      for (f3; f3 < d2; f3++) if (e2 = a2[f3], e2.d = e2.w / a2.w, e2.d >= a2.d) {
        !e2.cached && (b2 = a2[f3 - 1]) && b2.d > a2.d - 0.13 * Math.pow(a2.d, 2.2) && (c2 = Math.pow(b2.d - 0.6, 1.6), b2.cached && (b2.d += 0.15 * c2), b2.d + (e2.d - a2.d) * c2 > a2.d && (e2 = b2));
        break;
      }
      return e2;
    }, k = /* @__PURE__ */ (function() {
      var a2, b2 = /(([^,\s].[^\s]+)\s+(\d+)w)/g, c2 = /\s/, d2 = function(b3, c3, d3, e2) {
        a2.push({ c: c3, u: d3, w: 1 * e2 });
      };
      return function(e2) {
        return a2 = [], e2 = e2.trim(), e2.replace(h, "").replace(b2, d2), a2.length || !e2 || c2.test(e2) || a2.push({ c: e2, u: e2, w: 99 }), a2;
      };
    })(), l = function() {
      l.init || (l.init = true, addEventListener("resize", (function() {
        var a2, c2 = b.getElementsByClassName("lazymatchmedia"), e2 = function() {
          var a3, b2;
          for (a3 = 0, b2 = c2.length; a3 < b2; a3++) d(c2[a3]);
        };
        return function() {
          clearTimeout(a2), a2 = setTimeout(e2, 66);
        };
      })()));
    }, m = function(b2, d2) {
      var f3, g2 = b2.getAttribute("srcset") || b2.getAttribute(e.srcsetAttr);
      !g2 && d2 && (g2 = b2._lazypolyfill ? b2._lazypolyfill._set : b2.getAttribute(e.srcAttr) || b2.getAttribute("src")), b2._lazypolyfill && b2._lazypolyfill._set == g2 || (f3 = k(g2 || ""), d2 && b2.parentNode && (f3.isPicture = "PICTURE" == b2.parentNode.nodeName.toUpperCase(), f3.isPicture && a.matchMedia && (c.aC(b2, "lazymatchmedia"), l())), f3._set = g2, Object.defineProperty(b2, "_lazypolyfill", { value: f3, writable: true }));
    }, n2 = function(b2) {
      var d2 = a.devicePixelRatio || 1, e2 = c.getX && c.getX(b2);
      return Math.min(e2 || d2, 2.5, d2);
    }, o = function(b2) {
      return a.matchMedia ? (o = function(a2) {
        return !a2 || (matchMedia(a2) || {}).matches;
      })(b2) : !b2;
    }, p = function(a2) {
      var b2, d2, g2, h2, k2, l2, p2;
      if (h2 = a2, m(h2, true), k2 = h2._lazypolyfill, k2.isPicture) {
        for (d2 = 0, b2 = a2.parentNode.getElementsByTagName("source"), g2 = b2.length; d2 < g2; d2++) if (e.supportsType(b2[d2].getAttribute("type"), a2) && o(b2[d2].getAttribute("media"))) {
          h2 = b2[d2], m(h2), k2 = h2._lazypolyfill;
          break;
        }
      }
      return k2.length > 1 ? (p2 = h2.getAttribute("sizes") || "", p2 = i2.test(p2) && parseInt(p2, 10) || c.gW(a2, a2.parentNode), k2.d = n2(a2), !k2.src || !k2.w || k2.w < p2 ? (k2.w = p2, l2 = j(k2.sort(f2)), k2.src = l2) : l2 = k2.src) : l2 = k2[0], l2;
    }, q = function(a2) {
      if (!g || !a2.parentNode || "PICTURE" == a2.parentNode.nodeName.toUpperCase()) {
        var b2 = p(a2);
        b2 && b2.u && a2._lazypolyfill.cur != b2.u && (a2._lazypolyfill.cur = b2.u, b2.cached = true, a2.setAttribute(e.srcAttr, b2.u), a2.setAttribute("src", b2.u));
      }
    };
    return q.parse = k, q;
  })(), e.loadedClass && e.loadingClass && (function() {
    var a2 = [];
    ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(b2) {
      a2.push(b2 + e.loadedClass), a2.push(b2 + e.loadingClass);
    }), e.pf({ elements: b.querySelectorAll(a2.join(", ")) });
  })());
});
;
!(function(a, b) {
  var c = function() {
    b(a.lazySizes), a.removeEventListener("lazyunveilread", c, true);
  };
  b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, true);
})(window, function(a, b, c) {
  "use strict";
  function d(a2, c2) {
    if (!g[a2]) {
      var d2 = b.createElement(c2 ? "link" : "script"), e2 = b.getElementsByTagName("script")[0];
      c2 ? (d2.rel = "stylesheet", d2.href = a2) : d2.src = a2, g[a2] = true, g[d2.src || d2.href] = true, e2.parentNode.insertBefore(d2, e2);
    }
  }
  var e, f, g = {};
  b.addEventListener && (f = /\(|\)|\s|'/, e = function(a2, c2) {
    var d2 = b.createElement("img");
    d2.onload = function() {
      d2.onload = null, d2.onerror = null, d2 = null, c2();
    }, d2.onerror = d2.onload, d2.src = a2, d2 && d2.complete && d2.onload && d2.onload();
  }, addEventListener("lazybeforeunveil", function(a2) {
    if (a2.detail.instance == c) {
      var b2, g2, h, i;
      if (!a2.defaultPrevented) {
        var j = a2.target;
        if ("none" == j.preload && (j.preload = j.getAttribute("data-preload") || "auto"), null != j.getAttribute("data-autoplay")) if (j.getAttribute("data-expand") && !j.autoplay) try {
          j.play();
        } catch (a3) {
        }
        else requestAnimationFrame(function() {
          j.setAttribute("data-expand", "-10"), c.aC(j, c.cfg.lazyClass);
        });
        b2 = j.getAttribute("data-link"), b2 && d(b2, true), b2 = j.getAttribute("data-script"), b2 && d(b2), b2 = j.getAttribute("data-require"), b2 && (c.cfg.requireJs ? c.cfg.requireJs([b2]) : d(b2)), h = j.getAttribute("data-bg"), h && (a2.detail.firesLoad = true, g2 = function() {
          j.style.backgroundImage = "url(" + (f.test(h) ? JSON.stringify(h) : h) + ")", a2.detail.firesLoad = false, c.fire(j, "_lazyloaded", {}, true, true);
        }, e(h, g2)), i = j.getAttribute("data-poster"), i && (a2.detail.firesLoad = true, g2 = function() {
          j.poster = i, a2.detail.firesLoad = false, c.fire(j, "_lazyloaded", {}, true, true);
        }, e(i, g2));
      }
    }
  }, false));
});
;
!(function(t2, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t2 = "undefined" != typeof globalThis ? globalThis : t2 || self).noUiSlider = {});
})(this, function(ut) {
  "use strict";
  function n2(t3) {
    return "object" == typeof t3 && "function" == typeof t3.to;
  }
  function ct(t3) {
    t3.parentElement.removeChild(t3);
  }
  function pt(t3) {
    return null != t3;
  }
  function ft(t3) {
    t3.preventDefault();
  }
  function i(t3) {
    return "number" == typeof t3 && !isNaN(t3) && isFinite(t3);
  }
  function dt(t3, e2, r3) {
    0 < r3 && (gt(t3, e2), setTimeout(function() {
      vt(t3, e2);
    }, r3));
  }
  function ht(t3) {
    return Math.max(Math.min(t3, 100), 0);
  }
  function mt(t3) {
    return Array.isArray(t3) ? t3 : [t3];
  }
  function e(t3) {
    t3 = (t3 = String(t3)).split(".");
    return 1 < t3.length ? t3[1].length : 0;
  }
  function gt(t3, e2) {
    t3.classList && !/\s/.test(e2) ? t3.classList.add(e2) : t3.className += " " + e2;
  }
  function vt(t3, e2) {
    t3.classList && !/\s/.test(e2) ? t3.classList.remove(e2) : t3.className = t3.className.replace(new RegExp("(^|\\b)" + e2.split(" ").join("|") + "(\\b|$)", "gi"), " ");
  }
  function bt(t3) {
    var e2 = void 0 !== window.pageXOffset, r3 = "CSS1Compat" === (t3.compatMode || "");
    return { x: e2 ? window.pageXOffset : (r3 ? t3.documentElement : t3.body).scrollLeft, y: e2 ? window.pageYOffset : (r3 ? t3.documentElement : t3.body).scrollTop };
  }
  function s(t3, e2) {
    return 100 / (e2 - t3);
  }
  function a(t3, e2, r3) {
    return 100 * e2 / (t3[r3 + 1] - t3[r3]);
  }
  function l(t3, e2) {
    for (var r3 = 1; t3 >= e2[r3]; ) r3 += 1;
    return r3;
  }
  function r2(t3, e2, r3) {
    if (r3 >= t3.slice(-1)[0]) return 100;
    var n3 = l(r3, t3), i2 = t3[n3 - 1], o2 = t3[n3], t3 = e2[n3 - 1], n3 = e2[n3];
    return t3 + (r3 = r3, a(o2 = [i2, o2], o2[0] < 0 ? r3 + Math.abs(o2[0]) : r3 - o2[0], 0) / s(t3, n3));
  }
  function o(t3, e2, r3, n3) {
    if (100 === n3) return n3;
    var i2 = l(n3, t3), o2 = t3[i2 - 1], s2 = t3[i2];
    return r3 ? (s2 - o2) / 2 < n3 - o2 ? s2 : o2 : e2[i2 - 1] ? t3[i2 - 1] + (t3 = n3 - t3[i2 - 1], i2 = e2[i2 - 1], Math.round(t3 / i2) * i2) : n3;
  }
  ut.PipsMode = void 0, (z = ut.PipsMode || (ut.PipsMode = {})).Range = "range", z.Steps = "steps", z.Positions = "positions", z.Count = "count", z.Values = "values", ut.PipsType = void 0, (z = ut.PipsType || (ut.PipsType = {}))[z.None = -1] = "None", z[z.NoValue = 0] = "NoValue", z[z.LargeValue = 1] = "LargeValue", z[z.SmallValue = 2] = "SmallValue";
  var u = (t2.prototype.getDistance = function(t3) {
    for (var e2 = [], r3 = 0; r3 < this.xNumSteps.length - 1; r3++) e2[r3] = a(this.xVal, t3, r3);
    return e2;
  }, t2.prototype.getAbsoluteDistance = function(t3, e2, r3) {
    var n3 = 0;
    if (t3 < this.xPct[this.xPct.length - 1]) for (; t3 > this.xPct[n3 + 1]; ) n3++;
    else t3 === this.xPct[this.xPct.length - 1] && (n3 = this.xPct.length - 2);
    r3 || t3 !== this.xPct[n3 + 1] || n3++;
    for (var i2, o2 = 1, s2 = (e2 = null === e2 ? [] : e2)[n3], a2 = 0, l2 = 0, u2 = 0, c2 = r3 ? (t3 - this.xPct[n3]) / (this.xPct[n3 + 1] - this.xPct[n3]) : (this.xPct[n3 + 1] - t3) / (this.xPct[n3 + 1] - this.xPct[n3]); 0 < s2; ) i2 = this.xPct[n3 + 1 + u2] - this.xPct[n3 + u2], 100 < e2[n3 + u2] * o2 + 100 - 100 * c2 ? (a2 = i2 * c2, o2 = (s2 - 100 * c2) / e2[n3 + u2], c2 = 1) : (a2 = e2[n3 + u2] * i2 / 100 * o2, o2 = 0), r3 ? (l2 -= a2, 1 <= this.xPct.length + u2 && u2--) : (l2 += a2, 1 <= this.xPct.length - u2 && u2++), s2 = e2[n3 + u2] * o2;
    return t3 + l2;
  }, t2.prototype.toStepping = function(t3) {
    return t3 = r2(this.xVal, this.xPct, t3);
  }, t2.prototype.fromStepping = function(t3) {
    return (function(t4, e2, r3) {
      if (100 <= r3) return t4.slice(-1)[0];
      var n3 = l(r3, e2), i2 = t4[n3 - 1], o2 = t4[n3], t4 = e2[n3 - 1], n3 = e2[n3];
      return (r3 - t4) * s(t4, n3) * ((o2 = [i2, o2])[1] - o2[0]) / 100 + o2[0];
    })(this.xVal, this.xPct, t3);
  }, t2.prototype.getStep = function(t3) {
    return t3 = o(this.xPct, this.xSteps, this.snap, t3);
  }, t2.prototype.getDefaultStep = function(t3, e2, r3) {
    var n3 = l(t3, this.xPct);
    return (100 === t3 || e2 && t3 === this.xPct[n3 - 1]) && (n3 = Math.max(n3 - 1, 1)), (this.xVal[n3] - this.xVal[n3 - 1]) / r3;
  }, t2.prototype.getNearbySteps = function(t3) {
    t3 = l(t3, this.xPct);
    return { stepBefore: { startValue: this.xVal[t3 - 2], step: this.xNumSteps[t3 - 2], highestStep: this.xHighestCompleteStep[t3 - 2] }, thisStep: { startValue: this.xVal[t3 - 1], step: this.xNumSteps[t3 - 1], highestStep: this.xHighestCompleteStep[t3 - 1] }, stepAfter: { startValue: this.xVal[t3], step: this.xNumSteps[t3], highestStep: this.xHighestCompleteStep[t3] } };
  }, t2.prototype.countStepDecimals = function() {
    var t3 = this.xNumSteps.map(e);
    return Math.max.apply(null, t3);
  }, t2.prototype.hasNoSize = function() {
    return this.xVal[0] === this.xVal[this.xVal.length - 1];
  }, t2.prototype.convert = function(t3) {
    return this.getStep(this.toStepping(t3));
  }, t2.prototype.handleEntryPoint = function(t3, e2) {
    t3 = "min" === t3 ? 0 : "max" === t3 ? 100 : parseFloat(t3);
    if (!i(t3) || !i(e2[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
    this.xPct.push(t3), this.xVal.push(e2[0]);
    e2 = Number(e2[1]);
    t3 ? this.xSteps.push(!isNaN(e2) && e2) : isNaN(e2) || (this.xSteps[0] = e2), this.xHighestCompleteStep.push(0);
  }, t2.prototype.handleStepPoint = function(t3, e2) {
    e2 && (this.xVal[t3] !== this.xVal[t3 + 1] ? (this.xSteps[t3] = a([this.xVal[t3], this.xVal[t3 + 1]], e2, 0) / s(this.xPct[t3], this.xPct[t3 + 1]), e2 = (this.xVal[t3 + 1] - this.xVal[t3]) / this.xNumSteps[t3], e2 = Math.ceil(Number(e2.toFixed(3)) - 1), e2 = this.xVal[t3] + this.xNumSteps[t3] * e2, this.xHighestCompleteStep[t3] = e2) : this.xSteps[t3] = this.xHighestCompleteStep[t3] = this.xVal[t3]);
  }, t2);
  function t2(e2, t3, r3) {
    var n3;
    this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [r3 || false], this.xNumSteps = [false], this.snap = t3;
    var i2 = [];
    for (Object.keys(e2).forEach(function(t4) {
      i2.push([mt(e2[t4]), t4]);
    }), i2.sort(function(t4, e3) {
      return t4[0][0] - e3[0][0];
    }), n3 = 0; n3 < i2.length; n3++) this.handleEntryPoint(i2[n3][1], i2[n3][0]);
    for (this.xNumSteps = this.xSteps.slice(0), n3 = 0; n3 < this.xNumSteps.length; n3++) this.handleStepPoint(n3, this.xNumSteps[n3]);
  }
  var c = { to: function(t3) {
    return void 0 === t3 ? "" : t3.toFixed(2);
  }, from: Number }, p = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, St = { tooltips: ".__tooltips", aria: ".__aria" };
  function f(t3, e2) {
    if (!i(e2)) throw new Error("noUiSlider: 'step' is not numeric.");
    t3.singleStep = e2;
  }
  function d(t3, e2) {
    if (!i(e2)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
    t3.keyboardPageMultiplier = e2;
  }
  function h(t3, e2) {
    if (!i(e2)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
    t3.keyboardMultiplier = e2;
  }
  function m(t3, e2) {
    if (!i(e2)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
    t3.keyboardDefaultStep = e2;
  }
  function g(t3, e2) {
    if ("object" != typeof e2 || Array.isArray(e2)) throw new Error("noUiSlider: 'range' is not an object.");
    if (void 0 === e2.min || void 0 === e2.max) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
    t3.spectrum = new u(e2, t3.snap || false, t3.singleStep);
  }
  function v(t3, e2) {
    if (e2 = mt(e2), !Array.isArray(e2) || !e2.length) throw new Error("noUiSlider: 'start' option is incorrect.");
    t3.handles = e2.length, t3.start = e2;
  }
  function b(t3, e2) {
    if ("boolean" != typeof e2) throw new Error("noUiSlider: 'snap' option must be a boolean.");
    t3.snap = e2;
  }
  function S(t3, e2) {
    if ("boolean" != typeof e2) throw new Error("noUiSlider: 'animate' option must be a boolean.");
    t3.animate = e2;
  }
  function x(t3, e2) {
    if ("number" != typeof e2) throw new Error("noUiSlider: 'animationDuration' option must be a number.");
    t3.animationDuration = e2;
  }
  function xt(t3, e2) {
    var r3, n3 = [false];
    if ("lower" === e2 ? e2 = [true, false] : "upper" === e2 && (e2 = [false, true]), true === e2 || false === e2) {
      for (r3 = 1; r3 < t3.handles; r3++) n3.push(e2);
      n3.push(false);
    } else {
      if (!Array.isArray(e2) || !e2.length || e2.length !== t3.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
      n3 = e2;
    }
    t3.connect = n3;
  }
  function y(t3, e2) {
    switch (e2) {
      case "horizontal":
        t3.ort = 0;
        break;
      case "vertical":
        t3.ort = 1;
        break;
      default:
        throw new Error("noUiSlider: 'orientation' option is invalid.");
    }
  }
  function w(t3, e2) {
    if (!i(e2)) throw new Error("noUiSlider: 'margin' option must be numeric.");
    0 !== e2 && (t3.margin = t3.spectrum.getDistance(e2));
  }
  function E(t3, e2) {
    if (!i(e2)) throw new Error("noUiSlider: 'limit' option must be numeric.");
    if (t3.limit = t3.spectrum.getDistance(e2), !t3.limit || t3.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
  }
  function P(t3, e2) {
    var r3;
    if (!i(e2) && !Array.isArray(e2)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (Array.isArray(e2) && 2 !== e2.length && !i(e2[0]) && !i(e2[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (0 !== e2) {
      for (Array.isArray(e2) || (e2 = [e2, e2]), t3.padding = [t3.spectrum.getDistance(e2[0]), t3.spectrum.getDistance(e2[1])], r3 = 0; r3 < t3.spectrum.xNumSteps.length - 1; r3++) if (t3.padding[0][r3] < 0 || t3.padding[1][r3] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
      var n3 = e2[0] + e2[1], e2 = t3.spectrum.xVal[0];
      if (1 < n3 / (t3.spectrum.xVal[t3.spectrum.xVal.length - 1] - e2)) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
    }
  }
  function C(t3, e2) {
    switch (e2) {
      case "ltr":
        t3.dir = 0;
        break;
      case "rtl":
        t3.dir = 1;
        break;
      default:
        throw new Error("noUiSlider: 'direction' option was not recognized.");
    }
  }
  function N(t3, e2) {
    if ("string" != typeof e2) throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
    var r3 = 0 <= e2.indexOf("tap"), n3 = 0 <= e2.indexOf("drag"), i2 = 0 <= e2.indexOf("fixed"), o2 = 0 <= e2.indexOf("snap"), s2 = 0 <= e2.indexOf("hover"), a2 = 0 <= e2.indexOf("unconstrained"), l2 = 0 <= e2.indexOf("invert-connects"), u2 = 0 <= e2.indexOf("drag-all"), e2 = 0 <= e2.indexOf("smooth-steps");
    if (i2) {
      if (2 !== t3.handles) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
      w(t3, t3.start[1] - t3.start[0]);
    }
    if (l2 && 2 !== t3.handles) throw new Error("noUiSlider: 'invert-connects' behaviour must be used with 2 handles");
    if (a2 && (t3.margin || t3.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
    t3.events = { tap: r3 || o2, drag: n3, dragAll: u2, smoothSteps: e2, fixed: i2, snap: o2, hover: s2, unconstrained: a2, invertConnects: l2 };
  }
  function V(t3, e2) {
    if (false !== e2) if (true === e2 || n2(e2)) {
      t3.tooltips = [];
      for (var r3 = 0; r3 < t3.handles; r3++) t3.tooltips.push(e2);
    } else {
      if ((e2 = mt(e2)).length !== t3.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
      e2.forEach(function(t4) {
        if ("boolean" != typeof t4 && !n2(t4)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
      }), t3.tooltips = e2;
    }
  }
  function A(t3, e2) {
    if (e2.length !== t3.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
    t3.handleAttributes = e2;
  }
  function k(t3, e2) {
    if (!n2(e2)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
    t3.ariaFormat = e2;
  }
  function M(t3, e2) {
    if (!n2(r3 = e2) || "function" != typeof r3.from) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
    var r3;
    t3.format = e2;
  }
  function U(t3, e2) {
    if ("boolean" != typeof e2) throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
    t3.keyboardSupport = e2;
  }
  function D(t3, e2) {
    t3.documentElement = e2;
  }
  function O(t3, e2) {
    if ("string" != typeof e2 && false !== e2) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
    t3.cssPrefix = e2;
  }
  function L(e2, r3) {
    if ("object" != typeof r3) throw new Error("noUiSlider: 'cssClasses' must be an object.");
    "string" == typeof e2.cssPrefix ? (e2.cssClasses = {}, Object.keys(r3).forEach(function(t3) {
      e2.cssClasses[t3] = e2.cssPrefix + r3[t3];
    })) : e2.cssClasses = r3;
  }
  function yt(e2) {
    var r3 = { margin: null, limit: null, padding: null, animate: true, animationDuration: 300, ariaFormat: c, format: c }, n3 = { step: { r: false, t: f }, keyboardPageMultiplier: { r: false, t: d }, keyboardMultiplier: { r: false, t: h }, keyboardDefaultStep: { r: false, t: m }, start: { r: true, t: v }, connect: { r: true, t: xt }, direction: { r: true, t: C }, snap: { r: false, t: b }, animate: { r: false, t: S }, animationDuration: { r: false, t: x }, range: { r: true, t: g }, orientation: { r: false, t: y }, margin: { r: false, t: w }, limit: { r: false, t: E }, padding: { r: false, t: P }, behaviour: { r: true, t: N }, ariaFormat: { r: false, t: k }, format: { r: false, t: M }, tooltips: { r: false, t: V }, keyboardSupport: { r: true, t: U }, documentElement: { r: false, t: D }, cssPrefix: { r: true, t: O }, cssClasses: { r: true, t: L }, handleAttributes: { r: false, t: A } }, i2 = { connect: false, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: true, cssPrefix: "noUi-", cssClasses: p, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
    e2.format && !e2.ariaFormat && (e2.ariaFormat = e2.format), Object.keys(n3).forEach(function(t4) {
      if (pt(e2[t4]) || void 0 !== i2[t4]) n3[t4].t(r3, (pt(e2[t4]) ? e2 : i2)[t4]);
      else if (n3[t4].r) throw new Error("noUiSlider: '" + t4 + "' is required.");
    }), r3.pips = e2.pips;
    var t3 = document.createElement("div"), o2 = void 0 !== t3.style.msTransform, t3 = void 0 !== t3.style.transform;
    r3.transformRule = t3 ? "transform" : o2 ? "msTransform" : "webkitTransform";
    return r3.style = [["left", "top"], ["right", "bottom"]][r3.dir][r3.ort], r3;
  }
  function T(t3, f2, o2) {
    var i2, n3, l2, u2, s2, a2, c2 = window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" }, p2 = window.CSS && CSS.supports && CSS.supports("touch-action", "none") && (function() {
      var t4 = false;
      try {
        var e3 = Object.defineProperty({}, "passive", { get: function() {
          t4 = true;
        } });
        window.addEventListener("test", null, e3);
      } catch (t5) {
      }
      return t4;
    })(), d2 = t3, S2 = f2.spectrum, h2 = [], m2 = [], g2 = [], v2 = 0, b2 = {}, x2 = false, y2 = t3.ownerDocument, w2 = f2.documentElement || y2.documentElement, E2 = y2.body, r3 = "rtl" === y2.dir || 1 === f2.ort ? 0 : 100;
    function P2(t4, e3) {
      var r4 = y2.createElement("div");
      return e3 && gt(r4, e3), t4.appendChild(r4), r4;
    }
    function C2(t4, e3) {
      var r4, t4 = P2(t4, f2.cssClasses.origin), n4 = P2(t4, f2.cssClasses.handle);
      return P2(n4, f2.cssClasses.touchArea), n4.setAttribute("data-handle", String(e3)), f2.keyboardSupport && (n4.setAttribute("tabindex", "0"), n4.addEventListener("keydown", function(t5) {
        return (function(t6, e4) {
          if (V2() || A2(e4)) return false;
          var r5 = ["Left", "Right"], n5 = ["Down", "Up"], i3 = ["PageDown", "PageUp"], o3 = ["Home", "End"];
          f2.dir && !f2.ort ? r5.reverse() : f2.ort && !f2.dir && (n5.reverse(), i3.reverse());
          var s3 = t6.key.replace("Arrow", ""), a3 = s3 === i3[0], l3 = s3 === i3[1], i3 = s3 === n5[0] || s3 === r5[0] || a3, n5 = s3 === n5[1] || s3 === r5[1] || l3, r5 = s3 === o3[0], o3 = s3 === o3[1];
          if (!(i3 || n5 || r5 || o3)) return true;
          if (t6.preventDefault(), n5 || i3) {
            var u3 = i3 ? 0 : 1, u3 = st(e4)[u3];
            if (null === u3) return false;
            false === u3 && (u3 = S2.getDefaultStep(m2[e4], i3, f2.keyboardDefaultStep)), u3 *= l3 || a3 ? f2.keyboardPageMultiplier : f2.keyboardMultiplier, u3 = Math.max(u3, 1e-7), u3 *= i3 ? -1 : 1, u3 = h2[e4] + u3;
          } else u3 = o3 ? f2.spectrum.xVal[f2.spectrum.xVal.length - 1] : f2.spectrum.xVal[0];
          return et(e4, S2.toStepping(u3), true, true), $("slide", e4), $("update", e4), $("change", e4), $("set", e4), false;
        })(t5, e3);
      })), void 0 !== f2.handleAttributes && (r4 = f2.handleAttributes[e3], Object.keys(r4).forEach(function(t5) {
        n4.setAttribute(t5, r4[t5]);
      })), n4.setAttribute("role", "slider"), n4.setAttribute("aria-orientation", f2.ort ? "vertical" : "horizontal"), 0 === e3 ? gt(n4, f2.cssClasses.handleLower) : e3 === f2.handles - 1 && gt(n4, f2.cssClasses.handleUpper), t4.handle = n4, t4;
    }
    function N2(t4, e3) {
      return !!e3 && P2(t4, f2.cssClasses.connect);
    }
    function e2(t4, e3) {
      return !(!f2.tooltips || !f2.tooltips[e3]) && P2(t4.firstChild, f2.cssClasses.tooltip);
    }
    function V2() {
      return d2.hasAttribute("disabled");
    }
    function A2(t4) {
      return l2[t4].hasAttribute("disabled");
    }
    function k2() {
      a2 && (W("update" + St.tooltips), a2.forEach(function(t4) {
        t4 && ct(t4);
      }), a2 = null);
    }
    function M2() {
      k2(), a2 = l2.map(e2), I("update" + St.tooltips, function(t4, e3, r4) {
        a2 && f2.tooltips && false !== a2[e3] && (t4 = t4[e3], true !== f2.tooltips[e3] && (t4 = f2.tooltips[e3].to(r4[e3])), a2[e3].innerHTML = t4);
      });
    }
    function U2(t4, e3) {
      return t4.map(function(t5) {
        return S2.fromStepping(e3 ? S2.getStep(t5) : t5);
      });
    }
    function D2(d3) {
      var h3 = (function(t5) {
        if (t5.mode === ut.PipsMode.Range || t5.mode === ut.PipsMode.Steps) return S2.xVal;
        if (t5.mode !== ut.PipsMode.Count) return t5.mode === ut.PipsMode.Positions ? U2(t5.values, t5.stepped) : t5.mode === ut.PipsMode.Values ? t5.stepped ? t5.values.map(function(t6) {
          return S2.fromStepping(S2.getStep(S2.toStepping(t6)));
        }) : t5.values : [];
        if (t5.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
        for (var e4 = t5.values - 1, r4 = 100 / e4, n4 = []; e4--; ) n4[e4] = e4 * r4;
        return n4.push(100), U2(n4, t5.stepped);
      })(d3), m3 = {}, t4 = S2.xVal[0], e3 = S2.xVal[S2.xVal.length - 1], g3 = false, v3 = false, b3 = 0;
      return (h3 = h3.slice().sort(function(t5, e4) {
        return t5 - e4;
      }).filter(function(t5) {
        return !this[t5] && (this[t5] = true);
      }, {}))[0] !== t4 && (h3.unshift(t4), g3 = true), h3[h3.length - 1] !== e3 && (h3.push(e3), v3 = true), h3.forEach(function(t5, e4) {
        var r4, n4, i3, o3, s3, a3, l3, u3, t5 = t5, c3 = h3[e4 + 1], p3 = d3.mode === ut.PipsMode.Steps, f3 = (f3 = p3 ? S2.xNumSteps[e4] : f3) || c3 - t5;
        for (void 0 === c3 && (c3 = t5), f3 = Math.max(f3, 1e-7), r4 = t5; r4 <= c3; r4 = Number((r4 + f3).toFixed(7))) {
          for (a3 = (o3 = (i3 = S2.toStepping(r4)) - b3) / (d3.density || 1), u3 = o3 / (l3 = Math.round(a3)), n4 = 1; n4 <= l3; n4 += 1) m3[(s3 = b3 + n4 * u3).toFixed(5)] = [S2.fromStepping(s3), 0];
          a3 = -1 < h3.indexOf(r4) ? ut.PipsType.LargeValue : p3 ? ut.PipsType.SmallValue : ut.PipsType.NoValue, !e4 && g3 && r4 !== c3 && (a3 = 0), r4 === c3 && v3 || (m3[i3.toFixed(5)] = [r4, a3]), b3 = i3;
        }
      }), m3;
    }
    function O2(i3, o3, s3) {
      var t4, a3 = y2.createElement("div"), n4 = ((t4 = {})[ut.PipsType.None] = "", t4[ut.PipsType.NoValue] = f2.cssClasses.valueNormal, t4[ut.PipsType.LargeValue] = f2.cssClasses.valueLarge, t4[ut.PipsType.SmallValue] = f2.cssClasses.valueSub, t4), l3 = ((t4 = {})[ut.PipsType.None] = "", t4[ut.PipsType.NoValue] = f2.cssClasses.markerNormal, t4[ut.PipsType.LargeValue] = f2.cssClasses.markerLarge, t4[ut.PipsType.SmallValue] = f2.cssClasses.markerSub, t4), u3 = [f2.cssClasses.valueHorizontal, f2.cssClasses.valueVertical], c3 = [f2.cssClasses.markerHorizontal, f2.cssClasses.markerVertical];
      function p3(t5, e3) {
        var r4 = e3 === f2.cssClasses.value;
        return e3 + " " + (r4 ? u3 : c3)[f2.ort] + " " + (r4 ? n4 : l3)[t5];
      }
      return gt(a3, f2.cssClasses.pips), gt(a3, 0 === f2.ort ? f2.cssClasses.pipsHorizontal : f2.cssClasses.pipsVertical), Object.keys(i3).forEach(function(t5) {
        var e3, r4, n5;
        r4 = i3[e3 = t5][0], n5 = i3[t5][1], (n5 = o3 ? o3(r4, n5) : n5) !== ut.PipsType.None && ((t5 = P2(a3, false)).className = p3(n5, f2.cssClasses.marker), t5.style[f2.style] = e3 + "%", n5 > ut.PipsType.NoValue && ((t5 = P2(a3, false)).className = p3(n5, f2.cssClasses.value), t5.setAttribute("data-value", String(r4)), t5.style[f2.style] = e3 + "%", t5.innerHTML = String(s3.to(r4))));
      }), a3;
    }
    function L2() {
      s2 && (ct(s2), s2 = null);
    }
    function T2(t4) {
      L2();
      var e3 = D2(t4), r4 = t4.filter, t4 = t4.format || { to: function(t5) {
        return String(Math.round(t5));
      } };
      return s2 = d2.appendChild(O2(e3, r4, t4));
    }
    function j2() {
      var t4 = i2.getBoundingClientRect(), e3 = "offset" + ["Width", "Height"][f2.ort];
      return 0 === f2.ort ? t4.width || i2[e3] : t4.height || i2[e3];
    }
    function z2(n4, i3, o3, s3) {
      function e3(t4) {
        var e4, r5 = (function(e5, t5, r6) {
          var n5 = 0 === e5.type.indexOf("touch"), i4 = 0 === e5.type.indexOf("mouse"), o4 = 0 === e5.type.indexOf("pointer"), s4 = 0, a3 = 0;
          0 === e5.type.indexOf("MSPointer") && (o4 = true);
          if ("mousedown" === e5.type && !e5.buttons && !e5.touches) return false;
          if (n5) {
            var l3 = function(t6) {
              t6 = t6.target;
              return t6 === r6 || r6.contains(t6) || e5.composed && e5.composedPath().shift() === r6;
            };
            if ("touchstart" === e5.type) {
              n5 = Array.prototype.filter.call(e5.touches, l3);
              if (1 < n5.length) return false;
              s4 = n5[0].pageX, a3 = n5[0].pageY;
            } else {
              l3 = Array.prototype.find.call(e5.changedTouches, l3);
              if (!l3) return false;
              s4 = l3.pageX, a3 = l3.pageY;
            }
          }
          t5 = t5 || bt(y2), (i4 || o4) && (s4 = e5.clientX + t5.x, a3 = e5.clientY + t5.y);
          return e5.pageOffset = t5, e5.points = [s4, a3], e5.cursor = i4 || o4, e5;
        })(t4, s3.pageOffset, s3.target || i3);
        return !!r5 && (!(V2() && !s3.doNotReject) && (e4 = d2, t4 = f2.cssClasses.tap, !((e4.classList ? e4.classList.contains(t4) : new RegExp("\\b" + t4 + "\\b").test(e4.className)) && !s3.doNotReject) && (!(n4 === c2.start && void 0 !== r5.buttons && 1 < r5.buttons) && ((!s3.hover || !r5.buttons) && (p2 || r5.preventDefault(), r5.calcPoint = r5.points[f2.ort], void o3(r5, s3))))));
      }
      var r4 = [];
      return n4.split(" ").forEach(function(t4) {
        i3.addEventListener(t4, e3, !!p2 && { passive: true }), r4.push([t4, e3]);
      }), r4;
    }
    function H(t4) {
      var e3, r4, n4 = ht(n4 = 100 * (t4 - (n4 = i2, e3 = f2.ort, r4 = n4.getBoundingClientRect(), n4 = (t4 = n4.ownerDocument).documentElement, t4 = bt(t4), /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (t4.x = 0), e3 ? r4.top + t4.y - n4.clientTop : r4.left + t4.x - n4.clientLeft)) / j2());
      return f2.dir ? 100 - n4 : n4;
    }
    function F(t4, e3) {
      "mouseout" === t4.type && "HTML" === t4.target.nodeName && null === t4.relatedTarget && _(t4, e3);
    }
    function R(t4, e3) {
      if (-1 === navigator.appVersion.indexOf("MSIE 9") && 0 === t4.buttons && 0 !== e3.buttonsProperty) return _(t4, e3);
      t4 = (f2.dir ? -1 : 1) * (t4.calcPoint - e3.startCalcPoint);
      K(0 < t4, 100 * t4 / e3.baseSize, e3.locations, e3.handleNumbers, e3.connect);
    }
    function _(t4, e3) {
      e3.handle && (vt(e3.handle, f2.cssClasses.active), --v2), e3.listeners.forEach(function(t5) {
        w2.removeEventListener(t5[0], t5[1]);
      }), 0 === v2 && (vt(d2, f2.cssClasses.drag), tt(), t4.cursor && (E2.style.cursor = "", E2.removeEventListener("selectstart", ft))), f2.events.smoothSteps && (e3.handleNumbers.forEach(function(t5) {
        et(t5, m2[t5], true, true, false, false);
      }), e3.handleNumbers.forEach(function(t5) {
        $("update", t5);
      })), e3.handleNumbers.forEach(function(t5) {
        $("change", t5), $("set", t5), $("end", t5);
      });
    }
    function B(t4, e3) {
      var r4, n4, i3, o3;
      e3.handleNumbers.some(A2) || (1 === e3.handleNumbers.length && (o3 = l2[e3.handleNumbers[0]].children[0], v2 += 1, gt(o3, f2.cssClasses.active)), t4.stopPropagation(), n4 = z2(c2.move, w2, R, { target: t4.target, handle: o3, connect: e3.connect, listeners: r4 = [], startCalcPoint: t4.calcPoint, baseSize: j2(), pageOffset: t4.pageOffset, handleNumbers: e3.handleNumbers, buttonsProperty: t4.buttons, locations: m2.slice() }), i3 = z2(c2.end, w2, _, { target: t4.target, handle: o3, listeners: r4, doNotReject: true, handleNumbers: e3.handleNumbers }), o3 = z2("mouseout", w2, F, { target: t4.target, handle: o3, listeners: r4, doNotReject: true, handleNumbers: e3.handleNumbers }), r4.push.apply(r4, n4.concat(i3, o3)), t4.cursor && (E2.style.cursor = getComputedStyle(t4.target).cursor, 1 < l2.length && gt(d2, f2.cssClasses.drag), E2.addEventListener("selectstart", ft, false)), e3.handleNumbers.forEach(function(t5) {
        $("start", t5);
      }));
    }
    function q(t4) {
      t4.stopPropagation();
      var i3, o3, s3, e3 = H(t4.calcPoint), r4 = (i3 = e3, s3 = !(o3 = 100), l2.forEach(function(t5, e4) {
        var r5, n4;
        A2(e4) || (r5 = m2[e4], ((n4 = Math.abs(r5 - i3)) < o3 || n4 <= o3 && r5 < i3 || 100 === n4 && 100 === o3) && (s3 = e4, o3 = n4));
      }), s3);
      false !== r4 && (f2.events.snap || dt(d2, f2.cssClasses.tap, f2.animationDuration), et(r4, e3, true, true), tt(), $("slide", r4, true), $("update", r4, true), f2.events.snap ? B(t4, { handleNumbers: [r4] }) : ($("change", r4, true), $("set", r4, true)));
    }
    function X(t4) {
      var t4 = H(t4.calcPoint), t4 = S2.getStep(t4), e3 = S2.fromStepping(t4);
      Object.keys(b2).forEach(function(t5) {
        "hover" === t5.split(".")[0] && b2[t5].forEach(function(t6) {
          t6.call(lt, e3);
        });
      });
    }
    function Y(a3) {
      a3.fixed || l2.forEach(function(t4, e3) {
        z2(c2.start, t4.children[0], B, { handleNumbers: [e3] });
      }), a3.tap && z2(c2.start, i2, q, {}), a3.hover && z2(c2.move, i2, X, { hover: true }), a3.drag && u2.forEach(function(e3, t4) {
        var r4, n4, i3, o3, s3;
        false !== e3 && 0 !== t4 && t4 !== u2.length - 1 && (r4 = l2[t4 - 1], n4 = l2[t4], i3 = [e3], o3 = [r4, n4], s3 = [t4 - 1, t4], gt(e3, f2.cssClasses.draggable), a3.fixed && (i3.push(r4.children[0]), i3.push(n4.children[0])), a3.dragAll && (o3 = l2, s3 = g2), i3.forEach(function(t5) {
          z2(c2.start, t5, B, { handles: o3, handleNumbers: s3, connect: e3 });
        }));
      });
    }
    function I(t4, e3) {
      b2[t4] = b2[t4] || [], b2[t4].push(e3), "update" === t4.split(".")[0] && l2.forEach(function(t5, e4) {
        $("update", e4);
      });
    }
    function W(t4) {
      var n4 = t4 && t4.split(".")[0], i3 = n4 ? t4.substring(n4.length) : t4;
      Object.keys(b2).forEach(function(t5) {
        var e3 = t5.split(".")[0], r4 = t5.substring(e3.length);
        n4 && n4 !== e3 || i3 && i3 !== r4 || ((e3 = r4) !== St.aria && e3 !== St.tooltips || i3 === r4) && delete b2[t5];
      });
    }
    function $(r4, n4, i3) {
      Object.keys(b2).forEach(function(t4) {
        var e3 = t4.split(".")[0];
        r4 === e3 && b2[t4].forEach(function(t5) {
          t5.call(lt, h2.map(f2.format.to), n4, h2.slice(), i3 || false, m2.slice(), lt);
        });
      });
    }
    function G(t4, e3, r4, n4, i3, o3, s3) {
      var a3;
      return 1 < l2.length && !f2.events.unconstrained && (n4 && 0 < e3 && (a3 = S2.getAbsoluteDistance(t4[e3 - 1], f2.margin, false), r4 = Math.max(r4, a3)), i3 && e3 < l2.length - 1 && (a3 = S2.getAbsoluteDistance(t4[e3 + 1], f2.margin, true), r4 = Math.min(r4, a3))), 1 < l2.length && f2.limit && (n4 && 0 < e3 && (a3 = S2.getAbsoluteDistance(t4[e3 - 1], f2.limit, false), r4 = Math.min(r4, a3)), i3 && e3 < l2.length - 1 && (a3 = S2.getAbsoluteDistance(t4[e3 + 1], f2.limit, true), r4 = Math.max(r4, a3))), f2.padding && (0 === e3 && (a3 = S2.getAbsoluteDistance(0, f2.padding[0], false), r4 = Math.max(r4, a3)), e3 === l2.length - 1 && (a3 = S2.getAbsoluteDistance(100, f2.padding[1], true), r4 = Math.min(r4, a3))), !((r4 = ht(r4 = !s3 ? S2.getStep(r4) : r4)) === t4[e3] && !o3) && r4;
    }
    function J(t4, e3) {
      var r4 = f2.ort;
      return (r4 ? e3 : t4) + ", " + (r4 ? t4 : e3);
    }
    function K(t4, r4, n4, e3, i3) {
      var o3 = n4.slice(), s3 = e3[0], a3 = f2.events.smoothSteps, l3 = [!t4, t4], u3 = [t4, !t4];
      e3 = e3.slice(), t4 && e3.reverse(), 1 < e3.length ? e3.forEach(function(t5, e4) {
        e4 = G(o3, t5, o3[t5] + r4, l3[e4], u3[e4], false, a3);
        false === e4 ? r4 = 0 : (r4 = e4 - o3[t5], o3[t5] = e4);
      }) : l3 = u3 = [true];
      var c3 = false;
      e3.forEach(function(t5, e4) {
        c3 = et(t5, n4[t5] + r4, l3[e4], u3[e4], false, a3) || c3;
      }), c3 && (e3.forEach(function(t5) {
        $("update", t5), $("slide", t5);
      }), null != i3 && $("drag", s3));
    }
    function Q(t4, e3) {
      return f2.dir ? 100 - t4 - e3 : t4;
    }
    function Z(t4, e3) {
      m2[t4] = e3, h2[t4] = S2.fromStepping(e3);
      e3 = "translate(" + J(Q(e3, 0) - r3 + "%", "0") + ")";
      if (l2[t4].style[f2.transformRule] = e3, f2.events.invertConnects && 1 < m2.length) {
        e3 = m2.every(function(t5, e4, r4) {
          return 0 === e4 || t5 >= r4[e4 - 1];
        });
        if (x2 !== !e3) return x2 = !x2, xt(f2, f2.connect.map(function(t5) {
          return !t5;
        })), void at();
      }
      rt(t4), rt(t4 + 1), x2 && (rt(t4 - 1), rt(t4 + 2));
    }
    function tt() {
      g2.forEach(function(t4) {
        var e3 = 50 < m2[t4] ? -1 : 1, e3 = 3 + (l2.length + e3 * t4);
        l2[t4].style.zIndex = String(e3);
      });
    }
    function et(t4, e3, r4, n4, i3, o3) {
      return false !== (e3 = i3 ? e3 : G(m2, t4, e3, r4, n4, false, o3)) && (Z(t4, e3), true);
    }
    function rt(t4) {
      var e3, r4, n4;
      u2[t4] && (e3 = m2.slice(), x2 && e3.sort(function(t5, e4) {
        return t5 - e4;
      }), n4 = 100, r4 = "translate(" + J(Q(r4 = (r4 = 0) !== t4 ? e3[t4 - 1] : r4, n4 = (n4 = t4 !== u2.length - 1 ? e3[t4] : n4) - r4) + "%", "0") + ")", n4 = "scale(" + J(n4 / 100, "1") + ")", u2[t4].style[f2.transformRule] = r4 + " " + n4);
    }
    function nt(t4, e3) {
      return null === t4 || false === t4 || void 0 === t4 ? m2[e3] : ("number" == typeof t4 && (t4 = String(t4)), false === (t4 = false !== (t4 = f2.format.from(t4)) ? S2.toStepping(t4) : t4) || isNaN(t4) ? m2[e3] : t4);
    }
    function it(t4, e3, r4) {
      var n4 = mt(t4), t4 = void 0 === m2[0];
      e3 = void 0 === e3 || e3, f2.animate && !t4 && dt(d2, f2.cssClasses.tap, f2.animationDuration), g2.forEach(function(t5) {
        et(t5, nt(n4[t5], t5), true, false, r4);
      });
      var i3, o3 = 1 === g2.length ? 0 : 1;
      for (t4 && S2.hasNoSize() && (r4 = true, m2[0] = 0, 1 < g2.length && (i3 = 100 / (g2.length - 1), g2.forEach(function(t5) {
        m2[t5] = t5 * i3;
      }))); o3 < g2.length; ++o3) g2.forEach(function(t5) {
        et(t5, m2[t5], true, true, r4);
      });
      tt(), g2.forEach(function(t5) {
        $("update", t5), null !== n4[t5] && e3 && $("set", t5);
      });
    }
    function ot(t4) {
      if (t4 = void 0 === t4 ? false : t4) return 1 === h2.length ? h2[0] : h2.slice(0);
      t4 = h2.map(f2.format.to);
      return 1 === t4.length ? t4[0] : t4;
    }
    function st(t4) {
      var e3 = m2[t4], r4 = S2.getNearbySteps(e3), n4 = h2[t4], i3 = r4.thisStep.step, t4 = null;
      if (f2.snap) return [n4 - r4.stepBefore.startValue || null, r4.stepAfter.startValue - n4 || null];
      false !== i3 && n4 + i3 > r4.stepAfter.startValue && (i3 = r4.stepAfter.startValue - n4), t4 = n4 > r4.thisStep.startValue ? r4.thisStep.step : false !== r4.stepBefore.step && n4 - r4.stepBefore.highestStep, 100 === e3 ? i3 = null : 0 === e3 && (t4 = null);
      e3 = S2.countStepDecimals();
      return null !== i3 && false !== i3 && (i3 = Number(i3.toFixed(e3))), [t4 = null !== t4 && false !== t4 ? Number(t4.toFixed(e3)) : t4, i3];
    }
    function at() {
      for (; n3.firstChild; ) n3.removeChild(n3.firstChild);
      for (var t4 = 0; t4 <= f2.handles; t4++) u2[t4] = N2(n3, f2.connect[t4]), rt(t4);
      Y({ drag: f2.events.drag, fixed: true });
    }
    gt(t3 = d2, f2.cssClasses.target), 0 === f2.dir ? gt(t3, f2.cssClasses.ltr) : gt(t3, f2.cssClasses.rtl), 0 === f2.ort ? gt(t3, f2.cssClasses.horizontal) : gt(t3, f2.cssClasses.vertical), gt(t3, "rtl" === getComputedStyle(t3).direction ? f2.cssClasses.textDirectionRtl : f2.cssClasses.textDirectionLtr), i2 = P2(t3, f2.cssClasses.base), (function(t4, e3) {
      n3 = P2(e3, f2.cssClasses.connects), l2 = [], (u2 = []).push(N2(n3, t4[0]));
      for (var r4 = 0; r4 < f2.handles; r4++) l2.push(C2(e3, r4)), g2[r4] = r4, u2.push(N2(n3, t4[r4 + 1]));
    })(f2.connect, i2), Y(f2.events), it(f2.start), f2.pips && T2(f2.pips), f2.tooltips && M2(), W("update" + St.aria), I("update" + St.aria, function(t4, e3, o3, r4, s3) {
      g2.forEach(function(t5) {
        var e4 = l2[t5], r5 = G(m2, t5, 0, true, true, true), n4 = G(m2, t5, 100, true, true, true), i3 = s3[t5], t5 = String(f2.ariaFormat.to(o3[t5])), r5 = S2.fromStepping(r5).toFixed(1), n4 = S2.fromStepping(n4).toFixed(1), i3 = S2.fromStepping(i3).toFixed(1);
        e4.children[0].setAttribute("aria-valuemin", r5), e4.children[0].setAttribute("aria-valuemax", n4), e4.children[0].setAttribute("aria-valuenow", i3), e4.children[0].setAttribute("aria-valuetext", t5);
      });
    });
    var lt = { destroy: function() {
      for (W(St.aria), W(St.tooltips), Object.keys(f2.cssClasses).forEach(function(t4) {
        vt(d2, f2.cssClasses[t4]);
      }); d2.firstChild; ) d2.removeChild(d2.firstChild);
      delete d2.noUiSlider;
    }, steps: function() {
      return g2.map(st);
    }, on: I, off: W, get: ot, set: it, setHandle: function(t4, e3, r4, n4) {
      if (!(0 <= (t4 = Number(t4)) && t4 < g2.length)) throw new Error("noUiSlider: invalid handle number, got: " + t4);
      et(t4, nt(e3, t4), true, true, n4), $("update", t4), r4 && $("set", t4);
    }, reset: function(t4) {
      it(f2.start, t4);
    }, disable: function(t4) {
      null != t4 ? (l2[t4].setAttribute("disabled", ""), l2[t4].handle.removeAttribute("tabindex")) : (d2.setAttribute("disabled", ""), l2.forEach(function(t5) {
        t5.handle.removeAttribute("tabindex");
      }));
    }, enable: function(t4) {
      null != t4 ? (l2[t4].removeAttribute("disabled"), l2[t4].handle.setAttribute("tabindex", "0")) : (d2.removeAttribute("disabled"), l2.forEach(function(t5) {
        t5.removeAttribute("disabled"), t5.handle.setAttribute("tabindex", "0");
      }));
    }, __moveHandles: function(t4, e3, r4) {
      K(t4, e3, m2, r4);
    }, options: o2, updateOptions: function(e3, t4) {
      var r4 = ot(), n4 = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips", "connect"];
      n4.forEach(function(t5) {
        void 0 !== e3[t5] && (o2[t5] = e3[t5]);
      });
      var i3 = yt(o2);
      n4.forEach(function(t5) {
        void 0 !== e3[t5] && (f2[t5] = i3[t5]);
      }), S2 = i3.spectrum, f2.margin = i3.margin, f2.limit = i3.limit, f2.padding = i3.padding, f2.pips ? T2(f2.pips) : L2(), (f2.tooltips ? M2 : k2)(), m2 = [], it(pt(e3.start) ? e3.start : r4, t4), e3.connect && at();
    }, target: d2, removePips: L2, removeTooltips: k2, getPositions: function() {
      return m2.slice();
    }, getTooltips: function() {
      return a2;
    }, getOrigins: function() {
      return l2;
    }, pips: T2 };
    return lt;
  }
  function j(t3, e2) {
    if (!t3 || !t3.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + t3);
    if (t3.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
    e2 = T(t3, yt(e2), e2);
    return t3.noUiSlider = e2;
  }
  var z = { __spectrum: u, cssClasses: p, create: j };
  ut.create = j, ut.cssClasses = p, ut.default = z, Object.defineProperty(ut, "__esModule", { value: true });
});
;
;
(function(root, factory) {
  if (typeof define === "function" && define.amd) {
    define(factory);
  } else if (typeof exports === "object") {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }
})(this, function() {
  var NProgress = {};
  NProgress.version = "0.2.0";
  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: "linear",
    positionUsing: "",
    speed: 200,
    trickle: true,
    trickleSpeed: 200,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: "body",
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== void 0 && options.hasOwnProperty(key)) Settings[key] = value;
    }
    return this;
  };
  NProgress.status = null;
  NProgress.set = function(n2) {
    var started = NProgress.isStarted();
    n2 = clamp(n2, Settings.minimum, 1);
    NProgress.status = n2 === 1 ? null : n2;
    var progress = NProgress.render(!started), bar = progress.querySelector(Settings.barSelector), speed = Settings.speed, ease = Settings.easing;
    progress.offsetWidth;
    queue(function(next) {
      if (Settings.positionUsing === "") Settings.positionUsing = NProgress.getPositioningCSS();
      css(bar, barPositionCSS(n2, speed, ease));
      if (n2 === 1) {
        css(progress, {
          transition: "none",
          opacity: 1
        });
        progress.offsetWidth;
        setTimeout(function() {
          css(progress, {
            transition: "all " + speed + "ms linear",
            opacity: 0
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });
    return this;
  };
  NProgress.isStarted = function() {
    return typeof NProgress.status === "number";
  };
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);
    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };
    if (Settings.trickle) work();
    return this;
  };
  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;
    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };
  NProgress.inc = function(amount) {
    var n2 = NProgress.status;
    if (!n2) {
      return NProgress.start();
    } else if (n2 > 1) {
      return;
    } else {
      if (typeof amount !== "number") {
        if (n2 >= 0 && n2 < 0.2) {
          amount = 0.1;
        } else if (n2 >= 0.2 && n2 < 0.5) {
          amount = 0.04;
        } else if (n2 >= 0.5 && n2 < 0.8) {
          amount = 0.02;
        } else if (n2 >= 0.8 && n2 < 0.99) {
          amount = 5e-3;
        } else {
          amount = 0;
        }
      }
      n2 = clamp(n2 + amount, 0, 0.994);
      return NProgress.set(n2);
    }
  };
  NProgress.trickle = function() {
    return NProgress.inc();
  };
  (function() {
    var initial = 0, current = 0;
    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }
      if (current === 0) {
        NProgress.start();
      }
      initial++;
      current++;
      $promise.always(function() {
        current--;
        if (current === 0) {
          initial = 0;
          NProgress.done();
        } else {
          NProgress.set((initial - current) / initial);
        }
      });
      return this;
    };
  })();
  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById("nprogress");
    addClass(document.documentElement, "nprogress-busy");
    var progress = document.createElement("div");
    progress.id = "nprogress";
    progress.innerHTML = Settings.template;
    var bar = progress.querySelector(Settings.barSelector), perc = fromStart ? "-100" : toBarPerc(NProgress.status || 0), parent = document.querySelector(Settings.parent), spinner;
    css(bar, {
      transition: "all 0 linear",
      transform: "translate3d(" + perc + "%,0,0)"
    });
    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }
    if (parent != document.body) {
      addClass(parent, "nprogress-custom-parent");
    }
    parent.appendChild(progress);
    return progress;
  };
  NProgress.remove = function() {
    removeClass(document.documentElement, "nprogress-busy");
    removeClass(document.querySelector(Settings.parent), "nprogress-custom-parent");
    var progress = document.getElementById("nprogress");
    progress && removeElement(progress);
  };
  NProgress.isRendered = function() {
    return !!document.getElementById("nprogress");
  };
  NProgress.getPositioningCSS = function() {
    var bodyStyle = document.body.style;
    var vendorPrefix = "WebkitTransform" in bodyStyle ? "Webkit" : "MozTransform" in bodyStyle ? "Moz" : "msTransform" in bodyStyle ? "ms" : "OTransform" in bodyStyle ? "O" : "";
    if (vendorPrefix + "Perspective" in bodyStyle) {
      return "translate3d";
    } else if (vendorPrefix + "Transform" in bodyStyle) {
      return "translate";
    } else {
      return "margin";
    }
  };
  function clamp(n2, min, max) {
    if (n2 < min) return min;
    if (n2 > max) return max;
    return n2;
  }
  function toBarPerc(n2) {
    return (-1 + n2) * 100;
  }
  function barPositionCSS(n2, speed, ease) {
    var barCSS;
    if (Settings.positionUsing === "translate3d") {
      barCSS = { transform: "translate3d(" + toBarPerc(n2) + "%,0,0)" };
    } else if (Settings.positionUsing === "translate") {
      barCSS = { transform: "translate(" + toBarPerc(n2) + "%,0)" };
    } else {
      barCSS = { "margin-left": toBarPerc(n2) + "%" };
    }
    barCSS.transition = "all " + speed + "ms " + ease;
    return barCSS;
  }
  var queue = /* @__PURE__ */ (function() {
    var pending = [];
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }
    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();
  var css = /* @__PURE__ */ (function() {
    var cssPrefixes = ["Webkit", "O", "Moz", "ms"], cssProps = {};
    function camelCase(string) {
      return string.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }
    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;
      var i = cssPrefixes.length, capName = name.charAt(0).toUpperCase() + name.slice(1), vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }
      return name;
    }
    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }
    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }
    return function(element, properties) {
      var args = arguments, prop, value;
      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== void 0 && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    };
  })();
  function hasClass(element, name) {
    var list = typeof element == "string" ? element : classList(element);
    return list.indexOf(" " + name + " ") >= 0;
  }
  function addClass(element, name) {
    var oldList = classList(element), newList = oldList + name;
    if (hasClass(oldList, name)) return;
    element.className = newList.substring(1);
  }
  function removeClass(element, name) {
    var oldList = classList(element), newList;
    if (!hasClass(element, name)) return;
    newList = oldList.replace(" " + name + " ", " ");
    element.className = newList.substring(1, newList.length - 1);
  }
  function classList(element) {
    return (" " + (element && element.className || "") + " ").replace(/\s+/gi, " ");
  }
  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }
  return NProgress;
});
;
!(function(t2, i) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define(i) : (t2 = "undefined" != typeof globalThis ? globalThis : t2 || self).PhotoSwipeLightbox = i();
})(this, (function() {
  "use strict";
  function t2(t3, i2, s2) {
    const h2 = document.createElement(i2);
    return t3 && (h2.className = t3), s2 && s2.appendChild(h2), h2;
  }
  function i(t3, i2, s2) {
    t3.style.width = "number" == typeof i2 ? `${i2}px` : i2, t3.style.height = "number" == typeof s2 ? `${s2}px` : s2;
  }
  const s = "idle", h = "loading", e = "loaded", n2 = "error";
  function o(t3, i2, s2 = document) {
    let h2 = [];
    if (t3 instanceof Element) h2 = [t3];
    else if (t3 instanceof NodeList || Array.isArray(t3)) h2 = Array.from(t3);
    else {
      const e2 = "string" == typeof t3 ? t3 : i2;
      e2 && (h2 = Array.from(s2.querySelectorAll(e2)));
    }
    return h2;
  }
  function r2() {
    return !(!navigator.vendor || !navigator.vendor.match(/apple/i));
  }
  class l {
    constructor(t3, i2) {
      this.type = t3, this.defaultPrevented = false, i2 && Object.assign(this, i2);
    }
    preventDefault() {
      this.defaultPrevented = true;
    }
  }
  class a {
    constructor(i2, s2) {
      if (this.element = t2("pswp__img pswp__img--placeholder", i2 ? "img" : "div", s2), i2) {
        const t3 = this.element;
        t3.decoding = "async", t3.alt = "", t3.src = i2, t3.setAttribute("role", "presentation");
      }
      this.element.setAttribute("aria-hidden", "true");
    }
    setDisplayedSize(t3, s2) {
      this.element && ("IMG" === this.element.tagName ? (i(this.element, 250, "auto"), this.element.style.transformOrigin = "0 0", this.element.style.transform = (function(t4, i2, s3) {
        let h2 = `translate3d(${t4}px,${i2 || 0}px,0)`;
        return void 0 !== s3 && (h2 += ` scale3d(${s3},${s3},1)`), h2;
      })(0, 0, t3 / 250)) : i(this.element, t3, s2));
    }
    destroy() {
      var t3;
      null !== (t3 = this.element) && void 0 !== t3 && t3.parentNode && this.element.remove(), this.element = null;
    }
  }
  class d {
    constructor(t3, i2, h2) {
      this.instance = i2, this.data = t3, this.index = h2, this.element = void 0, this.placeholder = void 0, this.slide = void 0, this.displayedImageWidth = 0, this.displayedImageHeight = 0, this.width = Number(this.data.w) || Number(this.data.width) || 0, this.height = Number(this.data.h) || Number(this.data.height) || 0, this.isAttached = false, this.hasSlide = false, this.isDecoding = false, this.state = s, this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html", this.instance.dispatch("contentInit", { content: this });
    }
    removePlaceholder() {
      this.placeholder && !this.keepPlaceholder() && setTimeout((() => {
        this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0);
      }), 1e3);
    }
    load(i2, s2) {
      if (this.slide && this.usePlaceholder()) if (this.placeholder) {
        const t3 = this.placeholder.element;
        t3 && !t3.parentElement && this.slide.container.prepend(t3);
      } else {
        const t3 = this.instance.applyFilters("placeholderSrc", !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc, this);
        this.placeholder = new a(t3, this.slide.container);
      }
      this.element && !s2 || this.instance.dispatch("contentLoad", { content: this, isLazy: i2 }).defaultPrevented || (this.isImageContent() ? (this.element = t2("pswp__img", "img"), this.displayedImageWidth && this.loadImage(i2)) : (this.element = t2("pswp__content", "div"), this.element.innerHTML = this.data.html || ""), s2 && this.slide && this.slide.updateContentSize(true));
    }
    loadImage(t3) {
      var i2, s2;
      if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", { content: this, isLazy: t3 }).defaultPrevented) return;
      const e2 = this.element;
      this.updateSrcsetSizes(), this.data.srcset && (e2.srcset = this.data.srcset), e2.src = null !== (i2 = this.data.src) && void 0 !== i2 ? i2 : "", e2.alt = null !== (s2 = this.data.alt) && void 0 !== s2 ? s2 : "", this.state = h, e2.complete ? this.onLoaded() : (e2.onload = () => {
        this.onLoaded();
      }, e2.onerror = () => {
        this.onError();
      });
    }
    setSlide(t3) {
      this.slide = t3, this.hasSlide = true, this.instance = t3.pswp;
    }
    onLoaded() {
      this.state = e, this.slide && this.element && (this.instance.dispatch("loadComplete", { slide: this.slide, content: this }), this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(true)), this.state !== e && this.state !== n2 || this.removePlaceholder());
    }
    onError() {
      this.state = n2, this.slide && (this.displayError(), this.instance.dispatch("loadComplete", { slide: this.slide, isError: true, content: this }), this.instance.dispatch("loadError", { slide: this.slide, content: this }));
    }
    isLoading() {
      return this.instance.applyFilters("isContentLoading", this.state === h, this);
    }
    isError() {
      return this.state === n2;
    }
    isImageContent() {
      return "image" === this.type;
    }
    setDisplayedSize(t3, s2) {
      if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(t3, s2), !this.instance.dispatch("contentResize", { content: this, width: t3, height: s2 }).defaultPrevented && (i(this.element, t3, s2), this.isImageContent() && !this.isError()))) {
        const i2 = !this.displayedImageWidth && t3;
        this.displayedImageWidth = t3, this.displayedImageHeight = s2, i2 ? this.loadImage(false) : this.updateSrcsetSizes(), this.slide && this.instance.dispatch("imageSizeChange", { slide: this.slide, width: t3, height: s2, content: this });
      }
    }
    isZoomable() {
      return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== n2, this);
    }
    updateSrcsetSizes() {
      if (!this.isImageContent() || !this.element || !this.data.srcset) return;
      const t3 = this.element, i2 = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
      (!t3.dataset.largestUsedSize || i2 > parseInt(t3.dataset.largestUsedSize, 10)) && (t3.sizes = i2 + "px", t3.dataset.largestUsedSize = String(i2));
    }
    usePlaceholder() {
      return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
    }
    lazyLoad() {
      this.instance.dispatch("contentLazyLoad", { content: this }).defaultPrevented || this.load(true);
    }
    keepPlaceholder() {
      return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
    }
    destroy() {
      this.hasSlide = false, this.slide = void 0, this.instance.dispatch("contentDestroy", { content: this }).defaultPrevented || (this.remove(), this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0), this.isImageContent() && this.element && (this.element.onload = null, this.element.onerror = null, this.element = void 0));
    }
    displayError() {
      if (this.slide) {
        var i2, s2;
        let h2 = t2("pswp__error-msg", "div");
        h2.innerText = null !== (i2 = null === (s2 = this.instance.options) || void 0 === s2 ? void 0 : s2.errorMsg) && void 0 !== i2 ? i2 : "", h2 = this.instance.applyFilters("contentErrorElement", h2, this), this.element = t2("pswp__content pswp__error-msg-container", "div"), this.element.appendChild(h2), this.slide.container.innerText = "", this.slide.container.appendChild(this.element), this.slide.updateContentSize(true), this.removePlaceholder();
      }
    }
    append() {
      if (this.isAttached || !this.element) return;
      if (this.isAttached = true, this.state === n2) return void this.displayError();
      if (this.instance.dispatch("contentAppend", { content: this }).defaultPrevented) return;
      const t3 = "decode" in this.element;
      this.isImageContent() ? t3 && this.slide && (!this.slide.isActive || r2()) ? (this.isDecoding = true, this.element.decode().catch((() => {
      })).finally((() => {
        this.isDecoding = false, this.appendImage();
      }))) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
    }
    activate() {
      !this.instance.dispatch("contentActivate", { content: this }).defaultPrevented && this.slide && (this.isImageContent() && this.isDecoding && !r2() ? this.appendImage() : this.isError() && this.load(false, true), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"));
    }
    deactivate() {
      this.instance.dispatch("contentDeactivate", { content: this }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true");
    }
    remove() {
      this.isAttached = false, this.instance.dispatch("contentRemove", { content: this }).defaultPrevented || (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove());
    }
    appendImage() {
      this.isAttached && (this.instance.dispatch("contentAppendImage", { content: this }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), this.state !== e && this.state !== n2 || this.removePlaceholder()));
    }
  }
  function c(t3, i2, s2, h2, e2) {
    let n3 = 0;
    if (i2.paddingFn) n3 = i2.paddingFn(s2, h2, e2)[t3];
    else if (i2.padding) n3 = i2.padding[t3];
    else {
      const s3 = "padding" + t3[0].toUpperCase() + t3.slice(1);
      i2[s3] && (n3 = i2[s3]);
    }
    return Number(n3) || 0;
  }
  class u {
    constructor(t3, i2, s2, h2) {
      this.pswp = h2, this.options = t3, this.itemData = i2, this.index = s2, this.panAreaSize = null, this.elementSize = null, this.fit = 1, this.fill = 1, this.vFill = 1, this.initial = 1, this.secondary = 1, this.max = 1, this.min = 1;
    }
    update(t3, i2, s2) {
      const h2 = { x: t3, y: i2 };
      this.elementSize = h2, this.panAreaSize = s2;
      const e2 = s2.x / h2.x, n3 = s2.y / h2.y;
      this.fit = Math.min(1, e2 < n3 ? e2 : n3), this.fill = Math.min(1, e2 > n3 ? e2 : n3), this.vFill = Math.min(1, n3), this.initial = this.t(), this.secondary = this.i(), this.max = Math.max(this.initial, this.secondary, this.o()), this.min = Math.min(this.fit, this.initial, this.secondary), this.pswp && this.pswp.dispatch("zoomLevelsUpdate", { zoomLevels: this, slideData: this.itemData });
    }
    l(t3) {
      const i2 = t3 + "ZoomLevel", s2 = this.options[i2];
      if (s2) return "function" == typeof s2 ? s2(this) : "fill" === s2 ? this.fill : "fit" === s2 ? this.fit : Number(s2);
    }
    i() {
      let t3 = this.l("secondary");
      return t3 || (t3 = Math.min(1, 3 * this.fit), this.elementSize && t3 * this.elementSize.x > 4e3 && (t3 = 4e3 / this.elementSize.x), t3);
    }
    t() {
      return this.l("initial") || this.fit;
    }
    o() {
      return this.l("max") || Math.max(1, 4 * this.fit);
    }
  }
  function p(t3, i2, s2) {
    const h2 = i2.createContentFromData(t3, s2);
    let e2;
    const { options: n3 } = i2;
    if (n3) {
      let o2;
      e2 = new u(n3, t3, -1), o2 = i2.pswp ? i2.pswp.viewportSize : (function(t4, i3) {
        if (t4.getViewportSizeFn) {
          const s3 = t4.getViewportSizeFn(t4, i3);
          if (s3) return s3;
        }
        return { x: document.documentElement.clientWidth, y: window.innerHeight };
      })(n3, i2);
      const r3 = (function(t4, i3, s3, h3) {
        return { x: i3.x - c("left", t4, i3, s3, h3) - c("right", t4, i3, s3, h3), y: i3.y - c("top", t4, i3, s3, h3) - c("bottom", t4, i3, s3, h3) };
      })(n3, o2, t3, s2);
      e2.update(h2.width, h2.height, r3);
    }
    return h2.lazyLoad(), e2 && h2.setDisplayedSize(Math.ceil(h2.width * e2.initial), Math.ceil(h2.height * e2.initial)), h2;
  }
  return class extends class extends class {
    constructor() {
      this.u = {}, this.p = {}, this.pswp = void 0, this.options = void 0;
    }
    addFilter(t3, i2, s2 = 100) {
      var h2, e2, n3;
      this.p[t3] || (this.p[t3] = []), null === (h2 = this.p[t3]) || void 0 === h2 || h2.push({ fn: i2, priority: s2 }), null === (e2 = this.p[t3]) || void 0 === e2 || e2.sort(((t4, i3) => t4.priority - i3.priority)), null === (n3 = this.pswp) || void 0 === n3 || n3.addFilter(t3, i2, s2);
    }
    removeFilter(t3, i2) {
      this.p[t3] && (this.p[t3] = this.p[t3].filter(((t4) => t4.fn !== i2))), this.pswp && this.pswp.removeFilter(t3, i2);
    }
    applyFilters(t3, ...i2) {
      var s2;
      return null === (s2 = this.p[t3]) || void 0 === s2 || s2.forEach(((t4) => {
        i2[0] = t4.fn.apply(this, i2);
      })), i2[0];
    }
    on(t3, i2) {
      var s2, h2;
      this.u[t3] || (this.u[t3] = []), null === (s2 = this.u[t3]) || void 0 === s2 || s2.push(i2), null === (h2 = this.pswp) || void 0 === h2 || h2.on(t3, i2);
    }
    off(t3, i2) {
      var s2;
      this.u[t3] && (this.u[t3] = this.u[t3].filter(((t4) => i2 !== t4))), null === (s2 = this.pswp) || void 0 === s2 || s2.off(t3, i2);
    }
    dispatch(t3, i2) {
      var s2;
      if (this.pswp) return this.pswp.dispatch(t3, i2);
      const h2 = new l(t3, i2);
      return null === (s2 = this.u[t3]) || void 0 === s2 || s2.forEach(((t4) => {
        t4.call(this, h2);
      })), h2;
    }
  } {
    getNumItems() {
      var t3;
      let i2 = 0;
      const s2 = null === (t3 = this.options) || void 0 === t3 ? void 0 : t3.dataSource;
      s2 && "length" in s2 ? i2 = s2.length : s2 && "gallery" in s2 && (s2.items || (s2.items = this.v(s2.gallery)), s2.items && (i2 = s2.items.length));
      const h2 = this.dispatch("numItems", { dataSource: s2, numItems: i2 });
      return this.applyFilters("numItems", h2.numItems, s2);
    }
    createContentFromData(t3, i2) {
      return new d(t3, this, i2);
    }
    getItemData(t3) {
      var i2;
      const s2 = null === (i2 = this.options) || void 0 === i2 ? void 0 : i2.dataSource;
      let h2 = {};
      Array.isArray(s2) ? h2 = s2[t3] : s2 && "gallery" in s2 && (s2.items || (s2.items = this.v(s2.gallery)), h2 = s2.items[t3]);
      let e2 = h2;
      e2 instanceof Element && (e2 = this.m(e2));
      const n3 = this.dispatch("itemData", { itemData: e2 || {}, index: t3 });
      return this.applyFilters("itemData", n3.itemData, t3);
    }
    v(t3) {
      var i2, s2;
      return null !== (i2 = this.options) && void 0 !== i2 && i2.children || null !== (s2 = this.options) && void 0 !== s2 && s2.childSelector ? o(this.options.children, this.options.childSelector, t3) || [] : [t3];
    }
    m(t3) {
      const i2 = { element: t3 }, s2 = "A" === t3.tagName ? t3 : t3.querySelector("a");
      if (s2) {
        i2.src = s2.dataset.pswpSrc || s2.href, s2.dataset.pswpSrcset && (i2.srcset = s2.dataset.pswpSrcset), i2.width = s2.dataset.pswpWidth ? parseInt(s2.dataset.pswpWidth, 10) : 0, i2.height = s2.dataset.pswpHeight ? parseInt(s2.dataset.pswpHeight, 10) : 0, i2.w = i2.width, i2.h = i2.height, s2.dataset.pswpType && (i2.type = s2.dataset.pswpType);
        const e2 = t3.querySelector("img");
        var h2;
        if (e2) i2.msrc = e2.currentSrc || e2.src, i2.alt = null !== (h2 = e2.getAttribute("alt")) && void 0 !== h2 ? h2 : "";
        (s2.dataset.pswpCropped || s2.dataset.cropped) && (i2.thumbCropped = true);
      }
      return this.applyFilters("domItemData", i2, t3, s2);
    }
    lazyLoadData(t3, i2) {
      return p(t3, this, i2);
    }
  } {
    constructor(t3) {
      super(), this.options = t3 || {}, this.g = 0, this.shouldOpen = false, this._ = void 0, this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
    }
    init() {
      o(this.options.gallery, this.options.gallerySelector).forEach(((t3) => {
        t3.addEventListener("click", this.onThumbnailsClick, false);
      }));
    }
    onThumbnailsClick(t3) {
      if ((function(t4) {
        return "button" in t4 && 1 === t4.button || t4.ctrlKey || t4.metaKey || t4.altKey || t4.shiftKey;
      })(t3) || window.pswp) return;
      let i2 = { x: t3.clientX, y: t3.clientY };
      i2.x || i2.y || (i2 = null);
      let s2 = this.getClickedIndex(t3);
      s2 = this.applyFilters("clickedIndex", s2, t3, this);
      const h2 = { gallery: t3.currentTarget };
      s2 >= 0 && (t3.preventDefault(), this.loadAndOpen(s2, h2, i2));
    }
    getClickedIndex(t3) {
      if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, t3);
      const i2 = t3.target, s2 = o(this.options.children, this.options.childSelector, t3.currentTarget).findIndex(((t4) => t4 === i2 || t4.contains(i2)));
      return -1 !== s2 ? s2 : this.options.children || this.options.childSelector ? -1 : 0;
    }
    loadAndOpen(t3, i2, s2) {
      if (window.pswp || !this.options) return false;
      if (!i2 && this.options.gallery && this.options.children) {
        const t4 = o(this.options.gallery);
        t4[0] && (i2 = { gallery: t4[0] });
      }
      return this.options.index = t3, this.options.initialPointerPos = s2, this.shouldOpen = true, this.preload(t3, i2), true;
    }
    preload(t3, i2) {
      const { options: s2 } = this;
      i2 && (s2.dataSource = i2);
      const h2 = [], e2 = typeof s2.pswpModule;
      if ("function" == typeof (n3 = s2.pswpModule) && n3.prototype && n3.prototype.goTo) h2.push(Promise.resolve(s2.pswpModule));
      else {
        if ("string" === e2) throw new Error("pswpModule as string is no longer supported");
        if ("function" !== e2) throw new Error("pswpModule is not valid");
        h2.push(s2.pswpModule());
      }
      var n3;
      "function" == typeof s2.openPromise && h2.push(s2.openPromise()), false !== s2.preloadFirstSlide && t3 >= 0 && (this._ = (function(t4, i3) {
        const s3 = i3.getItemData(t4);
        if (!i3.dispatch("lazyLoadSlide", { index: t4, itemData: s3 }).defaultPrevented) return p(s3, i3, t4);
      })(t3, this));
      const o2 = ++this.g;
      Promise.all(h2).then(((t4) => {
        if (this.shouldOpen) {
          const i3 = t4[0];
          this.I(i3, o2);
        }
      }));
    }
    I(t3, i2) {
      if (i2 !== this.g && this.shouldOpen) return;
      if (this.shouldOpen = false, window.pswp) return;
      const s2 = "object" == typeof t3 ? new t3.default(this.options) : new t3(this.options);
      this.pswp = s2, window.pswp = s2, Object.keys(this.u).forEach(((t4) => {
        var i3;
        null === (i3 = this.u[t4]) || void 0 === i3 || i3.forEach(((i4) => {
          s2.on(t4, i4);
        }));
      })), Object.keys(this.p).forEach(((t4) => {
        var i3;
        null === (i3 = this.p[t4]) || void 0 === i3 || i3.forEach(((i4) => {
          s2.addFilter(t4, i4.fn, i4.priority);
        }));
      })), this._ && (s2.contentLoader.addToCache(this._), this._ = void 0), s2.on("destroy", (() => {
        this.pswp = void 0, delete window.pswp;
      })), s2.init();
    }
    destroy() {
      var t3;
      null === (t3 = this.pswp) || void 0 === t3 || t3.destroy(), this.shouldOpen = false, this.u = {}, o(this.options.gallery, this.options.gallerySelector).forEach(((t4) => {
        t4.removeEventListener("click", this.onThumbnailsClick, false);
      }));
    }
  };
}));
;
!(function(t2, i) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define(i) : (t2 = "undefined" != typeof globalThis ? globalThis : t2 || self).PhotoSwipe = i();
})(this, (function() {
  "use strict";
  function t2(t3, i2, s2) {
    const h2 = document.createElement(i2);
    return t3 && (h2.className = t3), s2 && s2.appendChild(h2), h2;
  }
  function i(t3, i2) {
    return t3.x = i2.x, t3.y = i2.y, void 0 !== i2.id && (t3.id = i2.id), t3;
  }
  function s(t3) {
    t3.x = Math.round(t3.x), t3.y = Math.round(t3.y);
  }
  function h(t3, i2) {
    const s2 = Math.abs(t3.x - i2.x), h2 = Math.abs(t3.y - i2.y);
    return Math.sqrt(s2 * s2 + h2 * h2);
  }
  function e(t3, i2) {
    return t3.x === i2.x && t3.y === i2.y;
  }
  function n2(t3, i2, s2) {
    return Math.min(Math.max(t3, i2), s2);
  }
  function o(t3, i2, s2) {
    let h2 = `translate3d(${t3}px,${i2 || 0}px,0)`;
    return void 0 !== s2 && (h2 += ` scale3d(${s2},${s2},1)`), h2;
  }
  function r2(t3, i2, s2, h2) {
    t3.style.transform = o(i2, s2, h2);
  }
  function a(t3, i2, s2, h2) {
    t3.style.transition = i2 ? `${i2} ${s2}ms ${h2 || "cubic-bezier(.4,0,.22,1)"}` : "none";
  }
  function l(t3, i2, s2) {
    t3.style.width = "number" == typeof i2 ? `${i2}px` : i2, t3.style.height = "number" == typeof s2 ? `${s2}px` : s2;
  }
  const c = "idle", d = "loading", u = "loaded", p = "error";
  function m() {
    return !(!navigator.vendor || !navigator.vendor.match(/apple/i));
  }
  let v = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: () => {
      v = true;
    } }));
  } catch (t3) {
  }
  class f {
    constructor() {
      this.t = [];
    }
    add(t3, i2, s2, h2) {
      this.i(t3, i2, s2, h2);
    }
    remove(t3, i2, s2, h2) {
      this.i(t3, i2, s2, h2, true);
    }
    removeAll() {
      this.t.forEach(((t3) => {
        this.i(t3.target, t3.type, t3.listener, t3.passive, true, true);
      })), this.t = [];
    }
    i(t3, i2, s2, h2, e2, n3) {
      if (!t3) return;
      const o2 = e2 ? "removeEventListener" : "addEventListener";
      i2.split(" ").forEach(((i3) => {
        if (i3) {
          n3 || (e2 ? this.t = this.t.filter(((h3) => h3.type !== i3 || h3.listener !== s2 || h3.target !== t3)) : this.t.push({ target: t3, type: i3, listener: s2, passive: h2 }));
          const r3 = !!v && { passive: h2 || false };
          t3[o2](i3, s2, r3);
        }
      }));
    }
  }
  function w(t3, i2) {
    if (t3.getViewportSizeFn) {
      const s2 = t3.getViewportSizeFn(t3, i2);
      if (s2) return s2;
    }
    return { x: document.documentElement.clientWidth, y: window.innerHeight };
  }
  function g(t3, i2, s2, h2, e2) {
    let n3 = 0;
    if (i2.paddingFn) n3 = i2.paddingFn(s2, h2, e2)[t3];
    else if (i2.padding) n3 = i2.padding[t3];
    else {
      const s3 = "padding" + t3[0].toUpperCase() + t3.slice(1);
      i2[s3] && (n3 = i2[s3]);
    }
    return Number(n3) || 0;
  }
  function y(t3, i2, s2, h2) {
    return { x: i2.x - g("left", t3, i2, s2, h2) - g("right", t3, i2, s2, h2), y: i2.y - g("top", t3, i2, s2, h2) - g("bottom", t3, i2, s2, h2) };
  }
  class _ {
    constructor(t3) {
      this.slide = t3, this.currZoomLevel = 1, this.center = { x: 0, y: 0 }, this.max = { x: 0, y: 0 }, this.min = { x: 0, y: 0 };
    }
    update(t3) {
      this.currZoomLevel = t3, this.slide.width ? (this.o("x"), this.o("y"), this.slide.pswp.dispatch("calcBounds", { slide: this.slide })) : this.reset();
    }
    o(t3) {
      const { pswp: i2 } = this.slide, s2 = this.slide["x" === t3 ? "width" : "height"] * this.currZoomLevel, h2 = g("x" === t3 ? "left" : "top", i2.options, i2.viewportSize, this.slide.data, this.slide.index), e2 = this.slide.panAreaSize[t3];
      this.center[t3] = Math.round((e2 - s2) / 2) + h2, this.max[t3] = s2 > e2 ? Math.round(e2 - s2) + h2 : this.center[t3], this.min[t3] = s2 > e2 ? h2 : this.center[t3];
    }
    reset() {
      this.center.x = 0, this.center.y = 0, this.max.x = 0, this.max.y = 0, this.min.x = 0, this.min.y = 0;
    }
    correctPan(t3, i2) {
      return n2(i2, this.max[t3], this.min[t3]);
    }
  }
  class x {
    constructor(t3, i2, s2, h2) {
      this.pswp = h2, this.options = t3, this.itemData = i2, this.index = s2, this.panAreaSize = null, this.elementSize = null, this.fit = 1, this.fill = 1, this.vFill = 1, this.initial = 1, this.secondary = 1, this.max = 1, this.min = 1;
    }
    update(t3, i2, s2) {
      const h2 = { x: t3, y: i2 };
      this.elementSize = h2, this.panAreaSize = s2;
      const e2 = s2.x / h2.x, n3 = s2.y / h2.y;
      this.fit = Math.min(1, e2 < n3 ? e2 : n3), this.fill = Math.min(1, e2 > n3 ? e2 : n3), this.vFill = Math.min(1, n3), this.initial = this.l(), this.secondary = this.u(), this.max = Math.max(this.initial, this.secondary, this.p()), this.min = Math.min(this.fit, this.initial, this.secondary), this.pswp && this.pswp.dispatch("zoomLevelsUpdate", { zoomLevels: this, slideData: this.itemData });
    }
    m(t3) {
      const i2 = t3 + "ZoomLevel", s2 = this.options[i2];
      if (s2) return "function" == typeof s2 ? s2(this) : "fill" === s2 ? this.fill : "fit" === s2 ? this.fit : Number(s2);
    }
    u() {
      let t3 = this.m("secondary");
      return t3 || (t3 = Math.min(1, 3 * this.fit), this.elementSize && t3 * this.elementSize.x > 4e3 && (t3 = 4e3 / this.elementSize.x), t3);
    }
    l() {
      return this.m("initial") || this.fit;
    }
    p() {
      return this.m("max") || Math.max(1, 4 * this.fit);
    }
  }
  class b {
    constructor(i2, s2, h2) {
      this.data = i2, this.index = s2, this.pswp = h2, this.isActive = s2 === h2.currIndex, this.currentResolution = 0, this.panAreaSize = { x: 0, y: 0 }, this.pan = { x: 0, y: 0 }, this.isFirstSlide = this.isActive && !h2.opener.isOpen, this.zoomLevels = new x(h2.options, i2, s2, h2), this.pswp.dispatch("gettingData", { slide: this, data: this.data, index: s2 }), this.content = this.pswp.contentLoader.getContentBySlide(this), this.container = t2("pswp__zoom-wrap", "div"), this.holderElement = null, this.currZoomLevel = 1, this.width = this.content.width, this.height = this.content.height, this.heavyAppended = false, this.bounds = new _(this), this.prevDisplayedWidth = -1, this.prevDisplayedHeight = -1, this.pswp.dispatch("slideInit", { slide: this });
    }
    setIsActive(t3) {
      t3 && !this.isActive ? this.activate() : !t3 && this.isActive && this.deactivate();
    }
    append(t3) {
      this.holderElement = t3, this.container.style.transformOrigin = "0 0", this.data && (this.calculateSize(), this.load(), this.updateContentSize(), this.appendHeavy(), this.holderElement.appendChild(this.container), this.zoomAndPanToInitial(), this.pswp.dispatch("firstZoomPan", { slide: this }), this.applyCurrentZoomPan(), this.pswp.dispatch("afterSetContent", { slide: this }), this.isActive && this.activate());
    }
    load() {
      this.content.load(false), this.pswp.dispatch("slideLoad", { slide: this });
    }
    appendHeavy() {
      const { pswp: t3 } = this;
      !this.heavyAppended && t3.opener.isOpen && !t3.mainScroll.isShifted() && (this.isActive, 1) && (this.pswp.dispatch("appendHeavy", { slide: this }).defaultPrevented || (this.heavyAppended = true, this.content.append(), this.pswp.dispatch("appendHeavyContent", { slide: this })));
    }
    activate() {
      this.isActive = true, this.appendHeavy(), this.content.activate(), this.pswp.dispatch("slideActivate", { slide: this });
    }
    deactivate() {
      this.isActive = false, this.content.deactivate(), this.currZoomLevel !== this.zoomLevels.initial && this.calculateSize(), this.currentResolution = 0, this.zoomAndPanToInitial(), this.applyCurrentZoomPan(), this.updateContentSize(), this.pswp.dispatch("slideDeactivate", { slide: this });
    }
    destroy() {
      this.content.hasSlide = false, this.content.remove(), this.container.remove(), this.pswp.dispatch("slideDestroy", { slide: this });
    }
    resize() {
      this.currZoomLevel !== this.zoomLevels.initial && this.isActive ? (this.calculateSize(), this.bounds.update(this.currZoomLevel), this.panTo(this.pan.x, this.pan.y)) : (this.calculateSize(), this.currentResolution = 0, this.zoomAndPanToInitial(), this.applyCurrentZoomPan(), this.updateContentSize());
    }
    updateContentSize(t3) {
      const i2 = this.currentResolution || this.zoomLevels.initial;
      if (!i2) return;
      const s2 = Math.round(this.width * i2) || this.pswp.viewportSize.x, h2 = Math.round(this.height * i2) || this.pswp.viewportSize.y;
      (this.sizeChanged(s2, h2) || t3) && this.content.setDisplayedSize(s2, h2);
    }
    sizeChanged(t3, i2) {
      return (t3 !== this.prevDisplayedWidth || i2 !== this.prevDisplayedHeight) && (this.prevDisplayedWidth = t3, this.prevDisplayedHeight = i2, true);
    }
    getPlaceholderElement() {
      var t3;
      return null === (t3 = this.content.placeholder) || void 0 === t3 ? void 0 : t3.element;
    }
    zoomTo(t3, i2, h2, e2) {
      const { pswp: o2 } = this;
      if (!this.isZoomable() || o2.mainScroll.isShifted()) return;
      o2.dispatch("beforeZoomTo", { destZoomLevel: t3, centerPoint: i2, transitionDuration: h2 }), o2.animations.stopAllPan();
      const r3 = this.currZoomLevel;
      e2 || (t3 = n2(t3, this.zoomLevels.min, this.zoomLevels.max)), this.setZoomLevel(t3), this.pan.x = this.calculateZoomToPanOffset("x", i2, r3), this.pan.y = this.calculateZoomToPanOffset("y", i2, r3), s(this.pan);
      const a2 = () => {
        this.v(t3), this.applyCurrentZoomPan();
      };
      h2 ? o2.animations.startTransition({ isPan: true, name: "zoomTo", target: this.container, transform: this.getCurrentTransform(), onComplete: a2, duration: h2, easing: o2.options.easing }) : a2();
    }
    toggleZoom(t3) {
      this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, t3, this.pswp.options.zoomAnimationDuration);
    }
    setZoomLevel(t3) {
      this.currZoomLevel = t3, this.bounds.update(this.currZoomLevel);
    }
    calculateZoomToPanOffset(t3, i2, s2) {
      if (0 === this.bounds.max[t3] - this.bounds.min[t3]) return this.bounds.center[t3];
      i2 || (i2 = this.pswp.getViewportCenterPoint()), s2 || (s2 = this.zoomLevels.initial);
      const h2 = this.currZoomLevel / s2;
      return this.bounds.correctPan(t3, (this.pan[t3] - i2[t3]) * h2 + i2[t3]);
    }
    panTo(t3, i2) {
      this.pan.x = this.bounds.correctPan("x", t3), this.pan.y = this.bounds.correctPan("y", i2), this.applyCurrentZoomPan();
    }
    isPannable() {
      return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
    }
    isZoomable() {
      return Boolean(this.width) && this.content.isZoomable();
    }
    applyCurrentZoomPan() {
      this.g(this.pan.x, this.pan.y, this.currZoomLevel), this === this.pswp.currSlide && this.pswp.dispatch("zoomPanUpdate", { slide: this });
    }
    zoomAndPanToInitial() {
      this.currZoomLevel = this.zoomLevels.initial, this.bounds.update(this.currZoomLevel), i(this.pan, this.bounds.center), this.pswp.dispatch("initialZoomPan", { slide: this });
    }
    g(t3, i2, s2) {
      s2 /= this.currentResolution || this.zoomLevels.initial, r2(this.container, t3, i2, s2);
    }
    calculateSize() {
      const { pswp: t3 } = this;
      i(this.panAreaSize, y(t3.options, t3.viewportSize, this.data, this.index)), this.zoomLevels.update(this.width, this.height, this.panAreaSize), t3.dispatch("calcSlideSize", { slide: this });
    }
    getCurrentTransform() {
      const t3 = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
      return o(this.pan.x, this.pan.y, t3);
    }
    v(t3) {
      t3 !== this.currentResolution && (this.currentResolution = t3, this.updateContentSize(), this.pswp.dispatch("resolutionChanged"));
    }
  }
  class S {
    constructor(t3) {
      this.gestures = t3, this.pswp = t3.pswp, this.startPan = { x: 0, y: 0 };
    }
    start() {
      this.pswp.currSlide && i(this.startPan, this.pswp.currSlide.pan), this.pswp.animations.stopAll();
    }
    change() {
      const { p1: t3, prevP1: i2, dragAxis: h2 } = this.gestures, { currSlide: e2 } = this.pswp;
      if ("y" === h2 && this.pswp.options.closeOnVerticalDrag && e2 && e2.currZoomLevel <= e2.zoomLevels.fit && !this.gestures.isMultitouch) {
        const s2 = e2.pan.y + (t3.y - i2.y);
        if (!this.pswp.dispatch("verticalDrag", { panY: s2 }).defaultPrevented) {
          this._("y", s2, 0.6);
          const t4 = 1 - Math.abs(this.S(e2.pan.y));
          this.pswp.applyBgOpacity(t4), e2.applyCurrentZoomPan();
        }
      } else {
        this.M("x") || (this.M("y"), e2 && (s(e2.pan), e2.applyCurrentZoomPan()));
      }
    }
    end() {
      const { velocity: t3 } = this.gestures, { mainScroll: i2, currSlide: s2 } = this.pswp;
      let h2 = 0;
      if (this.pswp.animations.stopAll(), i2.isShifted()) {
        const s3 = (i2.x - i2.getCurrSlideX()) / this.pswp.viewportSize.x;
        t3.x < -0.5 && s3 < 0 || t3.x < 0.1 && s3 < -0.5 ? (h2 = 1, t3.x = Math.min(t3.x, 0)) : (t3.x > 0.5 && s3 > 0 || t3.x > -0.1 && s3 > 0.5) && (h2 = -1, t3.x = Math.max(t3.x, 0)), i2.moveIndexBy(h2, true, t3.x);
      }
      s2 && s2.currZoomLevel > s2.zoomLevels.max || this.gestures.isMultitouch ? this.gestures.zoomLevels.correctZoomPan(true) : (this.P("x"), this.P("y"));
    }
    P(t3) {
      const { velocity: i2 } = this.gestures, { currSlide: s2 } = this.pswp;
      if (!s2) return;
      const { pan: h2, bounds: e2 } = s2, o2 = h2[t3], r3 = this.pswp.bgOpacity < 1 && "y" === t3, a2 = o2 + (function(t4, i3) {
        return t4 * i3 / (1 - i3);
      })(i2[t3], 0.995);
      if (r3) {
        const t4 = this.S(o2), i3 = this.S(a2);
        if (t4 < 0 && i3 < -0.4 || t4 > 0 && i3 > 0.4) return void this.pswp.close();
      }
      const l2 = e2.correctPan(t3, a2);
      if (o2 === l2) return;
      const c2 = l2 === a2 ? 1 : 0.82, d2 = this.pswp.bgOpacity, u2 = l2 - o2;
      this.pswp.animations.startSpring({ name: "panGesture" + t3, isPan: true, start: o2, end: l2, velocity: i2[t3], dampingRatio: c2, onUpdate: (i3) => {
        if (r3 && this.pswp.bgOpacity < 1) {
          const t4 = 1 - (l2 - i3) / u2;
          this.pswp.applyBgOpacity(n2(d2 + (1 - d2) * t4, 0, 1));
        }
        h2[t3] = Math.floor(i3), s2.applyCurrentZoomPan();
      } });
    }
    M(t3) {
      const { p1: i2, dragAxis: s2, prevP1: h2, isMultitouch: e2 } = this.gestures, { currSlide: n3, mainScroll: o2 } = this.pswp, r3 = i2[t3] - h2[t3], a2 = o2.x + r3;
      if (!r3 || !n3) return false;
      if ("x" === t3 && !n3.isPannable() && !e2) return o2.moveTo(a2, true), true;
      const { bounds: l2 } = n3, c2 = n3.pan[t3] + r3;
      if (this.pswp.options.allowPanToNext && "x" === s2 && "x" === t3 && !e2) {
        const i3 = o2.getCurrSlideX(), s3 = o2.x - i3, h3 = r3 > 0, e3 = !h3;
        if (c2 > l2.min[t3] && h3) {
          if (l2.min[t3] <= this.startPan[t3]) return o2.moveTo(a2, true), true;
          this._(t3, c2);
        } else if (c2 < l2.max[t3] && e3) {
          if (this.startPan[t3] <= l2.max[t3]) return o2.moveTo(a2, true), true;
          this._(t3, c2);
        } else if (0 !== s3) {
          if (s3 > 0) return o2.moveTo(Math.max(a2, i3), true), true;
          if (s3 < 0) return o2.moveTo(Math.min(a2, i3), true), true;
        } else this._(t3, c2);
      } else "y" === t3 && (o2.isShifted() || l2.min.y === l2.max.y) || this._(t3, c2);
      return false;
    }
    S(t3) {
      var i2, s2;
      return (t3 - (null !== (i2 = null === (s2 = this.pswp.currSlide) || void 0 === s2 ? void 0 : s2.bounds.center.y) && void 0 !== i2 ? i2 : 0)) / (this.pswp.viewportSize.y / 3);
    }
    _(t3, i2, s2) {
      const { currSlide: h2 } = this.pswp;
      if (!h2) return;
      const { pan: e2, bounds: n3 } = h2;
      if (n3.correctPan(t3, i2) !== i2 || s2) {
        const h3 = Math.round(i2 - e2[t3]);
        e2[t3] += h3 * (s2 || 0.35);
      } else e2[t3] = i2;
    }
  }
  function z(t3, i2, s2) {
    return t3.x = (i2.x + s2.x) / 2, t3.y = (i2.y + s2.y) / 2, t3;
  }
  class M {
    constructor(t3) {
      this.gestures = t3, this.C = { x: 0, y: 0 }, this.T = { x: 0, y: 0 }, this.A = { x: 0, y: 0 }, this.D = false, this.I = 1;
    }
    start() {
      const { currSlide: t3 } = this.gestures.pswp;
      t3 && (this.I = t3.currZoomLevel, i(this.C, t3.pan)), this.gestures.pswp.animations.stopAllPan(), this.D = false;
    }
    change() {
      const { p1: t3, startP1: i2, p2: s2, startP2: e2, pswp: n3 } = this.gestures, { currSlide: o2 } = n3;
      if (!o2) return;
      const r3 = o2.zoomLevels.min, a2 = o2.zoomLevels.max;
      if (!o2.isZoomable() || n3.mainScroll.isShifted()) return;
      z(this.T, i2, e2), z(this.A, t3, s2);
      let l2 = 1 / h(i2, e2) * h(t3, s2) * this.I;
      if (l2 > o2.zoomLevels.initial + o2.zoomLevels.initial / 15 && (this.D = true), l2 < r3) if (n3.options.pinchToClose && !this.D && this.I <= o2.zoomLevels.initial) {
        const t4 = 1 - (r3 - l2) / (r3 / 1.2);
        n3.dispatch("pinchClose", { bgOpacity: t4 }).defaultPrevented || n3.applyBgOpacity(t4);
      } else l2 = r3 - 0.15 * (r3 - l2);
      else l2 > a2 && (l2 = a2 + 0.05 * (l2 - a2));
      o2.pan.x = this.L("x", l2), o2.pan.y = this.L("y", l2), o2.setZoomLevel(l2), o2.applyCurrentZoomPan();
    }
    end() {
      const { pswp: t3 } = this.gestures, { currSlide: i2 } = t3;
      (!i2 || i2.currZoomLevel < i2.zoomLevels.initial) && !this.D && t3.options.pinchToClose ? t3.close() : this.correctZoomPan();
    }
    L(t3, i2) {
      const s2 = i2 / this.I;
      return this.A[t3] - (this.T[t3] - this.C[t3]) * s2;
    }
    correctZoomPan(t3) {
      const { pswp: s2 } = this.gestures, { currSlide: h2 } = s2;
      if (null == h2 || !h2.isZoomable()) return;
      0 === this.A.x && (t3 = true);
      const o2 = h2.currZoomLevel;
      let r3, a2 = true;
      o2 < h2.zoomLevels.initial ? r3 = h2.zoomLevels.initial : o2 > h2.zoomLevels.max ? r3 = h2.zoomLevels.max : (a2 = false, r3 = o2);
      const l2 = s2.bgOpacity, c2 = s2.bgOpacity < 1, d2 = i({ x: 0, y: 0 }, h2.pan);
      let u2 = i({ x: 0, y: 0 }, d2);
      t3 && (this.A.x = 0, this.A.y = 0, this.T.x = 0, this.T.y = 0, this.I = o2, i(this.C, d2)), a2 && (u2 = { x: this.L("x", r3), y: this.L("y", r3) }), h2.setZoomLevel(r3), u2 = { x: h2.bounds.correctPan("x", u2.x), y: h2.bounds.correctPan("y", u2.y) }, h2.setZoomLevel(o2);
      const p2 = !e(u2, d2);
      if (!p2 && !a2 && !c2) return h2.v(r3), void h2.applyCurrentZoomPan();
      s2.animations.stopAllPan(), s2.animations.startSpring({ isPan: true, start: 0, end: 1e3, velocity: 0, dampingRatio: 1, naturalFrequency: 40, onUpdate: (t4) => {
        if (t4 /= 1e3, p2 || a2) {
          if (p2 && (h2.pan.x = d2.x + (u2.x - d2.x) * t4, h2.pan.y = d2.y + (u2.y - d2.y) * t4), a2) {
            const i2 = o2 + (r3 - o2) * t4;
            h2.setZoomLevel(i2);
          }
          h2.applyCurrentZoomPan();
        }
        c2 && s2.bgOpacity < 1 && s2.applyBgOpacity(n2(l2 + (1 - l2) * t4, 0, 1));
      }, onComplete: () => {
        h2.v(r3), h2.applyCurrentZoomPan();
      } });
    }
  }
  function P(t3) {
    return !!t3.target.closest(".pswp__container");
  }
  class C {
    constructor(t3) {
      this.gestures = t3;
    }
    click(t3, i2) {
      const s2 = i2.target.classList, h2 = s2.contains("pswp__img"), e2 = s2.contains("pswp__item") || s2.contains("pswp__zoom-wrap");
      h2 ? this.k("imageClick", t3, i2) : e2 && this.k("bgClick", t3, i2);
    }
    tap(t3, i2) {
      P(i2) && this.k("tap", t3, i2);
    }
    doubleTap(t3, i2) {
      P(i2) && this.k("doubleTap", t3, i2);
    }
    k(t3, i2, s2) {
      var h2;
      const { pswp: e2 } = this.gestures, { currSlide: n3 } = e2, o2 = t3 + "Action", r3 = e2.options[o2];
      if (!e2.dispatch(o2, { point: i2, originalEvent: s2 }).defaultPrevented) if ("function" != typeof r3) switch (r3) {
        case "close":
        case "next":
          e2[r3]();
          break;
        case "zoom":
          null == n3 || n3.toggleZoom(i2);
          break;
        case "zoom-or-close":
          null != n3 && n3.isZoomable() && n3.zoomLevels.secondary !== n3.zoomLevels.initial ? n3.toggleZoom(i2) : e2.options.clickToCloseNonZoomable && e2.close();
          break;
        case "toggle-controls":
          null === (h2 = this.gestures.pswp.element) || void 0 === h2 || h2.classList.toggle("pswp--ui-visible");
      }
      else r3.call(e2, i2, s2);
    }
  }
  class T {
    constructor(t3) {
      this.pswp = t3, this.dragAxis = null, this.p1 = { x: 0, y: 0 }, this.p2 = { x: 0, y: 0 }, this.prevP1 = { x: 0, y: 0 }, this.prevP2 = { x: 0, y: 0 }, this.startP1 = { x: 0, y: 0 }, this.startP2 = { x: 0, y: 0 }, this.velocity = { x: 0, y: 0 }, this.Z = { x: 0, y: 0 }, this.B = { x: 0, y: 0 }, this.F = 0, this.O = [], this.R = "ontouchstart" in window, this.N = !!window.PointerEvent, this.supportsTouch = this.R || this.N && navigator.maxTouchPoints > 1, this.F = 0, this.U = 0, this.V = false, this.isMultitouch = false, this.isDragging = false, this.isZooming = false, this.raf = null, this.G = null, this.supportsTouch || (t3.options.allowPanToNext = false), this.drag = new S(this), this.zoomLevels = new M(this), this.tapHandler = new C(this), t3.on("bindEvents", (() => {
        t3.events.add(t3.scrollWrap, "click", this.$.bind(this)), this.N ? this.q("pointer", "down", "up", "cancel") : this.R ? (this.q("touch", "start", "end", "cancel"), t3.scrollWrap && (t3.scrollWrap.ontouchmove = () => {
        }, t3.scrollWrap.ontouchend = () => {
        })) : this.q("mouse", "down", "up");
      }));
    }
    q(t3, i2, s2, h2) {
      const { pswp: e2 } = this, { events: n3 } = e2, o2 = h2 ? t3 + h2 : "";
      n3.add(e2.scrollWrap, t3 + i2, this.onPointerDown.bind(this)), n3.add(window, t3 + "move", this.onPointerMove.bind(this)), n3.add(window, t3 + s2, this.onPointerUp.bind(this)), o2 && n3.add(e2.scrollWrap, o2, this.onPointerUp.bind(this));
    }
    onPointerDown(t3) {
      const s2 = "mousedown" === t3.type || "mouse" === t3.pointerType;
      if (s2 && t3.button > 0) return;
      const { pswp: h2 } = this;
      h2.opener.isOpen ? h2.dispatch("pointerDown", { originalEvent: t3 }).defaultPrevented || (s2 && (h2.mouseDetected(), this.H(t3, "down")), h2.animations.stopAll(), this.K(t3, "down"), 1 === this.F && (this.dragAxis = null, i(this.startP1, this.p1)), this.F > 1 ? (this.W(), this.isMultitouch = true) : this.isMultitouch = false) : t3.preventDefault();
    }
    onPointerMove(t3) {
      this.H(t3, "move"), this.F && (this.K(t3, "move"), this.pswp.dispatch("pointerMove", { originalEvent: t3 }).defaultPrevented || (1 !== this.F || this.isDragging ? this.F > 1 && !this.isZooming && (this.j(), this.isZooming = true, this.X(), this.zoomLevels.start(), this.Y(), this.J()) : (this.dragAxis || this.tt(), this.dragAxis && !this.isDragging && (this.isZooming && (this.isZooming = false, this.zoomLevels.end()), this.isDragging = true, this.W(), this.X(), this.U = Date.now(), this.V = false, i(this.B, this.p1), this.velocity.x = 0, this.velocity.y = 0, this.drag.start(), this.Y(), this.J()))));
    }
    j() {
      this.isDragging && (this.isDragging = false, this.V || this.it(true), this.drag.end(), this.dragAxis = null);
    }
    onPointerUp(t3) {
      this.F && (this.K(t3, "up"), this.pswp.dispatch("pointerUp", { originalEvent: t3 }).defaultPrevented || (0 === this.F && (this.Y(), this.isDragging ? this.j() : this.isZooming || this.isMultitouch || this.st(t3)), this.F < 2 && this.isZooming && (this.isZooming = false, this.zoomLevels.end(), 1 === this.F && (this.dragAxis = null, this.X()))));
    }
    J() {
      (this.isDragging || this.isZooming) && (this.it(), this.isDragging ? e(this.p1, this.prevP1) || this.drag.change() : e(this.p1, this.prevP1) && e(this.p2, this.prevP2) || this.zoomLevels.change(), this.ht(), this.raf = requestAnimationFrame(this.J.bind(this)));
    }
    it(t3) {
      const s2 = Date.now(), h2 = s2 - this.U;
      h2 < 50 && !t3 || (this.velocity.x = this.et("x", h2), this.velocity.y = this.et("y", h2), this.U = s2, i(this.B, this.p1), this.V = true);
    }
    st(t3) {
      const { mainScroll: s2 } = this.pswp;
      if (s2.isShifted()) return void s2.moveIndexBy(0, true);
      if (t3.type.indexOf("cancel") > 0) return;
      if ("mouseup" === t3.type || "mouse" === t3.pointerType) return void this.tapHandler.click(this.startP1, t3);
      const e2 = this.pswp.options.doubleTapAction ? 300 : 0;
      this.G ? (this.W(), h(this.Z, this.startP1) < 25 && this.tapHandler.doubleTap(this.startP1, t3)) : (i(this.Z, this.startP1), this.G = setTimeout((() => {
        this.tapHandler.tap(this.startP1, t3), this.W();
      }), e2));
    }
    W() {
      this.G && (clearTimeout(this.G), this.G = null);
    }
    et(t3, i2) {
      const s2 = this.p1[t3] - this.B[t3];
      return Math.abs(s2) > 1 && i2 > 5 ? s2 / i2 : 0;
    }
    Y() {
      this.raf && (cancelAnimationFrame(this.raf), this.raf = null);
    }
    H(t3, i2) {
      this.pswp.applyFilters("preventPointerEvent", true, t3, i2) && t3.preventDefault();
    }
    K(t3, s2) {
      if (this.N) {
        const h2 = t3, e2 = this.O.findIndex(((t4) => t4.id === h2.pointerId));
        "up" === s2 && e2 > -1 ? this.O.splice(e2, 1) : "down" === s2 && -1 === e2 ? this.O.push(this.nt(h2, { x: 0, y: 0 })) : e2 > -1 && this.nt(h2, this.O[e2]), this.F = this.O.length, this.F > 0 && i(this.p1, this.O[0]), this.F > 1 && i(this.p2, this.O[1]);
      } else {
        const i2 = t3;
        this.F = 0, i2.type.indexOf("touch") > -1 ? i2.touches && i2.touches.length > 0 && (this.nt(i2.touches[0], this.p1), this.F++, i2.touches.length > 1 && (this.nt(i2.touches[1], this.p2), this.F++)) : (this.nt(t3, this.p1), "up" === s2 ? this.F = 0 : this.F++);
      }
    }
    ht() {
      i(this.prevP1, this.p1), i(this.prevP2, this.p2);
    }
    X() {
      i(this.startP1, this.p1), i(this.startP2, this.p2), this.ht();
    }
    tt() {
      if (this.pswp.mainScroll.isShifted()) this.dragAxis = "x";
      else {
        const t3 = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
        if (0 !== t3) {
          const i2 = t3 > 0 ? "x" : "y";
          Math.abs(this.p1[i2] - this.startP1[i2]) >= 10 && (this.dragAxis = i2);
        }
      }
    }
    nt(t3, i2) {
      return i2.x = t3.pageX - this.pswp.offset.x, i2.y = t3.pageY - this.pswp.offset.y, "pointerId" in t3 ? i2.id = t3.pointerId : void 0 !== t3.identifier && (i2.id = t3.identifier), i2;
    }
    $(t3) {
      this.pswp.mainScroll.isShifted() && (t3.preventDefault(), t3.stopPropagation());
    }
  }
  class A {
    constructor(t3) {
      this.pswp = t3, this.x = 0, this.slideWidth = 0, this.ot = 0, this.rt = 0, this.lt = -1, this.itemHolders = [];
    }
    resize(t3) {
      const { pswp: i2 } = this, s2 = Math.round(i2.viewportSize.x + i2.viewportSize.x * i2.options.spacing), h2 = s2 !== this.slideWidth;
      h2 && (this.slideWidth = s2, this.moveTo(this.getCurrSlideX())), this.itemHolders.forEach(((i3, s3) => {
        h2 && r2(i3.el, (s3 + this.lt) * this.slideWidth), t3 && i3.slide && i3.slide.resize();
      }));
    }
    resetPosition() {
      this.ot = 0, this.rt = 0, this.slideWidth = 0, this.lt = -1;
    }
    appendHolders() {
      this.itemHolders = [];
      for (let i2 = 0; i2 < 3; i2++) {
        const s2 = t2("pswp__item", "div", this.pswp.container);
        s2.setAttribute("role", "group"), s2.setAttribute("aria-roledescription", "slide"), s2.setAttribute("aria-hidden", "true"), s2.style.display = 1 === i2 ? "block" : "none", this.itemHolders.push({ el: s2 });
      }
    }
    canBeSwiped() {
      return this.pswp.getNumItems() > 1;
    }
    moveIndexBy(t3, i2, s2) {
      const { pswp: h2 } = this;
      let e2 = h2.potentialIndex + t3;
      const n3 = h2.getNumItems();
      if (h2.canLoop()) {
        e2 = h2.getLoopedIndex(e2);
        const i3 = (t3 + n3) % n3;
        t3 = i3 <= n3 / 2 ? i3 : i3 - n3;
      } else e2 < 0 ? e2 = 0 : e2 >= n3 && (e2 = n3 - 1), t3 = e2 - h2.potentialIndex;
      h2.potentialIndex = e2, this.ot -= t3, h2.animations.stopMainScroll();
      const o2 = this.getCurrSlideX();
      if (i2) {
        h2.animations.startSpring({ isMainScroll: true, start: this.x, end: o2, velocity: s2 || 0, naturalFrequency: 30, dampingRatio: 1, onUpdate: (t5) => {
          this.moveTo(t5);
        }, onComplete: () => {
          this.updateCurrItem(), h2.appendHeavy();
        } });
        let t4 = h2.potentialIndex - h2.currIndex;
        if (h2.canLoop()) {
          const i3 = (t4 + n3) % n3;
          t4 = i3 <= n3 / 2 ? i3 : i3 - n3;
        }
        Math.abs(t4) > 1 && this.updateCurrItem();
      } else this.moveTo(o2), this.updateCurrItem();
      return Boolean(t3);
    }
    getCurrSlideX() {
      return this.slideWidth * this.ot;
    }
    isShifted() {
      return this.x !== this.getCurrSlideX();
    }
    updateCurrItem() {
      var t3;
      const { pswp: i2 } = this, s2 = this.rt - this.ot;
      if (!s2) return;
      this.rt = this.ot, i2.currIndex = i2.potentialIndex;
      let h2, e2 = Math.abs(s2);
      e2 >= 3 && (this.lt += s2 + (s2 > 0 ? -3 : 3), e2 = 3, this.itemHolders.forEach(((t4) => {
        var i3;
        null === (i3 = t4.slide) || void 0 === i3 || i3.destroy(), t4.slide = void 0;
      })));
      for (let t4 = 0; t4 < e2; t4++) s2 > 0 ? (h2 = this.itemHolders.shift(), h2 && (this.itemHolders[2] = h2, this.lt++, r2(h2.el, (this.lt + 2) * this.slideWidth), i2.setContent(h2, i2.currIndex - e2 + t4 + 2))) : (h2 = this.itemHolders.pop(), h2 && (this.itemHolders.unshift(h2), this.lt--, r2(h2.el, this.lt * this.slideWidth), i2.setContent(h2, i2.currIndex + e2 - t4 - 2)));
      Math.abs(this.lt) > 50 && !this.isShifted() && (this.resetPosition(), this.resize()), i2.animations.stopAllPan(), this.itemHolders.forEach(((t4, i3) => {
        t4.slide && t4.slide.setIsActive(1 === i3);
      })), i2.currSlide = null === (t3 = this.itemHolders[1]) || void 0 === t3 ? void 0 : t3.slide, i2.contentLoader.updateLazy(s2), i2.currSlide && i2.currSlide.applyCurrentZoomPan(), i2.dispatch("change");
    }
    moveTo(t3, i2) {
      if (!this.pswp.canLoop() && i2) {
        let i3 = (this.slideWidth * this.ot - t3) / this.slideWidth;
        i3 += this.pswp.currIndex;
        const s2 = Math.round(t3 - this.x);
        (i3 < 0 && s2 > 0 || i3 >= this.pswp.getNumItems() - 1 && s2 < 0) && (t3 = this.x + 0.35 * s2);
      }
      this.x = t3, this.pswp.container && r2(this.pswp.container, t3), this.pswp.dispatch("moveMainScroll", { x: t3, dragging: null != i2 && i2 });
    }
  }
  const D = { Escape: 27, z: 90, ArrowLeft: 37, ArrowUp: 38, ArrowRight: 39, ArrowDown: 40, Tab: 9 }, I = (t3, i2) => i2 ? t3 : D[t3];
  class E {
    constructor(t3) {
      this.pswp = t3, this.ct = false, t3.on("bindEvents", (() => {
        t3.options.trapFocus && (t3.options.initialPointerPos || this.dt(), t3.events.add(document, "focusin", this.ut.bind(this))), t3.events.add(document, "keydown", this.vt.bind(this));
      }));
      const i2 = document.activeElement;
      t3.on("destroy", (() => {
        t3.options.returnFocus && i2 && this.ct && i2.focus();
      }));
    }
    dt() {
      !this.ct && this.pswp.element && (this.pswp.element.focus(), this.ct = true);
    }
    vt(t3) {
      const { pswp: i2 } = this;
      if (i2.dispatch("keydown", { originalEvent: t3 }).defaultPrevented) return;
      if ((function(t4) {
        return "button" in t4 && 1 === t4.button || t4.ctrlKey || t4.metaKey || t4.altKey || t4.shiftKey;
      })(t3)) return;
      let s2, h2, e2 = false;
      const n3 = "key" in t3;
      switch (n3 ? t3.key : t3.keyCode) {
        case I("Escape", n3):
          i2.options.escKey && (s2 = "close");
          break;
        case I("z", n3):
          s2 = "toggleZoom";
          break;
        case I("ArrowLeft", n3):
          h2 = "x";
          break;
        case I("ArrowUp", n3):
          h2 = "y";
          break;
        case I("ArrowRight", n3):
          h2 = "x", e2 = true;
          break;
        case I("ArrowDown", n3):
          e2 = true, h2 = "y";
          break;
        case I("Tab", n3):
          this.dt();
      }
      if (h2) {
        t3.preventDefault();
        const { currSlide: n4 } = i2;
        i2.options.arrowKeys && "x" === h2 && i2.getNumItems() > 1 ? s2 = e2 ? "next" : "prev" : n4 && n4.currZoomLevel > n4.zoomLevels.fit && (n4.pan[h2] += e2 ? -80 : 80, n4.panTo(n4.pan.x, n4.pan.y));
      }
      s2 && (t3.preventDefault(), i2[s2]());
    }
    ut(t3) {
      const { template: i2 } = this.pswp;
      i2 && document !== t3.target && i2 !== t3.target && !i2.contains(t3.target) && i2.focus();
    }
  }
  const L = "cubic-bezier(.4,0,.22,1)";
  class k {
    constructor(t3) {
      var i2;
      this.props = t3;
      const { target: s2, onComplete: h2, transform: e2, onFinish: n3 = (() => {
      }), duration: o2 = 333, easing: r3 = L } = t3;
      this.onFinish = n3;
      const l2 = e2 ? "transform" : "opacity", c2 = null !== (i2 = t3[l2]) && void 0 !== i2 ? i2 : "";
      this.ft = s2, this.wt = h2, this.gt = false, this.yt = this.yt.bind(this), this._t = setTimeout((() => {
        a(s2, l2, o2, r3), this._t = setTimeout((() => {
          s2.addEventListener("transitionend", this.yt, false), s2.addEventListener("transitioncancel", this.yt, false), this._t = setTimeout((() => {
            this.xt();
          }), o2 + 500), s2.style[l2] = c2;
        }), 30);
      }), 0);
    }
    yt(t3) {
      t3.target === this.ft && this.xt();
    }
    xt() {
      this.gt || (this.gt = true, this.onFinish(), this.wt && this.wt());
    }
    destroy() {
      this._t && clearTimeout(this._t), a(this.ft), this.ft.removeEventListener("transitionend", this.yt, false), this.ft.removeEventListener("transitioncancel", this.yt, false), this.gt || this.xt();
    }
  }
  class Z {
    constructor(t3, i2, s2) {
      this.velocity = 1e3 * t3, this.bt = i2 || 0.75, this.St = s2 || 12, this.zt = this.St, this.bt < 1 && (this.zt *= Math.sqrt(1 - this.bt * this.bt));
    }
    easeFrame(t3, i2) {
      let s2, h2 = 0;
      i2 /= 1e3;
      const e2 = Math.E ** (-this.bt * this.St * i2);
      if (1 === this.bt) s2 = this.velocity + this.St * t3, h2 = (t3 + s2 * i2) * e2, this.velocity = h2 * -this.St + s2 * e2;
      else if (this.bt < 1) {
        s2 = 1 / this.zt * (this.bt * this.St * t3 + this.velocity);
        const n3 = Math.cos(this.zt * i2), o2 = Math.sin(this.zt * i2);
        h2 = e2 * (t3 * n3 + s2 * o2), this.velocity = h2 * -this.St * this.bt + e2 * (-this.zt * t3 * o2 + this.zt * s2 * n3);
      }
      return h2;
    }
  }
  class B {
    constructor(t3) {
      this.props = t3, this.Mt = 0;
      const { start: i2, end: s2, velocity: h2, onUpdate: e2, onComplete: n3, onFinish: o2 = (() => {
      }), dampingRatio: r3, naturalFrequency: a2 } = t3;
      this.onFinish = o2;
      const l2 = new Z(h2, r3, a2);
      let c2 = Date.now(), d2 = i2 - s2;
      const u2 = () => {
        this.Mt && (d2 = l2.easeFrame(d2, Date.now() - c2), Math.abs(d2) < 1 && Math.abs(l2.velocity) < 50 ? (e2(s2), n3 && n3(), this.onFinish()) : (c2 = Date.now(), e2(d2 + s2), this.Mt = requestAnimationFrame(u2)));
      };
      this.Mt = requestAnimationFrame(u2);
    }
    destroy() {
      this.Mt >= 0 && cancelAnimationFrame(this.Mt), this.Mt = 0;
    }
  }
  class F {
    constructor() {
      this.activeAnimations = [];
    }
    startSpring(t3) {
      this.Pt(t3, true);
    }
    startTransition(t3) {
      this.Pt(t3);
    }
    Pt(t3, i2) {
      const s2 = i2 ? new B(t3) : new k(t3);
      return this.activeAnimations.push(s2), s2.onFinish = () => this.stop(s2), s2;
    }
    stop(t3) {
      t3.destroy();
      const i2 = this.activeAnimations.indexOf(t3);
      i2 > -1 && this.activeAnimations.splice(i2, 1);
    }
    stopAll() {
      this.activeAnimations.forEach(((t3) => {
        t3.destroy();
      })), this.activeAnimations = [];
    }
    stopAllPan() {
      this.activeAnimations = this.activeAnimations.filter(((t3) => !t3.props.isPan || (t3.destroy(), false)));
    }
    stopMainScroll() {
      this.activeAnimations = this.activeAnimations.filter(((t3) => !t3.props.isMainScroll || (t3.destroy(), false)));
    }
    isPanRunning() {
      return this.activeAnimations.some(((t3) => t3.props.isPan));
    }
  }
  class O {
    constructor(t3) {
      this.pswp = t3, t3.events.add(t3.element, "wheel", this.Ct.bind(this));
    }
    Ct(t3) {
      t3.preventDefault();
      const { currSlide: i2 } = this.pswp;
      let { deltaX: s2, deltaY: h2 } = t3;
      if (i2 && !this.pswp.dispatch("wheel", { originalEvent: t3 }).defaultPrevented) if (t3.ctrlKey || this.pswp.options.wheelToZoom) {
        if (i2.isZoomable()) {
          let s3 = -h2;
          1 === t3.deltaMode ? s3 *= 0.05 : s3 *= t3.deltaMode ? 1 : 2e-3, s3 = 2 ** s3;
          const e2 = i2.currZoomLevel * s3;
          i2.zoomTo(e2, { x: t3.clientX, y: t3.clientY });
        }
      } else i2.isPannable() && (1 === t3.deltaMode && (s2 *= 18, h2 *= 18), i2.panTo(i2.pan.x - s2, i2.pan.y - h2));
    }
  }
  class R {
    constructor(i2, s2) {
      var h2;
      const e2 = s2.name || s2.className;
      let n3 = s2.html;
      if (false === i2.options[e2]) return;
      "string" == typeof i2.options[e2 + "SVG"] && (n3 = i2.options[e2 + "SVG"]), i2.dispatch("uiElementCreate", { data: s2 });
      let o2 = "";
      s2.isButton ? (o2 += "pswp__button ", o2 += s2.className || `pswp__button--${s2.name}`) : o2 += s2.className || `pswp__${s2.name}`;
      let r3 = s2.isButton ? s2.tagName || "button" : s2.tagName || "div";
      r3 = r3.toLowerCase();
      const a2 = t2(o2, r3);
      if (s2.isButton) {
        "button" === r3 && (a2.type = "button");
        let { title: t3 } = s2;
        const { ariaLabel: h3 } = s2;
        "string" == typeof i2.options[e2 + "Title"] && (t3 = i2.options[e2 + "Title"]), t3 && (a2.title = t3);
        const n4 = h3 || t3;
        n4 && a2.setAttribute("aria-label", n4);
      }
      a2.innerHTML = (function(t3) {
        if ("string" == typeof t3) return t3;
        if (!t3 || !t3.isCustomSVG) return "";
        const i3 = t3;
        let s3 = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
        return s3 = s3.split("%d").join(i3.size || 32), i3.outlineID && (s3 += '<use class="pswp__icn-shadow" xlink:href="#' + i3.outlineID + '"/>'), s3 += i3.inner, s3 += "</svg>", s3;
      })(n3), s2.onInit && s2.onInit(a2, i2), s2.onClick && (a2.onclick = (t3) => {
        "string" == typeof s2.onClick ? i2[s2.onClick]() : "function" == typeof s2.onClick && s2.onClick(t3, a2, i2);
      });
      const l2 = s2.appendTo || "bar";
      let c2 = i2.element;
      "bar" === l2 ? (i2.topBar || (i2.topBar = t2("pswp__top-bar pswp__hide-on-close", "div", i2.scrollWrap)), c2 = i2.topBar) : (a2.classList.add("pswp__hide-on-close"), "wrapper" === l2 && (c2 = i2.scrollWrap)), null === (h2 = c2) || void 0 === h2 || h2.appendChild(i2.applyFilters("uiElement", a2, s2));
    }
  }
  function N(t3, i2, s2) {
    t3.classList.add("pswp__button--arrow"), t3.setAttribute("aria-controls", "pswp__items"), i2.on("change", (() => {
      i2.options.loop || (t3.disabled = s2 ? !(i2.currIndex < i2.getNumItems() - 1) : !(i2.currIndex > 0));
    }));
  }
  const U = { name: "arrowPrev", className: "pswp__button--arrow--prev", title: "Previous", order: 10, isButton: true, appendTo: "wrapper", html: { isCustomSVG: true, size: 60, inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>', outlineID: "pswp__icn-arrow" }, onClick: "prev", onInit: N }, V = { name: "arrowNext", className: "pswp__button--arrow--next", title: "Next", order: 11, isButton: true, appendTo: "wrapper", html: { isCustomSVG: true, size: 60, inner: '<use xlink:href="#pswp__icn-arrow"/>', outlineID: "pswp__icn-arrow" }, onClick: "next", onInit: (t3, i2) => {
    N(t3, i2, true);
  } }, G = { name: "close", title: "Close", order: 20, isButton: true, html: { isCustomSVG: true, inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>', outlineID: "pswp__icn-close" }, onClick: "close" }, $ = { name: "zoom", title: "Zoom", order: 10, isButton: true, html: { isCustomSVG: true, inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>', outlineID: "pswp__icn-zoom" }, onClick: "toggleZoom" }, q = { name: "preloader", appendTo: "bar", order: 7, html: { isCustomSVG: true, inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>', outlineID: "pswp__icn-loading" }, onInit: (t3, i2) => {
    let s2, h2 = null;
    const e2 = (i3) => {
      var h3, e3;
      s2 !== i3 && (s2 = i3, h3 = "active", e3 = i3, t3.classList.toggle("pswp__preloader--" + h3, e3));
    }, n3 = () => {
      var t4;
      if (null === (t4 = i2.currSlide) || void 0 === t4 || !t4.content.isLoading()) return e2(false), void (h2 && (clearTimeout(h2), h2 = null));
      h2 || (h2 = setTimeout((() => {
        var t5;
        e2(Boolean(null === (t5 = i2.currSlide) || void 0 === t5 ? void 0 : t5.content.isLoading())), h2 = null;
      }), i2.options.preloaderDelay));
    };
    i2.on("change", n3), i2.on("loadComplete", ((t4) => {
      i2.currSlide === t4.slide && n3();
    })), i2.ui && (i2.ui.updatePreloaderVisibility = n3);
  } }, H = { name: "counter", order: 5, onInit: (t3, i2) => {
    i2.on("change", (() => {
      t3.innerText = i2.currIndex + 1 + i2.options.indexIndicatorSep + i2.getNumItems();
    }));
  } };
  function K(t3, i2) {
    t3.classList.toggle("pswp--zoomed-in", i2);
  }
  class W {
    constructor(t3) {
      this.pswp = t3, this.isRegistered = false, this.uiElementsData = [], this.items = [], this.updatePreloaderVisibility = () => {
      }, this.Tt = void 0;
    }
    init() {
      const { pswp: t3 } = this;
      this.isRegistered = false, this.uiElementsData = [G, U, V, $, q, H], t3.dispatch("uiRegister"), this.uiElementsData.sort(((t4, i2) => (t4.order || 0) - (i2.order || 0))), this.items = [], this.isRegistered = true, this.uiElementsData.forEach(((t4) => {
        this.registerElement(t4);
      })), t3.on("change", (() => {
        var i2;
        null === (i2 = t3.element) || void 0 === i2 || i2.classList.toggle("pswp--one-slide", 1 === t3.getNumItems());
      })), t3.on("zoomPanUpdate", (() => this.At()));
    }
    registerElement(t3) {
      this.isRegistered ? this.items.push(new R(this.pswp, t3)) : this.uiElementsData.push(t3);
    }
    At() {
      const { template: t3, currSlide: i2, options: s2 } = this.pswp;
      if (this.pswp.opener.isClosing || !t3 || !i2) return;
      let { currZoomLevel: h2 } = i2;
      if (this.pswp.opener.isOpen || (h2 = i2.zoomLevels.initial), h2 === this.Tt) return;
      this.Tt = h2;
      const e2 = i2.zoomLevels.initial - i2.zoomLevels.secondary;
      if (Math.abs(e2) < 0.01 || !i2.isZoomable()) return K(t3, false), void t3.classList.remove("pswp--zoom-allowed");
      t3.classList.add("pswp--zoom-allowed");
      K(t3, (h2 === i2.zoomLevels.initial ? i2.zoomLevels.secondary : i2.zoomLevels.initial) <= h2), "zoom" !== s2.imageClickAction && "zoom-or-close" !== s2.imageClickAction || t3.classList.add("pswp--click-to-zoom");
    }
  }
  class j {
    constructor(t3, i2) {
      this.type = t3, this.defaultPrevented = false, i2 && Object.assign(this, i2);
    }
    preventDefault() {
      this.defaultPrevented = true;
    }
  }
  class X {
    constructor(i2, s2) {
      if (this.element = t2("pswp__img pswp__img--placeholder", i2 ? "img" : "div", s2), i2) {
        const t3 = this.element;
        t3.decoding = "async", t3.alt = "", t3.src = i2, t3.setAttribute("role", "presentation");
      }
      this.element.setAttribute("aria-hidden", "true");
    }
    setDisplayedSize(t3, i2) {
      this.element && ("IMG" === this.element.tagName ? (l(this.element, 250, "auto"), this.element.style.transformOrigin = "0 0", this.element.style.transform = o(0, 0, t3 / 250)) : l(this.element, t3, i2));
    }
    destroy() {
      var t3;
      null !== (t3 = this.element) && void 0 !== t3 && t3.parentNode && this.element.remove(), this.element = null;
    }
  }
  class Y {
    constructor(t3, i2, s2) {
      this.instance = i2, this.data = t3, this.index = s2, this.element = void 0, this.placeholder = void 0, this.slide = void 0, this.displayedImageWidth = 0, this.displayedImageHeight = 0, this.width = Number(this.data.w) || Number(this.data.width) || 0, this.height = Number(this.data.h) || Number(this.data.height) || 0, this.isAttached = false, this.hasSlide = false, this.isDecoding = false, this.state = c, this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html", this.instance.dispatch("contentInit", { content: this });
    }
    removePlaceholder() {
      this.placeholder && !this.keepPlaceholder() && setTimeout((() => {
        this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0);
      }), 1e3);
    }
    load(i2, s2) {
      if (this.slide && this.usePlaceholder()) if (this.placeholder) {
        const t3 = this.placeholder.element;
        t3 && !t3.parentElement && this.slide.container.prepend(t3);
      } else {
        const t3 = this.instance.applyFilters("placeholderSrc", !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc, this);
        this.placeholder = new X(t3, this.slide.container);
      }
      this.element && !s2 || this.instance.dispatch("contentLoad", { content: this, isLazy: i2 }).defaultPrevented || (this.isImageContent() ? (this.element = t2("pswp__img", "img"), this.displayedImageWidth && this.loadImage(i2)) : (this.element = t2("pswp__content", "div"), this.element.innerHTML = this.data.html || ""), s2 && this.slide && this.slide.updateContentSize(true));
    }
    loadImage(t3) {
      var i2, s2;
      if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", { content: this, isLazy: t3 }).defaultPrevented) return;
      const h2 = this.element;
      this.updateSrcsetSizes(), this.data.srcset && (h2.srcset = this.data.srcset), h2.src = null !== (i2 = this.data.src) && void 0 !== i2 ? i2 : "", h2.alt = null !== (s2 = this.data.alt) && void 0 !== s2 ? s2 : "", this.state = d, h2.complete ? this.onLoaded() : (h2.onload = () => {
        this.onLoaded();
      }, h2.onerror = () => {
        this.onError();
      });
    }
    setSlide(t3) {
      this.slide = t3, this.hasSlide = true, this.instance = t3.pswp;
    }
    onLoaded() {
      this.state = u, this.slide && this.element && (this.instance.dispatch("loadComplete", { slide: this.slide, content: this }), this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(true)), this.state !== u && this.state !== p || this.removePlaceholder());
    }
    onError() {
      this.state = p, this.slide && (this.displayError(), this.instance.dispatch("loadComplete", { slide: this.slide, isError: true, content: this }), this.instance.dispatch("loadError", { slide: this.slide, content: this }));
    }
    isLoading() {
      return this.instance.applyFilters("isContentLoading", this.state === d, this);
    }
    isError() {
      return this.state === p;
    }
    isImageContent() {
      return "image" === this.type;
    }
    setDisplayedSize(t3, i2) {
      if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(t3, i2), !this.instance.dispatch("contentResize", { content: this, width: t3, height: i2 }).defaultPrevented && (l(this.element, t3, i2), this.isImageContent() && !this.isError()))) {
        const s2 = !this.displayedImageWidth && t3;
        this.displayedImageWidth = t3, this.displayedImageHeight = i2, s2 ? this.loadImage(false) : this.updateSrcsetSizes(), this.slide && this.instance.dispatch("imageSizeChange", { slide: this.slide, width: t3, height: i2, content: this });
      }
    }
    isZoomable() {
      return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== p, this);
    }
    updateSrcsetSizes() {
      if (!this.isImageContent() || !this.element || !this.data.srcset) return;
      const t3 = this.element, i2 = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
      (!t3.dataset.largestUsedSize || i2 > parseInt(t3.dataset.largestUsedSize, 10)) && (t3.sizes = i2 + "px", t3.dataset.largestUsedSize = String(i2));
    }
    usePlaceholder() {
      return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
    }
    lazyLoad() {
      this.instance.dispatch("contentLazyLoad", { content: this }).defaultPrevented || this.load(true);
    }
    keepPlaceholder() {
      return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
    }
    destroy() {
      this.hasSlide = false, this.slide = void 0, this.instance.dispatch("contentDestroy", { content: this }).defaultPrevented || (this.remove(), this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0), this.isImageContent() && this.element && (this.element.onload = null, this.element.onerror = null, this.element = void 0));
    }
    displayError() {
      if (this.slide) {
        var i2, s2;
        let h2 = t2("pswp__error-msg", "div");
        h2.innerText = null !== (i2 = null === (s2 = this.instance.options) || void 0 === s2 ? void 0 : s2.errorMsg) && void 0 !== i2 ? i2 : "", h2 = this.instance.applyFilters("contentErrorElement", h2, this), this.element = t2("pswp__content pswp__error-msg-container", "div"), this.element.appendChild(h2), this.slide.container.innerText = "", this.slide.container.appendChild(this.element), this.slide.updateContentSize(true), this.removePlaceholder();
      }
    }
    append() {
      if (this.isAttached || !this.element) return;
      if (this.isAttached = true, this.state === p) return void this.displayError();
      if (this.instance.dispatch("contentAppend", { content: this }).defaultPrevented) return;
      const t3 = "decode" in this.element;
      this.isImageContent() ? t3 && this.slide && (!this.slide.isActive || m()) ? (this.isDecoding = true, this.element.decode().catch((() => {
      })).finally((() => {
        this.isDecoding = false, this.appendImage();
      }))) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
    }
    activate() {
      !this.instance.dispatch("contentActivate", { content: this }).defaultPrevented && this.slide && (this.isImageContent() && this.isDecoding && !m() ? this.appendImage() : this.isError() && this.load(false, true), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"));
    }
    deactivate() {
      this.instance.dispatch("contentDeactivate", { content: this }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true");
    }
    remove() {
      this.isAttached = false, this.instance.dispatch("contentRemove", { content: this }).defaultPrevented || (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove());
    }
    appendImage() {
      this.isAttached && (this.instance.dispatch("contentAppendImage", { content: this }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), this.state !== u && this.state !== p || this.removePlaceholder()));
    }
  }
  function J(t3, i2, s2) {
    const h2 = i2.createContentFromData(t3, s2);
    let e2;
    const { options: n3 } = i2;
    if (n3) {
      let o2;
      e2 = new x(n3, t3, -1), o2 = i2.pswp ? i2.pswp.viewportSize : w(n3, i2);
      const r3 = y(n3, o2, t3, s2);
      e2.update(h2.width, h2.height, r3);
    }
    return h2.lazyLoad(), e2 && h2.setDisplayedSize(Math.ceil(h2.width * e2.initial), Math.ceil(h2.height * e2.initial)), h2;
  }
  class Q {
    constructor(t3) {
      this.pswp = t3, this.limit = Math.max(t3.options.preload[0] + t3.options.preload[1] + 1, 5), this.Dt = [];
    }
    updateLazy(t3) {
      const { pswp: i2 } = this;
      if (i2.dispatch("lazyLoad").defaultPrevented) return;
      const { preload: s2 } = i2.options, h2 = void 0 === t3 || t3 >= 0;
      let e2;
      for (e2 = 0; e2 <= s2[1]; e2++) this.loadSlideByIndex(i2.currIndex + (h2 ? e2 : -e2));
      for (e2 = 1; e2 <= s2[0]; e2++) this.loadSlideByIndex(i2.currIndex + (h2 ? -e2 : e2));
    }
    loadSlideByIndex(t3) {
      const i2 = this.pswp.getLoopedIndex(t3);
      let s2 = this.getContentByIndex(i2);
      s2 || (s2 = (function(t4, i3) {
        const s3 = i3.getItemData(t4);
        if (!i3.dispatch("lazyLoadSlide", { index: t4, itemData: s3 }).defaultPrevented) return J(s3, i3, t4);
      })(i2, this.pswp), s2 && this.addToCache(s2));
    }
    getContentBySlide(t3) {
      let i2 = this.getContentByIndex(t3.index);
      return i2 || (i2 = this.pswp.createContentFromData(t3.data, t3.index), this.addToCache(i2)), i2.setSlide(t3), i2;
    }
    addToCache(t3) {
      if (this.removeByIndex(t3.index), this.Dt.push(t3), this.Dt.length > this.limit) {
        const t4 = this.Dt.findIndex(((t5) => !t5.isAttached && !t5.hasSlide));
        if (-1 !== t4) {
          this.Dt.splice(t4, 1)[0].destroy();
        }
      }
    }
    removeByIndex(t3) {
      const i2 = this.Dt.findIndex(((i3) => i3.index === t3));
      -1 !== i2 && this.Dt.splice(i2, 1);
    }
    getContentByIndex(t3) {
      return this.Dt.find(((i2) => i2.index === t3));
    }
    destroy() {
      this.Dt.forEach(((t3) => t3.destroy())), this.Dt = [];
    }
  }
  const tt = 3e-3;
  class it {
    constructor(t3) {
      this.pswp = t3, this.isClosed = true, this.isOpen = false, this.isClosing = false, this.isOpening = false, this.It = void 0, this.Et = false, this.Lt = false, this.kt = false, this.Zt = false, this.Bt = void 0, this.Ft = void 0, this.Ot = void 0, this.Rt = void 0, this.Nt = void 0, this.Ut = this.Ut.bind(this), t3.on("firstZoomPan", this.Ut);
    }
    open() {
      this.Ut(), this.Pt();
    }
    close() {
      if (this.isClosed || this.isClosing || this.isOpening) return;
      const t3 = this.pswp.currSlide;
      this.isOpen = false, this.isOpening = false, this.isClosing = true, this.It = this.pswp.options.hideAnimationDuration, t3 && t3.currZoomLevel * t3.width >= this.pswp.options.maxWidthToAnimate && (this.It = 0), this.Vt(), setTimeout((() => {
        this.Pt();
      }), this.Lt ? 30 : 0);
    }
    Ut() {
      if (this.pswp.off("firstZoomPan", this.Ut), !this.isOpening) {
        const t3 = this.pswp.currSlide;
        this.isOpening = true, this.isClosing = false, this.It = this.pswp.options.showAnimationDuration, t3 && t3.zoomLevels.initial * t3.width >= this.pswp.options.maxWidthToAnimate && (this.It = 0), this.Vt();
      }
    }
    Vt() {
      const { pswp: t3 } = this, i2 = this.pswp.currSlide, { options: s2 } = t3;
      var h2, e2;
      ("fade" === s2.showHideAnimationType ? (s2.showHideOpacity = true, this.Nt = void 0) : "none" === s2.showHideAnimationType ? (s2.showHideOpacity = false, this.It = 0, this.Nt = void 0) : this.isOpening && t3.Gt ? this.Nt = t3.Gt : this.Nt = this.pswp.getThumbBounds(), this.Bt = null == i2 ? void 0 : i2.getPlaceholderElement(), t3.animations.stopAll(), this.Et = Boolean(this.It && this.It > 50), this.$t = Boolean(this.Nt) && (null == i2 ? void 0 : i2.content.usePlaceholder()) && (!this.isClosing || !t3.mainScroll.isShifted()), this.$t) ? this.kt = null !== (h2 = s2.showHideOpacity) && void 0 !== h2 && h2 : (this.kt = true, this.isOpening && i2 && (i2.zoomAndPanToInitial(), i2.applyCurrentZoomPan()));
      if (this.Zt = !this.kt && this.pswp.options.bgOpacity > tt, this.Ft = this.kt ? t3.element : t3.bg, !this.Et) return this.It = 0, this.$t = false, this.Zt = false, this.kt = true, void (this.isOpening && (t3.element && (t3.element.style.opacity = String(tt)), t3.applyBgOpacity(1)));
      this.$t && this.Nt && this.Nt.innerRect ? (this.Lt = true, this.Ot = this.pswp.container, this.Rt = null === (e2 = this.pswp.currSlide) || void 0 === e2 ? void 0 : e2.holderElement, t3.container && (t3.container.style.overflow = "hidden", t3.container.style.width = t3.viewportSize.x + "px")) : this.Lt = false;
      this.isOpening ? (this.kt ? (t3.element && (t3.element.style.opacity = String(tt)), t3.applyBgOpacity(1)) : (this.Zt && t3.bg && (t3.bg.style.opacity = String(tt)), t3.element && (t3.element.style.opacity = "1")), this.$t && (this.qt(), this.Bt && (this.Bt.style.willChange = "transform", this.Bt.style.opacity = String(tt)))) : this.isClosing && (t3.mainScroll.itemHolders[0] && (t3.mainScroll.itemHolders[0].el.style.display = "none"), t3.mainScroll.itemHolders[2] && (t3.mainScroll.itemHolders[2].el.style.display = "none"), this.Lt && 0 !== t3.mainScroll.x && (t3.mainScroll.resetPosition(), t3.mainScroll.resize()));
    }
    Pt() {
      this.isOpening && this.Et && this.Bt && "IMG" === this.Bt.tagName ? new Promise(((t3) => {
        let i2 = false, s2 = true;
        var h2;
        (h2 = this.Bt, "decode" in h2 ? h2.decode().catch((() => {
        })) : h2.complete ? Promise.resolve(h2) : new Promise(((t4, i3) => {
          h2.onload = () => t4(h2), h2.onerror = i3;
        }))).finally((() => {
          i2 = true, s2 || t3(true);
        })), setTimeout((() => {
          s2 = false, i2 && t3(true);
        }), 50), setTimeout(t3, 250);
      })).finally((() => this.Ht())) : this.Ht();
    }
    Ht() {
      var t3, i2;
      null === (t3 = this.pswp.element) || void 0 === t3 || t3.style.setProperty("--pswp-transition-duration", this.It + "ms"), this.pswp.dispatch(this.isOpening ? "openingAnimationStart" : "closingAnimationStart"), this.pswp.dispatch("initialZoom" + (this.isOpening ? "In" : "Out")), null === (i2 = this.pswp.element) || void 0 === i2 || i2.classList.toggle("pswp--ui-visible", this.isOpening), this.isOpening ? (this.Bt && (this.Bt.style.opacity = "1"), this.Kt()) : this.isClosing && this.Wt(), this.Et || this.jt();
    }
    jt() {
      const { pswp: t3 } = this;
      if (this.isOpen = this.isOpening, this.isClosed = this.isClosing, this.isOpening = false, this.isClosing = false, t3.dispatch(this.isOpen ? "openingAnimationEnd" : "closingAnimationEnd"), t3.dispatch("initialZoom" + (this.isOpen ? "InEnd" : "OutEnd")), this.isClosed) t3.destroy();
      else if (this.isOpen) {
        var i2;
        this.$t && t3.container && (t3.container.style.overflow = "visible", t3.container.style.width = "100%"), null === (i2 = t3.currSlide) || void 0 === i2 || i2.applyCurrentZoomPan();
      }
    }
    Kt() {
      const { pswp: t3 } = this;
      this.$t && (this.Lt && this.Ot && this.Rt && (this.Xt(this.Ot, "transform", "translate3d(0,0,0)"), this.Xt(this.Rt, "transform", "none")), t3.currSlide && (t3.currSlide.zoomAndPanToInitial(), this.Xt(t3.currSlide.container, "transform", t3.currSlide.getCurrentTransform()))), this.Zt && t3.bg && this.Xt(t3.bg, "opacity", String(t3.options.bgOpacity)), this.kt && t3.element && this.Xt(t3.element, "opacity", "1");
    }
    Wt() {
      const { pswp: t3 } = this;
      this.$t && this.qt(true), this.Zt && t3.bgOpacity > 0.01 && t3.bg && this.Xt(t3.bg, "opacity", "0"), this.kt && t3.element && this.Xt(t3.element, "opacity", "0");
    }
    qt(t3) {
      if (!this.Nt) return;
      const { pswp: s2 } = this, { innerRect: h2 } = this.Nt, { currSlide: e2, viewportSize: n3 } = s2;
      if (this.Lt && h2 && this.Ot && this.Rt) {
        const i2 = -n3.x + (this.Nt.x - h2.x) + h2.w, s3 = -n3.y + (this.Nt.y - h2.y) + h2.h, e3 = n3.x - h2.w, a2 = n3.y - h2.h;
        t3 ? (this.Xt(this.Ot, "transform", o(i2, s3)), this.Xt(this.Rt, "transform", o(e3, a2))) : (r2(this.Ot, i2, s3), r2(this.Rt, e3, a2));
      }
      e2 && (i(e2.pan, h2 || this.Nt), e2.currZoomLevel = this.Nt.w / e2.width, t3 ? this.Xt(e2.container, "transform", e2.getCurrentTransform()) : e2.applyCurrentZoomPan());
    }
    Xt(t3, i2, s2) {
      if (!this.It) return void (t3.style[i2] = s2);
      const { animations: h2 } = this.pswp, e2 = { duration: this.It, easing: this.pswp.options.easing, onComplete: () => {
        h2.activeAnimations.length || this.jt();
      }, target: t3 };
      e2[i2] = s2, h2.startTransition(e2);
    }
  }
  const st = { allowPanToNext: true, spacing: 0.1, loop: true, pinchToClose: true, closeOnVerticalDrag: true, hideAnimationDuration: 333, showAnimationDuration: 333, zoomAnimationDuration: 333, escKey: true, arrowKeys: true, trapFocus: true, returnFocus: true, maxWidthToAnimate: 4e3, clickToCloseNonZoomable: true, imageClickAction: "zoom-or-close", bgClickAction: "close", tapAction: "toggle-controls", doubleTapAction: "zoom", indexIndicatorSep: " / ", preloaderDelay: 2e3, bgOpacity: 0.8, index: 0, errorMsg: "The image cannot be loaded", preload: [1, 2], easing: "cubic-bezier(.4,0,.22,1)" };
  return class extends class extends class {
    constructor() {
      this.Yt = {}, this.Jt = {}, this.pswp = void 0, this.options = void 0;
    }
    addFilter(t3, i2, s2 = 100) {
      var h2, e2, n3;
      this.Jt[t3] || (this.Jt[t3] = []), null === (h2 = this.Jt[t3]) || void 0 === h2 || h2.push({ fn: i2, priority: s2 }), null === (e2 = this.Jt[t3]) || void 0 === e2 || e2.sort(((t4, i3) => t4.priority - i3.priority)), null === (n3 = this.pswp) || void 0 === n3 || n3.addFilter(t3, i2, s2);
    }
    removeFilter(t3, i2) {
      this.Jt[t3] && (this.Jt[t3] = this.Jt[t3].filter(((t4) => t4.fn !== i2))), this.pswp && this.pswp.removeFilter(t3, i2);
    }
    applyFilters(t3, ...i2) {
      var s2;
      return null === (s2 = this.Jt[t3]) || void 0 === s2 || s2.forEach(((t4) => {
        i2[0] = t4.fn.apply(this, i2);
      })), i2[0];
    }
    on(t3, i2) {
      var s2, h2;
      this.Yt[t3] || (this.Yt[t3] = []), null === (s2 = this.Yt[t3]) || void 0 === s2 || s2.push(i2), null === (h2 = this.pswp) || void 0 === h2 || h2.on(t3, i2);
    }
    off(t3, i2) {
      var s2;
      this.Yt[t3] && (this.Yt[t3] = this.Yt[t3].filter(((t4) => i2 !== t4))), null === (s2 = this.pswp) || void 0 === s2 || s2.off(t3, i2);
    }
    dispatch(t3, i2) {
      var s2;
      if (this.pswp) return this.pswp.dispatch(t3, i2);
      const h2 = new j(t3, i2);
      return null === (s2 = this.Yt[t3]) || void 0 === s2 || s2.forEach(((t4) => {
        t4.call(this, h2);
      })), h2;
    }
  } {
    getNumItems() {
      var t3;
      let i2 = 0;
      const s2 = null === (t3 = this.options) || void 0 === t3 ? void 0 : t3.dataSource;
      s2 && "length" in s2 ? i2 = s2.length : s2 && "gallery" in s2 && (s2.items || (s2.items = this.Qt(s2.gallery)), s2.items && (i2 = s2.items.length));
      const h2 = this.dispatch("numItems", { dataSource: s2, numItems: i2 });
      return this.applyFilters("numItems", h2.numItems, s2);
    }
    createContentFromData(t3, i2) {
      return new Y(t3, this, i2);
    }
    getItemData(t3) {
      var i2;
      const s2 = null === (i2 = this.options) || void 0 === i2 ? void 0 : i2.dataSource;
      let h2 = {};
      Array.isArray(s2) ? h2 = s2[t3] : s2 && "gallery" in s2 && (s2.items || (s2.items = this.Qt(s2.gallery)), h2 = s2.items[t3]);
      let e2 = h2;
      e2 instanceof Element && (e2 = this.ti(e2));
      const n3 = this.dispatch("itemData", { itemData: e2 || {}, index: t3 });
      return this.applyFilters("itemData", n3.itemData, t3);
    }
    Qt(t3) {
      var i2, s2;
      return null !== (i2 = this.options) && void 0 !== i2 && i2.children || null !== (s2 = this.options) && void 0 !== s2 && s2.childSelector ? (function(t4, i3, s3 = document) {
        let h2 = [];
        if (t4 instanceof Element) h2 = [t4];
        else if (t4 instanceof NodeList || Array.isArray(t4)) h2 = Array.from(t4);
        else {
          const e2 = "string" == typeof t4 ? t4 : i3;
          e2 && (h2 = Array.from(s3.querySelectorAll(e2)));
        }
        return h2;
      })(this.options.children, this.options.childSelector, t3) || [] : [t3];
    }
    ti(t3) {
      const i2 = { element: t3 }, s2 = "A" === t3.tagName ? t3 : t3.querySelector("a");
      if (s2) {
        i2.src = s2.dataset.pswpSrc || s2.href, s2.dataset.pswpSrcset && (i2.srcset = s2.dataset.pswpSrcset), i2.width = s2.dataset.pswpWidth ? parseInt(s2.dataset.pswpWidth, 10) : 0, i2.height = s2.dataset.pswpHeight ? parseInt(s2.dataset.pswpHeight, 10) : 0, i2.w = i2.width, i2.h = i2.height, s2.dataset.pswpType && (i2.type = s2.dataset.pswpType);
        const e2 = t3.querySelector("img");
        var h2;
        if (e2) i2.msrc = e2.currentSrc || e2.src, i2.alt = null !== (h2 = e2.getAttribute("alt")) && void 0 !== h2 ? h2 : "";
        (s2.dataset.pswpCropped || s2.dataset.cropped) && (i2.thumbCropped = true);
      }
      return this.applyFilters("domItemData", i2, t3, s2);
    }
    lazyLoadData(t3, i2) {
      return J(t3, this, i2);
    }
  } {
    constructor(t3) {
      super(), this.options = this.ii(t3 || {}), this.offset = { x: 0, y: 0 }, this.si = { x: 0, y: 0 }, this.viewportSize = { x: 0, y: 0 }, this.bgOpacity = 1, this.currIndex = 0, this.potentialIndex = 0, this.isOpen = false, this.isDestroying = false, this.hasMouse = false, this.hi = {}, this.Gt = void 0, this.topBar = void 0, this.element = void 0, this.template = void 0, this.container = void 0, this.scrollWrap = void 0, this.currSlide = void 0, this.events = new f(), this.animations = new F(), this.mainScroll = new A(this), this.gestures = new T(this), this.opener = new it(this), this.keyboard = new E(this), this.contentLoader = new Q(this);
    }
    init() {
      if (this.isOpen || this.isDestroying) return false;
      this.isOpen = true, this.dispatch("init"), this.dispatch("beforeOpen"), this.ei();
      let t3 = "pswp--open";
      return this.gestures.supportsTouch && (t3 += " pswp--touch"), this.options.mainClass && (t3 += " " + this.options.mainClass), this.element && (this.element.className += " " + t3), this.currIndex = this.options.index || 0, this.potentialIndex = this.currIndex, this.dispatch("firstUpdate"), this.scrollWheel = new O(this), (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) && (this.currIndex = 0), this.gestures.supportsTouch || this.mouseDetected(), this.updateSize(), this.offset.y = window.pageYOffset, this.hi = this.getItemData(this.currIndex), this.dispatch("gettingData", { index: this.currIndex, data: this.hi, slide: void 0 }), this.Gt = this.getThumbBounds(), this.dispatch("initialLayout"), this.on("openingAnimationEnd", (() => {
        const { itemHolders: t4 } = this.mainScroll;
        t4[0] && (t4[0].el.style.display = "block", this.setContent(t4[0], this.currIndex - 1)), t4[2] && (t4[2].el.style.display = "block", this.setContent(t4[2], this.currIndex + 1)), this.appendHeavy(), this.contentLoader.updateLazy(), this.events.add(window, "resize", this.ni.bind(this)), this.events.add(window, "scroll", this.oi.bind(this)), this.dispatch("bindEvents");
      })), this.mainScroll.itemHolders[1] && this.setContent(this.mainScroll.itemHolders[1], this.currIndex), this.dispatch("change"), this.opener.open(), this.dispatch("afterInit"), true;
    }
    getLoopedIndex(t3) {
      const i2 = this.getNumItems();
      return this.options.loop && (t3 > i2 - 1 && (t3 -= i2), t3 < 0 && (t3 += i2)), n2(t3, 0, i2 - 1);
    }
    appendHeavy() {
      this.mainScroll.itemHolders.forEach(((t3) => {
        var i2;
        null === (i2 = t3.slide) || void 0 === i2 || i2.appendHeavy();
      }));
    }
    goTo(t3) {
      this.mainScroll.moveIndexBy(this.getLoopedIndex(t3) - this.potentialIndex);
    }
    next() {
      this.goTo(this.potentialIndex + 1);
    }
    prev() {
      this.goTo(this.potentialIndex - 1);
    }
    zoomTo(...t3) {
      var i2;
      null === (i2 = this.currSlide) || void 0 === i2 || i2.zoomTo(...t3);
    }
    toggleZoom() {
      var t3;
      null === (t3 = this.currSlide) || void 0 === t3 || t3.toggleZoom();
    }
    close() {
      this.opener.isOpen && !this.isDestroying && (this.isDestroying = true, this.dispatch("close"), this.events.removeAll(), this.opener.close());
    }
    destroy() {
      var t3;
      if (!this.isDestroying) return this.options.showHideAnimationType = "none", void this.close();
      this.dispatch("destroy"), this.Yt = {}, this.scrollWrap && (this.scrollWrap.ontouchmove = null, this.scrollWrap.ontouchend = null), null === (t3 = this.element) || void 0 === t3 || t3.remove(), this.mainScroll.itemHolders.forEach(((t4) => {
        var i2;
        null === (i2 = t4.slide) || void 0 === i2 || i2.destroy();
      })), this.contentLoader.destroy(), this.events.removeAll();
    }
    refreshSlideContent(t3) {
      this.contentLoader.removeByIndex(t3), this.mainScroll.itemHolders.forEach(((i2, s2) => {
        var h2, e2;
        let n3 = (null !== (h2 = null === (e2 = this.currSlide) || void 0 === e2 ? void 0 : e2.index) && void 0 !== h2 ? h2 : 0) - 1 + s2;
        var o2;
        (this.canLoop() && (n3 = this.getLoopedIndex(n3)), n3 === t3) && (this.setContent(i2, t3, true), 1 === s2 && (this.currSlide = i2.slide, null === (o2 = i2.slide) || void 0 === o2 || o2.setIsActive(true)));
      })), this.dispatch("change");
    }
    setContent(t3, i2, s2) {
      if (this.canLoop() && (i2 = this.getLoopedIndex(i2)), t3.slide) {
        if (t3.slide.index === i2 && !s2) return;
        t3.slide.destroy(), t3.slide = void 0;
      }
      if (!this.canLoop() && (i2 < 0 || i2 >= this.getNumItems())) return;
      const h2 = this.getItemData(i2);
      t3.slide = new b(h2, i2, this), i2 === this.currIndex && (this.currSlide = t3.slide), t3.slide.append(t3.el);
    }
    getViewportCenterPoint() {
      return { x: this.viewportSize.x / 2, y: this.viewportSize.y / 2 };
    }
    updateSize(t3) {
      if (this.isDestroying) return;
      const s2 = w(this.options, this);
      !t3 && e(s2, this.si) || (i(this.si, s2), this.dispatch("beforeResize"), i(this.viewportSize, this.si), this.oi(), this.dispatch("viewportSize"), this.mainScroll.resize(this.opener.isOpen), !this.hasMouse && window.matchMedia("(any-hover: hover)").matches && this.mouseDetected(), this.dispatch("resize"));
    }
    applyBgOpacity(t3) {
      this.bgOpacity = Math.max(t3, 0), this.bg && (this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity));
    }
    mouseDetected() {
      var t3;
      this.hasMouse || (this.hasMouse = true, null === (t3 = this.element) || void 0 === t3 || t3.classList.add("pswp--has_mouse"));
    }
    ni() {
      this.updateSize(), /iPhone|iPad|iPod/i.test(window.navigator.userAgent) && setTimeout((() => {
        this.updateSize();
      }), 500);
    }
    oi() {
      this.setScrollOffset(0, window.pageYOffset);
    }
    setScrollOffset(t3, i2) {
      this.offset.x = t3, this.offset.y = i2, this.dispatch("updateScrollOffset");
    }
    ei() {
      this.element = t2("pswp", "div"), this.element.setAttribute("tabindex", "-1"), this.element.setAttribute("role", "dialog"), this.template = this.element, this.bg = t2("pswp__bg", "div", this.element), this.scrollWrap = t2("pswp__scroll-wrap", "section", this.element), this.container = t2("pswp__container", "div", this.scrollWrap), this.scrollWrap.setAttribute("aria-roledescription", "carousel"), this.container.setAttribute("aria-live", "off"), this.container.setAttribute("id", "pswp__items"), this.mainScroll.appendHolders(), this.ui = new W(this), this.ui.init(), (this.options.appendToEl || document.body).appendChild(this.element);
    }
    getThumbBounds() {
      return (function(t3, i2, s2) {
        const h2 = s2.dispatch("thumbBounds", { index: t3, itemData: i2, instance: s2 });
        if (h2.thumbBounds) return h2.thumbBounds;
        const { element: e2 } = i2;
        let n3, o2;
        if (e2 && false !== s2.options.thumbSelector) {
          const t4 = s2.options.thumbSelector || "img";
          o2 = e2.matches(t4) ? e2 : e2.querySelector(t4);
        }
        return o2 = s2.applyFilters("thumbEl", o2, i2, t3), o2 && (n3 = i2.thumbCropped ? (function(t4, i3, s3) {
          const h3 = t4.getBoundingClientRect(), e3 = h3.width / i3, n4 = h3.height / s3, o3 = e3 > n4 ? e3 : n4, r3 = (h3.width - i3 * o3) / 2, a2 = (h3.height - s3 * o3) / 2, l2 = { x: h3.left + r3, y: h3.top + a2, w: i3 * o3 };
          return l2.innerRect = { w: h3.width, h: h3.height, x: r3, y: a2 }, l2;
        })(o2, i2.width || i2.w || 0, i2.height || i2.h || 0) : (function(t4) {
          const i3 = t4.getBoundingClientRect();
          return { x: i3.left, y: i3.top, w: i3.width };
        })(o2)), s2.applyFilters("thumbBounds", n3, i2, t3);
      })(this.currIndex, this.currSlide ? this.currSlide.data : this.hi, this);
    }
    canLoop() {
      return this.options.loop && this.getNumItems() > 2;
    }
    ii(t3) {
      return window.matchMedia("(prefers-reduced-motion), (update: slow)").matches && (t3.showHideAnimationType = "none", t3.zoomAnimationDuration = 0), { ...st, ...t3 };
    }
  };
}));
;
"object" == typeof navigator && (function(e, t2) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t2() : "function" == typeof define && define.amd ? define("Plyr", t2) : (e = "undefined" != typeof globalThis ? globalThis : e || self).Plyr = t2();
})(this, (function() {
  "use strict";
  function e(e2, t3, i2) {
    return t3 in e2 ? Object.defineProperty(e2, t3, { value: i2, enumerable: true, configurable: true, writable: true }) : e2[t3] = i2, e2;
  }
  function t2(e2, t3) {
    for (var i2 = 0; i2 < t3.length; i2++) {
      var s2 = t3[i2];
      s2.enumerable = s2.enumerable || false, s2.configurable = true, "value" in s2 && (s2.writable = true), Object.defineProperty(e2, s2.key, s2);
    }
  }
  function i(e2, t3, i2) {
    return t3 in e2 ? Object.defineProperty(e2, t3, { value: i2, enumerable: true, configurable: true, writable: true }) : e2[t3] = i2, e2;
  }
  function s(e2, t3) {
    var i2 = Object.keys(e2);
    if (Object.getOwnPropertySymbols) {
      var s2 = Object.getOwnPropertySymbols(e2);
      t3 && (s2 = s2.filter((function(t4) {
        return Object.getOwnPropertyDescriptor(e2, t4).enumerable;
      }))), i2.push.apply(i2, s2);
    }
    return i2;
  }
  function n2(e2) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var n3 = null != arguments[t3] ? arguments[t3] : {};
      t3 % 2 ? s(Object(n3), true).forEach((function(t4) {
        i(e2, t4, n3[t4]);
      })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(n3)) : s(Object(n3)).forEach((function(t4) {
        Object.defineProperty(e2, t4, Object.getOwnPropertyDescriptor(n3, t4));
      }));
    }
    return e2;
  }
  var a = { addCSS: true, thumbWidth: 15, watch: true };
  function l(e2, t3) {
    return function() {
      return Array.from(document.querySelectorAll(t3)).includes(this);
    }.call(e2, t3);
  }
  var o = function(e2) {
    return null != e2 ? e2.constructor : null;
  }, r2 = function(e2, t3) {
    return !!(e2 && t3 && e2 instanceof t3);
  }, c = function(e2) {
    return null == e2;
  }, h = function(e2) {
    return o(e2) === Object;
  }, u = function(e2) {
    return o(e2) === String;
  }, d = function(e2) {
    return Array.isArray(e2);
  }, m = function(e2) {
    return r2(e2, NodeList);
  }, p = u, g = d, f = m, b = function(e2) {
    return r2(e2, Element);
  }, y = function(e2) {
    return r2(e2, Event);
  }, v = function(e2) {
    return c(e2) || (u(e2) || d(e2) || m(e2)) && !e2.length || h(e2) && !Object.keys(e2).length;
  };
  function w(e2, t3) {
    if (1 > t3) {
      var i2 = (function(e3) {
        var t4 = "".concat(e3).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        return t4 ? Math.max(0, (t4[1] ? t4[1].length : 0) - (t4[2] ? +t4[2] : 0)) : 0;
      })(t3);
      return parseFloat(e2.toFixed(i2));
    }
    return Math.round(e2 / t3) * t3;
  }
  var T = (function() {
    function e2(t3, i2) {
      (function(e3, t4) {
        if (!(e3 instanceof t4)) throw new TypeError("Cannot call a class as a function");
      })(this, e2), b(t3) ? this.element = t3 : p(t3) && (this.element = document.querySelector(t3)), b(this.element) && v(this.element.rangeTouch) && (this.config = n2({}, a, {}, i2), this.init());
    }
    return (function(e3, i2, s2) {
      i2 && t2(e3.prototype, i2), s2 && t2(e3, s2);
    })(e2, [{ key: "init", value: function() {
      e2.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(true), this.element.rangeTouch = this);
    } }, { key: "destroy", value: function() {
      e2.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(false), this.element.rangeTouch = null);
    } }, { key: "listeners", value: function(e3) {
      var t3 = this, i2 = e3 ? "addEventListener" : "removeEventListener";
      ["touchstart", "touchmove", "touchend"].forEach((function(e4) {
        t3.element[i2](e4, (function(e5) {
          return t3.set(e5);
        }), false);
      }));
    } }, { key: "get", value: function(t3) {
      if (!e2.enabled || !y(t3)) return null;
      var i2, s2 = t3.target, n3 = t3.changedTouches[0], a2 = parseFloat(s2.getAttribute("min")) || 0, l2 = parseFloat(s2.getAttribute("max")) || 100, o2 = parseFloat(s2.getAttribute("step")) || 1, r3 = s2.getBoundingClientRect(), c2 = 100 / r3.width * (this.config.thumbWidth / 2) / 100;
      return 0 > (i2 = 100 / r3.width * (n3.clientX - r3.left)) ? i2 = 0 : 100 < i2 && (i2 = 100), 50 > i2 ? i2 -= (100 - 2 * i2) * c2 : 50 < i2 && (i2 += 2 * (i2 - 50) * c2), a2 + w(i2 / 100 * (l2 - a2), o2);
    } }, { key: "set", value: function(t3) {
      e2.enabled && y(t3) && !t3.target.disabled && (t3.preventDefault(), t3.target.value = this.get(t3), (function(e3, t4) {
        if (e3 && t4) {
          var i2 = new Event(t4, { bubbles: true });
          e3.dispatchEvent(i2);
        }
      })(t3.target, "touchend" === t3.type ? "change" : "input"));
    } }], [{ key: "setup", value: function(t3) {
      var i2 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s2 = null;
      if (v(t3) || p(t3) ? s2 = Array.from(document.querySelectorAll(p(t3) ? t3 : 'input[type="range"]')) : b(t3) ? s2 = [t3] : f(t3) ? s2 = Array.from(t3) : g(t3) && (s2 = t3.filter(b)), v(s2)) return null;
      var o2 = n2({}, a, {}, i2);
      if (p(t3) && o2.watch) {
        var r3 = new MutationObserver((function(i3) {
          Array.from(i3).forEach((function(i4) {
            Array.from(i4.addedNodes).forEach((function(i5) {
              b(i5) && l(i5, t3) && new e2(i5, o2);
            }));
          }));
        }));
        r3.observe(document.body, { childList: true, subtree: true });
      }
      return s2.map((function(t4) {
        return new e2(t4, i2);
      }));
    } }, { key: "enabled", get: function() {
      return "ontouchstart" in document.documentElement;
    } }]), e2;
  })();
  const k = (e2) => null != e2 ? e2.constructor : null, C = (e2, t3) => Boolean(e2 && t3 && e2 instanceof t3), A = (e2) => null == e2, S = (e2) => k(e2) === Object, E = (e2) => k(e2) === String, P = (e2) => k(e2) === Function, M = (e2) => Array.isArray(e2), N = (e2) => C(e2, NodeList), x = (e2) => A(e2) || (E(e2) || M(e2) || N(e2)) && !e2.length || S(e2) && !Object.keys(e2).length;
  var I = A, L = S, $ = (e2) => k(e2) === Number && !Number.isNaN(e2), _ = E, O = (e2) => k(e2) === Boolean, j = P, D = M, q = N, H = (e2) => null !== e2 && "object" == typeof e2 && 1 === e2.nodeType && "object" == typeof e2.style && "object" == typeof e2.ownerDocument, R = (e2) => C(e2, Event), F = (e2) => C(e2, KeyboardEvent), V = (e2) => C(e2, TextTrack) || !A(e2) && E(e2.kind), B = (e2) => C(e2, Promise) && P(e2.then), U = (e2) => {
    if (C(e2, window.URL)) return true;
    if (!E(e2)) return false;
    let t3 = e2;
    e2.startsWith("http://") && e2.startsWith("https://") || (t3 = `http://${e2}`);
    try {
      return !x(new URL(t3).hostname);
    } catch (e3) {
      return false;
    }
  }, W = x;
  const z = (() => {
    const e2 = document.createElement("span"), t3 = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" }, i2 = Object.keys(t3).find(((t4) => void 0 !== e2.style[t4]));
    return !!_(i2) && t3[i2];
  })();
  function K(e2, t3) {
    setTimeout((() => {
      try {
        e2.hidden = true, e2.offsetHeight, e2.hidden = false;
      } catch (e3) {
      }
    }), t3);
  }
  const Y = { isIE: Boolean(window.document.documentMode), isEdge: window.navigator.userAgent.includes("Edge"), isWebkit: "WebkitAppearance" in document.documentElement.style && !/Edge/.test(navigator.userAgent), isIPhone: /(iPhone|iPod)/gi.test(navigator.platform), isIos: "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1 || /(iPad|iPhone|iPod)/gi.test(navigator.platform) };
  function Q(e2, t3) {
    return t3.split(".").reduce(((e3, t4) => e3 && e3[t4]), e2);
  }
  function X(e2 = {}, ...t3) {
    if (!t3.length) return e2;
    const i2 = t3.shift();
    return L(i2) ? (Object.keys(i2).forEach(((t4) => {
      L(i2[t4]) ? (Object.keys(e2).includes(t4) || Object.assign(e2, { [t4]: {} }), X(e2[t4], i2[t4])) : Object.assign(e2, { [t4]: i2[t4] });
    })), X(e2, ...t3)) : e2;
  }
  function J(e2, t3) {
    const i2 = e2.length ? e2 : [e2];
    Array.from(i2).reverse().forEach(((e3, i3) => {
      const s2 = i3 > 0 ? t3.cloneNode(true) : t3, n3 = e3.parentNode, a2 = e3.nextSibling;
      s2.appendChild(e3), a2 ? n3.insertBefore(s2, a2) : n3.appendChild(s2);
    }));
  }
  function G(e2, t3) {
    H(e2) && !W(t3) && Object.entries(t3).filter((([, e3]) => !I(e3))).forEach((([t4, i2]) => e2.setAttribute(t4, i2)));
  }
  function Z(e2, t3, i2) {
    const s2 = document.createElement(e2);
    return L(t3) && G(s2, t3), _(i2) && (s2.innerText = i2), s2;
  }
  function ee(e2, t3, i2, s2) {
    H(t3) && t3.appendChild(Z(e2, i2, s2));
  }
  function te(e2) {
    q(e2) || D(e2) ? Array.from(e2).forEach(te) : H(e2) && H(e2.parentNode) && e2.parentNode.removeChild(e2);
  }
  function ie(e2) {
    if (!H(e2)) return;
    let { length: t3 } = e2.childNodes;
    for (; t3 > 0; ) e2.removeChild(e2.lastChild), t3 -= 1;
  }
  function se(e2, t3) {
    return H(t3) && H(t3.parentNode) && H(e2) ? (t3.parentNode.replaceChild(e2, t3), e2) : null;
  }
  function ne(e2, t3) {
    if (!_(e2) || W(e2)) return {};
    const i2 = {}, s2 = X({}, t3);
    return e2.split(",").forEach(((e3) => {
      const t4 = e3.trim(), n3 = t4.replace(".", ""), a2 = t4.replace(/[[\]]/g, "").split("="), [l2] = a2, o2 = a2.length > 1 ? a2[1].replace(/["']/g, "") : "";
      switch (t4.charAt(0)) {
        case ".":
          _(s2.class) ? i2.class = `${s2.class} ${n3}` : i2.class = n3;
          break;
        case "#":
          i2.id = t4.replace("#", "");
          break;
        case "[":
          i2[l2] = o2;
      }
    })), X(s2, i2);
  }
  function ae(e2, t3) {
    if (!H(e2)) return;
    let i2 = t3;
    O(i2) || (i2 = !e2.hidden), e2.hidden = i2;
  }
  function le(e2, t3, i2) {
    if (q(e2)) return Array.from(e2).map(((e3) => le(e3, t3, i2)));
    if (H(e2)) {
      let s2 = "toggle";
      return void 0 !== i2 && (s2 = i2 ? "add" : "remove"), e2.classList[s2](t3), e2.classList.contains(t3);
    }
    return false;
  }
  function oe(e2, t3) {
    return H(e2) && e2.classList.contains(t3);
  }
  function re(e2, t3) {
    const { prototype: i2 } = Element;
    return (i2.matches || i2.webkitMatchesSelector || i2.mozMatchesSelector || i2.msMatchesSelector || function() {
      return Array.from(document.querySelectorAll(t3)).includes(this);
    }).call(e2, t3);
  }
  function ce(e2) {
    return this.elements.container.querySelectorAll(e2);
  }
  function he(e2) {
    return this.elements.container.querySelector(e2);
  }
  function ue(e2 = null, t3 = false) {
    H(e2) && (e2.focus({ preventScroll: true }), t3 && le(e2, this.config.classNames.tabFocus));
  }
  const de = { "audio/ogg": "vorbis", "audio/wav": "1", "video/webm": "vp8, vorbis", "video/mp4": "avc1.42E01E, mp4a.40.2", "video/ogg": "theora" }, me = { audio: "canPlayType" in document.createElement("audio"), video: "canPlayType" in document.createElement("video"), check(e2, t3, i2) {
    const s2 = Y.isIPhone && i2 && me.playsinline, n3 = me[e2] || "html5" !== t3;
    return { api: n3, ui: n3 && me.rangeInput && ("video" !== e2 || !Y.isIPhone || s2) };
  }, pip: !(Y.isIPhone || !j(Z("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || Z("video").disablePictureInPicture)), airplay: j(window.WebKitPlaybackTargetAvailabilityEvent), playsinline: "playsInline" in document.createElement("video"), mime(e2) {
    if (W(e2)) return false;
    const [t3] = e2.split("/");
    let i2 = e2;
    if (!this.isHTML5 || t3 !== this.type) return false;
    Object.keys(de).includes(i2) && (i2 += `; codecs="${de[e2]}"`);
    try {
      return Boolean(i2 && this.media.canPlayType(i2).replace(/no/, ""));
    } catch (e3) {
      return false;
    }
  }, textTracks: "textTracks" in document.createElement("video"), rangeInput: (() => {
    const e2 = document.createElement("input");
    return e2.type = "range", "range" === e2.type;
  })(), touch: "ontouchstart" in document.documentElement, transitions: false !== z, reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches }, pe = (() => {
    let e2 = false;
    try {
      const t3 = Object.defineProperty({}, "passive", { get: () => (e2 = true, null) });
      window.addEventListener("test", null, t3), window.removeEventListener("test", null, t3);
    } catch (e3) {
    }
    return e2;
  })();
  function ge(e2, t3, i2, s2 = false, n3 = true, a2 = false) {
    if (!e2 || !("addEventListener" in e2) || W(t3) || !j(i2)) return;
    const l2 = t3.split(" ");
    let o2 = a2;
    pe && (o2 = { passive: n3, capture: a2 }), l2.forEach(((t4) => {
      this && this.eventListeners && s2 && this.eventListeners.push({ element: e2, type: t4, callback: i2, options: o2 }), e2[s2 ? "addEventListener" : "removeEventListener"](t4, i2, o2);
    }));
  }
  function fe(e2, t3 = "", i2, s2 = true, n3 = false) {
    ge.call(this, e2, t3, i2, true, s2, n3);
  }
  function be(e2, t3 = "", i2, s2 = true, n3 = false) {
    ge.call(this, e2, t3, i2, false, s2, n3);
  }
  function ye(e2, t3 = "", i2, s2 = true, n3 = false) {
    const a2 = (...l2) => {
      be(e2, t3, a2, s2, n3), i2.apply(this, l2);
    };
    ge.call(this, e2, t3, a2, true, s2, n3);
  }
  function ve(e2, t3 = "", i2 = false, s2 = {}) {
    if (!H(e2) || W(t3)) return;
    const n3 = new CustomEvent(t3, { bubbles: i2, detail: { ...s2, plyr: this } });
    e2.dispatchEvent(n3);
  }
  function we() {
    this && this.eventListeners && (this.eventListeners.forEach(((e2) => {
      const { element: t3, type: i2, callback: s2, options: n3 } = e2;
      t3.removeEventListener(i2, s2, n3);
    })), this.eventListeners = []);
  }
  function Te() {
    return new Promise(((e2) => this.ready ? setTimeout(e2, 0) : fe.call(this, this.elements.container, "ready", e2))).then((() => {
    }));
  }
  function ke(e2) {
    B(e2) && e2.then(null, (() => {
    }));
  }
  function Ce(e2) {
    return D(e2) ? e2.filter(((t3, i2) => e2.indexOf(t3) === i2)) : e2;
  }
  function Ae(e2, t3) {
    return D(e2) && e2.length ? e2.reduce(((e3, i2) => Math.abs(i2 - t3) < Math.abs(e3 - t3) ? i2 : e3)) : null;
  }
  function Se(e2) {
    return !(!window || !window.CSS) && window.CSS.supports(e2);
  }
  const Ee = [[1, 1], [4, 3], [3, 4], [5, 4], [4, 5], [3, 2], [2, 3], [16, 10], [10, 16], [16, 9], [9, 16], [21, 9], [9, 21], [32, 9], [9, 32]].reduce(((e2, [t3, i2]) => ({ ...e2, [t3 / i2]: [t3, i2] })), {});
  function Pe(e2) {
    if (!(D(e2) || _(e2) && e2.includes(":"))) return false;
    return (D(e2) ? e2 : e2.split(":")).map(Number).every($);
  }
  function Me(e2) {
    if (!D(e2) || !e2.every($)) return null;
    const [t3, i2] = e2, s2 = (e3, t4) => 0 === t4 ? e3 : s2(t4, e3 % t4), n3 = s2(t3, i2);
    return [t3 / n3, i2 / n3];
  }
  function Ne(e2) {
    const t3 = (e3) => Pe(e3) ? e3.split(":").map(Number) : null;
    let i2 = t3(e2);
    if (null === i2 && (i2 = t3(this.config.ratio)), null === i2 && !W(this.embed) && D(this.embed.ratio) && ({ ratio: i2 } = this.embed), null === i2 && this.isHTML5) {
      const { videoWidth: e3, videoHeight: t4 } = this.media;
      i2 = [e3, t4];
    }
    return Me(i2);
  }
  function xe(e2) {
    if (!this.isVideo) return {};
    const { wrapper: t3 } = this.elements, i2 = Ne.call(this, e2);
    if (!D(i2)) return {};
    const [s2, n3] = Me(i2), a2 = 100 / s2 * n3;
    if (Se(`aspect-ratio: ${s2}/${n3}`) ? t3.style.aspectRatio = `${s2}/${n3}` : t3.style.paddingBottom = `${a2}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
      const e3 = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), i3 = (e3 - a2) / (e3 / 50);
      this.fullscreen.active ? t3.style.paddingBottom = null : this.media.style.transform = `translateY(-${i3}%)`;
    } else this.isHTML5 && t3.classList.add(this.config.classNames.videoFixedRatio);
    return { padding: a2, ratio: i2 };
  }
  function Ie(e2, t3, i2 = 0.05) {
    const s2 = e2 / t3, n3 = Ae(Object.keys(Ee), s2);
    return Math.abs(n3 - s2) <= i2 ? Ee[n3] : [e2, t3];
  }
  const Le = { getSources() {
    if (!this.isHTML5) return [];
    return Array.from(this.media.querySelectorAll("source")).filter(((e2) => {
      const t3 = e2.getAttribute("type");
      return !!W(t3) || me.mime.call(this, t3);
    }));
  }, getQualityOptions() {
    return this.config.quality.forced ? this.config.quality.options : Le.getSources.call(this).map(((e2) => Number(e2.getAttribute("size")))).filter(Boolean);
  }, setup() {
    if (!this.isHTML5) return;
    const e2 = this;
    e2.options.speed = e2.config.speed.options, W(this.config.ratio) || xe.call(e2), Object.defineProperty(e2.media, "quality", { get() {
      const t3 = Le.getSources.call(e2).find(((t4) => t4.getAttribute("src") === e2.source));
      return t3 && Number(t3.getAttribute("size"));
    }, set(t3) {
      if (e2.quality !== t3) {
        if (e2.config.quality.forced && j(e2.config.quality.onChange)) e2.config.quality.onChange(t3);
        else {
          const i2 = Le.getSources.call(e2).find(((e3) => Number(e3.getAttribute("size")) === t3));
          if (!i2) return;
          const { currentTime: s2, paused: n3, preload: a2, readyState: l2, playbackRate: o2 } = e2.media;
          e2.media.src = i2.getAttribute("src"), ("none" !== a2 || l2) && (e2.once("loadedmetadata", (() => {
            e2.speed = o2, e2.currentTime = s2, n3 || ke(e2.play());
          })), e2.media.load());
        }
        ve.call(e2, e2.media, "qualitychange", false, { quality: t3 });
      }
    } });
  }, cancelRequests() {
    this.isHTML5 && (te(Le.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
  } };
  function $e(e2, ...t3) {
    return W(e2) ? e2 : e2.toString().replace(/{(\d+)}/g, ((e3, i2) => t3[i2].toString()));
  }
  const _e = (e2 = "", t3 = "", i2 = "") => e2.replace(new RegExp(t3.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i2.toString()), Oe = (e2 = "") => e2.toString().replace(/\w\S*/g, ((e3) => e3.charAt(0).toUpperCase() + e3.slice(1).toLowerCase()));
  function je(e2 = "") {
    let t3 = e2.toString();
    return t3 = (function(e3 = "") {
      let t4 = e3.toString();
      return t4 = _e(t4, "-", " "), t4 = _e(t4, "_", " "), t4 = Oe(t4), _e(t4, " ", "");
    })(t3), t3.charAt(0).toLowerCase() + t3.slice(1);
  }
  function De(e2) {
    const t3 = document.createElement("div");
    return t3.appendChild(e2), t3.innerHTML;
  }
  const qe = { pip: "PIP", airplay: "AirPlay", html5: "HTML5", vimeo: "Vimeo", youtube: "YouTube" }, He = { get(e2 = "", t3 = {}) {
    if (W(e2) || W(t3)) return "";
    let i2 = Q(t3.i18n, e2);
    if (W(i2)) return Object.keys(qe).includes(e2) ? qe[e2] : "";
    const s2 = { "{seektime}": t3.seekTime, "{title}": t3.title };
    return Object.entries(s2).forEach((([e3, t4]) => {
      i2 = _e(i2, e3, t4);
    })), i2;
  } };
  class Re {
    constructor(t3) {
      e(this, "get", ((e2) => {
        if (!Re.supported || !this.enabled) return null;
        const t4 = window.localStorage.getItem(this.key);
        if (W(t4)) return null;
        const i2 = JSON.parse(t4);
        return _(e2) && e2.length ? i2[e2] : i2;
      })), e(this, "set", ((e2) => {
        if (!Re.supported || !this.enabled) return;
        if (!L(e2)) return;
        let t4 = this.get();
        W(t4) && (t4 = {}), X(t4, e2);
        try {
          window.localStorage.setItem(this.key, JSON.stringify(t4));
        } catch (e3) {
        }
      })), this.enabled = t3.config.storage.enabled, this.key = t3.config.storage.key;
    }
    static get supported() {
      try {
        if (!("localStorage" in window)) return false;
        const e2 = "___test";
        return window.localStorage.setItem(e2, e2), window.localStorage.removeItem(e2), true;
      } catch (e2) {
        return false;
      }
    }
  }
  function Fe(e2, t3 = "text") {
    return new Promise(((i2, s2) => {
      try {
        const s3 = new XMLHttpRequest();
        if (!("withCredentials" in s3)) return;
        s3.addEventListener("load", (() => {
          if ("text" === t3) try {
            i2(JSON.parse(s3.responseText));
          } catch (e3) {
            i2(s3.responseText);
          }
          else i2(s3.response);
        })), s3.addEventListener("error", (() => {
          throw new Error(s3.status);
        })), s3.open("GET", e2, true), s3.responseType = t3, s3.send();
      } catch (e3) {
        s2(e3);
      }
    }));
  }
  function Ve(e2, t3) {
    if (!_(e2)) return;
    const i2 = _(t3);
    let s2 = false;
    const n3 = () => null !== document.getElementById(t3), a2 = (e3, t4) => {
      e3.innerHTML = t4, i2 && n3() || document.body.insertAdjacentElement("afterbegin", e3);
    };
    if (!i2 || !n3()) {
      const n4 = Re.supported, l2 = document.createElement("div");
      if (l2.setAttribute("hidden", ""), i2 && l2.setAttribute("id", t3), n4) {
        const e3 = window.localStorage.getItem(`cache-${t3}`);
        if (s2 = null !== e3, s2) {
          const t4 = JSON.parse(e3);
          a2(l2, t4.content);
        }
      }
      Fe(e2).then(((e3) => {
        if (!W(e3)) {
          if (n4) try {
            window.localStorage.setItem(`cache-${t3}`, JSON.stringify({ content: e3 }));
          } catch (e4) {
          }
          a2(l2, e3);
        }
      })).catch((() => {
      }));
    }
  }
  const Be = (e2) => Math.trunc(e2 / 60 / 60 % 60, 10);
  function Ue(e2 = 0, t3 = false, i2 = false) {
    if (!$(e2)) return Ue(void 0, t3, i2);
    const s2 = (e3) => `0${e3}`.slice(-2);
    let n3 = Be(e2);
    const a2 = (l2 = e2, Math.trunc(l2 / 60 % 60, 10));
    var l2;
    const o2 = ((e3) => Math.trunc(e3 % 60, 10))(e2);
    return n3 = t3 || n3 > 0 ? `${n3}:` : "", `${i2 && e2 > 0 ? "-" : ""}${n3}${s2(a2)}:${s2(o2)}`;
  }
  const We = { getIconUrl() {
    const e2 = new URL(this.config.iconUrl, window.location), t3 = window.location.host ? window.location.host : window.top.location.host, i2 = e2.host !== t3 || Y.isIE && !window.svg4everybody;
    return { url: this.config.iconUrl, cors: i2 };
  }, findElements() {
    try {
      return this.elements.controls = he.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = { play: ce.call(this, this.config.selectors.buttons.play), pause: he.call(this, this.config.selectors.buttons.pause), restart: he.call(this, this.config.selectors.buttons.restart), rewind: he.call(this, this.config.selectors.buttons.rewind), fastForward: he.call(this, this.config.selectors.buttons.fastForward), mute: he.call(this, this.config.selectors.buttons.mute), pip: he.call(this, this.config.selectors.buttons.pip), airplay: he.call(this, this.config.selectors.buttons.airplay), settings: he.call(this, this.config.selectors.buttons.settings), captions: he.call(this, this.config.selectors.buttons.captions), fullscreen: he.call(this, this.config.selectors.buttons.fullscreen) }, this.elements.progress = he.call(this, this.config.selectors.progress), this.elements.inputs = { seek: he.call(this, this.config.selectors.inputs.seek), volume: he.call(this, this.config.selectors.inputs.volume) }, this.elements.display = { buffer: he.call(this, this.config.selectors.display.buffer), currentTime: he.call(this, this.config.selectors.display.currentTime), duration: he.call(this, this.config.selectors.display.duration) }, H(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), true;
    } catch (e2) {
      return this.debug.warn("It looks like there is a problem with your custom controls HTML", e2), this.toggleNativeControls(true), false;
    }
  }, createIcon(e2, t3) {
    const i2 = "http://www.w3.org/2000/svg", s2 = We.getIconUrl.call(this), n3 = `${s2.cors ? "" : s2.url}#${this.config.iconPrefix}`, a2 = document.createElementNS(i2, "svg");
    G(a2, X(t3, { "aria-hidden": "true", focusable: "false" }));
    const l2 = document.createElementNS(i2, "use"), o2 = `${n3}-${e2}`;
    return "href" in l2 && l2.setAttributeNS("http://www.w3.org/1999/xlink", "href", o2), l2.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", o2), a2.appendChild(l2), a2;
  }, createLabel(e2, t3 = {}) {
    const i2 = He.get(e2, this.config);
    return Z("span", { ...t3, class: [t3.class, this.config.classNames.hidden].filter(Boolean).join(" ") }, i2);
  }, createBadge(e2) {
    if (W(e2)) return null;
    const t3 = Z("span", { class: this.config.classNames.menu.value });
    return t3.appendChild(Z("span", { class: this.config.classNames.menu.badge }, e2)), t3;
  }, createButton(e2, t3) {
    const i2 = X({}, t3);
    let s2 = je(e2);
    const n3 = { element: "button", toggle: false, label: null, icon: null, labelPressed: null, iconPressed: null };
    switch (["element", "icon", "label"].forEach(((e3) => {
      Object.keys(i2).includes(e3) && (n3[e3] = i2[e3], delete i2[e3]);
    })), "button" !== n3.element || Object.keys(i2).includes("type") || (i2.type = "button"), Object.keys(i2).includes("class") ? i2.class.split(" ").some(((e3) => e3 === this.config.classNames.control)) || X(i2, { class: `${i2.class} ${this.config.classNames.control}` }) : i2.class = this.config.classNames.control, e2) {
      case "play":
        n3.toggle = true, n3.label = "play", n3.labelPressed = "pause", n3.icon = "play", n3.iconPressed = "pause";
        break;
      case "mute":
        n3.toggle = true, n3.label = "mute", n3.labelPressed = "unmute", n3.icon = "volume", n3.iconPressed = "muted";
        break;
      case "captions":
        n3.toggle = true, n3.label = "enableCaptions", n3.labelPressed = "disableCaptions", n3.icon = "captions-off", n3.iconPressed = "captions-on";
        break;
      case "fullscreen":
        n3.toggle = true, n3.label = "enterFullscreen", n3.labelPressed = "exitFullscreen", n3.icon = "enter-fullscreen", n3.iconPressed = "exit-fullscreen";
        break;
      case "play-large":
        i2.class += ` ${this.config.classNames.control}--overlaid`, s2 = "play", n3.label = "play", n3.icon = "play";
        break;
      default:
        W(n3.label) && (n3.label = s2), W(n3.icon) && (n3.icon = e2);
    }
    const a2 = Z(n3.element);
    return n3.toggle ? (a2.appendChild(We.createIcon.call(this, n3.iconPressed, { class: "icon--pressed" })), a2.appendChild(We.createIcon.call(this, n3.icon, { class: "icon--not-pressed" })), a2.appendChild(We.createLabel.call(this, n3.labelPressed, { class: "label--pressed" })), a2.appendChild(We.createLabel.call(this, n3.label, { class: "label--not-pressed" }))) : (a2.appendChild(We.createIcon.call(this, n3.icon)), a2.appendChild(We.createLabel.call(this, n3.label))), X(i2, ne(this.config.selectors.buttons[s2], i2)), G(a2, i2), "play" === s2 ? (D(this.elements.buttons[s2]) || (this.elements.buttons[s2] = []), this.elements.buttons[s2].push(a2)) : this.elements.buttons[s2] = a2, a2;
  }, createRange(e2, t3) {
    const i2 = Z("input", X(ne(this.config.selectors.inputs[e2]), { type: "range", min: 0, max: 100, step: 0.01, value: 0, autocomplete: "off", role: "slider", "aria-label": He.get(e2, this.config), "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": 0 }, t3));
    return this.elements.inputs[e2] = i2, We.updateRangeFill.call(this, i2), T.setup(i2), i2;
  }, createProgress(e2, t3) {
    const i2 = Z("progress", X(ne(this.config.selectors.display[e2]), { min: 0, max: 100, value: 0, role: "progressbar", "aria-hidden": true }, t3));
    if ("volume" !== e2) {
      i2.appendChild(Z("span", null, "0"));
      const t4 = { played: "played", buffer: "buffered" }[e2], s2 = t4 ? He.get(t4, this.config) : "";
      i2.innerText = `% ${s2.toLowerCase()}`;
    }
    return this.elements.display[e2] = i2, i2;
  }, createTime(e2, t3) {
    const i2 = ne(this.config.selectors.display[e2], t3), s2 = Z("div", X(i2, { class: `${i2.class ? i2.class : ""} ${this.config.classNames.display.time} `.trim(), "aria-label": He.get(e2, this.config) }), "00:00");
    return this.elements.display[e2] = s2, s2;
  }, bindMenuItemShortcuts(e2, t3) {
    fe.call(this, e2, "keydown keyup", ((i2) => {
      if (!["Space", "ArrowUp", "ArrowDown", "ArrowRight"].includes(i2.key)) return;
      if (i2.preventDefault(), i2.stopPropagation(), "keydown" === i2.type) return;
      const s2 = re(e2, '[role="menuitemradio"]');
      if (!s2 && ["Space", "ArrowRight"].includes(i2.key)) We.showMenuPanel.call(this, t3, true);
      else {
        let t4;
        "Space" !== i2.key && ("ArrowDown" === i2.key || s2 && "ArrowRight" === i2.key ? (t4 = e2.nextElementSibling, H(t4) || (t4 = e2.parentNode.firstElementChild)) : (t4 = e2.previousElementSibling, H(t4) || (t4 = e2.parentNode.lastElementChild)), ue.call(this, t4, true));
      }
    }), false), fe.call(this, e2, "keyup", ((e3) => {
      "Return" === e3.key && We.focusFirstMenuItem.call(this, null, true);
    }));
  }, createMenuItem({ value: e2, list: t3, type: i2, title: s2, badge: n3 = null, checked: a2 = false }) {
    const l2 = ne(this.config.selectors.inputs[i2]), o2 = Z("button", X(l2, { type: "button", role: "menuitemradio", class: `${this.config.classNames.control} ${l2.class ? l2.class : ""}`.trim(), "aria-checked": a2, value: e2 })), r3 = Z("span");
    r3.innerHTML = s2, H(n3) && r3.appendChild(n3), o2.appendChild(r3), Object.defineProperty(o2, "checked", { enumerable: true, get: () => "true" === o2.getAttribute("aria-checked"), set(e3) {
      e3 && Array.from(o2.parentNode.children).filter(((e4) => re(e4, '[role="menuitemradio"]'))).forEach(((e4) => e4.setAttribute("aria-checked", "false"))), o2.setAttribute("aria-checked", e3 ? "true" : "false");
    } }), this.listeners.bind(o2, "click keyup", ((t4) => {
      if (!F(t4) || "Space" === t4.key) {
        switch (t4.preventDefault(), t4.stopPropagation(), o2.checked = true, i2) {
          case "language":
            this.currentTrack = Number(e2);
            break;
          case "quality":
            this.quality = e2;
            break;
          case "speed":
            this.speed = parseFloat(e2);
        }
        We.showMenuPanel.call(this, "home", F(t4));
      }
    }), i2, false), We.bindMenuItemShortcuts.call(this, o2, i2), t3.appendChild(o2);
  }, formatTime(e2 = 0, t3 = false) {
    if (!$(e2)) return e2;
    return Ue(e2, Be(this.duration) > 0, t3);
  }, updateTimeDisplay(e2 = null, t3 = 0, i2 = false) {
    H(e2) && $(t3) && (e2.innerText = We.formatTime(t3, i2));
  }, updateVolume() {
    this.supported.ui && (H(this.elements.inputs.volume) && We.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), H(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
  }, setRange(e2, t3 = 0) {
    H(e2) && (e2.value = t3, We.updateRangeFill.call(this, e2));
  }, updateProgress(e2) {
    if (!this.supported.ui || !R(e2)) return;
    let t3 = 0;
    const i2 = (e3, t4) => {
      const i3 = $(t4) ? t4 : 0, s3 = H(e3) ? e3 : this.elements.display.buffer;
      if (H(s3)) {
        s3.value = i3;
        const e4 = s3.getElementsByTagName("span")[0];
        H(e4) && (e4.childNodes[0].nodeValue = i3);
      }
    };
    if (e2) switch (e2.type) {
      case "timeupdate":
      case "seeking":
      case "seeked":
        s2 = this.currentTime, n3 = this.duration, t3 = 0 === s2 || 0 === n3 || Number.isNaN(s2) || Number.isNaN(n3) ? 0 : (s2 / n3 * 100).toFixed(2), "timeupdate" === e2.type && We.setRange.call(this, this.elements.inputs.seek, t3);
        break;
      case "playing":
      case "progress":
        i2(this.elements.display.buffer, 100 * this.buffered);
    }
    var s2, n3;
  }, updateRangeFill(e2) {
    const t3 = R(e2) ? e2.target : e2;
    if (H(t3) && "range" === t3.getAttribute("type")) {
      if (re(t3, this.config.selectors.inputs.seek)) {
        t3.setAttribute("aria-valuenow", this.currentTime);
        const e3 = We.formatTime(this.currentTime), i2 = We.formatTime(this.duration), s2 = He.get("seekLabel", this.config);
        t3.setAttribute("aria-valuetext", s2.replace("{currentTime}", e3).replace("{duration}", i2));
      } else if (re(t3, this.config.selectors.inputs.volume)) {
        const e3 = 100 * t3.value;
        t3.setAttribute("aria-valuenow", e3), t3.setAttribute("aria-valuetext", `${e3.toFixed(1)}%`);
      } else t3.setAttribute("aria-valuenow", t3.value);
      Y.isWebkit && t3.style.setProperty("--value", t3.value / t3.max * 100 + "%");
    }
  }, updateSeekTooltip(e2) {
    var t3, i2;
    if (!this.config.tooltips.seek || !H(this.elements.inputs.seek) || !H(this.elements.display.seekTooltip) || 0 === this.duration) return;
    const s2 = this.elements.display.seekTooltip, n3 = `${this.config.classNames.tooltip}--visible`, a2 = (e3) => le(s2, n3, e3);
    if (this.touch) return void a2(false);
    let l2 = 0;
    const o2 = this.elements.progress.getBoundingClientRect();
    if (R(e2)) l2 = 100 / o2.width * (e2.pageX - o2.left);
    else {
      if (!oe(s2, n3)) return;
      l2 = parseFloat(s2.style.left, 10);
    }
    l2 < 0 ? l2 = 0 : l2 > 100 && (l2 = 100);
    const r3 = this.duration / 100 * l2;
    s2.innerText = We.formatTime(r3);
    const c2 = null === (t3 = this.config.markers) || void 0 === t3 || null === (i2 = t3.points) || void 0 === i2 ? void 0 : i2.find((({ time: e3 }) => e3 === Math.round(r3)));
    c2 && s2.insertAdjacentHTML("afterbegin", `${c2.label}<br>`), s2.style.left = `${l2}%`, R(e2) && ["mouseenter", "mouseleave"].includes(e2.type) && a2("mouseenter" === e2.type);
  }, timeUpdate(e2) {
    const t3 = !H(this.elements.display.duration) && this.config.invertTime;
    We.updateTimeDisplay.call(this, this.elements.display.currentTime, t3 ? this.duration - this.currentTime : this.currentTime, t3), e2 && "timeupdate" === e2.type && this.media.seeking || We.updateProgress.call(this, e2);
  }, durationUpdate() {
    if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
    if (this.duration >= 2 ** 32) return ae(this.elements.display.currentTime, true), void ae(this.elements.progress, true);
    H(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
    const e2 = H(this.elements.display.duration);
    !e2 && this.config.displayDuration && this.paused && We.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e2 && We.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && We.setMarkers.call(this), We.updateSeekTooltip.call(this);
  }, toggleMenuButton(e2, t3) {
    ae(this.elements.settings.buttons[e2], !t3);
  }, updateSetting(e2, t3, i2) {
    const s2 = this.elements.settings.panels[e2];
    let n3 = null, a2 = t3;
    if ("captions" === e2) n3 = this.currentTrack;
    else {
      if (n3 = W(i2) ? this[e2] : i2, W(n3) && (n3 = this.config[e2].default), !W(this.options[e2]) && !this.options[e2].includes(n3)) return void this.debug.warn(`Unsupported value of '${n3}' for ${e2}`);
      if (!this.config[e2].options.includes(n3)) return void this.debug.warn(`Disabled value of '${n3}' for ${e2}`);
    }
    if (H(a2) || (a2 = s2 && s2.querySelector('[role="menu"]')), !H(a2)) return;
    this.elements.settings.buttons[e2].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = We.getLabel.call(this, e2, n3);
    const l2 = a2 && a2.querySelector(`[value="${n3}"]`);
    H(l2) && (l2.checked = true);
  }, getLabel(e2, t3) {
    switch (e2) {
      case "speed":
        return 1 === t3 ? He.get("normal", this.config) : `${t3}&times;`;
      case "quality":
        if ($(t3)) {
          const e3 = He.get(`qualityLabel.${t3}`, this.config);
          return e3.length ? e3 : `${t3}p`;
        }
        return Oe(t3);
      case "captions":
        return Ye.getLabel.call(this);
      default:
        return null;
    }
  }, setQualityMenu(e2) {
    if (!H(this.elements.settings.panels.quality)) return;
    const t3 = "quality", i2 = this.elements.settings.panels.quality.querySelector('[role="menu"]');
    D(e2) && (this.options.quality = Ce(e2).filter(((e3) => this.config.quality.options.includes(e3))));
    const s2 = !W(this.options.quality) && this.options.quality.length > 1;
    if (We.toggleMenuButton.call(this, t3, s2), ie(i2), We.checkMenu.call(this), !s2) return;
    const n3 = (e3) => {
      const t4 = He.get(`qualityBadge.${e3}`, this.config);
      return t4.length ? We.createBadge.call(this, t4) : null;
    };
    this.options.quality.sort(((e3, t4) => {
      const i3 = this.config.quality.options;
      return i3.indexOf(e3) > i3.indexOf(t4) ? 1 : -1;
    })).forEach(((e3) => {
      We.createMenuItem.call(this, { value: e3, list: i2, type: t3, title: We.getLabel.call(this, "quality", e3), badge: n3(e3) });
    })), We.updateSetting.call(this, t3, i2);
  }, setCaptionsMenu() {
    if (!H(this.elements.settings.panels.captions)) return;
    const e2 = "captions", t3 = this.elements.settings.panels.captions.querySelector('[role="menu"]'), i2 = Ye.getTracks.call(this), s2 = Boolean(i2.length);
    if (We.toggleMenuButton.call(this, e2, s2), ie(t3), We.checkMenu.call(this), !s2) return;
    const n3 = i2.map(((e3, i3) => ({ value: i3, checked: this.captions.toggled && this.currentTrack === i3, title: Ye.getLabel.call(this, e3), badge: e3.language && We.createBadge.call(this, e3.language.toUpperCase()), list: t3, type: "language" })));
    n3.unshift({ value: -1, checked: !this.captions.toggled, title: He.get("disabled", this.config), list: t3, type: "language" }), n3.forEach(We.createMenuItem.bind(this)), We.updateSetting.call(this, e2, t3);
  }, setSpeedMenu() {
    if (!H(this.elements.settings.panels.speed)) return;
    const e2 = "speed", t3 = this.elements.settings.panels.speed.querySelector('[role="menu"]');
    this.options.speed = this.options.speed.filter(((e3) => e3 >= this.minimumSpeed && e3 <= this.maximumSpeed));
    const i2 = !W(this.options.speed) && this.options.speed.length > 1;
    We.toggleMenuButton.call(this, e2, i2), ie(t3), We.checkMenu.call(this), i2 && (this.options.speed.forEach(((i3) => {
      We.createMenuItem.call(this, { value: i3, list: t3, type: e2, title: We.getLabel.call(this, "speed", i3) });
    })), We.updateSetting.call(this, e2, t3));
  }, checkMenu() {
    const { buttons: e2 } = this.elements.settings, t3 = !W(e2) && Object.values(e2).some(((e3) => !e3.hidden));
    ae(this.elements.settings.menu, !t3);
  }, focusFirstMenuItem(e2, t3 = false) {
    if (this.elements.settings.popup.hidden) return;
    let i2 = e2;
    H(i2) || (i2 = Object.values(this.elements.settings.panels).find(((e3) => !e3.hidden)));
    const s2 = i2.querySelector('[role^="menuitem"]');
    ue.call(this, s2, t3);
  }, toggleMenu(e2) {
    const { popup: t3 } = this.elements.settings, i2 = this.elements.buttons.settings;
    if (!H(t3) || !H(i2)) return;
    const { hidden: s2 } = t3;
    let n3 = s2;
    if (O(e2)) n3 = e2;
    else if (F(e2) && "Escape" === e2.key) n3 = false;
    else if (R(e2)) {
      const s3 = j(e2.composedPath) ? e2.composedPath()[0] : e2.target, a2 = t3.contains(s3);
      if (a2 || !a2 && e2.target !== i2 && n3) return;
    }
    i2.setAttribute("aria-expanded", n3), ae(t3, !n3), le(this.elements.container, this.config.classNames.menu.open, n3), n3 && F(e2) ? We.focusFirstMenuItem.call(this, null, true) : n3 || s2 || ue.call(this, i2, F(e2));
  }, getMenuSize(e2) {
    const t3 = e2.cloneNode(true);
    t3.style.position = "absolute", t3.style.opacity = 0, t3.removeAttribute("hidden"), e2.parentNode.appendChild(t3);
    const i2 = t3.scrollWidth, s2 = t3.scrollHeight;
    return te(t3), { width: i2, height: s2 };
  }, showMenuPanel(e2 = "", t3 = false) {
    const i2 = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e2}`);
    if (!H(i2)) return;
    const s2 = i2.parentNode, n3 = Array.from(s2.children).find(((e3) => !e3.hidden));
    if (me.transitions && !me.reducedMotion) {
      s2.style.width = `${n3.scrollWidth}px`, s2.style.height = `${n3.scrollHeight}px`;
      const e3 = We.getMenuSize.call(this, i2), t4 = (e4) => {
        e4.target === s2 && ["width", "height"].includes(e4.propertyName) && (s2.style.width = "", s2.style.height = "", be.call(this, s2, z, t4));
      };
      fe.call(this, s2, z, t4), s2.style.width = `${e3.width}px`, s2.style.height = `${e3.height}px`;
    }
    ae(n3, true), ae(i2, false), We.focusFirstMenuItem.call(this, i2, t3);
  }, setDownloadUrl() {
    const e2 = this.elements.buttons.download;
    H(e2) && e2.setAttribute("href", this.download);
  }, create(e2) {
    const { bindMenuItemShortcuts: t3, createButton: i2, createProgress: s2, createRange: n3, createTime: a2, setQualityMenu: l2, setSpeedMenu: o2, showMenuPanel: r3 } = We;
    this.elements.controls = null, D(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i2.call(this, "play-large"));
    const c2 = Z("div", ne(this.config.selectors.controls.wrapper));
    this.elements.controls = c2;
    const h2 = { class: "plyr__controls__item" };
    return Ce(D(this.config.controls) ? this.config.controls : []).forEach(((l3) => {
      if ("restart" === l3 && c2.appendChild(i2.call(this, "restart", h2)), "rewind" === l3 && c2.appendChild(i2.call(this, "rewind", h2)), "play" === l3 && c2.appendChild(i2.call(this, "play", h2)), "fast-forward" === l3 && c2.appendChild(i2.call(this, "fast-forward", h2)), "progress" === l3) {
        const t4 = Z("div", { class: `${h2.class} plyr__progress__container` }), i3 = Z("div", ne(this.config.selectors.progress));
        if (i3.appendChild(n3.call(this, "seek", { id: `plyr-seek-${e2.id}` })), i3.appendChild(s2.call(this, "buffer")), this.config.tooltips.seek) {
          const e3 = Z("span", { class: this.config.classNames.tooltip }, "00:00");
          i3.appendChild(e3), this.elements.display.seekTooltip = e3;
        }
        this.elements.progress = i3, t4.appendChild(this.elements.progress), c2.appendChild(t4);
      }
      if ("current-time" === l3 && c2.appendChild(a2.call(this, "currentTime", h2)), "duration" === l3 && c2.appendChild(a2.call(this, "duration", h2)), "mute" === l3 || "volume" === l3) {
        let { volume: t4 } = this.elements;
        if (H(t4) && c2.contains(t4) || (t4 = Z("div", X({}, h2, { class: `${h2.class} plyr__volume`.trim() })), this.elements.volume = t4, c2.appendChild(t4)), "mute" === l3 && t4.appendChild(i2.call(this, "mute")), "volume" === l3 && !Y.isIos) {
          const i3 = { max: 1, step: 0.05, value: this.config.volume };
          t4.appendChild(n3.call(this, "volume", X(i3, { id: `plyr-volume-${e2.id}` })));
        }
      }
      if ("captions" === l3 && c2.appendChild(i2.call(this, "captions", h2)), "settings" === l3 && !W(this.config.settings)) {
        const s3 = Z("div", X({}, h2, { class: `${h2.class} plyr__menu`.trim(), hidden: "" }));
        s3.appendChild(i2.call(this, "settings", { "aria-haspopup": true, "aria-controls": `plyr-settings-${e2.id}`, "aria-expanded": false }));
        const n4 = Z("div", { class: "plyr__menu__container", id: `plyr-settings-${e2.id}`, hidden: "" }), a3 = Z("div"), l4 = Z("div", { id: `plyr-settings-${e2.id}-home` }), o3 = Z("div", { role: "menu" });
        l4.appendChild(o3), a3.appendChild(l4), this.elements.settings.panels.home = l4, this.config.settings.forEach(((i3) => {
          const s4 = Z("button", X(ne(this.config.selectors.buttons.settings), { type: "button", class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`, role: "menuitem", "aria-haspopup": true, hidden: "" }));
          t3.call(this, s4, i3), fe.call(this, s4, "click", (() => {
            r3.call(this, i3, false);
          }));
          const n5 = Z("span", null, He.get(i3, this.config)), l5 = Z("span", { class: this.config.classNames.menu.value });
          l5.innerHTML = e2[i3], n5.appendChild(l5), s4.appendChild(n5), o3.appendChild(s4);
          const c3 = Z("div", { id: `plyr-settings-${e2.id}-${i3}`, hidden: "" }), h3 = Z("button", { type: "button", class: `${this.config.classNames.control} ${this.config.classNames.control}--back` });
          h3.appendChild(Z("span", { "aria-hidden": true }, He.get(i3, this.config))), h3.appendChild(Z("span", { class: this.config.classNames.hidden }, He.get("menuBack", this.config))), fe.call(this, c3, "keydown", ((e3) => {
            "ArrowLeft" === e3.key && (e3.preventDefault(), e3.stopPropagation(), r3.call(this, "home", true));
          }), false), fe.call(this, h3, "click", (() => {
            r3.call(this, "home", false);
          })), c3.appendChild(h3), c3.appendChild(Z("div", { role: "menu" })), a3.appendChild(c3), this.elements.settings.buttons[i3] = s4, this.elements.settings.panels[i3] = c3;
        })), n4.appendChild(a3), s3.appendChild(n4), c2.appendChild(s3), this.elements.settings.popup = n4, this.elements.settings.menu = s3;
      }
      if ("pip" === l3 && me.pip && c2.appendChild(i2.call(this, "pip", h2)), "airplay" === l3 && me.airplay && c2.appendChild(i2.call(this, "airplay", h2)), "download" === l3) {
        const e3 = X({}, h2, { element: "a", href: this.download, target: "_blank" });
        this.isHTML5 && (e3.download = "");
        const { download: t4 } = this.config.urls;
        !U(t4) && this.isEmbed && X(e3, { icon: `logo-${this.provider}`, label: this.provider }), c2.appendChild(i2.call(this, "download", e3));
      }
      "fullscreen" === l3 && c2.appendChild(i2.call(this, "fullscreen", h2));
    })), this.isHTML5 && l2.call(this, Le.getQualityOptions.call(this)), o2.call(this), c2;
  }, inject() {
    if (this.config.loadSprite) {
      const e3 = We.getIconUrl.call(this);
      e3.cors && Ve(e3.url, "sprite-plyr");
    }
    this.id = Math.floor(1e4 * Math.random());
    let e2 = null;
    this.elements.controls = null;
    const t3 = { id: this.id, seektime: this.config.seekTime, title: this.config.title };
    let i2 = true;
    j(this.config.controls) && (this.config.controls = this.config.controls.call(this, t3)), this.config.controls || (this.config.controls = []), H(this.config.controls) || _(this.config.controls) ? e2 = this.config.controls : (e2 = We.create.call(this, { id: this.id, seektime: this.config.seekTime, speed: this.speed, quality: this.quality, captions: Ye.getLabel.call(this) }), i2 = false);
    let s2;
    i2 && _(this.config.controls) && (e2 = ((e3) => {
      let i3 = e3;
      return Object.entries(t3).forEach((([e4, t4]) => {
        i3 = _e(i3, `{${e4}}`, t4);
      })), i3;
    })(e2)), _(this.config.selectors.controls.container) && (s2 = document.querySelector(this.config.selectors.controls.container)), H(s2) || (s2 = this.elements.container);
    if (s2[H(e2) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e2), H(this.elements.controls) || We.findElements.call(this), !W(this.elements.buttons)) {
      const e3 = (e4) => {
        const t4 = this.config.classNames.controlPressed;
        Object.defineProperty(e4, "pressed", { enumerable: true, get: () => oe(e4, t4), set(i3 = false) {
          le(e4, t4, i3);
        } });
      };
      Object.values(this.elements.buttons).filter(Boolean).forEach(((t4) => {
        D(t4) || q(t4) ? Array.from(t4).filter(Boolean).forEach(e3) : e3(t4);
      }));
    }
    if (Y.isEdge && K(s2), this.config.tooltips.controls) {
      const { classNames: e3, selectors: t4 } = this.config, i3 = `${t4.controls.wrapper} ${t4.labels} .${e3.hidden}`, s3 = ce.call(this, i3);
      Array.from(s3).forEach(((e4) => {
        le(e4, this.config.classNames.hidden, false), le(e4, this.config.classNames.tooltip, true);
      }));
    }
  }, setMediaMetadata() {
    try {
      "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({ title: this.config.mediaMetadata.title, artist: this.config.mediaMetadata.artist, album: this.config.mediaMetadata.album, artwork: this.config.mediaMetadata.artwork }));
    } catch (e2) {
    }
  }, setMarkers() {
    var e2, t3;
    if (!this.duration || this.elements.markers) return;
    const i2 = null === (e2 = this.config.markers) || void 0 === e2 || null === (t3 = e2.points) || void 0 === t3 ? void 0 : t3.filter((({ time: e3 }) => e3 > 0 && e3 < this.duration));
    if (null == i2 || !i2.length) return;
    const s2 = document.createDocumentFragment(), n3 = document.createDocumentFragment();
    let a2 = null;
    const l2 = `${this.config.classNames.tooltip}--visible`, o2 = (e3) => le(a2, l2, e3);
    i2.forEach(((e3) => {
      const t4 = Z("span", { class: this.config.classNames.marker }, ""), i3 = e3.time / this.duration * 100 + "%";
      a2 && (t4.addEventListener("mouseenter", (() => {
        e3.label || (a2.style.left = i3, a2.innerHTML = e3.label, o2(true));
      })), t4.addEventListener("mouseleave", (() => {
        o2(false);
      }))), t4.addEventListener("click", (() => {
        this.currentTime = e3.time;
      })), t4.style.left = i3, n3.appendChild(t4);
    })), s2.appendChild(n3), this.config.tooltips.seek || (a2 = Z("span", { class: this.config.classNames.tooltip }, ""), s2.appendChild(a2)), this.elements.markers = { points: n3, tip: a2 }, this.elements.progress.appendChild(s2);
  } };
  function ze(e2, t3 = true) {
    let i2 = e2;
    if (t3) {
      const e3 = document.createElement("a");
      e3.href = i2, i2 = e3.href;
    }
    try {
      return new URL(i2);
    } catch (e3) {
      return null;
    }
  }
  function Ke(e2) {
    const t3 = new URLSearchParams();
    return L(e2) && Object.entries(e2).forEach((([e3, i2]) => {
      t3.set(e3, i2);
    })), t3;
  }
  const Ye = { setup() {
    if (!this.supported.ui) return;
    if (!this.isVideo || this.isYouTube || this.isHTML5 && !me.textTracks) return void (D(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && We.setCaptionsMenu.call(this));
    var e2, t3;
    if (H(this.elements.captions) || (this.elements.captions = Z("div", ne(this.config.selectors.captions)), e2 = this.elements.captions, t3 = this.elements.wrapper, H(e2) && H(t3) && t3.parentNode.insertBefore(e2, t3.nextSibling)), Y.isIE && window.URL) {
      const e3 = this.media.querySelectorAll("track");
      Array.from(e3).forEach(((e4) => {
        const t4 = e4.getAttribute("src"), i3 = ze(t4);
        null !== i3 && i3.hostname !== window.location.href.hostname && ["http:", "https:"].includes(i3.protocol) && Fe(t4, "blob").then(((t5) => {
          e4.setAttribute("src", window.URL.createObjectURL(t5));
        })).catch((() => {
          te(e4);
        }));
      }));
    }
    const i2 = Ce((navigator.languages || [navigator.language || navigator.userLanguage || "en"]).map(((e3) => e3.split("-")[0])));
    let s2 = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
    "auto" === s2 && ([s2] = i2);
    let n3 = this.storage.get("captions");
    if (O(n3) || ({ active: n3 } = this.config.captions), Object.assign(this.captions, { toggled: false, active: n3, language: s2, languages: i2 }), this.isHTML5) {
      const e3 = this.config.captions.update ? "addtrack removetrack" : "removetrack";
      fe.call(this, this.media.textTracks, e3, Ye.update.bind(this));
    }
    setTimeout(Ye.update.bind(this), 0);
  }, update() {
    const e2 = Ye.getTracks.call(this, true), { active: t3, language: i2, meta: s2, currentTrackNode: n3 } = this.captions, a2 = Boolean(e2.find(((e3) => e3.language === i2)));
    this.isHTML5 && this.isVideo && e2.filter(((e3) => !s2.get(e3))).forEach(((e3) => {
      this.debug.log("Track added", e3), s2.set(e3, { default: "showing" === e3.mode }), "showing" === e3.mode && (e3.mode = "hidden"), fe.call(this, e3, "cuechange", (() => Ye.updateCues.call(this)));
    })), (a2 && this.language !== i2 || !e2.includes(n3)) && (Ye.setLanguage.call(this, i2), Ye.toggle.call(this, t3 && a2)), this.elements && le(this.elements.container, this.config.classNames.captions.enabled, !W(e2)), D(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && We.setCaptionsMenu.call(this);
  }, toggle(e2, t3 = true) {
    if (!this.supported.ui) return;
    const { toggled: i2 } = this.captions, s2 = this.config.classNames.captions.active, n3 = I(e2) ? !i2 : e2;
    if (n3 !== i2) {
      if (t3 || (this.captions.active = n3, this.storage.set({ captions: n3 })), !this.language && n3 && !t3) {
        const e3 = Ye.getTracks.call(this), t4 = Ye.findTrack.call(this, [this.captions.language, ...this.captions.languages], true);
        return this.captions.language = t4.language, void Ye.set.call(this, e3.indexOf(t4));
      }
      this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n3), le(this.elements.container, s2, n3), this.captions.toggled = n3, We.updateSetting.call(this, "captions"), ve.call(this, this.media, n3 ? "captionsenabled" : "captionsdisabled");
    }
    setTimeout((() => {
      n3 && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
    }));
  }, set(e2, t3 = true) {
    const i2 = Ye.getTracks.call(this);
    if (-1 !== e2) if ($(e2)) if (e2 in i2) {
      if (this.captions.currentTrack !== e2) {
        this.captions.currentTrack = e2;
        const s2 = i2[e2], { language: n3 } = s2 || {};
        this.captions.currentTrackNode = s2, We.updateSetting.call(this, "captions"), t3 || (this.captions.language = n3, this.storage.set({ language: n3 })), this.isVimeo && this.embed.enableTextTrack(n3), ve.call(this, this.media, "languagechange");
      }
      Ye.toggle.call(this, true, t3), this.isHTML5 && this.isVideo && Ye.updateCues.call(this);
    } else this.debug.warn("Track not found", e2);
    else this.debug.warn("Invalid caption argument", e2);
    else Ye.toggle.call(this, false, t3);
  }, setLanguage(e2, t3 = true) {
    if (!_(e2)) return void this.debug.warn("Invalid language argument", e2);
    const i2 = e2.toLowerCase();
    this.captions.language = i2;
    const s2 = Ye.getTracks.call(this), n3 = Ye.findTrack.call(this, [i2]);
    Ye.set.call(this, s2.indexOf(n3), t3);
  }, getTracks(e2 = false) {
    return Array.from((this.media || {}).textTracks || []).filter(((t3) => !this.isHTML5 || e2 || this.captions.meta.has(t3))).filter(((e3) => ["captions", "subtitles"].includes(e3.kind)));
  }, findTrack(e2, t3 = false) {
    const i2 = Ye.getTracks.call(this), s2 = (e3) => Number((this.captions.meta.get(e3) || {}).default), n3 = Array.from(i2).sort(((e3, t4) => s2(t4) - s2(e3)));
    let a2;
    return e2.every(((e3) => (a2 = n3.find(((t4) => t4.language === e3)), !a2))), a2 || (t3 ? n3[0] : void 0);
  }, getCurrentTrack() {
    return Ye.getTracks.call(this)[this.currentTrack];
  }, getLabel(e2) {
    let t3 = e2;
    return !V(t3) && me.textTracks && this.captions.toggled && (t3 = Ye.getCurrentTrack.call(this)), V(t3) ? W(t3.label) ? W(t3.language) ? He.get("enabled", this.config) : e2.language.toUpperCase() : t3.label : He.get("disabled", this.config);
  }, updateCues(e2) {
    if (!this.supported.ui) return;
    if (!H(this.elements.captions)) return void this.debug.warn("No captions element to render to");
    if (!I(e2) && !Array.isArray(e2)) return void this.debug.warn("updateCues: Invalid input", e2);
    let t3 = e2;
    if (!t3) {
      const e3 = Ye.getCurrentTrack.call(this);
      t3 = Array.from((e3 || {}).activeCues || []).map(((e4) => e4.getCueAsHTML())).map(De);
    }
    const i2 = t3.map(((e3) => e3.trim())).join("\n");
    if (i2 !== this.elements.captions.innerHTML) {
      ie(this.elements.captions);
      const e3 = Z("span", ne(this.config.selectors.caption));
      e3.innerHTML = i2, this.elements.captions.appendChild(e3), ve.call(this, this.media, "cuechange");
    }
  } }, Qe = { enabled: true, title: "", debug: false, autoplay: false, autopause: true, playsinline: true, seekTime: 10, volume: 1, muted: false, duration: null, displayDuration: true, invertTime: true, toggleInvert: true, ratio: null, clickToPlay: true, hideControls: true, resetOnEnd: false, disableContextMenu: true, loadSprite: true, iconPrefix: "plyr", iconUrl: "https://cdn.plyr.io/3.7.2/plyr.svg", blankVideo: "https://cdn.plyr.io/static/blank.mp4", quality: { default: 576, options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240], forced: false, onChange: null }, loop: { active: false }, speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4] }, keyboard: { focused: true, global: false }, tooltips: { controls: false, seek: true }, captions: { active: false, language: "auto", update: false }, fullscreen: { enabled: true, fallback: true, iosNative: false }, storage: { enabled: true, key: "plyr" }, controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen"], settings: ["captions", "quality", "speed"], i18n: { restart: "Restart", rewind: "Rewind {seektime}s", play: "Play", pause: "Pause", fastForward: "Forward {seektime}s", seek: "Seek", seekLabel: "{currentTime} of {duration}", played: "Played", buffered: "Buffered", currentTime: "Current time", duration: "Duration", volume: "Volume", mute: "Mute", unmute: "Unmute", enableCaptions: "Enable captions", disableCaptions: "Disable captions", download: "Download", enterFullscreen: "Enter fullscreen", exitFullscreen: "Exit fullscreen", frameTitle: "Player for {title}", captions: "Captions", settings: "Settings", pip: "PIP", menuBack: "Go back to previous menu", speed: "Speed", normal: "Normal", quality: "Quality", loop: "Loop", start: "Start", end: "End", all: "All", reset: "Reset", disabled: "Disabled", enabled: "Enabled", advertisement: "Ad", qualityBadge: { 2160: "4K", 1440: "HD", 1080: "HD", 720: "HD", 576: "SD", 480: "SD" } }, urls: { download: null, vimeo: { sdk: "https://player.vimeo.com/api/player.js", iframe: "https://player.vimeo.com/video/{0}?{1}", api: "https://vimeo.com/api/oembed.json?url={0}" }, youtube: { sdk: "https://www.youtube.com/iframe_api", api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}" }, googleIMA: { sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js" } }, listeners: { seek: null, play: null, pause: null, restart: null, rewind: null, fastForward: null, mute: null, volume: null, captions: null, download: null, fullscreen: null, pip: null, airplay: null, speed: null, quality: null, loop: null, language: null }, events: ["ended", "progress", "stalled", "playing", "waiting", "canplay", "canplaythrough", "loadstart", "loadeddata", "loadedmetadata", "timeupdate", "volumechange", "play", "pause", "error", "seeking", "seeked", "emptied", "ratechange", "cuechange", "download", "enterfullscreen", "exitfullscreen", "captionsenabled", "captionsdisabled", "languagechange", "controlshidden", "controlsshown", "ready", "statechange", "qualitychange", "adsloaded", "adscontentpause", "adscontentresume", "adstarted", "adsmidpoint", "adscomplete", "adsallcomplete", "adsimpression", "adsclick"], selectors: { editable: "input, textarea, select, [contenteditable]", container: ".plyr", controls: { container: null, wrapper: ".plyr__controls" }, labels: "[data-plyr]", buttons: { play: '[data-plyr="play"]', pause: '[data-plyr="pause"]', restart: '[data-plyr="restart"]', rewind: '[data-plyr="rewind"]', fastForward: '[data-plyr="fast-forward"]', mute: '[data-plyr="mute"]', captions: '[data-plyr="captions"]', download: '[data-plyr="download"]', fullscreen: '[data-plyr="fullscreen"]', pip: '[data-plyr="pip"]', airplay: '[data-plyr="airplay"]', settings: '[data-plyr="settings"]', loop: '[data-plyr="loop"]' }, inputs: { seek: '[data-plyr="seek"]', volume: '[data-plyr="volume"]', speed: '[data-plyr="speed"]', language: '[data-plyr="language"]', quality: '[data-plyr="quality"]' }, display: { currentTime: ".plyr__time--current", duration: ".plyr__time--duration", buffer: ".plyr__progress__buffer", loop: ".plyr__progress__loop", volume: ".plyr__volume--display" }, progress: ".plyr__progress", captions: ".plyr__captions", caption: ".plyr__caption" }, classNames: { type: "plyr--{0}", provider: "plyr--{0}", video: "plyr__video-wrapper", embed: "plyr__video-embed", videoFixedRatio: "plyr__video-wrapper--fixed-ratio", embedContainer: "plyr__video-embed__container", poster: "plyr__poster", posterEnabled: "plyr__poster-enabled", ads: "plyr__ads", control: "plyr__control", controlPressed: "plyr__control--pressed", playing: "plyr--playing", paused: "plyr--paused", stopped: "plyr--stopped", loading: "plyr--loading", hover: "plyr--hover", tooltip: "plyr__tooltip", cues: "plyr__cues", marker: "plyr__progress__marker", hidden: "plyr__sr-only", hideControls: "plyr--hide-controls", isIos: "plyr--is-ios", isTouch: "plyr--is-touch", uiSupported: "plyr--full-ui", noTransition: "plyr--no-transition", display: { time: "plyr__time" }, menu: { value: "plyr__menu__value", badge: "plyr__badge", open: "plyr--menu-open" }, captions: { enabled: "plyr--captions-enabled", active: "plyr--captions-active" }, fullscreen: { enabled: "plyr--fullscreen-enabled", fallback: "plyr--fullscreen-fallback" }, pip: { supported: "plyr--pip-supported", active: "plyr--pip-active" }, airplay: { supported: "plyr--airplay-supported", active: "plyr--airplay-active" }, tabFocus: "plyr__tab-focus", previewThumbnails: { thumbContainer: "plyr__preview-thumb", thumbContainerShown: "plyr__preview-thumb--is-shown", imageContainer: "plyr__preview-thumb__image-container", timeContainer: "plyr__preview-thumb__time-container", scrubbingContainer: "plyr__preview-scrubbing", scrubbingContainerShown: "plyr__preview-scrubbing--is-shown" } }, attributes: { embed: { provider: "data-plyr-provider", id: "data-plyr-embed-id", hash: "data-plyr-embed-hash" } }, ads: { enabled: false, publisherId: "", tagUrl: "" }, previewThumbnails: { enabled: false, src: "" }, vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false, customControls: true, referrerPolicy: null, premium: false }, youtube: { rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, customControls: true, noCookie: false }, mediaMetadata: { title: "", artist: "", album: "", artwork: [] }, markers: { enabled: false, points: [] } }, Xe = "picture-in-picture", Je = "inline", Ge = { html5: "html5", youtube: "youtube", vimeo: "vimeo" }, Ze = "audio", et = "video";
  const tt = () => {
  };
  class it {
    constructor(e2 = false) {
      this.enabled = window.console && e2, this.enabled && this.log("Debugging enabled");
    }
    get log() {
      return this.enabled ? Function.prototype.bind.call(console.log, console) : tt;
    }
    get warn() {
      return this.enabled ? Function.prototype.bind.call(console.warn, console) : tt;
    }
    get error() {
      return this.enabled ? Function.prototype.bind.call(console.error, console) : tt;
    }
  }
  class st {
    constructor(t3) {
      e(this, "onChange", (() => {
        if (!this.enabled) return;
        const e2 = this.player.elements.buttons.fullscreen;
        H(e2) && (e2.pressed = this.active);
        const t4 = this.target === this.player.media ? this.target : this.player.elements.container;
        ve.call(this.player, t4, this.active ? "enterfullscreen" : "exitfullscreen", true);
      })), e(this, "toggleFallback", ((e2 = false) => {
        if (e2 ? this.scrollPosition = { x: window.scrollX || 0, y: window.scrollY || 0 } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = e2 ? "hidden" : "", le(this.target, this.player.config.classNames.fullscreen.fallback, e2), Y.isIos) {
          let t4 = document.head.querySelector('meta[name="viewport"]');
          const i2 = "viewport-fit=cover";
          t4 || (t4 = document.createElement("meta"), t4.setAttribute("name", "viewport"));
          const s2 = _(t4.content) && t4.content.includes(i2);
          e2 ? (this.cleanupViewport = !s2, s2 || (t4.content += `,${i2}`)) : this.cleanupViewport && (t4.content = t4.content.split(",").filter(((e3) => e3.trim() !== i2)).join(","));
        }
        this.onChange();
      })), e(this, "trapFocus", ((e2) => {
        if (Y.isIos || !this.active || "Tab" !== e2.key) return;
        const t4 = document.activeElement, i2 = ce.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [s2] = i2, n3 = i2[i2.length - 1];
        t4 !== n3 || e2.shiftKey ? t4 === s2 && e2.shiftKey && (n3.focus(), e2.preventDefault()) : (s2.focus(), e2.preventDefault());
      })), e(this, "update", (() => {
        if (this.enabled) {
          let e2;
          e2 = this.forceFallback ? "Fallback (forced)" : st.native ? "Native" : "Fallback", this.player.debug.log(`${e2} fullscreen enabled`);
        } else this.player.debug.log("Fullscreen not supported and fallback disabled");
        le(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.enabled);
      })), e(this, "enter", (() => {
        this.enabled && (Y.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !st.native || this.forceFallback ? this.toggleFallback(true) : this.prefix ? W(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({ navigationUI: "hide" }));
      })), e(this, "exit", (() => {
        if (this.enabled) if (Y.isIos && this.player.config.fullscreen.iosNative) this.target.webkitExitFullscreen(), ke(this.player.play());
        else if (!st.native || this.forceFallback) this.toggleFallback(false);
        else if (this.prefix) {
          if (!W(this.prefix)) {
            const e2 = "moz" === this.prefix ? "Cancel" : "Exit";
            document[`${this.prefix}${e2}${this.property}`]();
          }
        } else (document.cancelFullScreen || document.exitFullscreen).call(document);
      })), e(this, "toggle", (() => {
        this.active ? this.exit() : this.enter();
      })), this.player = t3, this.prefix = st.prefix, this.property = st.property, this.scrollPosition = { x: 0, y: 0 }, this.forceFallback = "force" === t3.config.fullscreen.fallback, this.player.elements.fullscreen = t3.config.fullscreen.container && (function(e2, t4) {
        const { prototype: i2 } = Element;
        return (i2.closest || function() {
          let e3 = this;
          do {
            if (re.matches(e3, t4)) return e3;
            e3 = e3.parentElement || e3.parentNode;
          } while (null !== e3 && 1 === e3.nodeType);
          return null;
        }).call(e2, t4);
      })(this.player.elements.container, t3.config.fullscreen.container), fe.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, (() => {
        this.onChange();
      })), fe.call(this.player, this.player.elements.container, "dblclick", ((e2) => {
        H(this.player.elements.controls) && this.player.elements.controls.contains(e2.target) || this.player.listeners.proxy(e2, this.toggle, "fullscreen");
      })), fe.call(this, this.player.elements.container, "keydown", ((e2) => this.trapFocus(e2))), this.update();
    }
    static get native() {
      return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
    }
    get usingNative() {
      return st.native && !this.forceFallback;
    }
    static get prefix() {
      if (j(document.exitFullscreen)) return "";
      let e2 = "";
      return ["webkit", "moz", "ms"].some(((t3) => !(!j(document[`${t3}ExitFullscreen`]) && !j(document[`${t3}CancelFullScreen`])) && (e2 = t3, true))), e2;
    }
    static get property() {
      return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
    }
    get enabled() {
      return (st.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo;
    }
    get active() {
      if (!this.enabled) return false;
      if (!st.native || this.forceFallback) return oe(this.target, this.player.config.classNames.fullscreen.fallback);
      const e2 = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
      return e2 && e2.shadowRoot ? e2 === this.target.getRootNode().host : e2 === this.target;
    }
    get target() {
      return Y.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen || this.player.elements.container;
    }
  }
  function nt(e2, t3 = 1) {
    return new Promise(((i2, s2) => {
      const n3 = new Image(), a2 = () => {
        delete n3.onload, delete n3.onerror, (n3.naturalWidth >= t3 ? i2 : s2)(n3);
      };
      Object.assign(n3, { onload: a2, onerror: a2, src: e2 });
    }));
  }
  const at = { addStyleHook() {
    le(this.elements.container, this.config.selectors.container.replace(".", ""), true), le(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
  }, toggleNativeControls(e2 = false) {
    e2 && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
  }, build() {
    if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void at.toggleNativeControls.call(this, true);
    H(this.elements.controls) || (We.inject.call(this), this.listeners.controls()), at.toggleNativeControls.call(this), this.isHTML5 && Ye.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, We.updateVolume.call(this), We.timeUpdate.call(this), We.durationUpdate.call(this), at.checkPlaying.call(this), le(this.elements.container, this.config.classNames.pip.supported, me.pip && this.isHTML5 && this.isVideo), le(this.elements.container, this.config.classNames.airplay.supported, me.airplay && this.isHTML5), le(this.elements.container, this.config.classNames.isIos, Y.isIos), le(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = true, setTimeout((() => {
      ve.call(this, this.media, "ready");
    }), 0), at.setTitle.call(this), this.poster && at.setPoster.call(this, this.poster, false).catch((() => {
    })), this.config.duration && We.durationUpdate.call(this), this.config.mediaMetadata && We.setMediaMetadata.call(this);
  }, setTitle() {
    let e2 = He.get("play", this.config);
    if (_(this.config.title) && !W(this.config.title) && (e2 += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach(((t3) => {
      t3.setAttribute("aria-label", e2);
    })), this.isEmbed) {
      const e3 = he.call(this, "iframe");
      if (!H(e3)) return;
      const t3 = W(this.config.title) ? "video" : this.config.title, i2 = He.get("frameTitle", this.config);
      e3.setAttribute("title", i2.replace("{title}", t3));
    }
  }, togglePoster(e2) {
    le(this.elements.container, this.config.classNames.posterEnabled, e2);
  }, setPoster(e2, t3 = true) {
    return t3 && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e2), this.elements.poster.removeAttribute("hidden"), Te.call(this).then((() => nt(e2))).catch(((t4) => {
      throw e2 === this.poster && at.togglePoster.call(this, false), t4;
    })).then((() => {
      if (e2 !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
    })).then((() => (Object.assign(this.elements.poster.style, { backgroundImage: `url('${e2}')`, backgroundSize: "" }), at.togglePoster.call(this, true), e2))));
  }, checkPlaying(e2) {
    le(this.elements.container, this.config.classNames.playing, this.playing), le(this.elements.container, this.config.classNames.paused, this.paused), le(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach(((e3) => {
      Object.assign(e3, { pressed: this.playing }), e3.setAttribute("aria-label", He.get(this.playing ? "pause" : "play", this.config));
    })), R(e2) && "timeupdate" === e2.type || at.toggleControls.call(this);
  }, checkLoading(e2) {
    this.loading = ["stalled", "waiting"].includes(e2.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout((() => {
      le(this.elements.container, this.config.classNames.loading, this.loading), at.toggleControls.call(this);
    }), this.loading ? 250 : 0);
  }, toggleControls(e2) {
    const { controls: t3 } = this.elements;
    if (t3 && this.config.hideControls) {
      const i2 = this.touch && this.lastSeekTime + 2e3 > Date.now();
      this.toggleControls(Boolean(e2 || this.loading || this.paused || t3.pressed || t3.hover || i2));
    }
  }, migrateStyles() {
    Object.values({ ...this.media.style }).filter(((e2) => !W(e2) && _(e2) && e2.startsWith("--plyr"))).forEach(((e2) => {
      this.elements.container.style.setProperty(e2, this.media.style.getPropertyValue(e2)), this.media.style.removeProperty(e2);
    })), W(this.media.style) && this.media.removeAttribute("style");
  } };
  class lt {
    constructor(t3) {
      e(this, "firstTouch", (() => {
        const { player: e2 } = this, { elements: t4 } = e2;
        e2.touch = true, le(t4.container, e2.config.classNames.isTouch, true);
      })), e(this, "setTabFocus", ((e2) => {
        const { player: t4 } = this, { elements: i2 } = t4, { key: s2, type: n3, timeStamp: a2 } = e2;
        if (clearTimeout(this.focusTimer), "keydown" === n3 && "Tab" !== s2) return;
        "keydown" === n3 && (this.lastKeyDown = a2);
        const l2 = a2 - this.lastKeyDown <= 20;
        ("focus" !== n3 || l2) && ((() => {
          const e3 = t4.config.classNames.tabFocus;
          le(ce.call(t4, `.${e3}`), e3, false);
        })(), "focusout" !== n3 && (this.focusTimer = setTimeout((() => {
          const e3 = document.activeElement;
          i2.container.contains(e3) && le(document.activeElement, t4.config.classNames.tabFocus, true);
        }), 10)));
      })), e(this, "global", ((e2 = true) => {
        const { player: t4 } = this;
        t4.config.keyboard.global && ge.call(t4, window, "keydown keyup", this.handleKey, e2, false), ge.call(t4, document.body, "click", this.toggleMenu, e2), ye.call(t4, document.body, "touchstart", this.firstTouch), ge.call(t4, document.body, "keydown focus blur focusout", this.setTabFocus, e2, false, true);
      })), e(this, "container", (() => {
        const { player: e2 } = this, { config: t4, elements: i2, timers: s2 } = e2;
        !t4.keyboard.global && t4.keyboard.focused && fe.call(e2, i2.container, "keydown keyup", this.handleKey, false), fe.call(e2, i2.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", ((t5) => {
          const { controls: n4 } = i2;
          n4 && "enterfullscreen" === t5.type && (n4.pressed = false, n4.hover = false);
          let a3 = 0;
          ["touchstart", "touchmove", "mousemove"].includes(t5.type) && (at.toggleControls.call(e2, true), a3 = e2.touch ? 3e3 : 2e3), clearTimeout(s2.controls), s2.controls = setTimeout((() => at.toggleControls.call(e2, false)), a3);
        }));
        const n3 = () => {
          if (!e2.isVimeo || e2.config.vimeo.premium) return;
          const t5 = i2.wrapper, { active: s3 } = e2.fullscreen, [n4, a3] = Ne.call(e2), l2 = Se(`aspect-ratio: ${n4} / ${a3}`);
          if (!s3) return void (l2 ? (t5.style.width = null, t5.style.height = null) : (t5.style.maxWidth = null, t5.style.margin = null));
          const [o2, r3] = [Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0), Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)], c2 = o2 / r3 > n4 / a3;
          l2 ? (t5.style.width = c2 ? "auto" : "100%", t5.style.height = c2 ? "100%" : "auto") : (t5.style.maxWidth = c2 ? r3 / a3 * n4 + "px" : null, t5.style.margin = c2 ? "0 auto" : null);
        }, a2 = () => {
          clearTimeout(s2.resized), s2.resized = setTimeout(n3, 50);
        };
        fe.call(e2, i2.container, "enterfullscreen exitfullscreen", ((t5) => {
          const { target: s3 } = e2.fullscreen;
          if (s3 !== i2.container) return;
          if (!e2.isEmbed && W(e2.config.ratio)) return;
          n3();
          ("enterfullscreen" === t5.type ? fe : be).call(e2, window, "resize", a2);
        }));
      })), e(this, "media", (() => {
        const { player: e2 } = this, { elements: t4 } = e2;
        if (fe.call(e2, e2.media, "timeupdate seeking seeked", ((t5) => We.timeUpdate.call(e2, t5))), fe.call(e2, e2.media, "durationchange loadeddata loadedmetadata", ((t5) => We.durationUpdate.call(e2, t5))), fe.call(e2, e2.media, "ended", (() => {
          e2.isHTML5 && e2.isVideo && e2.config.resetOnEnd && (e2.restart(), e2.pause());
        })), fe.call(e2, e2.media, "progress playing seeking seeked", ((t5) => We.updateProgress.call(e2, t5))), fe.call(e2, e2.media, "volumechange", ((t5) => We.updateVolume.call(e2, t5))), fe.call(e2, e2.media, "playing play pause ended emptied timeupdate", ((t5) => at.checkPlaying.call(e2, t5))), fe.call(e2, e2.media, "waiting canplay seeked playing", ((t5) => at.checkLoading.call(e2, t5))), e2.supported.ui && e2.config.clickToPlay && !e2.isAudio) {
          const i3 = he.call(e2, `.${e2.config.classNames.video}`);
          if (!H(i3)) return;
          fe.call(e2, t4.container, "click", ((s2) => {
            ([t4.container, i3].includes(s2.target) || i3.contains(s2.target)) && (e2.touch && e2.config.hideControls || (e2.ended ? (this.proxy(s2, e2.restart, "restart"), this.proxy(s2, (() => {
              ke(e2.play());
            }), "play")) : this.proxy(s2, (() => {
              ke(e2.togglePlay());
            }), "play")));
          }));
        }
        e2.supported.ui && e2.config.disableContextMenu && fe.call(e2, t4.wrapper, "contextmenu", ((e3) => {
          e3.preventDefault();
        }), false), fe.call(e2, e2.media, "volumechange", (() => {
          e2.storage.set({ volume: e2.volume, muted: e2.muted });
        })), fe.call(e2, e2.media, "ratechange", (() => {
          We.updateSetting.call(e2, "speed"), e2.storage.set({ speed: e2.speed });
        })), fe.call(e2, e2.media, "qualitychange", ((t5) => {
          We.updateSetting.call(e2, "quality", null, t5.detail.quality);
        })), fe.call(e2, e2.media, "ready qualitychange", (() => {
          We.setDownloadUrl.call(e2);
        }));
        const i2 = e2.config.events.concat(["keyup", "keydown"]).join(" ");
        fe.call(e2, e2.media, i2, ((i3) => {
          let { detail: s2 = {} } = i3;
          "error" === i3.type && (s2 = e2.media.error), ve.call(e2, t4.container, i3.type, true, s2);
        }));
      })), e(this, "proxy", ((e2, t4, i2) => {
        const { player: s2 } = this, n3 = s2.config.listeners[i2];
        let a2 = true;
        j(n3) && (a2 = n3.call(s2, e2)), false !== a2 && j(t4) && t4.call(s2, e2);
      })), e(this, "bind", ((e2, t4, i2, s2, n3 = true) => {
        const { player: a2 } = this, l2 = a2.config.listeners[s2], o2 = j(l2);
        fe.call(a2, e2, t4, ((e3) => this.proxy(e3, i2, s2)), n3 && !o2);
      })), e(this, "controls", (() => {
        const { player: e2 } = this, { elements: t4 } = e2, i2 = Y.isIE ? "change" : "input";
        if (t4.buttons.play && Array.from(t4.buttons.play).forEach(((t5) => {
          this.bind(t5, "click", (() => {
            ke(e2.togglePlay());
          }), "play");
        })), this.bind(t4.buttons.restart, "click", e2.restart, "restart"), this.bind(t4.buttons.rewind, "click", (() => {
          e2.lastSeekTime = Date.now(), e2.rewind();
        }), "rewind"), this.bind(t4.buttons.fastForward, "click", (() => {
          e2.lastSeekTime = Date.now(), e2.forward();
        }), "fastForward"), this.bind(t4.buttons.mute, "click", (() => {
          e2.muted = !e2.muted;
        }), "mute"), this.bind(t4.buttons.captions, "click", (() => e2.toggleCaptions())), this.bind(t4.buttons.download, "click", (() => {
          ve.call(e2, e2.media, "download");
        }), "download"), this.bind(t4.buttons.fullscreen, "click", (() => {
          e2.fullscreen.toggle();
        }), "fullscreen"), this.bind(t4.buttons.pip, "click", (() => {
          e2.pip = "toggle";
        }), "pip"), this.bind(t4.buttons.airplay, "click", e2.airplay, "airplay"), this.bind(t4.buttons.settings, "click", ((t5) => {
          t5.stopPropagation(), t5.preventDefault(), We.toggleMenu.call(e2, t5);
        }), null, false), this.bind(t4.buttons.settings, "keyup", ((t5) => {
          ["Space", "Enter"].includes(t5.key) && ("Enter" !== t5.key ? (t5.preventDefault(), t5.stopPropagation(), We.toggleMenu.call(e2, t5)) : We.focusFirstMenuItem.call(e2, null, true));
        }), null, false), this.bind(t4.settings.menu, "keydown", ((t5) => {
          "Escape" === t5.key && We.toggleMenu.call(e2, t5);
        })), this.bind(t4.inputs.seek, "mousedown mousemove", ((e3) => {
          const i3 = t4.progress.getBoundingClientRect(), s2 = 100 / i3.width * (e3.pageX - i3.left);
          e3.currentTarget.setAttribute("seek-value", s2);
        })), this.bind(t4.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", ((t5) => {
          const i3 = t5.currentTarget, s2 = "play-on-seeked";
          if (F(t5) && !["ArrowLeft", "ArrowRight"].includes(t5.key)) return;
          e2.lastSeekTime = Date.now();
          const n3 = i3.hasAttribute(s2), a2 = ["mouseup", "touchend", "keyup"].includes(t5.type);
          n3 && a2 ? (i3.removeAttribute(s2), ke(e2.play())) : !a2 && e2.playing && (i3.setAttribute(s2, ""), e2.pause());
        })), Y.isIos) {
          const t5 = ce.call(e2, 'input[type="range"]');
          Array.from(t5).forEach(((e3) => this.bind(e3, i2, ((e4) => K(e4.target)))));
        }
        this.bind(t4.inputs.seek, i2, ((t5) => {
          const i3 = t5.currentTarget;
          let s2 = i3.getAttribute("seek-value");
          W(s2) && (s2 = i3.value), i3.removeAttribute("seek-value"), e2.currentTime = s2 / i3.max * e2.duration;
        }), "seek"), this.bind(t4.progress, "mouseenter mouseleave mousemove", ((t5) => We.updateSeekTooltip.call(e2, t5))), this.bind(t4.progress, "mousemove touchmove", ((t5) => {
          const { previewThumbnails: i3 } = e2;
          i3 && i3.loaded && i3.startMove(t5);
        })), this.bind(t4.progress, "mouseleave touchend click", (() => {
          const { previewThumbnails: t5 } = e2;
          t5 && t5.loaded && t5.endMove(false, true);
        })), this.bind(t4.progress, "mousedown touchstart", ((t5) => {
          const { previewThumbnails: i3 } = e2;
          i3 && i3.loaded && i3.startScrubbing(t5);
        })), this.bind(t4.progress, "mouseup touchend", ((t5) => {
          const { previewThumbnails: i3 } = e2;
          i3 && i3.loaded && i3.endScrubbing(t5);
        })), Y.isWebkit && Array.from(ce.call(e2, 'input[type="range"]')).forEach(((t5) => {
          this.bind(t5, "input", ((t6) => We.updateRangeFill.call(e2, t6.target)));
        })), e2.config.toggleInvert && !H(t4.display.duration) && this.bind(t4.display.currentTime, "click", (() => {
          0 !== e2.currentTime && (e2.config.invertTime = !e2.config.invertTime, We.timeUpdate.call(e2));
        })), this.bind(t4.inputs.volume, i2, ((t5) => {
          e2.volume = t5.target.value;
        }), "volume"), this.bind(t4.controls, "mouseenter mouseleave", ((i3) => {
          t4.controls.hover = !e2.touch && "mouseenter" === i3.type;
        })), t4.fullscreen && Array.from(t4.fullscreen.children).filter(((e3) => !e3.contains(t4.container))).forEach(((i3) => {
          this.bind(i3, "mouseenter mouseleave", ((i4) => {
            t4.controls && (t4.controls.hover = !e2.touch && "mouseenter" === i4.type);
          }));
        })), this.bind(t4.controls, "mousedown mouseup touchstart touchend touchcancel", ((e3) => {
          t4.controls.pressed = ["mousedown", "touchstart"].includes(e3.type);
        })), this.bind(t4.controls, "focusin", (() => {
          const { config: i3, timers: s2 } = e2;
          le(t4.controls, i3.classNames.noTransition, true), at.toggleControls.call(e2, true), setTimeout((() => {
            le(t4.controls, i3.classNames.noTransition, false);
          }), 0);
          const n3 = this.touch ? 3e3 : 4e3;
          clearTimeout(s2.controls), s2.controls = setTimeout((() => at.toggleControls.call(e2, false)), n3);
        })), this.bind(t4.inputs.volume, "wheel", ((t5) => {
          const i3 = t5.webkitDirectionInvertedFromDevice, [s2, n3] = [t5.deltaX, -t5.deltaY].map(((e3) => i3 ? -e3 : e3)), a2 = Math.sign(Math.abs(s2) > Math.abs(n3) ? s2 : n3);
          e2.increaseVolume(a2 / 50);
          const { volume: l2 } = e2.media;
          (1 === a2 && l2 < 1 || -1 === a2 && l2 > 0) && t5.preventDefault();
        }), "volume", false);
      })), this.player = t3, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.setTabFocus = this.setTabFocus.bind(this), this.firstTouch = this.firstTouch.bind(this);
    }
    handleKey(e2) {
      const { player: t3 } = this, { elements: i2 } = t3, { key: s2, type: n3, altKey: a2, ctrlKey: l2, metaKey: o2, shiftKey: r3 } = e2, c2 = "keydown" === n3, h2 = c2 && s2 === this.lastKey;
      if (a2 || l2 || o2 || r3) return;
      if (!s2) return;
      if (c2) {
        const n4 = document.activeElement;
        if (H(n4)) {
          const { editable: s3 } = t3.config.selectors, { seek: a3 } = i2.inputs;
          if (n4 !== a3 && re(n4, s3)) return;
          if ("Space" === e2.key && re(n4, 'button, [role^="menuitem"]')) return;
        }
        switch (["Space", "ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "c", "f", "k", "l", "m"].includes(s2) && (e2.preventDefault(), e2.stopPropagation()), s2) {
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            h2 || (u2 = parseInt(s2, 10), t3.currentTime = t3.duration / 10 * u2);
            break;
          case "Space":
          case "k":
            h2 || ke(t3.togglePlay());
            break;
          case "ArrowUp":
            t3.increaseVolume(0.1);
            break;
          case "ArrowDown":
            t3.decreaseVolume(0.1);
            break;
          case "m":
            h2 || (t3.muted = !t3.muted);
            break;
          case "ArrowRight":
            t3.forward();
            break;
          case "ArrowLeft":
            t3.rewind();
            break;
          case "f":
            t3.fullscreen.toggle();
            break;
          case "c":
            h2 || t3.toggleCaptions();
            break;
          case "l":
            t3.loop = !t3.loop;
        }
        "Escape" === s2 && !t3.fullscreen.usingNative && t3.fullscreen.active && t3.fullscreen.toggle(), this.lastKey = s2;
      } else this.lastKey = null;
      var u2;
    }
    toggleMenu(e2) {
      We.toggleMenu.call(this.player, e2);
    }
  }
  "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
  var ot = (function(e2, t3) {
    return e2(t3 = { exports: {} }, t3.exports), t3.exports;
  })((function(e2, t3) {
    e2.exports = (function() {
      var e3 = function() {
      }, t4 = {}, i2 = {}, s2 = {};
      function n3(e4, t5) {
        e4 = e4.push ? e4 : [e4];
        var n4, a3, l3, o3 = [], r4 = e4.length, c3 = r4;
        for (n4 = function(e5, i3) {
          i3.length && o3.push(e5), --c3 || t5(o3);
        }; r4--; ) a3 = e4[r4], (l3 = i2[a3]) ? n4(a3, l3) : (s2[a3] = s2[a3] || []).push(n4);
      }
      function a2(e4, t5) {
        if (e4) {
          var n4 = s2[e4];
          if (i2[e4] = t5, n4) for (; n4.length; ) n4[0](e4, t5), n4.splice(0, 1);
        }
      }
      function l2(t5, i3) {
        t5.call && (t5 = { success: t5 }), i3.length ? (t5.error || e3)(i3) : (t5.success || e3)(t5);
      }
      function o2(t5, i3, s3, n4) {
        var a3, l3, r4 = document, c3 = s3.async, h2 = (s3.numRetries || 0) + 1, u2 = s3.before || e3, d2 = t5.replace(/[\?|#].*$/, ""), m2 = t5.replace(/^(css|img)!/, "");
        n4 = n4 || 0, /(^css!|\.css$)/.test(d2) ? ((l3 = r4.createElement("link")).rel = "stylesheet", l3.href = m2, (a3 = "hideFocus" in l3) && l3.relList && (a3 = 0, l3.rel = "preload", l3.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d2) ? (l3 = r4.createElement("img")).src = m2 : ((l3 = r4.createElement("script")).src = t5, l3.async = void 0 === c3 || c3), l3.onload = l3.onerror = l3.onbeforeload = function(e4) {
          var r5 = e4.type[0];
          if (a3) try {
            l3.sheet.cssText.length || (r5 = "e");
          } catch (e5) {
            18 != e5.code && (r5 = "e");
          }
          if ("e" == r5) {
            if ((n4 += 1) < h2) return o2(t5, i3, s3, n4);
          } else if ("preload" == l3.rel && "style" == l3.as) return l3.rel = "stylesheet";
          i3(t5, r5, e4.defaultPrevented);
        }, false !== u2(t5, l3) && r4.head.appendChild(l3);
      }
      function r3(e4, t5, i3) {
        var s3, n4, a3 = (e4 = e4.push ? e4 : [e4]).length, l3 = a3, r4 = [];
        for (s3 = function(e5, i4, s4) {
          if ("e" == i4 && r4.push(e5), "b" == i4) {
            if (!s4) return;
            r4.push(e5);
          }
          --a3 || t5(r4);
        }, n4 = 0; n4 < l3; n4++) o2(e4[n4], s3, i3);
      }
      function c2(e4, i3, s3) {
        var n4, o3;
        if (i3 && i3.trim && (n4 = i3), o3 = (n4 ? s3 : i3) || {}, n4) {
          if (n4 in t4) throw "LoadJS";
          t4[n4] = true;
        }
        function c3(t5, i4) {
          r3(e4, (function(e5) {
            l2(o3, e5), t5 && l2({ success: t5, error: i4 }, e5), a2(n4, e5);
          }), o3);
        }
        if (o3.returnPromise) return new Promise(c3);
        c3();
      }
      return c2.ready = function(e4, t5) {
        return n3(e4, (function(e5) {
          l2(t5, e5);
        })), c2;
      }, c2.done = function(e4) {
        a2(e4, []);
      }, c2.reset = function() {
        t4 = {}, i2 = {}, s2 = {};
      }, c2.isDefined = function(e4) {
        return e4 in t4;
      }, c2;
    })();
  }));
  function rt(e2) {
    return new Promise(((t3, i2) => {
      ot(e2, { success: t3, error: i2 });
    }));
  }
  function ct(e2) {
    e2 && !this.embed.hasPlayed && (this.embed.hasPlayed = true), this.media.paused === e2 && (this.media.paused = !e2, ve.call(this, this.media, e2 ? "play" : "pause"));
  }
  const ht = { setup() {
    const e2 = this;
    le(e2.elements.wrapper, e2.config.classNames.embed, true), e2.options.speed = e2.config.speed.options, xe.call(e2), L(window.Vimeo) ? ht.ready.call(e2) : rt(e2.config.urls.vimeo.sdk).then((() => {
      ht.ready.call(e2);
    })).catch(((t3) => {
      e2.debug.warn("Vimeo SDK (player.js) failed to load", t3);
    }));
  }, ready() {
    const e2 = this, t3 = e2.config.vimeo, { premium: i2, referrerPolicy: s2, ...n3 } = t3;
    let a2 = e2.media.getAttribute("src"), l2 = "";
    W(a2) ? (a2 = e2.media.getAttribute(e2.config.attributes.embed.id), l2 = e2.media.getAttribute(e2.config.attributes.embed.hash)) : l2 = (function(e3) {
      const t4 = e3.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
      return t4 && 5 === t4.length ? t4[4] : null;
    })(a2);
    const o2 = l2 ? { h: l2 } : {};
    i2 && Object.assign(n3, { controls: false, sidedock: false });
    const r3 = Ke({ loop: e2.config.loop.active, autoplay: e2.autoplay, muted: e2.muted, gesture: "media", playsinline: !this.config.fullscreen.iosNative, ...o2, ...n3 }), c2 = W(h2 = a2) ? null : $(Number(h2)) ? h2 : h2.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : h2;
    var h2;
    const u2 = Z("iframe"), d2 = $e(e2.config.urls.vimeo.iframe, c2, r3);
    if (u2.setAttribute("src", d2), u2.setAttribute("allowfullscreen", ""), u2.setAttribute("allow", ["autoplay", "fullscreen", "picture-in-picture", "encrypted-media", "accelerometer", "gyroscope"].join("; ")), W(s2) || u2.setAttribute("referrerPolicy", s2), i2 || !t3.customControls) u2.setAttribute("data-poster", e2.poster), e2.media = se(u2, e2.media);
    else {
      const t4 = Z("div", { class: e2.config.classNames.embedContainer, "data-poster": e2.poster });
      t4.appendChild(u2), e2.media = se(t4, e2.media);
    }
    t3.customControls || Fe($e(e2.config.urls.vimeo.api, d2)).then(((t4) => {
      !W(t4) && t4.thumbnail_url && at.setPoster.call(e2, t4.thumbnail_url).catch((() => {
      }));
    })), e2.embed = new window.Vimeo.Player(u2, { autopause: e2.config.autopause, muted: e2.muted }), e2.media.paused = true, e2.media.currentTime = 0, e2.supported.ui && e2.embed.disableTextTrack(), e2.media.play = () => (ct.call(e2, true), e2.embed.play()), e2.media.pause = () => (ct.call(e2, false), e2.embed.pause()), e2.media.stop = () => {
      e2.pause(), e2.currentTime = 0;
    };
    let { currentTime: m2 } = e2.media;
    Object.defineProperty(e2.media, "currentTime", { get: () => m2, set(t4) {
      const { embed: i3, media: s3, paused: n4, volume: a3 } = e2, l3 = n4 && !i3.hasPlayed;
      s3.seeking = true, ve.call(e2, s3, "seeking"), Promise.resolve(l3 && i3.setVolume(0)).then((() => i3.setCurrentTime(t4))).then((() => l3 && i3.pause())).then((() => l3 && i3.setVolume(a3))).catch((() => {
      }));
    } });
    let p2 = e2.config.speed.selected;
    Object.defineProperty(e2.media, "playbackRate", { get: () => p2, set(t4) {
      e2.embed.setPlaybackRate(t4).then((() => {
        p2 = t4, ve.call(e2, e2.media, "ratechange");
      })).catch((() => {
        e2.options.speed = [1];
      }));
    } });
    let { volume: g2 } = e2.config;
    Object.defineProperty(e2.media, "volume", { get: () => g2, set(t4) {
      e2.embed.setVolume(t4).then((() => {
        g2 = t4, ve.call(e2, e2.media, "volumechange");
      }));
    } });
    let { muted: f2 } = e2.config;
    Object.defineProperty(e2.media, "muted", { get: () => f2, set(t4) {
      const i3 = !!O(t4) && t4;
      e2.embed.setVolume(i3 ? 0 : e2.config.volume).then((() => {
        f2 = i3, ve.call(e2, e2.media, "volumechange");
      }));
    } });
    let b2, { loop: y2 } = e2.config;
    Object.defineProperty(e2.media, "loop", { get: () => y2, set(t4) {
      const i3 = O(t4) ? t4 : e2.config.loop.active;
      e2.embed.setLoop(i3).then((() => {
        y2 = i3;
      }));
    } }), e2.embed.getVideoUrl().then(((t4) => {
      b2 = t4, We.setDownloadUrl.call(e2);
    })).catch(((e3) => {
      this.debug.warn(e3);
    })), Object.defineProperty(e2.media, "currentSrc", { get: () => b2 }), Object.defineProperty(e2.media, "ended", { get: () => e2.currentTime === e2.duration }), Promise.all([e2.embed.getVideoWidth(), e2.embed.getVideoHeight()]).then(((t4) => {
      const [i3, s3] = t4;
      e2.embed.ratio = Ie(i3, s3), xe.call(this);
    })), e2.embed.setAutopause(e2.config.autopause).then(((t4) => {
      e2.config.autopause = t4;
    })), e2.embed.getVideoTitle().then(((t4) => {
      e2.config.title = t4, at.setTitle.call(this);
    })), e2.embed.getCurrentTime().then(((t4) => {
      m2 = t4, ve.call(e2, e2.media, "timeupdate");
    })), e2.embed.getDuration().then(((t4) => {
      e2.media.duration = t4, ve.call(e2, e2.media, "durationchange");
    })), e2.embed.getTextTracks().then(((t4) => {
      e2.media.textTracks = t4, Ye.setup.call(e2);
    })), e2.embed.on("cuechange", (({ cues: t4 = [] }) => {
      const i3 = t4.map(((e3) => (function(e4) {
        const t5 = document.createDocumentFragment(), i4 = document.createElement("div");
        return t5.appendChild(i4), i4.innerHTML = e4, t5.firstChild.innerText;
      })(e3.text)));
      Ye.updateCues.call(e2, i3);
    })), e2.embed.on("loaded", (() => {
      if (e2.embed.getPaused().then(((t4) => {
        ct.call(e2, !t4), t4 || ve.call(e2, e2.media, "playing");
      })), H(e2.embed.element) && e2.supported.ui) {
        e2.embed.element.setAttribute("tabindex", -1);
      }
    })), e2.embed.on("bufferstart", (() => {
      ve.call(e2, e2.media, "waiting");
    })), e2.embed.on("bufferend", (() => {
      ve.call(e2, e2.media, "playing");
    })), e2.embed.on("play", (() => {
      ct.call(e2, true), ve.call(e2, e2.media, "playing");
    })), e2.embed.on("pause", (() => {
      ct.call(e2, false);
    })), e2.embed.on("timeupdate", ((t4) => {
      e2.media.seeking = false, m2 = t4.seconds, ve.call(e2, e2.media, "timeupdate");
    })), e2.embed.on("progress", ((t4) => {
      e2.media.buffered = t4.percent, ve.call(e2, e2.media, "progress"), 1 === parseInt(t4.percent, 10) && ve.call(e2, e2.media, "canplaythrough"), e2.embed.getDuration().then(((t5) => {
        t5 !== e2.media.duration && (e2.media.duration = t5, ve.call(e2, e2.media, "durationchange"));
      }));
    })), e2.embed.on("seeked", (() => {
      e2.media.seeking = false, ve.call(e2, e2.media, "seeked");
    })), e2.embed.on("ended", (() => {
      e2.media.paused = true, ve.call(e2, e2.media, "ended");
    })), e2.embed.on("error", ((t4) => {
      e2.media.error = t4, ve.call(e2, e2.media, "error");
    })), t3.customControls && setTimeout((() => at.build.call(e2)), 0);
  } };
  function ut(e2) {
    e2 && !this.embed.hasPlayed && (this.embed.hasPlayed = true), this.media.paused === e2 && (this.media.paused = !e2, ve.call(this, this.media, e2 ? "play" : "pause"));
  }
  function dt(e2) {
    return e2.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
  }
  const mt = { setup() {
    if (le(this.elements.wrapper, this.config.classNames.embed, true), L(window.YT) && j(window.YT.Player)) mt.ready.call(this);
    else {
      const e2 = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        j(e2) && e2(), mt.ready.call(this);
      }, rt(this.config.urls.youtube.sdk).catch(((e3) => {
        this.debug.warn("YouTube API failed to load", e3);
      }));
    }
  }, getTitle(e2) {
    Fe($e(this.config.urls.youtube.api, e2)).then(((e3) => {
      if (L(e3)) {
        const { title: t3, height: i2, width: s2 } = e3;
        this.config.title = t3, at.setTitle.call(this), this.embed.ratio = Ie(s2, i2);
      }
      xe.call(this);
    })).catch((() => {
      xe.call(this);
    }));
  }, ready() {
    const e2 = this, t3 = e2.config.youtube, i2 = e2.media && e2.media.getAttribute("id");
    if (!W(i2) && i2.startsWith("youtube-")) return;
    let s2 = e2.media.getAttribute("src");
    W(s2) && (s2 = e2.media.getAttribute(this.config.attributes.embed.id));
    const n3 = W(a2 = s2) ? null : a2.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a2;
    var a2;
    const l2 = Z("div", { id: `${e2.provider}-${Math.floor(1e4 * Math.random())}`, "data-poster": t3.customControls ? e2.poster : void 0 });
    if (e2.media = se(l2, e2.media), t3.customControls) {
      const t4 = (e3) => `https://i.ytimg.com/vi/${n3}/${e3}default.jpg`;
      nt(t4("maxres"), 121).catch((() => nt(t4("sd"), 121))).catch((() => nt(t4("hq")))).then(((t5) => at.setPoster.call(e2, t5.src))).then(((t5) => {
        t5.includes("maxres") || (e2.elements.poster.style.backgroundSize = "cover");
      })).catch((() => {
      }));
    }
    e2.embed = new window.YT.Player(e2.media, { videoId: n3, host: dt(t3), playerVars: X({}, { autoplay: e2.config.autoplay ? 1 : 0, hl: e2.config.hl, controls: e2.supported.ui && t3.customControls ? 0 : 1, disablekb: 1, playsinline: e2.config.fullscreen.iosNative ? 0 : 1, cc_load_policy: e2.captions.active ? 1 : 0, cc_lang_pref: e2.config.captions.language, widget_referrer: window ? window.location.href : null }, t3), events: { onError(t4) {
      if (!e2.media.error) {
        const i3 = t4.data, s3 = { 2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.", 5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.", 100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.", 101: "The owner of the requested video does not allow it to be played in embedded players.", 150: "The owner of the requested video does not allow it to be played in embedded players." }[i3] || "An unknown error occured";
        e2.media.error = { code: i3, message: s3 }, ve.call(e2, e2.media, "error");
      }
    }, onPlaybackRateChange(t4) {
      const i3 = t4.target;
      e2.media.playbackRate = i3.getPlaybackRate(), ve.call(e2, e2.media, "ratechange");
    }, onReady(i3) {
      if (j(e2.media.play)) return;
      const s3 = i3.target;
      mt.getTitle.call(e2, n3), e2.media.play = () => {
        ut.call(e2, true), s3.playVideo();
      }, e2.media.pause = () => {
        ut.call(e2, false), s3.pauseVideo();
      }, e2.media.stop = () => {
        s3.stopVideo();
      }, e2.media.duration = s3.getDuration(), e2.media.paused = true, e2.media.currentTime = 0, Object.defineProperty(e2.media, "currentTime", { get: () => Number(s3.getCurrentTime()), set(t4) {
        e2.paused && !e2.embed.hasPlayed && e2.embed.mute(), e2.media.seeking = true, ve.call(e2, e2.media, "seeking"), s3.seekTo(t4);
      } }), Object.defineProperty(e2.media, "playbackRate", { get: () => s3.getPlaybackRate(), set(e3) {
        s3.setPlaybackRate(e3);
      } });
      let { volume: a3 } = e2.config;
      Object.defineProperty(e2.media, "volume", { get: () => a3, set(t4) {
        a3 = t4, s3.setVolume(100 * a3), ve.call(e2, e2.media, "volumechange");
      } });
      let { muted: l3 } = e2.config;
      Object.defineProperty(e2.media, "muted", { get: () => l3, set(t4) {
        const i4 = O(t4) ? t4 : l3;
        l3 = i4, s3[i4 ? "mute" : "unMute"](), s3.setVolume(100 * a3), ve.call(e2, e2.media, "volumechange");
      } }), Object.defineProperty(e2.media, "currentSrc", { get: () => s3.getVideoUrl() }), Object.defineProperty(e2.media, "ended", { get: () => e2.currentTime === e2.duration });
      const o2 = s3.getAvailablePlaybackRates();
      e2.options.speed = o2.filter(((t4) => e2.config.speed.options.includes(t4))), e2.supported.ui && t3.customControls && e2.media.setAttribute("tabindex", -1), ve.call(e2, e2.media, "timeupdate"), ve.call(e2, e2.media, "durationchange"), clearInterval(e2.timers.buffering), e2.timers.buffering = setInterval((() => {
        e2.media.buffered = s3.getVideoLoadedFraction(), (null === e2.media.lastBuffered || e2.media.lastBuffered < e2.media.buffered) && ve.call(e2, e2.media, "progress"), e2.media.lastBuffered = e2.media.buffered, 1 === e2.media.buffered && (clearInterval(e2.timers.buffering), ve.call(e2, e2.media, "canplaythrough"));
      }), 200), t3.customControls && setTimeout((() => at.build.call(e2)), 50);
    }, onStateChange(i3) {
      const s3 = i3.target;
      clearInterval(e2.timers.playing);
      switch (e2.media.seeking && [1, 2].includes(i3.data) && (e2.media.seeking = false, ve.call(e2, e2.media, "seeked")), i3.data) {
        case -1:
          ve.call(e2, e2.media, "timeupdate"), e2.media.buffered = s3.getVideoLoadedFraction(), ve.call(e2, e2.media, "progress");
          break;
        case 0:
          ut.call(e2, false), e2.media.loop ? (s3.stopVideo(), s3.playVideo()) : ve.call(e2, e2.media, "ended");
          break;
        case 1:
          t3.customControls && !e2.config.autoplay && e2.media.paused && !e2.embed.hasPlayed ? e2.media.pause() : (ut.call(e2, true), ve.call(e2, e2.media, "playing"), e2.timers.playing = setInterval((() => {
            ve.call(e2, e2.media, "timeupdate");
          }), 50), e2.media.duration !== s3.getDuration() && (e2.media.duration = s3.getDuration(), ve.call(e2, e2.media, "durationchange")));
          break;
        case 2:
          e2.muted || e2.embed.unMute(), ut.call(e2, false);
          break;
        case 3:
          ve.call(e2, e2.media, "waiting");
      }
      ve.call(e2, e2.elements.container, "statechange", false, { code: i3.data });
    } } });
  } }, pt = { setup() {
    this.media ? (le(this.elements.container, this.config.classNames.type.replace("{0}", this.type), true), le(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), true), this.isEmbed && le(this.elements.container, this.config.classNames.type.replace("{0}", "video"), true), this.isVideo && (this.elements.wrapper = Z("div", { class: this.config.classNames.video }), J(this.media, this.elements.wrapper), this.elements.poster = Z("div", { class: this.config.classNames.poster }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? Le.setup.call(this) : this.isYouTube ? mt.setup.call(this) : this.isVimeo && ht.setup.call(this)) : this.debug.warn("No media element found!");
  } };
  class gt {
    constructor(t3) {
      e(this, "load", (() => {
        this.enabled && (L(window.google) && L(window.google.ima) ? this.ready() : rt(this.player.config.urls.googleIMA.sdk).then((() => {
          this.ready();
        })).catch((() => {
          this.trigger("error", new Error("Google IMA SDK failed to load"));
        })));
      })), e(this, "ready", (() => {
        var e2;
        this.enabled || ((e2 = this).manager && e2.manager.destroy(), e2.elements.displayContainer && e2.elements.displayContainer.destroy(), e2.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then((() => {
          this.clearSafetyTimer("onAdsManagerLoaded()");
        })), this.listeners(), this.setupIMA();
      })), e(this, "setupIMA", (() => {
        this.elements.container = Z("div", { class: this.player.config.classNames.ads }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, ((e2) => this.onAdsManagerLoaded(e2)), false), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, ((e2) => this.onAdError(e2)), false), this.requestAds();
      })), e(this, "requestAds", (() => {
        const { container: e2 } = this.player.elements;
        try {
          const t4 = new google.ima.AdsRequest();
          t4.adTagUrl = this.tagUrl, t4.linearAdSlotWidth = e2.offsetWidth, t4.linearAdSlotHeight = e2.offsetHeight, t4.nonLinearAdSlotWidth = e2.offsetWidth, t4.nonLinearAdSlotHeight = e2.offsetHeight, t4.forceNonLinearFullSlot = false, t4.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(t4);
        } catch (e3) {
          this.onAdError(e3);
        }
      })), e(this, "pollCountdown", ((e2 = false) => {
        if (!e2) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
        this.countdownTimer = setInterval((() => {
          const e3 = Ue(Math.max(this.manager.getRemainingTime(), 0)), t4 = `${He.get("advertisement", this.player.config)} - ${e3}`;
          this.elements.container.setAttribute("data-badge-text", t4);
        }), 100);
      })), e(this, "onAdsManagerLoaded", ((e2) => {
        if (!this.enabled) return;
        const t4 = new google.ima.AdsRenderingSettings();
        t4.restoreCustomPlaybackStateOnAdBreakComplete = true, t4.enablePreloading = true, this.manager = e2.getAdsManager(this.player, t4), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, ((e3) => this.onAdError(e3))), Object.keys(google.ima.AdEvent.Type).forEach(((e3) => {
          this.manager.addEventListener(google.ima.AdEvent.Type[e3], ((e4) => this.onAdEvent(e4)));
        })), this.trigger("loaded");
      })), e(this, "addCuePoints", (() => {
        W(this.cuePoints) || this.cuePoints.forEach(((e2) => {
          if (0 !== e2 && -1 !== e2 && e2 < this.player.duration) {
            const t4 = this.player.elements.progress;
            if (H(t4)) {
              const i2 = 100 / this.player.duration * e2, s2 = Z("span", { class: this.player.config.classNames.cues });
              s2.style.left = `${i2.toString()}%`, t4.appendChild(s2);
            }
          }
        }));
      })), e(this, "onAdEvent", ((e2) => {
        const { container: t4 } = this.player.elements, i2 = e2.getAd(), s2 = e2.getAdData();
        switch (((e3) => {
          ve.call(this.player, this.player.media, `ads${e3.replace(/_/g, "").toLowerCase()}`);
        })(e2.type), e2.type) {
          case google.ima.AdEvent.Type.LOADED:
            this.trigger("loaded"), this.pollCountdown(true), i2.isLinear() || (i2.width = t4.offsetWidth, i2.height = t4.offsetHeight);
            break;
          case google.ima.AdEvent.Type.STARTED:
            this.manager.setVolume(this.player.volume);
            break;
          case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
            this.player.ended ? this.loadAds() : this.loader.contentComplete();
            break;
          case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
            this.pauseContent();
            break;
          case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
            this.pollCountdown(), this.resumeContent();
            break;
          case google.ima.AdEvent.Type.LOG:
            s2.adError && this.player.debug.warn(`Non-fatal ad error: ${s2.adError.getMessage()}`);
        }
      })), e(this, "onAdError", ((e2) => {
        this.cancel(), this.player.debug.warn("Ads error", e2);
      })), e(this, "listeners", (() => {
        const { container: e2 } = this.player.elements;
        let t4;
        this.player.on("canplay", (() => {
          this.addCuePoints();
        })), this.player.on("ended", (() => {
          this.loader.contentComplete();
        })), this.player.on("timeupdate", (() => {
          t4 = this.player.currentTime;
        })), this.player.on("seeked", (() => {
          const e3 = this.player.currentTime;
          W(this.cuePoints) || this.cuePoints.forEach(((i2, s2) => {
            t4 < i2 && i2 < e3 && (this.manager.discardAdBreak(), this.cuePoints.splice(s2, 1));
          }));
        })), window.addEventListener("resize", (() => {
          this.manager && this.manager.resize(e2.offsetWidth, e2.offsetHeight, google.ima.ViewMode.NORMAL);
        }));
      })), e(this, "play", (() => {
        const { container: e2 } = this.player.elements;
        this.managerPromise || this.resumeContent(), this.managerPromise.then((() => {
          this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
          try {
            this.initialized || (this.manager.init(e2.offsetWidth, e2.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = true;
          } catch (e3) {
            this.onAdError(e3);
          }
        })).catch((() => {
        }));
      })), e(this, "resumeContent", (() => {
        this.elements.container.style.zIndex = "", this.playing = false, ke(this.player.media.play());
      })), e(this, "pauseContent", (() => {
        this.elements.container.style.zIndex = 3, this.playing = true, this.player.media.pause();
      })), e(this, "cancel", (() => {
        this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
      })), e(this, "loadAds", (() => {
        this.managerPromise.then((() => {
          this.manager && this.manager.destroy(), this.managerPromise = new Promise(((e2) => {
            this.on("loaded", e2), this.player.debug.log(this.manager);
          })), this.initialized = false, this.requestAds();
        })).catch((() => {
        }));
      })), e(this, "trigger", ((e2, ...t4) => {
        const i2 = this.events[e2];
        D(i2) && i2.forEach(((e3) => {
          j(e3) && e3.apply(this, t4);
        }));
      })), e(this, "on", ((e2, t4) => (D(this.events[e2]) || (this.events[e2] = []), this.events[e2].push(t4), this))), e(this, "startSafetyTimer", ((e2, t4) => {
        this.player.debug.log(`Safety timer invoked from: ${t4}`), this.safetyTimer = setTimeout((() => {
          this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
        }), e2);
      })), e(this, "clearSafetyTimer", ((e2) => {
        I(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e2}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
      })), this.player = t3, this.config = t3.config.ads, this.playing = false, this.initialized = false, this.elements = { container: null, displayContainer: null }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise(((e2, t4) => {
        this.on("loaded", e2), this.on("error", t4);
      })), this.load();
    }
    get enabled() {
      const { config: e2 } = this;
      return this.player.isHTML5 && this.player.isVideo && e2.enabled && (!W(e2.publisherId) || U(e2.tagUrl));
    }
    get tagUrl() {
      const { config: e2 } = this;
      if (U(e2.tagUrl)) return e2.tagUrl;
      return `https://go.aniview.com/api/adserver6/vast/?${Ke({ AV_PUBLISHERID: "58c25bb0073ef448b1087ad6", AV_CHANNELID: "5a0458dc28a06145e4519d21", AV_URL: window.location.hostname, cb: Date.now(), AV_WIDTH: 640, AV_HEIGHT: 480, AV_CDIM2: e2.publisherId })}`;
    }
  }
  function ft(e2 = 0, t3 = 0, i2 = 255) {
    return Math.min(Math.max(e2, t3), i2);
  }
  const bt = (e2) => {
    const t3 = [];
    return e2.split(/\r\n\r\n|\n\n|\r\r/).forEach(((e3) => {
      const i2 = {};
      e3.split(/\r\n|\n|\r/).forEach(((e4) => {
        if ($(i2.startTime)) {
          if (!W(e4.trim()) && W(i2.text)) {
            const t4 = e4.trim().split("#xywh=");
            [i2.text] = t4, t4[1] && ([i2.x, i2.y, i2.w, i2.h] = t4[1].split(","));
          }
        } else {
          const t4 = e4.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
          t4 && (i2.startTime = 60 * Number(t4[1] || 0) * 60 + 60 * Number(t4[2]) + Number(t4[3]) + Number(`0.${t4[4]}`), i2.endTime = 60 * Number(t4[6] || 0) * 60 + 60 * Number(t4[7]) + Number(t4[8]) + Number(`0.${t4[9]}`));
        }
      })), i2.text && t3.push(i2);
    })), t3;
  }, yt = (e2, t3) => {
    const i2 = {};
    return e2 > t3.width / t3.height ? (i2.width = t3.width, i2.height = 1 / e2 * t3.width) : (i2.height = t3.height, i2.width = e2 * t3.height), i2;
  };
  class vt {
    constructor(t3) {
      e(this, "load", (() => {
        this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then((() => {
          this.enabled && (this.render(), this.determineContainerAutoSizing(), this.loaded = true);
        }));
      })), e(this, "getThumbnails", (() => new Promise(((e2) => {
        const { src: t4 } = this.player.config.previewThumbnails;
        if (W(t4)) throw new Error("Missing previewThumbnails.src config attribute");
        const i2 = () => {
          this.thumbnails.sort(((e3, t5) => e3.height - t5.height)), this.player.debug.log("Preview thumbnails", this.thumbnails), e2();
        };
        if (j(t4)) t4(((e3) => {
          this.thumbnails = e3, i2();
        }));
        else {
          const e3 = (_(t4) ? [t4] : t4).map(((e4) => this.getThumbnail(e4)));
          Promise.all(e3).then(i2);
        }
      })))), e(this, "getThumbnail", ((e2) => new Promise(((t4) => {
        Fe(e2).then(((i2) => {
          const s2 = { frames: bt(i2), height: null, urlPrefix: "" };
          s2.frames[0].text.startsWith("/") || s2.frames[0].text.startsWith("http://") || s2.frames[0].text.startsWith("https://") || (s2.urlPrefix = e2.substring(0, e2.lastIndexOf("/") + 1));
          const n3 = new Image();
          n3.onload = () => {
            s2.height = n3.naturalHeight, s2.width = n3.naturalWidth, this.thumbnails.push(s2), t4();
          }, n3.src = s2.urlPrefix + s2.frames[0].text;
        }));
      })))), e(this, "startMove", ((e2) => {
        if (this.loaded && R(e2) && ["touchmove", "mousemove"].includes(e2.type) && this.player.media.duration) {
          if ("touchmove" === e2.type) this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
          else {
            var t4, i2;
            const s2 = this.player.elements.progress.getBoundingClientRect(), n3 = 100 / s2.width * (e2.pageX - s2.left);
            this.seekTime = this.player.media.duration * (n3 / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = e2.pageX, this.elements.thumb.time.innerText = Ue(this.seekTime);
            const a2 = null === (t4 = this.player.config.markers) || void 0 === t4 || null === (i2 = t4.points) || void 0 === i2 ? void 0 : i2.find((({ time: e3 }) => e3 === Math.round(this.seekTime)));
            a2 && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${a2.label}<br>`);
          }
          this.showImageAtCurrentTime();
        }
      })), e(this, "endMove", (() => {
        this.toggleThumbContainer(false, true);
      })), e(this, "startScrubbing", ((e2) => {
        (I(e2.button) || false === e2.button || 0 === e2.button) && (this.mouseDown = true, this.player.media.duration && (this.toggleScrubbingContainer(true), this.toggleThumbContainer(false, true), this.showImageAtCurrentTime()));
      })), e(this, "endScrubbing", (() => {
        this.mouseDown = false, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(false) : ye.call(this.player, this.player.media, "timeupdate", (() => {
          this.mouseDown || this.toggleScrubbingContainer(false);
        }));
      })), e(this, "listeners", (() => {
        this.player.on("play", (() => {
          this.toggleThumbContainer(false, true);
        })), this.player.on("seeked", (() => {
          this.toggleThumbContainer(false);
        })), this.player.on("timeupdate", (() => {
          this.lastTime = this.player.media.currentTime;
        }));
      })), e(this, "render", (() => {
        this.elements.thumb.container = Z("div", { class: this.player.config.classNames.previewThumbnails.thumbContainer }), this.elements.thumb.imageContainer = Z("div", { class: this.player.config.classNames.previewThumbnails.imageContainer }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
        const e2 = Z("div", { class: this.player.config.classNames.previewThumbnails.timeContainer });
        this.elements.thumb.time = Z("span", {}, "00:00"), e2.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(e2), H(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = Z("div", { class: this.player.config.classNames.previewThumbnails.scrubbingContainer }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
      })), e(this, "destroy", (() => {
        this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
      })), e(this, "showImageAtCurrentTime", (() => {
        this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
        const e2 = this.thumbnails[0].frames.findIndex(((e3) => this.seekTime >= e3.startTime && this.seekTime <= e3.endTime)), t4 = e2 >= 0;
        let i2 = 0;
        this.mouseDown || this.toggleThumbContainer(t4), t4 && (this.thumbnails.forEach(((t5, s2) => {
          this.loadedImages.includes(t5.frames[e2].text) && (i2 = s2);
        })), e2 !== this.showingThumb && (this.showingThumb = e2, this.loadImage(i2)));
      })), e(this, "loadImage", ((e2 = 0) => {
        const t4 = this.showingThumb, i2 = this.thumbnails[e2], { urlPrefix: s2 } = i2, n3 = i2.frames[t4], a2 = i2.frames[t4].text, l2 = s2 + a2;
        if (this.currentImageElement && this.currentImageElement.dataset.filename === a2) this.showImage(this.currentImageElement, n3, e2, t4, a2, false), this.currentImageElement.dataset.index = t4, this.removeOldImages(this.currentImageElement);
        else {
          this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
          const i3 = new Image();
          i3.src = l2, i3.dataset.index = t4, i3.dataset.filename = a2, this.showingThumbFilename = a2, this.player.debug.log(`Loading image: ${l2}`), i3.onload = () => this.showImage(i3, n3, e2, t4, a2, true), this.loadingImage = i3, this.removeOldImages(i3);
        }
      })), e(this, "showImage", ((e2, t4, i2, s2, n3, a2 = true) => {
        this.player.debug.log(`Showing thumb: ${n3}. num: ${s2}. qual: ${i2}. newimg: ${a2}`), this.setImageSizeAndOffset(e2, t4), a2 && (this.currentImageContainer.appendChild(e2), this.currentImageElement = e2, this.loadedImages.includes(n3) || this.loadedImages.push(n3)), this.preloadNearby(s2, true).then(this.preloadNearby(s2, false)).then(this.getHigherQuality(i2, e2, t4, n3));
      })), e(this, "removeOldImages", ((e2) => {
        Array.from(this.currentImageContainer.children).forEach(((t4) => {
          if ("img" !== t4.tagName.toLowerCase()) return;
          const i2 = this.usingSprites ? 500 : 1e3;
          if (t4.dataset.index !== e2.dataset.index && !t4.dataset.deleting) {
            t4.dataset.deleting = true;
            const { currentImageContainer: e3 } = this;
            setTimeout((() => {
              e3.removeChild(t4), this.player.debug.log(`Removing thumb: ${t4.dataset.filename}`);
            }), i2);
          }
        }));
      })), e(this, "preloadNearby", ((e2, t4 = true) => new Promise(((i2) => {
        setTimeout((() => {
          const s2 = this.thumbnails[0].frames[e2].text;
          if (this.showingThumbFilename === s2) {
            let n3;
            n3 = t4 ? this.thumbnails[0].frames.slice(e2) : this.thumbnails[0].frames.slice(0, e2).reverse();
            let a2 = false;
            n3.forEach(((e3) => {
              const t5 = e3.text;
              if (t5 !== s2 && !this.loadedImages.includes(t5)) {
                a2 = true, this.player.debug.log(`Preloading thumb filename: ${t5}`);
                const { urlPrefix: e4 } = this.thumbnails[0], s3 = e4 + t5, n4 = new Image();
                n4.src = s3, n4.onload = () => {
                  this.player.debug.log(`Preloaded thumb filename: ${t5}`), this.loadedImages.includes(t5) || this.loadedImages.push(t5), i2();
                };
              }
            })), a2 || i2();
          }
        }), 300);
      })))), e(this, "getHigherQuality", ((e2, t4, i2, s2) => {
        if (e2 < this.thumbnails.length - 1) {
          let n3 = t4.naturalHeight;
          this.usingSprites && (n3 = i2.h), n3 < this.thumbContainerHeight && setTimeout((() => {
            this.showingThumbFilename === s2 && (this.player.debug.log(`Showing higher quality thumb for: ${s2}`), this.loadImage(e2 + 1));
          }), 300);
        }
      })), e(this, "toggleThumbContainer", ((e2 = false, t4 = false) => {
        const i2 = this.player.config.classNames.previewThumbnails.thumbContainerShown;
        this.elements.thumb.container.classList.toggle(i2, e2), !e2 && t4 && (this.showingThumb = null, this.showingThumbFilename = null);
      })), e(this, "toggleScrubbingContainer", ((e2 = false) => {
        const t4 = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
        this.elements.scrubbing.container.classList.toggle(t4, e2), e2 || (this.showingThumb = null, this.showingThumbFilename = null);
      })), e(this, "determineContainerAutoSizing", (() => {
        (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = true);
      })), e(this, "setThumbContainerSizeAndPos", (() => {
        const { imageContainer: e2 } = this.elements.thumb;
        if (this.sizeSpecifiedInCSS) {
          if (e2.clientHeight > 20 && e2.clientWidth < 20) {
            const t4 = Math.floor(e2.clientHeight * this.thumbAspectRatio);
            e2.style.width = `${t4}px`;
          } else if (e2.clientHeight < 20 && e2.clientWidth > 20) {
            const t4 = Math.floor(e2.clientWidth / this.thumbAspectRatio);
            e2.style.height = `${t4}px`;
          }
        } else {
          const t4 = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
          e2.style.height = `${this.thumbContainerHeight}px`, e2.style.width = `${t4}px`;
        }
        this.setThumbContainerPos();
      })), e(this, "setThumbContainerPos", (() => {
        const e2 = this.player.elements.progress.getBoundingClientRect(), t4 = this.player.elements.container.getBoundingClientRect(), { container: i2 } = this.elements.thumb, s2 = t4.left - e2.left + 10, n3 = t4.right - e2.left - i2.clientWidth - 10, a2 = this.mousePosX - e2.left - i2.clientWidth / 2, l2 = ft(a2, s2, n3);
        i2.style.left = `${l2}px`, i2.style.setProperty("--preview-arrow-offset", a2 - l2 + "px");
      })), e(this, "setScrubbingContainerSize", (() => {
        const { width: e2, height: t4 } = yt(this.thumbAspectRatio, { width: this.player.media.clientWidth, height: this.player.media.clientHeight });
        this.elements.scrubbing.container.style.width = `${e2}px`, this.elements.scrubbing.container.style.height = `${t4}px`;
      })), e(this, "setImageSizeAndOffset", ((e2, t4) => {
        if (!this.usingSprites) return;
        const i2 = this.thumbContainerHeight / t4.h;
        e2.style.height = e2.naturalHeight * i2 + "px", e2.style.width = e2.naturalWidth * i2 + "px", e2.style.left = `-${t4.x * i2}px`, e2.style.top = `-${t4.y * i2}px`;
      })), this.player = t3, this.thumbnails = [], this.loaded = false, this.lastMouseMoveTime = Date.now(), this.mouseDown = false, this.loadedImages = [], this.elements = { thumb: {}, scrubbing: {} }, this.load();
    }
    get enabled() {
      return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
    }
    get currentImageContainer() {
      return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
    }
    get usingSprites() {
      return Object.keys(this.thumbnails[0].frames[0]).includes("w");
    }
    get thumbAspectRatio() {
      return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
    }
    get thumbContainerHeight() {
      if (this.mouseDown) {
        const { height: e2 } = yt(this.thumbAspectRatio, { width: this.player.media.clientWidth, height: this.player.media.clientHeight });
        return e2;
      }
      return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
    }
    get currentImageElement() {
      return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
    }
    set currentImageElement(e2) {
      this.mouseDown ? this.currentScrubbingImageElement = e2 : this.currentThumbnailImageElement = e2;
    }
  }
  const wt = { insertElements(e2, t3) {
    _(t3) ? ee(e2, this.media, { src: t3 }) : D(t3) && t3.forEach(((t4) => {
      ee(e2, this.media, t4);
    }));
  }, change(e2) {
    Q(e2, "sources.length") ? (Le.cancelRequests.call(this), this.destroy.call(this, (() => {
      this.options.quality = [], te(this.media), this.media = null, H(this.elements.container) && this.elements.container.removeAttribute("class");
      const { sources: t3, type: i2 } = e2, [{ provider: s2 = Ge.html5, src: n3 }] = t3, a2 = "html5" === s2 ? i2 : "div", l2 = "html5" === s2 ? {} : { src: n3 };
      Object.assign(this, { provider: s2, type: i2, supported: me.check(i2, s2, this.config.playsinline), media: Z(a2, l2) }), this.elements.container.appendChild(this.media), O(e2.autoplay) && (this.config.autoplay = e2.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), W(e2.poster) || (this.poster = e2.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), at.addStyleHook.call(this), this.isHTML5 && wt.insertElements.call(this, "source", t3), this.config.title = e2.title, pt.setup.call(this), this.isHTML5 && Object.keys(e2).includes("tracks") && wt.insertElements.call(this, "track", e2.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && at.build.call(this), this.isHTML5 && this.media.load(), W(e2.previewThumbnails) || (Object.assign(this.config.previewThumbnails, e2.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new vt(this))), this.fullscreen.update();
    }), true)) : this.debug.warn("Invalid source format");
  } };
  class Tt {
    constructor(t3, i2) {
      if (e(this, "play", (() => j(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then((() => this.ads.play())).catch((() => ke(this.media.play()))), this.media.play()) : null)), e(this, "pause", (() => this.playing && j(this.media.pause) ? this.media.pause() : null)), e(this, "togglePlay", ((e2) => (O(e2) ? e2 : !this.playing) ? this.play() : this.pause())), e(this, "stop", (() => {
        this.isHTML5 ? (this.pause(), this.restart()) : j(this.media.stop) && this.media.stop();
      })), e(this, "restart", (() => {
        this.currentTime = 0;
      })), e(this, "rewind", ((e2) => {
        this.currentTime -= $(e2) ? e2 : this.config.seekTime;
      })), e(this, "forward", ((e2) => {
        this.currentTime += $(e2) ? e2 : this.config.seekTime;
      })), e(this, "increaseVolume", ((e2) => {
        const t4 = this.media.muted ? 0 : this.volume;
        this.volume = t4 + ($(e2) ? e2 : 0);
      })), e(this, "decreaseVolume", ((e2) => {
        this.increaseVolume(-e2);
      })), e(this, "airplay", (() => {
        me.airplay && this.media.webkitShowPlaybackTargetPicker();
      })), e(this, "toggleControls", ((e2) => {
        if (this.supported.ui && !this.isAudio) {
          const t4 = oe(this.elements.container, this.config.classNames.hideControls), i3 = void 0 === e2 ? void 0 : !e2, s3 = le(this.elements.container, this.config.classNames.hideControls, i3);
          if (s3 && D(this.config.controls) && this.config.controls.includes("settings") && !W(this.config.settings) && We.toggleMenu.call(this, false), s3 !== t4) {
            const e3 = s3 ? "controlshidden" : "controlsshown";
            ve.call(this, this.media, e3);
          }
          return !s3;
        }
        return false;
      })), e(this, "on", ((e2, t4) => {
        fe.call(this, this.elements.container, e2, t4);
      })), e(this, "once", ((e2, t4) => {
        ye.call(this, this.elements.container, e2, t4);
      })), e(this, "off", ((e2, t4) => {
        be(this.elements.container, e2, t4);
      })), e(this, "destroy", ((e2, t4 = false) => {
        if (!this.ready) return;
        const i3 = () => {
          document.body.style.overflow = "", this.embed = null, t4 ? (Object.keys(this.elements).length && (te(this.elements.buttons.play), te(this.elements.captions), te(this.elements.controls), te(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), j(e2) && e2()) : (we.call(this), Le.cancelRequests.call(this), se(this.elements.original, this.elements.container), ve.call(this, this.elements.original, "destroyed", true), j(e2) && e2.call(this.elements.original), this.ready = false, setTimeout((() => {
            this.elements = null, this.media = null;
          }), 200));
        };
        this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (at.toggleNativeControls.call(this, true), i3()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && j(this.embed.destroy) && this.embed.destroy(), i3()) : this.isVimeo && (null !== this.embed && this.embed.unload().then(i3), setTimeout(i3, 200));
      })), e(this, "supports", ((e2) => me.mime.call(this, e2))), this.timers = {}, this.ready = false, this.loading = false, this.failed = false, this.touch = me.touch, this.media = t3, _(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || q(this.media) || D(this.media)) && (this.media = this.media[0]), this.config = X({}, Qe, Tt.defaults, i2 || {}, (() => {
        try {
          return JSON.parse(this.media.getAttribute("data-plyr-config"));
        } catch (e2) {
          return {};
        }
      })()), this.elements = { container: null, fullscreen: null, captions: null, buttons: {}, display: {}, progress: {}, inputs: {}, settings: { popup: null, menu: null, panels: {}, buttons: {} } }, this.captions = { active: null, currentTrack: -1, meta: /* @__PURE__ */ new WeakMap() }, this.fullscreen = { active: false }, this.options = { speed: [], quality: [] }, this.debug = new it(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", me), I(this.media) || !H(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
      if (this.media.plyr) return void this.debug.warn("Target already setup");
      if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
      if (!me.check().api) return void this.debug.error("Setup failed: no support");
      const s2 = this.media.cloneNode(true);
      s2.autoplay = false, this.elements.original = s2;
      const n3 = this.media.tagName.toLowerCase();
      let a2 = null, l2 = null;
      switch (n3) {
        case "div":
          if (a2 = this.media.querySelector("iframe"), H(a2)) {
            if (l2 = ze(a2.getAttribute("src")), this.provider = (function(e2) {
              return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e2) ? Ge.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e2) ? Ge.vimeo : null;
            })(l2.toString()), this.elements.container = this.media, this.media = a2, this.elements.container.className = "", l2.search.length) {
              const e2 = ["1", "true"];
              e2.includes(l2.searchParams.get("autoplay")) && (this.config.autoplay = true), e2.includes(l2.searchParams.get("loop")) && (this.config.loop.active = true), this.isYouTube ? (this.config.playsinline = e2.includes(l2.searchParams.get("playsinline")), this.config.youtube.hl = l2.searchParams.get("hl")) : this.config.playsinline = true;
            }
          } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
          if (W(this.provider) || !Object.values(Ge).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
          this.type = et;
          break;
        case "video":
        case "audio":
          this.type = n3, this.provider = Ge.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = true), this.media.hasAttribute("autoplay") && (this.config.autoplay = true), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = true), this.media.hasAttribute("muted") && (this.config.muted = true), this.media.hasAttribute("loop") && (this.config.loop.active = true);
          break;
        default:
          return void this.debug.error("Setup failed: unsupported type");
      }
      this.supported = me.check(this.type, this.provider, this.config.playsinline), this.supported.api ? (this.eventListeners = [], this.listeners = new lt(this), this.storage = new Re(this), this.media.plyr = this, H(this.elements.container) || (this.elements.container = Z("div", { tabindex: 0 }), J(this.media, this.elements.container)), at.migrateStyles.call(this), at.addStyleHook.call(this), pt.setup.call(this), this.config.debug && fe.call(this, this.elements.container, this.config.events.join(" "), ((e2) => {
        this.debug.log(`event: ${e2.type}`);
      })), this.fullscreen = new st(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && at.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new gt(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", (() => ke(this.play()))), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new vt(this))) : this.debug.error("Setup failed: no support");
    }
    get isHTML5() {
      return this.provider === Ge.html5;
    }
    get isEmbed() {
      return this.isYouTube || this.isVimeo;
    }
    get isYouTube() {
      return this.provider === Ge.youtube;
    }
    get isVimeo() {
      return this.provider === Ge.vimeo;
    }
    get isVideo() {
      return this.type === et;
    }
    get isAudio() {
      return this.type === Ze;
    }
    get playing() {
      return Boolean(this.ready && !this.paused && !this.ended);
    }
    get paused() {
      return Boolean(this.media.paused);
    }
    get stopped() {
      return Boolean(this.paused && 0 === this.currentTime);
    }
    get ended() {
      return Boolean(this.media.ended);
    }
    set currentTime(e2) {
      if (!this.duration) return;
      const t3 = $(e2) && e2 > 0;
      this.media.currentTime = t3 ? Math.min(e2, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
    }
    get currentTime() {
      return Number(this.media.currentTime);
    }
    get buffered() {
      const { buffered: e2 } = this.media;
      return $(e2) ? e2 : e2 && e2.length && this.duration > 0 ? e2.end(0) / this.duration : 0;
    }
    get seeking() {
      return Boolean(this.media.seeking);
    }
    get duration() {
      const e2 = parseFloat(this.config.duration), t3 = (this.media || {}).duration, i2 = $(t3) && t3 !== 1 / 0 ? t3 : 0;
      return e2 || i2;
    }
    set volume(e2) {
      let t3 = e2;
      _(t3) && (t3 = Number(t3)), $(t3) || (t3 = this.storage.get("volume")), $(t3) || ({ volume: t3 } = this.config), t3 > 1 && (t3 = 1), t3 < 0 && (t3 = 0), this.config.volume = t3, this.media.volume = t3, !W(e2) && this.muted && t3 > 0 && (this.muted = false);
    }
    get volume() {
      return Number(this.media.volume);
    }
    set muted(e2) {
      let t3 = e2;
      O(t3) || (t3 = this.storage.get("muted")), O(t3) || (t3 = this.config.muted), this.config.muted = t3, this.media.muted = t3;
    }
    get muted() {
      return Boolean(this.media.muted);
    }
    get hasAudio() {
      return !this.isHTML5 || (!!this.isAudio || (Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length)));
    }
    set speed(e2) {
      let t3 = null;
      $(e2) && (t3 = e2), $(t3) || (t3 = this.storage.get("speed")), $(t3) || (t3 = this.config.speed.selected);
      const { minimumSpeed: i2, maximumSpeed: s2 } = this;
      t3 = ft(t3, i2, s2), this.config.speed.selected = t3, setTimeout((() => {
        this.media && (this.media.playbackRate = t3);
      }), 0);
    }
    get speed() {
      return Number(this.media.playbackRate);
    }
    get minimumSpeed() {
      return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? 0.5 : 0.0625;
    }
    get maximumSpeed() {
      return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
    }
    set quality(e2) {
      const t3 = this.config.quality, i2 = this.options.quality;
      if (!i2.length) return;
      let s2 = [!W(e2) && Number(e2), this.storage.get("quality"), t3.selected, t3.default].find($), n3 = true;
      if (!i2.includes(s2)) {
        const e3 = Ae(i2, s2);
        this.debug.warn(`Unsupported quality option: ${s2}, using ${e3} instead`), s2 = e3, n3 = false;
      }
      t3.selected = s2, this.media.quality = s2, n3 && this.storage.set({ quality: s2 });
    }
    get quality() {
      return this.media.quality;
    }
    set loop(e2) {
      const t3 = O(e2) ? e2 : this.config.loop.active;
      this.config.loop.active = t3, this.media.loop = t3;
    }
    get loop() {
      return Boolean(this.media.loop);
    }
    set source(e2) {
      wt.change.call(this, e2);
    }
    get source() {
      return this.media.currentSrc;
    }
    get download() {
      const { download: e2 } = this.config.urls;
      return U(e2) ? e2 : this.source;
    }
    set download(e2) {
      U(e2) && (this.config.urls.download = e2, We.setDownloadUrl.call(this));
    }
    set poster(e2) {
      this.isVideo ? at.setPoster.call(this, e2, false).catch((() => {
      })) : this.debug.warn("Poster can only be set for video");
    }
    get poster() {
      return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
    }
    get ratio() {
      if (!this.isVideo) return null;
      const e2 = Me(Ne.call(this));
      return D(e2) ? e2.join(":") : e2;
    }
    set ratio(e2) {
      this.isVideo ? _(e2) && Pe(e2) ? (this.config.ratio = Me(e2), xe.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e2})`) : this.debug.warn("Aspect ratio can only be set for video");
    }
    set autoplay(e2) {
      this.config.autoplay = O(e2) ? e2 : this.config.autoplay;
    }
    get autoplay() {
      return Boolean(this.config.autoplay);
    }
    toggleCaptions(e2) {
      Ye.toggle.call(this, e2, false);
    }
    set currentTrack(e2) {
      Ye.set.call(this, e2, false), Ye.setup.call(this);
    }
    get currentTrack() {
      const { toggled: e2, currentTrack: t3 } = this.captions;
      return e2 ? t3 : -1;
    }
    set language(e2) {
      Ye.setLanguage.call(this, e2, false);
    }
    get language() {
      return (Ye.getCurrentTrack.call(this) || {}).language;
    }
    set pip(e2) {
      if (!me.pip) return;
      const t3 = O(e2) ? e2 : !this.pip;
      j(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t3 ? Xe : Je), j(this.media.requestPictureInPicture) && (!this.pip && t3 ? this.media.requestPictureInPicture() : this.pip && !t3 && document.exitPictureInPicture());
    }
    get pip() {
      return me.pip ? W(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Xe : null;
    }
    setPreviewThumbnails(e2) {
      this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e2), this.config.previewThumbnails.enabled && (this.previewThumbnails = new vt(this));
    }
    static supported(e2, t3, i2) {
      return me.check(e2, t3, i2);
    }
    static loadSprite(e2, t3) {
      return Ve(e2, t3);
    }
    static setup(e2, t3 = {}) {
      let i2 = null;
      return _(e2) ? i2 = Array.from(document.querySelectorAll(e2)) : q(e2) ? i2 = Array.from(e2) : D(e2) && (i2 = e2.filter(H)), W(i2) ? null : i2.map(((e3) => new Tt(e3, t3)));
    }
  }
  var kt;
  return Tt.defaults = (kt = Qe, JSON.parse(JSON.stringify(kt))), Tt;
}));
;
(function(S) {
  typeof define == "function" && define.amd ? define(S) : S();
})(function() {
  "use strict";
  function S(n2) {
    n2.length = 0;
  }
  function D(n2, t2, r2) {
    return Array.prototype.slice.call(n2, t2, r2);
  }
  function _(n2) {
    return n2.bind.apply(n2, [null].concat(D(arguments, 1)));
  }
  function q(n2) {
    return requestAnimationFrame(n2);
  }
  function C(n2, t2) {
    return typeof t2 === n2;
  }
  var z = Array.isArray;
  _(C, "function"), _(C, "string"), _(C, "undefined");
  function B(n2) {
    return z(n2) ? n2 : [n2];
  }
  function H(n2, t2) {
    B(n2).forEach(t2);
  }
  var cn = Object.keys;
  function sn(n2, t2, r2) {
    if (n2) {
      var e = cn(n2);
      e = r2 ? e.reverse() : e;
      for (var o = 0; o < e.length; o++) {
        var c = e[o];
        if (c !== "__proto__" && t2(n2[c], c) === false) break;
      }
    }
    return n2;
  }
  function dn(n2) {
    return D(arguments, 1).forEach(function(t2) {
      sn(t2, function(r2, e) {
        n2[e] = t2[e];
      });
    }), n2;
  }
  var ln = Math.min;
  function vn() {
    var n2 = [];
    function t2(u, s, a, d) {
      o(u, s, function(f, v, l) {
        var h = "addEventListener" in f, w = h ? f.removeEventListener.bind(f, v, a, d) : f.removeListener.bind(f, a);
        h ? f.addEventListener(v, a, d) : f.addListener(a), n2.push([f, v, l, a, w]);
      });
    }
    function r2(u, s, a) {
      o(u, s, function(d, f, v) {
        n2 = n2.filter(function(l) {
          return l[0] === d && l[1] === f && l[2] === v && (!a || l[3] === a) ? (l[4](), false) : true;
        });
      });
    }
    function e(u, s, a) {
      var d, f = true;
      return typeof CustomEvent == "function" ? d = new CustomEvent(s, { bubbles: f, detail: a }) : (d = document.createEvent("CustomEvent"), d.initCustomEvent(s, f, false, a)), u.dispatchEvent(d), d;
    }
    function o(u, s, a) {
      H(u, function(d) {
        d && H(s, function(f) {
          f.split(" ").forEach(function(v) {
            var l = v.split(".");
            a(d, l[0], l[1]);
          });
        });
      });
    }
    function c() {
      n2.forEach(function(u) {
        u[4]();
      }), S(n2);
    }
    return { bind: t2, unbind: r2, dispatch: e, destroy: c };
  }
  var K = "move", J = "moved", En = "updated", Q = "drag", pn = "dragged", U = "scroll", W = "scrolled", mn = "destroy";
  function hn(n2) {
    var t2 = n2 ? n2.event.bus : document.createDocumentFragment(), r2 = vn();
    function e(c, u) {
      r2.bind(t2, B(c).join(" "), function(s) {
        u.apply(u, z(s.detail) ? s.detail : []);
      });
    }
    function o(c) {
      r2.dispatch(t2, c, D(arguments, 1));
    }
    return n2 && n2.event.on(mn, r2.destroy), dn(r2, { bus: t2, on: e, off: _(r2.unbind, t2), emit: o });
  }
  function Y(n2, t2, r2, e) {
    var o = Date.now, c, u = 0, s, a = true, d = 0;
    function f() {
      if (!a) {
        if (u = n2 ? ln((o() - c) / n2, 1) : 1, r2 && r2(u), u >= 1 && (t2(), c = o(), e && ++d >= e)) return l();
        q(f);
      }
    }
    function v(E) {
      !E && w(), c = o() - (E ? u * n2 : 0), a = false, q(f);
    }
    function l() {
      a = true;
    }
    function h() {
      c = o(), u = 0, r2 && r2(u);
    }
    function w() {
      s && cancelAnimationFrame(s), u = 0, s = 0, a = true;
    }
    function M(E) {
      n2 = E;
    }
    function N() {
      return a;
    }
    return { start: v, rewind: h, pause: l, cancel: w, set: M, isPaused: N };
  }
  function An(n2, t2) {
    var r2;
    function e() {
      r2 || (r2 = Y(t2 || 0, function() {
        n2(), r2 = null;
      }, null, 1), r2.start());
    }
    return e;
  }
  var gn = "is-active", wn = "slide", yn = "fade";
  function X(n2, t2, r2) {
    return Array.prototype.slice.call(n2, t2, r2);
  }
  function V(n2) {
    return n2.bind.apply(n2, [null].concat(X(arguments, 1)));
  }
  function L(n2, t2) {
    return typeof t2 === n2;
  }
  function $(n2) {
    return !Z(n2) && L("object", n2);
  }
  var bn = Array.isArray;
  V(L, "function"), V(L, "string");
  var Sn = V(L, "undefined");
  function Z(n2) {
    return n2 === null;
  }
  function _n(n2) {
    return bn(n2) ? n2 : [n2];
  }
  function O(n2, t2) {
    _n(n2).forEach(t2);
  }
  function Ln(n2, t2, r2) {
    n2 && O(t2, function(e) {
      e && n2.classList[r2 ? "add" : "remove"](e);
    });
  }
  var On = Object.keys;
  function j(n2, t2, r2) {
    if (n2) {
      var e = On(n2);
      e = r2 ? e.reverse() : e;
      for (var o = 0; o < e.length; o++) {
        var c = e[o];
        if (c !== "__proto__" && t2(n2[c], c) === false) break;
      }
    }
    return n2;
  }
  function k(n2) {
    return X(arguments, 1).forEach(function(t2) {
      j(t2, function(r2, e) {
        n2[e] = t2[e];
      });
    }), n2;
  }
  function Tn(n2, t2) {
    O(n2, function(r2) {
      O(t2, function(e) {
        r2 && r2.removeAttribute(e);
      });
    });
  }
  function nn(n2, t2, r2) {
    $(t2) ? j(t2, function(e, o) {
      nn(n2, o, e);
    }) : O(n2, function(e) {
      Z(r2) || r2 === "" ? Tn(e, t2) : e.setAttribute(t2, String(r2));
    });
  }
  var tn = Math.min, rn = Math.max, qn = Math.floor, zn = Math.ceil, Bn = Math.abs;
  function Dn(n2, t2, r2) {
    var e = tn(t2, r2), o = rn(t2, r2);
    return tn(rn(e, n2), o);
  }
  var Cn = { speed: 1, autoStart: true, pauseOnHover: true, pauseOnFocus: true }, Vn = { startScroll: "Start auto scroll", pauseScroll: "Pause auto scroll" };
  function $n(n2, t2, r2) {
    var e = hn(n2), o = e.on, c = e.off, u = e.bind, s = e.unbind, a = t2.Move, d = a.translate, f = a.getPosition, v = a.toIndex, l = a.getLimit, h = t2.Controller, w = h.setIndex, M = h.getIndex, N = t2.Direction.orient, E = t2.Elements.toggle, en = t2.Live, I = n2.root, Mn = An(t2.Arrows.update, 500), p = {}, m, A, x, F, P, T;
    function Nn() {
      var i = r2.autoScroll;
      p = k({}, Cn, $(i) ? i : {});
    }
    function on() {
      n2.is(yn) || !m && r2.autoScroll !== false && (m = Y(0, Pn), In(), Fn());
    }
    function un() {
      m && (m.cancel(), m = null, T = void 0, c([K, Q, U, J, W]), s(I, "mouseenter mouseleave focusin focusout"), s(E, "click"));
    }
    function In() {
      p.pauseOnHover && u(I, "mouseenter mouseleave", function(i) {
        x = i.type === "mouseenter", R();
      }), p.pauseOnFocus && u(I, "focusin focusout", function(i) {
        F = i.type === "focusin", R();
      }), p.useToggleButton && u(E, "click", function() {
        A ? y() : b();
      }), o(En, xn), o([K, Q, U], function() {
        P = true, b(false);
      }), o([J, pn, W], function() {
        P = false, R();
      });
    }
    function xn() {
      var i = r2.autoScroll;
      i !== false ? (p = k({}, p, $(i) ? i : {}), on()) : un(), m && !Sn(T) && d(T);
    }
    function Fn() {
      p.autoStart && (document.readyState === "complete" ? y() : u(window, "load", y));
    }
    function y() {
      G() && (m.start(true), en.disable(true), F = x = A = false, an());
    }
    function b(i) {
      i === void 0 && (i = true), A || (A = i, an(), G() || (m.pause(), en.disable(false)));
    }
    function R() {
      A || (x || F || P ? b(false) : y());
    }
    function Pn() {
      var i = f(), g = Rn(i);
      i !== g ? (d(g), Gn(T = f())) : (b(false), p.rewind && n2.go(p.speed > 0 ? 0 : t2.Controller.getEnd())), Mn();
    }
    function Rn(i) {
      var g = p.speed || 1;
      return i += N(g), n2.is(wn) && (i = Dn(i, l(false), l(true))), i;
    }
    function Gn(i) {
      var g = n2.length, fn = (v(i) + g) % g;
      fn !== M() && (w(fn), t2.Slides.update(), t2.Pagination.update(), r2.lazyLoad === "nearby" && t2.LazyLoad.check());
    }
    function an() {
      if (E) {
        var i = A ? "startScroll" : "pauseScroll";
        Ln(E, gn, !A), nn(E, "aria-label", r2.i18n[i] || Vn[i]);
      }
    }
    function G() {
      return !m || m.isPaused();
    }
    return { setup: Nn, mount: on, destroy: un, play: y, pause: b, isPaused: G };
  }
  typeof window < "u" && (window.splide = window.splide || {}, window.splide.Extensions = window.splide.Extensions || {}, window.splide.Extensions.AutoScroll = $n);
});
;
(function(O) {
  typeof define == "function" && define.amd ? define(O) : O();
})(function() {
  "use strict";
  function O(n2) {
    n2.length = 0;
  }
  function S(n2, t2, i) {
    return Array.prototype.slice.call(n2, t2, i);
  }
  function T(n2) {
    return n2.bind.apply(n2, [null].concat(S(arguments, 1)));
  }
  function V(n2, t2) {
    return typeof t2 === n2;
  }
  var Q = Array.isArray;
  T(V, "function"), T(V, "string"), T(V, "undefined");
  function X(n2) {
    return Q(n2) ? n2 : [n2];
  }
  function Z(n2, t2) {
    X(n2).forEach(t2);
  }
  var hn = Object.keys;
  function En(n2, t2, i) {
    if (n2) {
      var r2 = hn(n2);
      r2 = i ? r2.reverse() : r2;
      for (var f = 0; f < r2.length; f++) {
        var a = r2[f];
        if (a !== "__proto__" && t2(n2[a], a) === false) break;
      }
    }
    return n2;
  }
  function gn(n2) {
    return S(arguments, 1).forEach(function(t2) {
      En(t2, function(i, r2) {
        n2[r2] = t2[r2];
      });
    }), n2;
  }
  var j = "splide";
  function mn() {
    var n2 = [];
    function t2(u, c, l, v) {
      f(u, c, function(d, g, m) {
        var _ = "addEventListener" in d, C = _ ? d.removeEventListener.bind(d, g, l, v) : d.removeListener.bind(d, l);
        _ ? d.addEventListener(g, l, v) : d.addListener(l), n2.push([d, g, m, l, C]);
      });
    }
    function i(u, c, l) {
      f(u, c, function(v, d, g) {
        n2 = n2.filter(function(m) {
          return m[0] === v && m[1] === d && m[2] === g && (!l || m[3] === l) ? (m[4](), false) : true;
        });
      });
    }
    function r2(u, c, l) {
      var v, d = true;
      return typeof CustomEvent == "function" ? v = new CustomEvent(c, { bubbles: d, detail: l }) : (v = document.createEvent("CustomEvent"), v.initCustomEvent(c, d, false, l)), u.dispatchEvent(v), v;
    }
    function f(u, c, l) {
      Z(u, function(v) {
        v && Z(c, function(d) {
          d.split(" ").forEach(function(g) {
            var m = g.split(".");
            l(v, m[0], m[1]);
          });
        });
      });
    }
    function a() {
      n2.forEach(function(u) {
        u[4]();
      }), O(n2);
    }
    return { bind: t2, unbind: i, dispatch: r2, destroy: a };
  }
  var pn = "visible", yn = "hidden", H = "refresh", wn = "updated", _n = "destroy";
  function k(n2) {
    var t2 = n2 ? n2.event.bus : document.createDocumentFragment(), i = mn();
    function r2(a, u) {
      i.bind(t2, X(a).join(" "), function(c) {
        u.apply(u, Q(c.detail) ? c.detail : []);
      });
    }
    function f(a) {
      i.dispatch(t2, a, S(arguments, 1));
    }
    return n2 && n2.event.on(_n, i.destroy), gn(i, { bus: t2, on: r2, off: T(i.unbind, t2), emit: f });
  }
  var Cn = j, $ = j + "__slide", An = $ + "__container";
  function nn(n2) {
    n2.length = 0;
  }
  function I(n2, t2, i) {
    return Array.prototype.slice.call(n2, t2, i);
  }
  function B(n2) {
    return n2.bind.apply(n2, [null].concat(I(arguments, 1)));
  }
  function N(n2, t2) {
    return typeof t2 === n2;
  }
  function bn(n2) {
    return !P(n2) && N("object", n2);
  }
  var F = Array.isArray;
  B(N, "function");
  var G = B(N, "string"), Ln = B(N, "undefined");
  function P(n2) {
    return n2 === null;
  }
  function Dn(n2) {
    return n2 instanceof HTMLElement;
  }
  function U(n2) {
    return F(n2) ? n2 : [n2];
  }
  function A(n2, t2) {
    U(n2).forEach(t2);
  }
  function tn(n2, t2) {
    return n2.push.apply(n2, U(t2)), n2;
  }
  function rn(n2, t2, i) {
    n2 && A(t2, function(r2) {
      r2 && n2.classList[i ? "add" : "remove"](r2);
    });
  }
  function q(n2, t2) {
    rn(n2, G(t2) ? t2.split(" ") : t2, true);
  }
  function R(n2, t2) {
    A(t2, n2.appendChild.bind(n2));
  }
  function On(n2, t2) {
    return Dn(n2) && (n2.msMatchesSelector || n2.matches).call(n2, t2);
  }
  function Tn(n2, t2) {
    var i = n2 ? I(n2.children) : [];
    return t2 ? i.filter(function(r2) {
      return On(r2, t2);
    }) : i;
  }
  function on(n2, t2) {
    return t2 ? Tn(n2, t2)[0] : n2.firstElementChild;
  }
  var en = Object.keys;
  function un(n2, t2, i) {
    if (n2) {
      var r2 = en(n2);
      r2 = i ? r2.reverse() : r2;
      for (var f = 0; f < r2.length; f++) {
        var a = r2[f];
        if (a !== "__proto__" && t2(n2[a], a) === false) break;
      }
    }
    return n2;
  }
  function $n(n2) {
    return I(arguments, 1).forEach(function(t2) {
      un(t2, function(i, r2) {
        n2[r2] = t2[r2];
      });
    }), n2;
  }
  function In(n2, t2) {
    U(t2 || en(n2)).forEach(function(i) {
      delete n2[i];
    });
  }
  function J(n2, t2) {
    A(n2, function(i) {
      A(t2, function(r2) {
        i && i.removeAttribute(r2);
      });
    });
  }
  function K(n2, t2, i) {
    bn(t2) ? un(t2, function(r2, f) {
      K(n2, f, r2);
    }) : A(n2, function(r2) {
      P(i) || i === "" ? J(r2, t2) : r2.setAttribute(t2, String(i));
    });
  }
  function fn(n2, t2, i) {
    var r2 = document.createElement(n2);
    return t2 && (G(t2) ? q(r2, t2) : K(r2, t2)), i && R(i, r2), r2;
  }
  function p(n2, t2, i) {
    if (Ln(i)) return getComputedStyle(n2)[t2];
    P(i) || (n2.style[t2] = "" + i);
  }
  function Nn(n2, t2) {
    return n2 && n2.classList.contains(t2);
  }
  function Rn(n2) {
    A(n2, function(t2) {
      t2 && t2.parentNode && t2.parentNode.removeChild(t2);
    });
  }
  function an(n2, t2) {
    return t2 ? I(n2.querySelectorAll(t2)) : [];
  }
  function cn(n2, t2) {
    rn(n2, t2, false);
  }
  function x(n2) {
    return G(n2) ? n2 : n2 ? n2 + "px" : "";
  }
  var xn = "splide";
  function Mn(n2, t2) {
    if (!n2) throw new Error("[" + xn + "] " + (t2 || ""));
  }
  var Sn = Math.min, Un = Math.max, qn = Math.floor, Jn = Math.ceil, Kn = Math.abs;
  function Vn(n2) {
    return n2 < 10 ? "0" + n2 : "" + n2;
  }
  var sn = $ + "__row", z = $ + "--col", Hn = { rows: 1, cols: 1, dimensions: [], gap: {} };
  function Bn(n2) {
    function t2() {
      var f = n2.rows, a = n2.cols, u = n2.dimensions;
      return F(u) && u.length ? u : [[f, a]];
    }
    function i(f) {
      var a = t2();
      return a[Sn(f, a.length - 1)];
    }
    function r2(f) {
      for (var a = t2(), u, c, l = 0, v = 0; v < a.length; v++) {
        var d = a[v];
        if (u = d[0] || 1, c = d[1] || 1, l += u * c, f < l) break;
      }
      return Mn(u && c, "Invalid dimension"), [u, c];
    }
    return { get: i, getAt: r2 };
  }
  function Fn(n2, t2, i) {
    var r2 = k(n2), f = r2.on, a = r2.destroy, u = n2.Components, c = n2.options, l = u.Direction.resolve, v = u.Slides.forEach;
    function d() {
      m(), c.slideFocus && (f(pn, W), f(yn, Y));
    }
    function g() {
      v(function(e) {
        var s = e.slide;
        D(s, false), M(s).forEach(function(o) {
          J(o, "style");
        }), b(s).forEach(function(o) {
          L(o, true), J(o, "style");
        });
      }), a();
    }
    function m() {
      v(function(e) {
        var s = e.slide, o = i.get(e.isClone ? e.slideIndex : e.index), h = o[0], E = o[1];
        _(h, s), C(E, s), b(e.slide).forEach(function(y, w) {
          y.id = e.slide.id + "-col" + Vn(w + 1), n2.options.cover && L(y);
        });
      });
    }
    function _(e, s) {
      var o = t2.gap.row, h = "calc(" + 100 / e + "%" + (o ? " - " + x(o) + " * " + (e - 1) / e : "") + ")";
      M(s).forEach(function(E, y, w) {
        p(E, "height", h), p(E, "display", "flex"), p(E, "margin", "0 0 " + x(o) + " 0"), p(E, "padding", 0), y === w.length - 1 && p(E, "marginBottom", 0);
      });
    }
    function C(e, s) {
      var o = t2.gap.col, h = "calc(" + 100 / e + "%" + (o ? " - " + x(o) + " * " + (e - 1) / e : "") + ")";
      b(s).forEach(function(E, y, w) {
        p(E, "width", h), y !== w.length - 1 && p(E, l("marginRight"), x(o));
      });
    }
    function L(e, s) {
      var o = on(e, "." + An), h = on(o || e, "img");
      h && h.src && (p(o || e, "background", s ? "" : 'center/cover no-repeat url("' + h.src + '")'), p(h, "display", s ? "" : "none"));
    }
    function M(e) {
      return an(e, "." + sn);
    }
    function b(e) {
      return an(e, "." + z);
    }
    function D(e, s) {
      b(e).forEach(function(o) {
        K(o, "tabindex", s ? 0 : null);
      });
    }
    function W(e) {
      D(e.slide, true);
    }
    function Y(e) {
      D(e.slide, false);
    }
    return { mount: d, destroy: g };
  }
  function Gn(n2, t2, i) {
    var r2 = k(n2), f = r2.on, a = r2.off, u = t2.Elements, c = {}, l = Bn(c), v = Fn(n2, c, l), d = Cn + "--grid", g = [];
    function m() {
      _(), f(wn, _);
    }
    function _() {
      In(c), $n(c, Hn, i.grid || {}), Y() ? (C(), tn(g, u.slides), q(n2.root, d), R(u.list, b()), a(H), f(H, M), L()) : e() && (C(), L());
    }
    function C() {
      if (e()) {
        var s = u.slides;
        v.destroy(), g.forEach(function(o) {
          cn(o, z), R(u.list, o);
        }), Rn(s), cn(n2.root, d), nn(s), tn(s, g), nn(g), a(H);
      }
    }
    function L() {
      n2.refresh();
    }
    function M() {
      e() && v.mount();
    }
    function b() {
      var s = [], o = 0, h = 0, E, y;
      return g.forEach(function(w, Pn) {
        var dn = l.getAt(Pn), vn = dn[0], ln = dn[1];
        h || (o || (E = fn(w.tagName, $), s.push(E)), y = D(vn, w, E)), W(ln, w, y), ++h >= ln && (h = 0, o = ++o >= vn ? 0 : o);
      }), s;
    }
    function D(s, o, h) {
      var E = o.tagName.toLowerCase() === "li" ? "ul" : "div";
      return fn(E, sn, h);
    }
    function W(s, o, h) {
      return q(o, z), R(h, o), o;
    }
    function Y() {
      if (i.grid) {
        var s = c.rows, o = c.cols, h = c.dimensions;
        return s > 1 || o > 1 || F(h) && h.length > 0;
      }
      return false;
    }
    function e() {
      return Nn(n2.root, d);
    }
    return { mount: m, destroy: C };
  }
  typeof window < "u" && (window.splide = window.splide || {}, window.splide.Extensions = window.splide.Extensions || {}, window.splide.Extensions.Grid = Gn);
});
;
(function(b) {
  typeof define == "function" && define.amd ? define(b) : b();
})(function() {
  "use strict";
  function b(n2) {
    n2.length = 0;
  }
  function y(n2, e, i) {
    return Array.prototype.slice.call(n2, e, i);
  }
  function E(n2) {
    return n2.bind.apply(n2, [null].concat(y(arguments, 1)));
  }
  function w(n2, e) {
    return typeof e === n2;
  }
  var _ = Array.isArray;
  E(w, "function"), E(w, "string"), E(w, "undefined");
  function O(n2) {
    return _(n2) ? n2 : [n2];
  }
  function T(n2, e) {
    O(n2).forEach(e);
  }
  var V = Object.keys;
  function N(n2, e, i) {
    if (n2) {
      var t2 = V(n2);
      t2 = i ? t2.reverse() : t2;
      for (var f = 0; f < t2.length; f++) {
        var o = t2[f];
        if (o !== "__proto__" && e(n2[o], o) === false) break;
      }
    }
    return n2;
  }
  function C(n2) {
    return y(arguments, 1).forEach(function(e) {
      N(e, function(i, t2) {
        n2[t2] = e[t2];
      });
    }), n2;
  }
  function g() {
    var n2 = [];
    function e(c, r2, s, a) {
      f(c, r2, function(u, l, d) {
        var m = "addEventListener" in u, v = m ? u.removeEventListener.bind(u, l, s, a) : u.removeListener.bind(u, s);
        m ? u.addEventListener(l, s, a) : u.addListener(s), n2.push([u, l, d, s, v]);
      });
    }
    function i(c, r2, s) {
      f(c, r2, function(a, u, l) {
        n2 = n2.filter(function(d) {
          return d[0] === a && d[1] === u && d[2] === l && (!s || d[3] === s) ? (d[4](), false) : true;
        });
      });
    }
    function t2(c, r2, s) {
      var a, u = true;
      return typeof CustomEvent == "function" ? a = new CustomEvent(r2, { bubbles: u, detail: s }) : (a = document.createEvent("CustomEvent"), a.initCustomEvent(r2, u, false, s)), c.dispatchEvent(a), a;
    }
    function f(c, r2, s) {
      T(c, function(a) {
        a && T(r2, function(u) {
          u.split(" ").forEach(function(l) {
            var d = l.split(".");
            s(a, d[0], d[1]);
          });
        });
      });
    }
    function o() {
      n2.forEach(function(c) {
        c[4]();
      }), b(n2);
    }
    return { bind: e, unbind: i, dispatch: t2, destroy: o };
  }
  var L = "destroy";
  function $(n2) {
    var e = n2 ? n2.event.bus : document.createDocumentFragment(), i = g();
    function t2(o, c) {
      i.bind(e, O(o).join(" "), function(r2) {
        c.apply(c, _(r2.detail) ? r2.detail : []);
      });
    }
    function f(o) {
      i.dispatch(e, o, y(arguments, 1));
    }
    return n2 && n2.event.on(L, i.destroy), C(i, { bus: e, on: t2, off: E(i.unbind, e), emit: f });
  }
  function K(n2, e, i) {
    return Array.prototype.slice.call(n2, e, i);
  }
  function h(n2) {
    return n2.bind.apply(n2, [null].concat(K(arguments, 1)));
  }
  function I(n2, e) {
    return typeof e === n2;
  }
  h(I, "function"), h(I, "string");
  var R = h(I, "undefined"), x = Object.keys;
  function S(n2, e, i) {
    if (n2) {
      var t2 = x(n2);
      t2 = i ? t2.reverse() : t2;
      for (var f = 0; f < t2.length; f++) {
        var o = t2[f];
        if (o !== "__proto__" && e(n2[o], o) === false) break;
      }
    }
    return n2;
  }
  var D = "intersection", M = "intersection:in", U = "intersection:out";
  function B(n2) {
    var e = n2.Components;
    return { keyboard: { enable: function() {
      e.Keyboard.disable(false);
    }, disable: function() {
      e.Keyboard.disable(true);
    } }, autoplay: { enable: function() {
      n2.options.autoplay && e.Autoplay.play();
    }, disable: function() {
      e.Autoplay.pause();
    } }, autoScroll: { enable: function() {
      var t2 = e.AutoScroll;
      t2 && t2.play();
    }, disable: function() {
      var t2 = e.AutoScroll;
      t2 && t2.pause();
    } }, video: { enable: function() {
      var t2 = e.Video;
      t2 && t2.play();
    }, disable: function() {
      var t2 = e.Video;
      t2 && t2.pause();
    } } };
  }
  function F(n2, e, i) {
    var t2 = $(n2), f = t2.emit, o = i.intersection || {}, c = B(n2), r2;
    function s() {
      window.IntersectionObserver && (r2 = new IntersectionObserver(u, { root: o.root, rootMargin: o.rootMargin, threshold: o.threshold }), r2.observe(n2.root));
    }
    function a() {
      r2 && (r2.disconnect(), r2 = null);
    }
    function u(v) {
      var p = v[0];
      p && (p.isIntersecting ? d(p) : m(p), f(D, p));
    }
    function l(v) {
      S(v, function(p, H) {
        if (!R(p)) {
          var A = c[H];
          p ? A.enable() : A.disable();
        }
      });
    }
    function d(v) {
      l(o.inView || {}), f(M, v), o.once && a();
    }
    function m(v) {
      l(o.outView || {}), f(U, v);
    }
    return { mount: s, destroy: a };
  }
  typeof window < "u" && (window.splide = window.splide || {}, window.splide.Extensions = window.splide.Extensions || {}, window.splide.Extensions.Intersection = F);
});
;
function r(n2, t2) {
  for (var i = 0; i < t2.length; i++) {
    var r2 = t2[i];
    r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(n2, r2.key, r2);
  }
}
function Jt(n2, t2, i) {
  t2 && r(n2.prototype, t2), i && r(n2, i), Object.defineProperty(n2, "prototype", { writable: false });
}
var n, t;
n = this, t = function() {
  "use strict";
  var v = "(prefers-reduced-motion: reduce)", G = 4, rn = 5, r2 = { CREATED: 1, MOUNTED: 2, IDLE: 3, MOVING: G, SCROLLING: rn, DRAGGING: 6, DESTROYED: 7 };
  function D(n3) {
    n3.length = 0;
  }
  function o(n3, t3, i2) {
    return Array.prototype.slice.call(n3, t3, i2);
  }
  function R(n3) {
    return n3.bind.apply(n3, [null].concat(o(arguments, 1)));
  }
  function on() {
  }
  var p = setTimeout;
  function h(n3) {
    return requestAnimationFrame(n3);
  }
  function u(n3, t3) {
    return typeof t3 === n3;
  }
  function un(n3) {
    return !c(n3) && u("object", n3);
  }
  var e = Array.isArray, x = R(u, "function"), C = R(u, "string"), en = R(u, "undefined");
  function c(n3) {
    return null === n3;
  }
  function m(n3) {
    try {
      return n3 instanceof (n3.ownerDocument.defaultView || window).HTMLElement;
    } catch (n4) {
      return false;
    }
  }
  function y(n3) {
    return e(n3) ? n3 : [n3];
  }
  function g(n3, t3) {
    y(n3).forEach(t3);
  }
  function b(n3, t3) {
    return -1 < n3.indexOf(t3);
  }
  function k(n3, t3) {
    return n3.push.apply(n3, y(t3)), n3;
  }
  function A(t3, n3, i2) {
    t3 && g(n3, function(n4) {
      n4 && t3.classList[i2 ? "add" : "remove"](n4);
    });
  }
  function M(n3, t3) {
    A(n3, C(t3) ? t3.split(" ") : t3, true);
  }
  function L(n3, t3) {
    g(t3, n3.appendChild.bind(n3));
  }
  function O(n3, i2) {
    g(n3, function(n4) {
      var t3 = (i2 || n4).parentNode;
      t3 && t3.insertBefore(n4, i2);
    });
  }
  function cn(n3, t3) {
    return m(n3) && (n3.msMatchesSelector || n3.matches).call(n3, t3);
  }
  function S(n3, t3) {
    n3 = n3 ? o(n3.children) : [];
    return t3 ? n3.filter(function(n4) {
      return cn(n4, t3);
    }) : n3;
  }
  function fn(n3, t3) {
    return t3 ? S(n3, t3)[0] : n3.firstElementChild;
  }
  var E = Object.keys;
  function w(t3, i2, n3) {
    t3 && (n3 ? E(t3).reverse() : E(t3)).forEach(function(n4) {
      "__proto__" !== n4 && i2(t3[n4], n4);
    });
  }
  function an(r3) {
    return o(arguments, 1).forEach(function(i2) {
      w(i2, function(n3, t3) {
        r3[t3] = i2[t3];
      });
    }), r3;
  }
  function d(i2) {
    return o(arguments, 1).forEach(function(n3) {
      w(n3, function(n4, t3) {
        e(n4) ? i2[t3] = n4.slice() : un(n4) ? i2[t3] = d({}, un(i2[t3]) ? i2[t3] : {}, n4) : i2[t3] = n4;
      });
    }), i2;
  }
  function sn(t3, n3) {
    g(n3 || E(t3), function(n4) {
      delete t3[n4];
    });
  }
  function P(n3, i2) {
    g(n3, function(t3) {
      g(i2, function(n4) {
        t3 && t3.removeAttribute(n4);
      });
    });
  }
  function I(i2, t3, r3) {
    un(t3) ? w(t3, function(n3, t4) {
      I(i2, t4, n3);
    }) : g(i2, function(n3) {
      c(r3) || "" === r3 ? P(n3, t3) : n3.setAttribute(t3, String(r3));
    });
  }
  function j(n3, t3, i2) {
    n3 = document.createElement(n3);
    return t3 && (C(t3) ? M : I)(n3, t3), i2 && L(i2, n3), n3;
  }
  function _(n3, t3, i2) {
    if (en(i2)) return getComputedStyle(n3)[t3];
    c(i2) || (n3.style[t3] = "" + i2);
  }
  function ln(n3, t3) {
    _(n3, "display", t3);
  }
  function dn(n3) {
    n3.setActive && n3.setActive() || n3.focus({ preventScroll: true });
  }
  function z(n3, t3) {
    return n3.getAttribute(t3);
  }
  function vn(n3, t3) {
    return n3 && n3.classList.contains(t3);
  }
  function N(n3) {
    return n3.getBoundingClientRect();
  }
  function T(n3) {
    g(n3, function(n4) {
      n4 && n4.parentNode && n4.parentNode.removeChild(n4);
    });
  }
  function hn(n3) {
    return fn(new DOMParser().parseFromString(n3, "text/html").body);
  }
  function F(n3, t3) {
    n3.preventDefault(), t3 && (n3.stopPropagation(), n3.stopImmediatePropagation());
  }
  function pn(n3, t3) {
    return n3 && n3.querySelector(t3);
  }
  function gn(n3, t3) {
    return t3 ? o(n3.querySelectorAll(t3)) : [];
  }
  function X(n3, t3) {
    A(n3, t3, false);
  }
  function mn(n3) {
    return n3.timeStamp;
  }
  function W(n3) {
    return C(n3) ? n3 : n3 ? n3 + "px" : "";
  }
  var yn = "splide", f = "data-" + yn;
  function bn(n3, t3) {
    if (!n3) throw new Error("[" + yn + "] " + (t3 || ""));
  }
  var Y = Math.min, wn = Math.max, xn = Math.floor, kn = Math.ceil, U = Math.abs;
  function Sn(n3, t3, i2) {
    return U(n3 - t3) < i2;
  }
  function En(n3, t3, i2, r3) {
    var o2 = Y(t3, i2), t3 = wn(t3, i2);
    return r3 ? o2 < n3 && n3 < t3 : o2 <= n3 && n3 <= t3;
  }
  function q(n3, t3, i2) {
    var r3 = Y(t3, i2), t3 = wn(t3, i2);
    return Y(wn(r3, n3), t3);
  }
  function Ln(n3) {
    return (0 < n3) - (n3 < 0);
  }
  function On(t3, n3) {
    return g(n3, function(n4) {
      t3 = t3.replace("%s", "" + n4);
    }), t3;
  }
  function An(n3) {
    return n3 < 10 ? "0" + n3 : "" + n3;
  }
  var _n = {};
  function zn() {
    var c2 = [];
    function i2(n3, i3, r3) {
      g(n3, function(t3) {
        t3 && g(i3, function(n4) {
          n4.split(" ").forEach(function(n5) {
            n5 = n5.split(".");
            r3(t3, n5[0], n5[1]);
          });
        });
      });
    }
    return { bind: function(n3, t3, u2, e2) {
      i2(n3, t3, function(n4, t4, i3) {
        var r3 = "addEventListener" in n4, o2 = r3 ? n4.removeEventListener.bind(n4, t4, u2, e2) : n4.removeListener.bind(n4, u2);
        r3 ? n4.addEventListener(t4, u2, e2) : n4.addListener(u2), c2.push([n4, t4, i3, u2, o2]);
      });
    }, unbind: function(n3, t3, o2) {
      i2(n3, t3, function(t4, i3, r3) {
        c2 = c2.filter(function(n4) {
          return !!(n4[0] !== t4 || n4[1] !== i3 || n4[2] !== r3 || o2 && n4[3] !== o2) || (n4[4](), false);
        });
      });
    }, dispatch: function(n3, t3, i3) {
      var r3;
      return "function" == typeof CustomEvent ? r3 = new CustomEvent(t3, { bubbles: true, detail: i3 }) : (r3 = document.createEvent("CustomEvent")).initCustomEvent(t3, true, false, i3), n3.dispatchEvent(r3), r3;
    }, destroy: function() {
      c2.forEach(function(n3) {
        n3[4]();
      }), D(c2);
    } };
  }
  var B = "mounted", H = "move", Dn = "moved", Mn = "click", Pn = "active", In = "inactive", Rn = "visible", Cn = "hidden", J = "refresh", K = "updated", jn = "resize", Nn = "resized", Tn = "scroll", V = "scrolled", a = "destroy", Gn = "navigation:mounted", Fn = "autoplay:play", Xn = "autoplay:pause", Wn = "lazyload:loaded", Yn = "sk", Un = "sh";
  function Q(n3) {
    var i2 = n3 ? n3.event.bus : document.createDocumentFragment(), r3 = zn();
    return n3 && n3.event.on(a, r3.destroy), an(r3, { bus: i2, on: function(n4, t3) {
      r3.bind(i2, y(n4).join(" "), function(n5) {
        t3.apply(t3, e(n5.detail) ? n5.detail : []);
      });
    }, off: R(r3.unbind, i2), emit: function(n4) {
      r3.dispatch(i2, n4, o(arguments, 1));
    } });
  }
  function qn(t3, n3, i2, r3) {
    var o2, u2, e2 = Date.now, c2 = 0, f2 = true, a2 = 0;
    function s2() {
      if (!f2) {
        if (c2 = t3 ? Y((e2() - o2) / t3, 1) : 1, i2 && i2(c2), 1 <= c2 && (n3(), o2 = e2(), r3 && ++a2 >= r3)) return l2();
        u2 = h(s2);
      }
    }
    function l2() {
      f2 = true;
    }
    function d2() {
      u2 && cancelAnimationFrame(u2), f2 = !(u2 = c2 = 0);
    }
    return { start: function(n4) {
      n4 || d2(), o2 = e2() - (n4 ? c2 * t3 : 0), f2 = false, u2 = h(s2);
    }, rewind: function() {
      o2 = e2(), c2 = 0, i2 && i2(c2);
    }, pause: l2, cancel: d2, set: function(n4) {
      t3 = n4;
    }, isPaused: function() {
      return f2;
    } };
  }
  function s(n3) {
    var t3 = n3;
    return { set: function(n4) {
      t3 = n4;
    }, is: function(n4) {
      return b(y(n4), t3);
    } };
  }
  var n2 = "Arrow", Bn = n2 + "Left", Hn = n2 + "Right", t2 = n2 + "Up", n2 = n2 + "Down", Jn = "ttb", l = { width: ["height"], left: ["top", "right"], right: ["bottom", "left"], x: ["y"], X: ["Y"], Y: ["X"], ArrowLeft: [t2, Hn], ArrowRight: [n2, Bn] };
  var Z = "role", $ = "tabindex", i = "aria-", Kn = i + "controls", Vn = i + "current", Qn = i + "selected", nn = i + "label", Zn = i + "labelledby", $n = i + "hidden", nt = i + "orientation", tt = i + "roledescription", it = i + "live", rt = i + "busy", ot = i + "atomic", ut = [Z, $, "disabled", Kn, Vn, nn, Zn, $n, nt, tt], i = yn + "__", et = yn, ct = i + "track", ft = i + "list", at = i + "slide", st = at + "--clone", lt = at + "__container", dt = i + "arrows", vt = i + "arrow", ht = vt + "--prev", pt = vt + "--next", gt = i + "pagination", mt = gt + "__page", yt = i + "progress__bar", bt = i + "toggle", wt = i + "sr", tn = "is-active", xt = "is-prev", kt = "is-next", St = "is-visible", Et = "is-loading", Lt = "is-focus-in", Ot = "is-overflow", At = [tn, St, xt, kt, Et, Lt, Ot];
  var _t = "touchstart mousedown", zt = "touchmove mousemove", Dt = "touchend touchcancel mouseup click";
  var Mt = "slide", Pt = "loop", It = "fade";
  function Rt(o2, r3, t3, u2) {
    var e2, n3 = Q(o2), i2 = n3.on, c2 = n3.emit, f2 = n3.bind, a2 = o2.Components, s2 = o2.root, l2 = o2.options, d2 = l2.isNavigation, v2 = l2.updateOnMove, h2 = l2.i18n, p2 = l2.pagination, g2 = l2.slideFocus, m2 = a2.Direction.resolve, y2 = z(u2, "style"), b2 = z(u2, nn), w2 = -1 < t3, x2 = fn(u2, "." + lt);
    function k2() {
      var n4 = o2.splides.map(function(n5) {
        n5 = n5.splide.Components.Slides.getAt(r3);
        return n5 ? n5.slide.id : "";
      }).join(" ");
      I(u2, nn, On(h2.slideX, (w2 ? t3 : r3) + 1)), I(u2, Kn, n4), I(u2, Z, g2 ? "button" : ""), g2 && P(u2, tt);
    }
    function S2() {
      e2 || E2();
    }
    function E2() {
      var n4, t4, i3;
      e2 || (n4 = o2.index, (i3 = L2()) !== vn(u2, tn) && (A(u2, tn, i3), I(u2, Vn, d2 && i3 || ""), c2(i3 ? Pn : In, O2)), i3 = (function() {
        if (o2.is(It)) return L2();
        var n5 = N(a2.Elements.track), t5 = N(u2), i4 = m2("left", true), r4 = m2("right", true);
        return xn(n5[i4]) <= kn(t5[i4]) && xn(t5[r4]) <= kn(n5[r4]);
      })(), t4 = !i3 && (!L2() || w2), o2.state.is([G, rn]) || I(u2, $n, t4 || ""), I(gn(u2, l2.focusableNodes || ""), $, t4 ? -1 : ""), g2 && I(u2, $, t4 ? -1 : 0), i3 !== vn(u2, St) && (A(u2, St, i3), c2(i3 ? Rn : Cn, O2)), i3 || document.activeElement !== u2 || (t4 = a2.Slides.getAt(o2.index)) && dn(t4.slide), A(u2, xt, r3 === n4 - 1), A(u2, kt, r3 === n4 + 1));
    }
    function L2() {
      var n4 = o2.index;
      return n4 === r3 || l2.cloneStatus && n4 === t3;
    }
    var O2 = { index: r3, slideIndex: t3, slide: u2, container: x2, isClone: w2, mount: function() {
      w2 || (u2.id = s2.id + "-slide" + An(r3 + 1), I(u2, Z, p2 ? "tabpanel" : "group"), I(u2, tt, h2.slide), I(u2, nn, b2 || On(h2.slideLabel, [r3 + 1, o2.length]))), f2(u2, "click", R(c2, Mn, O2)), f2(u2, "keydown", R(c2, Yn, O2)), i2([Dn, Un, V], E2), i2(Gn, k2), v2 && i2(H, S2);
    }, destroy: function() {
      e2 = true, n3.destroy(), X(u2, At), P(u2, ut), I(u2, "style", y2), I(u2, nn, b2 || "");
    }, update: E2, style: function(n4, t4, i3) {
      _(i3 && x2 || u2, n4, t4);
    }, isWithin: function(n4, t4) {
      return n4 = U(n4 - r3), (n4 = w2 || !l2.rewind && !o2.is(Pt) ? n4 : Y(n4, o2.length - n4)) <= t4;
    } };
    return O2;
  }
  var Ct = f + "-interval";
  var jt = { passive: false, capture: true };
  var Nt = { Spacebar: " ", Right: Hn, Left: Bn, Up: t2, Down: n2 };
  function Tt(n3) {
    return n3 = C(n3) ? n3 : n3.key, Nt[n3] || n3;
  }
  var Gt = "keydown";
  var Ft = f + "-lazy", Xt = Ft + "-srcset", Wt = "[" + Ft + "], [" + Xt + "]";
  var Yt = [" ", "Enter"];
  var Ut = Object.freeze({ __proto__: null, Media: function(r3, n3, o2) {
    var u2 = r3.state, t3 = o2.breakpoints || {}, e2 = o2.reducedMotion || {}, i2 = zn(), c2 = [];
    function f2(n4) {
      n4 && i2.destroy();
    }
    function a2(n4, t4) {
      t4 = matchMedia(t4);
      i2.bind(t4, "change", s2), c2.push([n4, t4]);
    }
    function s2() {
      var n4 = u2.is(7), t4 = o2.direction, i3 = c2.reduce(function(n5, t5) {
        return d(n5, t5[1].matches ? t5[0] : {});
      }, {});
      sn(o2), l2(i3), o2.destroy ? r3.destroy("completely" === o2.destroy) : n4 ? (f2(true), r3.mount()) : t4 !== o2.direction && r3.refresh();
    }
    function l2(n4, t4, i3) {
      d(o2, n4), t4 && d(Object.getPrototypeOf(o2), n4), !i3 && u2.is(1) || r3.emit(K, o2);
    }
    return { setup: function() {
      var i3 = "min" === o2.mediaQuery;
      E(t3).sort(function(n4, t4) {
        return i3 ? +n4 - +t4 : +t4 - +n4;
      }).forEach(function(n4) {
        a2(t3[n4], "(" + (i3 ? "min" : "max") + "-width:" + n4 + "px)");
      }), a2(e2, v), s2();
    }, destroy: f2, reduce: function(n4) {
      matchMedia(v).matches && (n4 ? d(o2, e2) : sn(o2, E(e2)));
    }, set: l2 };
  }, Direction: function(n3, t3, o2) {
    return { resolve: function(n4, t4, i2) {
      var r3 = "rtl" !== (i2 = i2 || o2.direction) || t4 ? i2 === Jn ? 0 : -1 : 1;
      return l[n4] && l[n4][r3] || n4.replace(/width|left|right/i, function(n5, t5) {
        n5 = l[n5.toLowerCase()][r3] || n5;
        return 0 < t5 ? n5.charAt(0).toUpperCase() + n5.slice(1) : n5;
      });
    }, orient: function(n4) {
      return n4 * ("rtl" === o2.direction ? 1 : -1);
    } };
  }, Elements: function(n3, t3, i2) {
    var r3, o2, u2, e2 = Q(n3), c2 = e2.on, f2 = e2.bind, a2 = n3.root, s2 = i2.i18n, l2 = {}, d2 = [], v2 = [], h2 = [];
    function p2() {
      r3 = y2("." + ct), o2 = fn(r3, "." + ft), bn(r3 && o2, "A track/list element is missing."), k(d2, S(o2, "." + at + ":not(." + st + ")")), w({ arrows: dt, pagination: gt, prev: ht, next: pt, bar: yt, toggle: bt }, function(n5, t5) {
        l2[t5] = y2("." + n5);
      }), an(l2, { root: a2, track: r3, list: o2, slides: d2 });
      var n4 = a2.id || (function(n5) {
        return "" + n5 + An(_n[n5] = (_n[n5] || 0) + 1);
      })(yn), t4 = i2.role;
      a2.id = n4, r3.id = r3.id || n4 + "-track", o2.id = o2.id || n4 + "-list", !z(a2, Z) && "SECTION" !== a2.tagName && t4 && I(a2, Z, t4), I(a2, tt, s2.carousel), I(o2, Z, "presentation"), m2();
    }
    function g2(n4) {
      var t4 = ut.concat("style");
      D(d2), X(a2, v2), X(r3, h2), P([r3, o2], t4), P(a2, n4 ? t4 : ["style", tt]);
    }
    function m2() {
      X(a2, v2), X(r3, h2), v2 = b2(et), h2 = b2(ct), M(a2, v2), M(r3, h2), I(a2, nn, i2.label), I(a2, Zn, i2.labelledby);
    }
    function y2(n4) {
      n4 = pn(a2, n4);
      return n4 && (function(n5, t4) {
        if (x(n5.closest)) return n5.closest(t4);
        for (var i3 = n5; i3 && 1 === i3.nodeType && !cn(i3, t4); ) i3 = i3.parentElement;
        return i3;
      })(n4, "." + et) === a2 ? n4 : void 0;
    }
    function b2(n4) {
      return [n4 + "--" + i2.type, n4 + "--" + i2.direction, i2.drag && n4 + "--draggable", i2.isNavigation && n4 + "--nav", n4 === et && tn];
    }
    return an(l2, { setup: p2, mount: function() {
      c2(J, g2), c2(J, p2), c2(K, m2), f2(document, _t + " keydown", function(n4) {
        u2 = "keydown" === n4.type;
      }, { capture: true }), f2(a2, "focusin", function() {
        A(a2, Lt, !!u2);
      });
    }, destroy: g2 });
  }, Slides: function(r3, o2, u2) {
    var n3 = Q(r3), t3 = n3.on, e2 = n3.emit, c2 = n3.bind, f2 = (n3 = o2.Elements).slides, a2 = n3.list, s2 = [];
    function i2() {
      f2.forEach(function(n4, t4) {
        d2(n4, t4, -1);
      });
    }
    function l2() {
      h2(function(n4) {
        n4.destroy();
      }), D(s2);
    }
    function d2(n4, t4, i3) {
      t4 = Rt(r3, t4, i3, n4);
      t4.mount(), s2.push(t4), s2.sort(function(n5, t5) {
        return n5.index - t5.index;
      });
    }
    function v2(n4) {
      return n4 ? p2(function(n5) {
        return !n5.isClone;
      }) : s2;
    }
    function h2(n4, t4) {
      v2(t4).forEach(n4);
    }
    function p2(t4) {
      return s2.filter(x(t4) ? t4 : function(n4) {
        return C(t4) ? cn(n4.slide, t4) : b(y(t4), n4.index);
      });
    }
    return { mount: function() {
      i2(), t3(J, l2), t3(J, i2);
    }, destroy: l2, update: function() {
      h2(function(n4) {
        n4.update();
      });
    }, register: d2, get: v2, getIn: function(n4) {
      var t4 = o2.Controller, i3 = t4.toIndex(n4), r4 = t4.hasFocus() ? 1 : u2.perPage;
      return p2(function(n5) {
        return En(n5.index, i3, i3 + r4 - 1);
      });
    }, getAt: function(n4) {
      return p2(n4)[0];
    }, add: function(n4, o3) {
      g(n4, function(n5) {
        var t4, i3, r4;
        m(n5 = C(n5) ? hn(n5) : n5) && ((t4 = f2[o3]) ? O(n5, t4) : L(a2, n5), M(n5, u2.classes.slide), t4 = n5, i3 = R(e2, jn), t4 = gn(t4, "img"), (r4 = t4.length) ? t4.forEach(function(n6) {
          c2(n6, "load error", function() {
            --r4 || i3();
          });
        }) : i3());
      }), e2(J);
    }, remove: function(n4) {
      T(p2(n4).map(function(n5) {
        return n5.slide;
      })), e2(J);
    }, forEach: h2, filter: p2, style: function(t4, i3, r4) {
      h2(function(n4) {
        n4.style(t4, i3, r4);
      });
    }, getLength: function(n4) {
      return (n4 ? f2 : s2).length;
    }, isEnough: function() {
      return s2.length > u2.perPage;
    } };
  }, Layout: function(t3, n3, i2) {
    var r3, o2, u2, e2 = (a2 = Q(t3)).on, c2 = a2.bind, f2 = a2.emit, a2 = n3.Slides, s2 = n3.Direction.resolve, l2 = (n3 = n3.Elements).root, d2 = n3.track, v2 = n3.list, h2 = a2.getAt, p2 = a2.style;
    function g2() {
      r3 = i2.direction === Jn, _(l2, "maxWidth", W(i2.width)), _(d2, s2("paddingLeft"), y2(false)), _(d2, s2("paddingRight"), y2(true)), m2(true);
    }
    function m2(n4) {
      var t4 = N(l2);
      !n4 && o2.width === t4.width && o2.height === t4.height || (_(d2, "height", (function() {
        var n5 = "";
        r3 && (bn(n5 = b2(), "height or heightRatio is missing."), n5 = "calc(" + n5 + " - " + y2(false) + " - " + y2(true) + ")");
        return n5;
      })()), p2(s2("marginRight"), W(i2.gap)), p2("width", i2.autoWidth ? null : W(i2.fixedWidth) || (r3 ? "" : w2())), p2("height", W(i2.fixedHeight) || (r3 ? i2.autoHeight ? null : w2() : b2()), true), o2 = t4, f2(Nn), u2 !== (u2 = O2()) && (A(l2, Ot, u2), f2("overflow", u2)));
    }
    function y2(n4) {
      var t4 = i2.padding, n4 = s2(n4 ? "right" : "left");
      return t4 && W(t4[n4] || (un(t4) ? 0 : t4)) || "0px";
    }
    function b2() {
      return W(i2.height || N(v2).width * i2.heightRatio);
    }
    function w2() {
      var n4 = W(i2.gap);
      return "calc((100%" + (n4 && " + " + n4) + ")/" + (i2.perPage || 1) + (n4 && " - " + n4) + ")";
    }
    function x2() {
      return N(v2)[s2("width")];
    }
    function k2(n4, t4) {
      n4 = h2(n4 || 0);
      return n4 ? N(n4.slide)[s2("width")] + (t4 ? 0 : L2()) : 0;
    }
    function S2(n4, t4) {
      var i3, n4 = h2(n4);
      return n4 ? (n4 = N(n4.slide)[s2("right")], i3 = N(v2)[s2("left")], U(n4 - i3) + (t4 ? 0 : L2())) : 0;
    }
    function E2(n4) {
      return S2(t3.length - 1) - S2(0) + k2(0, n4);
    }
    function L2() {
      var n4 = h2(0);
      return n4 && parseFloat(_(n4.slide, s2("marginRight"))) || 0;
    }
    function O2() {
      return t3.is(It) || E2(true) > x2();
    }
    return { mount: function() {
      var n4, t4, i3;
      g2(), c2(window, "resize load", (n4 = R(f2, jn), i3 = qn(t4 || 0, n4, null, 1), function() {
        i3.isPaused() && i3.start();
      })), e2([K, J], g2), e2(jn, m2);
    }, resize: m2, listSize: x2, slideSize: k2, sliderSize: E2, totalSize: S2, getPadding: function(n4) {
      return parseFloat(_(d2, s2("padding" + (n4 ? "Right" : "Left")))) || 0;
    }, isOverflow: O2 };
  }, Clones: function(c2, i2, f2) {
    var t3, r3 = Q(c2), n3 = r3.on, a2 = i2.Elements, s2 = i2.Slides, o2 = i2.Direction.resolve, l2 = [];
    function u2() {
      if (n3(J, d2), n3([K, jn], v2), t3 = h2()) {
        var o3 = t3, u3 = s2.get().slice(), e3 = u3.length;
        if (e3) {
          for (; u3.length < o3; ) k(u3, u3);
          k(u3.slice(-o3), u3.slice(0, o3)).forEach(function(n4, t4) {
            var i3 = t4 < o3, r4 = (function(n5, t5) {
              n5 = n5.cloneNode(true);
              return M(n5, f2.classes.clone), n5.id = c2.root.id + "-clone" + An(t5 + 1), n5;
            })(n4.slide, t4);
            i3 ? O(r4, u3[0].slide) : L(a2.list, r4), k(l2, r4), s2.register(r4, t4 - o3 + (i3 ? 0 : e3), n4.index);
          });
        }
        i2.Layout.resize(true);
      }
    }
    function d2() {
      e2(), u2();
    }
    function e2() {
      T(l2), D(l2), r3.destroy();
    }
    function v2() {
      var n4 = h2();
      t3 !== n4 && (t3 < n4 || !n4) && r3.emit(J);
    }
    function h2() {
      var n4, t4 = f2.clones;
      return c2.is(Pt) ? en(t4) && (t4 = (n4 = f2[o2("fixedWidth")] && i2.Layout.slideSize(0)) && kn(N(a2.track)[o2("width")] / n4) || f2[o2("autoWidth")] && c2.length || 2 * f2.perPage) : t4 = 0, t4;
    }
    return { mount: u2, destroy: e2 };
  }, Move: function(r3, c2, o2) {
    var e2, n3 = Q(r3), t3 = n3.on, f2 = n3.emit, a2 = r3.state.set, u2 = (n3 = c2.Layout).slideSize, i2 = n3.getPadding, s2 = n3.totalSize, l2 = n3.listSize, d2 = n3.sliderSize, v2 = (n3 = c2.Direction).resolve, h2 = n3.orient, p2 = (n3 = c2.Elements).list, g2 = n3.track;
    function m2() {
      c2.Controller.isBusy() || (c2.Scroll.cancel(), y2(r3.index), c2.Slides.update());
    }
    function y2(n4) {
      b2(S2(n4, true));
    }
    function b2(n4, t4) {
      r3.is(It) || (t4 = t4 ? n4 : (function(n5) {
        {
          var t5, i3;
          r3.is(Pt) && (t5 = k2(n5), i3 = t5 > c2.Controller.getEnd(), (t5 < 0 || i3) && (n5 = w2(n5, i3)));
        }
        return n5;
      })(n4), _(p2, "transform", "translate" + v2("X") + "(" + t4 + "px)"), n4 !== t4 && f2(Un));
    }
    function w2(n4, t4) {
      var i3 = n4 - L2(t4), r4 = d2();
      return n4 -= h2(r4 * (kn(U(i3) / r4) || 1)) * (t4 ? 1 : -1);
    }
    function x2() {
      b2(E2(), true), e2.cancel();
    }
    function k2(n4) {
      for (var t4 = c2.Slides.get(), i3 = 0, r4 = 1 / 0, o3 = 0; o3 < t4.length; o3++) {
        var u3 = t4[o3].index, e3 = U(S2(u3, true) - n4);
        if (!(e3 <= r4)) break;
        r4 = e3, i3 = u3;
      }
      return i3;
    }
    function S2(n4, t4) {
      var i3 = h2(s2(n4 - 1) - (n4 = n4, "center" === (i3 = o2.focus) ? (l2() - u2(n4, true)) / 2 : +i3 * u2(n4) || 0));
      return t4 ? (n4 = i3, n4 = o2.trimSpace && r3.is(Mt) ? q(n4, 0, h2(d2(true) - l2())) : n4) : i3;
    }
    function E2() {
      var n4 = v2("left");
      return N(p2)[n4] - N(g2)[n4] + h2(i2(false));
    }
    function L2(n4) {
      return S2(n4 ? c2.Controller.getEnd() : 0, !!o2.trimSpace);
    }
    return { mount: function() {
      e2 = c2.Transition, t3([B, Nn, K, J], m2);
    }, move: function(n4, t4, i3, r4) {
      var o3, u3;
      n4 !== t4 && (o3 = i3 < n4, u3 = h2(w2(E2(), o3)), o3 ? 0 <= u3 : u3 <= p2[v2("scrollWidth")] - N(g2)[v2("width")]) && (x2(), b2(w2(E2(), i3 < n4), true)), a2(G), f2(H, t4, i3, n4), e2.start(t4, function() {
        a2(3), f2(Dn, t4, i3, n4), r4 && r4();
      });
    }, jump: y2, translate: b2, shift: w2, cancel: x2, toIndex: k2, toPosition: S2, getPosition: E2, getLimit: L2, exceededLimit: function(n4, t4) {
      t4 = en(t4) ? E2() : t4;
      var i3 = true !== n4 && h2(t4) < h2(L2(false)), n4 = false !== n4 && h2(t4) > h2(L2(true));
      return i3 || n4;
    }, reposition: m2 };
  }, Controller: function(o2, u2, e2) {
    var c2, f2, a2, s2, n3 = Q(o2), t3 = n3.on, i2 = n3.emit, l2 = u2.Move, d2 = l2.getPosition, r3 = l2.getLimit, v2 = l2.toPosition, h2 = (n3 = u2.Slides).isEnough, p2 = n3.getLength, g2 = e2.omitEnd, m2 = o2.is(Pt), y2 = o2.is(Mt), b2 = R(L2, false), w2 = R(L2, true), x2 = e2.start || 0, k2 = x2;
    function S2() {
      f2 = p2(true), a2 = e2.perMove, s2 = e2.perPage, c2 = _2();
      var n4 = q(x2, 0, g2 ? c2 : f2 - 1);
      n4 !== x2 && (x2 = n4, l2.reposition());
    }
    function E2() {
      c2 !== _2() && i2("ei");
    }
    function L2(n4, t4) {
      var i3 = a2 || (P2() ? 1 : s2), i3 = O2(x2 + i3 * (n4 ? -1 : 1), x2, !(a2 || P2()));
      return -1 === i3 && y2 && !Sn(d2(), r3(!n4), 1) ? n4 ? 0 : c2 : t4 ? i3 : A2(i3);
    }
    function O2(n4, t4, i3) {
      var r4;
      return h2() || P2() ? ((r4 = (function(n5) {
        if (y2 && "move" === e2.trimSpace && n5 !== x2) for (var t5 = d2(); t5 === v2(n5, true) && En(n5, 0, o2.length - 1, !e2.rewind); ) n5 < x2 ? --n5 : ++n5;
        return n5;
      })(n4)) !== n4 && (t4 = n4, n4 = r4, i3 = false), n4 < 0 || c2 < n4 ? n4 = a2 || !En(0, n4, t4, true) && !En(c2, t4, n4, true) ? m2 ? i3 ? n4 < 0 ? -(f2 % s2 || s2) : f2 : n4 : e2.rewind ? n4 < 0 ? c2 : 0 : -1 : z2(D2(n4)) : i3 && n4 !== t4 && (n4 = z2(D2(t4) + (n4 < t4 ? -1 : 1)))) : n4 = -1, n4;
    }
    function A2(n4) {
      return m2 ? (n4 + f2) % f2 || 0 : n4;
    }
    function _2() {
      for (var n4 = f2 - (P2() || m2 && a2 ? 1 : s2); g2 && 0 < n4--; ) if (v2(f2 - 1, true) !== v2(n4, true)) {
        n4++;
        break;
      }
      return q(n4, 0, f2 - 1);
    }
    function z2(n4) {
      return q(P2() ? n4 : s2 * n4, 0, c2);
    }
    function D2(n4) {
      return P2() ? Y(n4, c2) : xn((c2 <= n4 ? f2 - 1 : n4) / s2);
    }
    function M2(n4) {
      n4 !== x2 && (k2 = x2, x2 = n4);
    }
    function P2() {
      return !en(e2.focus) || e2.isNavigation;
    }
    function I2() {
      return o2.state.is([G, rn]) && !!e2.waitForTransition;
    }
    return { mount: function() {
      S2(), t3([K, J, "ei"], S2), t3(Nn, E2);
    }, go: function(n4, t4, i3) {
      var r4;
      I2() || -1 < (r4 = A2(n4 = (function(n5) {
        var t5 = x2;
        {
          var i4, r5;
          C(n5) ? (r5 = n5.match(/([+\-<>])(\d+)?/) || [], i4 = r5[1], r5 = r5[2], "+" === i4 || "-" === i4 ? t5 = O2(x2 + +("" + i4 + (+r5 || 1)), x2) : ">" === i4 ? t5 = r5 ? z2(+r5) : b2(true) : "<" === i4 && (t5 = w2(true))) : t5 = m2 ? n5 : q(n5, 0, c2);
        }
        return t5;
      })(n4))) && (t4 || r4 !== x2) && (M2(r4), l2.move(n4, r4, k2, i3));
    }, scroll: function(n4, t4, i3, r4) {
      u2.Scroll.scroll(n4, t4, i3, function() {
        var n5 = A2(l2.toIndex(d2()));
        M2(g2 ? Y(n5, c2) : n5), r4 && r4();
      });
    }, getNext: b2, getPrev: w2, getAdjacent: L2, getEnd: _2, setIndex: M2, getIndex: function(n4) {
      return n4 ? k2 : x2;
    }, toIndex: z2, toPage: D2, toDest: function(n4) {
      return n4 = l2.toIndex(n4), y2 ? q(n4, 0, c2) : n4;
    }, hasFocus: P2, isBusy: I2 };
  }, Arrows: function(o2, n3, t3) {
    var i2, r3, u2 = Q(o2), e2 = u2.on, c2 = u2.bind, f2 = u2.emit, a2 = t3.classes, s2 = t3.i18n, l2 = n3.Elements, d2 = n3.Controller, v2 = l2.arrows, h2 = l2.track, p2 = v2, g2 = l2.prev, m2 = l2.next, y2 = {};
    function b2() {
      var n4 = t3.arrows;
      !n4 || g2 && m2 || (p2 = v2 || j("div", a2.arrows), g2 = S2(true), m2 = S2(false), i2 = true, L(p2, [g2, m2]), v2 || O(p2, h2)), g2 && m2 && (an(y2, { prev: g2, next: m2 }), ln(p2, n4 ? "" : "none"), M(p2, r3 = dt + "--" + t3.direction), n4 && (e2([B, Dn, J, V, "ei"], E2), c2(m2, "click", R(k2, ">")), c2(g2, "click", R(k2, "<")), E2(), I([g2, m2], Kn, h2.id), f2("arrows:mounted", g2, m2))), e2(K, w2);
    }
    function w2() {
      x2(), b2();
    }
    function x2() {
      u2.destroy(), X(p2, r3), i2 ? (T(v2 ? [g2, m2] : p2), g2 = m2 = null) : P([g2, m2], ut);
    }
    function k2(n4) {
      d2.go(n4, true);
    }
    function S2(n4) {
      return hn('<button class="' + a2.arrow + " " + (n4 ? a2.prev : a2.next) + '" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="' + (t3.arrowPath || "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z") + '" />');
    }
    function E2() {
      var n4, t4, i3, r4;
      g2 && m2 && (r4 = o2.index, n4 = d2.getPrev(), t4 = d2.getNext(), i3 = -1 < n4 && r4 < n4 ? s2.last : s2.prev, r4 = -1 < t4 && t4 < r4 ? s2.first : s2.next, g2.disabled = n4 < 0, m2.disabled = t4 < 0, I(g2, nn, i3), I(m2, nn, r4), f2("arrows:updated", g2, m2, n4, t4));
    }
    return { arrows: y2, mount: b2, destroy: x2, update: E2 };
  }, Autoplay: function(n3, t3, i2) {
    var r3, o2, u2 = Q(n3), e2 = u2.on, c2 = u2.bind, f2 = u2.emit, a2 = qn(i2.interval, n3.go.bind(n3, ">"), function(n4) {
      var t4 = l2.bar;
      t4 && _(t4, "width", 100 * n4 + "%"), f2("autoplay:playing", n4);
    }), s2 = a2.isPaused, l2 = t3.Elements, d2 = (u2 = t3.Elements).root, v2 = u2.toggle, h2 = i2.autoplay, p2 = "pause" === h2;
    function g2() {
      s2() && t3.Slides.isEnough() && (a2.start(!i2.resetProgress), o2 = r3 = p2 = false, b2(), f2(Fn));
    }
    function m2(n4) {
      p2 = !!(n4 = void 0 === n4 ? true : n4), b2(), s2() || (a2.pause(), f2(Xn));
    }
    function y2() {
      p2 || (r3 || o2 ? m2(false) : g2());
    }
    function b2() {
      v2 && (A(v2, tn, !p2), I(v2, nn, i2.i18n[p2 ? "play" : "pause"]));
    }
    function w2(n4) {
      n4 = t3.Slides.getAt(n4);
      a2.set(n4 && +z(n4.slide, Ct) || i2.interval);
    }
    return { mount: function() {
      h2 && (i2.pauseOnHover && c2(d2, "mouseenter mouseleave", function(n4) {
        r3 = "mouseenter" === n4.type, y2();
      }), i2.pauseOnFocus && c2(d2, "focusin focusout", function(n4) {
        o2 = "focusin" === n4.type, y2();
      }), v2 && c2(v2, "click", function() {
        p2 ? g2() : m2(true);
      }), e2([H, Tn, J], a2.rewind), e2(H, w2), v2 && I(v2, Kn, l2.track.id), p2 || g2(), b2());
    }, destroy: a2.cancel, play: g2, pause: m2, isPaused: s2 };
  }, Cover: function(n3, t3, i2) {
    var r3 = Q(n3).on;
    function o2(i3) {
      t3.Slides.forEach(function(n4) {
        var t4 = fn(n4.container || n4.slide, "img");
        t4 && t4.src && u2(i3, t4, n4);
      });
    }
    function u2(n4, t4, i3) {
      i3.style("background", n4 ? 'center/cover no-repeat url("' + t4.src + '")' : "", true), ln(t4, n4 ? "none" : "");
    }
    return { mount: function() {
      i2.cover && (r3(Wn, R(u2, true)), r3([B, K, J], R(o2, true)));
    }, destroy: R(o2, false) };
  }, Scroll: function(n3, c2, u2) {
    var f2, a2, t3 = Q(n3), i2 = t3.on, s2 = t3.emit, l2 = n3.state.set, d2 = c2.Move, v2 = d2.getPosition, e2 = d2.getLimit, h2 = d2.exceededLimit, p2 = d2.translate, g2 = n3.is(Mt), m2 = 1;
    function y2(n4, t4, i3, r4, o2) {
      var u3, e3 = v2(), i3 = (x2(), !i3 || g2 && h2() || (i3 = c2.Layout.sliderSize(), u3 = Ln(n4) * i3 * xn(U(n4) / i3) || 0, n4 = d2.toPosition(c2.Controller.toDest(n4 % i3)) + u3), Sn(e3, n4, 1));
      m2 = 1, t4 = i3 ? 0 : t4 || wn(U(n4 - e3) / 1.5, 800), a2 = r4, f2 = qn(t4, b2, R(w2, e3, n4, o2), 1), l2(rn), s2(Tn), f2.start();
    }
    function b2() {
      l2(3), a2 && a2(), s2(V);
    }
    function w2(n4, t4, i3, r4) {
      var o2 = v2(), r4 = (n4 + (t4 - n4) * (t4 = r4, (n4 = u2.easingFunc) ? n4(t4) : 1 - Math.pow(1 - t4, 4)) - o2) * m2;
      p2(o2 + r4), g2 && !i3 && h2() && (m2 *= 0.6, U(r4) < 10 && y2(e2(h2(true)), 600, false, a2, true));
    }
    function x2() {
      f2 && f2.cancel();
    }
    function r3() {
      f2 && !f2.isPaused() && (x2(), b2());
    }
    return { mount: function() {
      i2(H, x2), i2([K, J], r3);
    }, destroy: x2, scroll: y2, cancel: r3 };
  }, Drag: function(e2, o2, c2) {
    var f2, t3, u2, a2, s2, l2, d2, v2, n3 = Q(e2), i2 = n3.on, h2 = n3.emit, p2 = n3.bind, g2 = n3.unbind, m2 = e2.state, y2 = o2.Move, b2 = o2.Scroll, w2 = o2.Controller, x2 = o2.Elements.track, k2 = o2.Media.reduce, r3 = (n3 = o2.Direction).resolve, S2 = n3.orient, E2 = y2.getPosition, L2 = y2.exceededLimit, O2 = false;
    function j2() {
      var n4 = c2.drag;
      C2(!n4), a2 = "free" === n4;
    }
    function N2(n4) {
      var t4, i3, r4;
      l2 = false, d2 || (t4 = R2(n4), i3 = n4.target, r4 = c2.noDrag, cn(i3, "." + mt + ", ." + vt) || r4 && cn(i3, r4) || !t4 && n4.button || (w2.isBusy() ? F(n4, true) : (v2 = t4 ? x2 : window, s2 = m2.is([G, rn]), u2 = null, p2(v2, zt, A2, jt), p2(v2, Dt, _2, jt), y2.cancel(), b2.cancel(), z2(n4))));
    }
    function A2(n4) {
      var t4, i3, r4, o3, u3;
      m2.is(6) || (m2.set(6), h2("drag")), n4.cancelable && (s2 ? (y2.translate(f2 + D2(n4) / (O2 && e2.is(Mt) ? 5 : 1)), u3 = 200 < M2(n4), t4 = O2 !== (O2 = L2()), (u3 || t4) && z2(n4), l2 = true, h2("dragging"), F(n4)) : U(D2(u3 = n4)) > U(D2(u3, true)) && (t4 = n4, i3 = c2.dragMinThreshold, r4 = un(i3), o3 = r4 && i3.mouse || 0, r4 = (r4 ? i3.touch : +i3) || 10, s2 = U(D2(t4)) > (R2(t4) ? r4 : o3), F(n4)));
    }
    function _2(n4) {
      var t4, i3, r4;
      m2.is(6) && (m2.set(3), h2("dragged")), s2 && (i3 = (function(n5) {
        return E2() + Ln(n5) * Y(U(n5) * (c2.flickPower || 600), a2 ? 1 / 0 : o2.Layout.listSize() * (c2.flickMaxPages || 1));
      })(t4 = (function(n5) {
        if (e2.is(Pt) || !O2) {
          var t5 = M2(n5);
          if (t5 && t5 < 200) return D2(n5) / t5;
        }
        return 0;
      })(t4 = n4)), r4 = c2.rewind && c2.rewindByDrag, k2(false), a2 ? w2.scroll(i3, 0, c2.snap) : e2.is(It) ? w2.go(S2(Ln(t4)) < 0 ? r4 ? "<" : "-" : r4 ? ">" : "+") : e2.is(Mt) && O2 && r4 ? w2.go(L2(true) ? ">" : "<") : w2.go(w2.toDest(i3), true), k2(true), F(n4)), g2(v2, zt, A2), g2(v2, Dt, _2), s2 = false;
    }
    function T2(n4) {
      !d2 && l2 && F(n4, true);
    }
    function z2(n4) {
      u2 = t3, t3 = n4, f2 = E2();
    }
    function D2(n4, t4) {
      return I2(n4, t4) - I2(P2(n4), t4);
    }
    function M2(n4) {
      return mn(n4) - mn(P2(n4));
    }
    function P2(n4) {
      return t3 === n4 && u2 || t3;
    }
    function I2(n4, t4) {
      return (R2(n4) ? n4.changedTouches[0] : n4)["page" + r3(t4 ? "Y" : "X")];
    }
    function R2(n4) {
      return "undefined" != typeof TouchEvent && n4 instanceof TouchEvent;
    }
    function C2(n4) {
      d2 = n4;
    }
    return { mount: function() {
      p2(x2, zt, on, jt), p2(x2, Dt, on, jt), p2(x2, _t, N2, jt), p2(x2, "click", T2, { capture: true }), p2(x2, "dragstart", F), i2([B, K], j2);
    }, disable: C2, isDragging: function() {
      return s2;
    } };
  }, Keyboard: function(t3, n3, i2) {
    var r3, o2, u2 = Q(t3), e2 = u2.on, c2 = u2.bind, f2 = u2.unbind, a2 = t3.root, s2 = n3.Direction.resolve;
    function l2() {
      var n4 = i2.keyboard;
      n4 && (r3 = "global" === n4 ? window : a2, c2(r3, Gt, h2));
    }
    function d2() {
      f2(r3, Gt);
    }
    function v2() {
      var n4 = o2;
      o2 = true, p(function() {
        o2 = n4;
      });
    }
    function h2(n4) {
      o2 || ((n4 = Tt(n4)) === s2(Bn) ? t3.go("<") : n4 === s2(Hn) && t3.go(">"));
    }
    return { mount: function() {
      l2(), e2(K, d2), e2(K, l2), e2(H, v2);
    }, destroy: d2, disable: function(n4) {
      o2 = n4;
    } };
  }, LazyLoad: function(i2, n3, o2) {
    var t3 = Q(i2), r3 = t3.on, u2 = t3.off, e2 = t3.bind, c2 = t3.emit, f2 = "sequential" === o2.lazyLoad, a2 = [Dn, V], s2 = [];
    function l2() {
      D(s2), n3.Slides.forEach(function(r4) {
        gn(r4.slide, Wt).forEach(function(n4) {
          var t4 = z(n4, Ft), i3 = z(n4, Xt);
          t4 === n4.src && i3 === n4.srcset || (t4 = o2.classes.spinner, t4 = fn(i3 = n4.parentElement, "." + t4) || j("span", t4, i3), s2.push([n4, r4, t4]), n4.src || ln(n4, "none"));
        });
      }), (f2 ? p2 : (u2(a2), r3(a2, d2), d2))();
    }
    function d2() {
      (s2 = s2.filter(function(n4) {
        var t4 = o2.perPage * ((o2.preloadPages || 1) + 1) - 1;
        return !n4[1].isWithin(i2.index, t4) || v2(n4);
      })).length || u2(a2);
    }
    function v2(n4) {
      var t4 = n4[0];
      M(n4[1].slide, Et), e2(t4, "load error", R(h2, n4)), I(t4, "src", z(t4, Ft)), I(t4, "srcset", z(t4, Xt)), P(t4, Ft), P(t4, Xt);
    }
    function h2(n4, t4) {
      var i3 = n4[0], r4 = n4[1];
      X(r4.slide, Et), "error" !== t4.type && (T(n4[2]), ln(i3, ""), c2(Wn, i3, r4), c2(jn)), f2 && p2();
    }
    function p2() {
      s2.length && v2(s2.shift());
    }
    return { mount: function() {
      o2.lazyLoad && (l2(), r3(J, l2));
    }, destroy: R(D, s2), check: d2 };
  }, Pagination: function(l2, n3, d2) {
    var v2, h2, t3 = Q(l2), p2 = t3.on, g2 = t3.emit, m2 = t3.bind, y2 = n3.Slides, b2 = n3.Elements, w2 = n3.Controller, x2 = w2.hasFocus, r3 = w2.getIndex, e2 = w2.go, c2 = n3.Direction.resolve, k2 = b2.pagination, S2 = [];
    function E2() {
      v2 && (T(k2 ? o(v2.children) : v2), X(v2, h2), D(S2), v2 = null), t3.destroy();
    }
    function L2(n4) {
      e2(">" + n4, true);
    }
    function O2(n4, t4) {
      var i2 = S2.length, r4 = Tt(t4), o2 = A2(), u2 = -1, o2 = (r4 === c2(Hn, false, o2) ? u2 = ++n4 % i2 : r4 === c2(Bn, false, o2) ? u2 = (--n4 + i2) % i2 : "Home" === r4 ? u2 = 0 : "End" === r4 && (u2 = i2 - 1), S2[u2]);
      o2 && (dn(o2.button), e2(">" + u2), F(t4, true));
    }
    function A2() {
      return d2.paginationDirection || d2.direction;
    }
    function _2(n4) {
      return S2[w2.toPage(n4)];
    }
    function z2() {
      var n4, t4 = _2(r3(true)), i2 = _2(r3());
      t4 && (X(n4 = t4.button, tn), P(n4, Qn), I(n4, $, -1)), i2 && (M(n4 = i2.button, tn), I(n4, Qn, true), I(n4, $, "")), g2("pagination:updated", { list: v2, items: S2 }, t4, i2);
    }
    return { items: S2, mount: function n4() {
      E2(), p2([K, J, "ei"], n4);
      var t4 = d2.pagination;
      if (k2 && ln(k2, t4 ? "" : "none"), t4) {
        p2([H, Tn, V], z2);
        var t4 = l2.length, i2 = d2.classes, r4 = d2.i18n, o2 = d2.perPage, u2 = x2() ? w2.getEnd() + 1 : kn(t4 / o2);
        M(v2 = k2 || j("ul", i2.pagination, b2.track.parentElement), h2 = gt + "--" + A2()), I(v2, Z, "tablist"), I(v2, nn, r4.select), I(v2, nt, A2() === Jn ? "vertical" : "");
        for (var e3 = 0; e3 < u2; e3++) {
          var c3 = j("li", null, v2), f2 = j("button", { class: i2.page, type: "button" }, c3), a2 = y2.getIn(e3).map(function(n5) {
            return n5.slide.id;
          }), s2 = !x2() && 1 < o2 ? r4.pageX : r4.slideX;
          m2(f2, "click", R(L2, e3)), d2.paginationKeyboard && m2(f2, "keydown", R(O2, e3)), I(c3, Z, "presentation"), I(f2, Z, "tab"), I(f2, Kn, a2.join(" ")), I(f2, nn, On(s2, e3 + 1)), I(f2, $, -1), S2.push({ li: c3, button: f2, page: e3 });
        }
        z2(), g2("pagination:mounted", { list: v2, items: S2 }, _2(l2.index));
      }
    }, destroy: E2, getAt: _2, update: z2 };
  }, Sync: function(i2, n3, t3) {
    var r3 = t3.isNavigation, o2 = t3.slideFocus, u2 = [];
    function e2() {
      var n4, t4;
      i2.splides.forEach(function(n5) {
        n5.isParent || (f2(i2, n5.splide), f2(n5.splide, i2));
      }), r3 && (n4 = Q(i2), (t4 = n4.on)(Mn, s2), t4(Yn, l2), t4([B, K], a2), u2.push(n4), n4.emit(Gn, i2.splides));
    }
    function c2() {
      u2.forEach(function(n4) {
        n4.destroy();
      }), D(u2);
    }
    function f2(n4, r4) {
      n4 = Q(n4);
      n4.on(H, function(n5, t4, i3) {
        r4.go(r4.is(Pt) ? i3 : n5);
      }), u2.push(n4);
    }
    function a2() {
      I(n3.Elements.list, nt, t3.direction === Jn ? "vertical" : "");
    }
    function s2(n4) {
      i2.go(n4.index);
    }
    function l2(n4, t4) {
      b(Yt, Tt(t4)) && (s2(n4), F(t4));
    }
    return { setup: R(n3.Media.set, { slideFocus: en(o2) ? r3 : o2 }, true), mount: e2, destroy: c2, remount: function() {
      c2(), e2();
    } };
  }, Wheel: function(e2, c2, f2) {
    var n3 = Q(e2).bind, a2 = 0;
    function t3(n4) {
      var t4, i2, r3, o2, u2;
      n4.cancelable && (t4 = (u2 = n4.deltaY) < 0, i2 = mn(n4), r3 = f2.wheelMinThreshold || 0, o2 = f2.wheelSleep || 0, U(u2) > r3 && o2 < i2 - a2 && (e2.go(t4 ? "<" : ">"), a2 = i2), u2 = t4, f2.releaseWheel && !e2.state.is(G) && -1 === c2.Controller.getAdjacent(u2) || F(n4));
    }
    return { mount: function() {
      f2.wheel && n3(c2.Elements.track, "wheel", t3, jt);
    } };
  }, Live: function(n3, t3, i2) {
    var r3 = Q(n3).on, o2 = t3.Elements.track, u2 = i2.live && !i2.isNavigation, e2 = j("span", wt), c2 = qn(90, R(f2, false));
    function f2(n4) {
      I(o2, rt, n4), n4 ? (L(o2, e2), c2.start()) : (T(e2), c2.cancel());
    }
    function a2(n4) {
      u2 && I(o2, it, n4 ? "off" : "polite");
    }
    return { mount: function() {
      u2 && (a2(!t3.Autoplay.isPaused()), I(o2, ot, true), e2.textContent = "\u2026", r3(Fn, R(a2, true)), r3(Xn, R(a2, false)), r3([Dn, V], R(f2, true)));
    }, disable: a2, destroy: function() {
      P(o2, [it, ot, rt]), T(e2);
    } };
  } }), qt = { type: "slide", role: "region", speed: 400, perPage: 1, cloneStatus: true, arrows: true, pagination: true, paginationKeyboard: true, interval: 5e3, pauseOnHover: true, pauseOnFocus: true, resetProgress: true, easing: "cubic-bezier(0.25, 1, 0.5, 1)", drag: true, direction: "ltr", trimSpace: true, focusableNodes: "a, button, textarea, input, select, iframe", live: true, classes: { slide: at, clone: st, arrows: dt, arrow: vt, prev: ht, next: pt, pagination: gt, page: mt, spinner: i + "spinner" }, i18n: { prev: "Previous slide", next: "Next slide", first: "Go to first slide", last: "Go to last slide", slideX: "Go to slide %s", pageX: "Go to page %s", play: "Start autoplay", pause: "Pause autoplay", carousel: "carousel", slide: "slide", select: "Select a slide to show", slideLabel: "%s of %s" }, reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: "pause" } };
  function Bt(n3, t3, i2) {
    var r3 = t3.Slides;
    function o2() {
      r3.forEach(function(n4) {
        n4.style("transform", "translateX(-" + 100 * n4.index + "%)");
      });
    }
    return { mount: function() {
      Q(n3).on([B, J], o2);
    }, start: function(n4, t4) {
      r3.style("transition", "opacity " + i2.speed + "ms " + i2.easing), p(t4);
    }, cancel: on };
  }
  function Ht(u2, n3, e2) {
    var c2, f2 = n3.Move, a2 = n3.Controller, s2 = n3.Scroll, t3 = n3.Elements.list, l2 = R(_, t3, "transition");
    function i2() {
      l2(""), s2.cancel();
    }
    return { mount: function() {
      Q(u2).bind(t3, "transitionend", function(n4) {
        n4.target === t3 && c2 && (i2(), c2());
      });
    }, start: function(n4, t4) {
      var i3 = f2.toPosition(n4, true), r3 = f2.getPosition(), o2 = (function(n5) {
        var t5 = e2.rewindSpeed;
        if (u2.is(Mt) && t5) {
          var i4 = a2.getIndex(true), r4 = a2.getEnd();
          if (0 === i4 && r4 <= n5 || r4 <= i4 && 0 === n5) return t5;
        }
        return e2.speed;
      })(n4);
      1 <= U(i3 - r3) && 1 <= o2 ? e2.useScroll ? s2.scroll(i3, o2, false, t4) : (l2("transform " + o2 + "ms " + e2.easing), f2.translate(i3, true), c2 = t4) : (f2.jump(n4), t4());
    }, cancel: i2 };
  }
  t2 = (function() {
    function i2(n4, t3) {
      this.event = Q(), this.Components = {}, this.state = s(1), this.splides = [], this.n = {}, this.t = {};
      n4 = C(n4) ? pn(document, n4) : n4;
      bn(n4, n4 + " is invalid."), t3 = d({ label: z(this.root = n4, nn) || "", labelledby: z(n4, Zn) || "" }, qt, i2.defaults, t3 || {});
      try {
        d(t3, JSON.parse(z(n4, f)));
      } catch (n5) {
        bn(false, "Invalid JSON");
      }
      this.n = Object.create(d({}, t3));
    }
    var n3 = i2.prototype;
    return n3.mount = function(n4, t3) {
      var i3 = this, r3 = this.state, o2 = this.Components;
      return bn(r3.is([1, 7]), "Already mounted!"), r3.set(1), this.i = o2, this.r = t3 || this.r || (this.is(It) ? Bt : Ht), this.t = n4 || this.t, w(an({}, Ut, this.t, { Transition: this.r }), function(n5, t4) {
        n5 = n5(i3, o2, i3.n);
        (o2[t4] = n5).setup && n5.setup();
      }), w(o2, function(n5) {
        n5.mount && n5.mount();
      }), this.emit(B), M(this.root, "is-initialized"), r3.set(3), this.emit("ready"), this;
    }, n3.sync = function(n4) {
      return this.splides.push({ splide: n4 }), n4.splides.push({ splide: this, isParent: true }), this.state.is(3) && (this.i.Sync.remount(), n4.Components.Sync.remount()), this;
    }, n3.go = function(n4) {
      return this.i.Controller.go(n4), this;
    }, n3.on = function(n4, t3) {
      return this.event.on(n4, t3), this;
    }, n3.off = function(n4) {
      return this.event.off(n4), this;
    }, n3.emit = function(n4) {
      var t3;
      return (t3 = this.event).emit.apply(t3, [n4].concat(o(arguments, 1))), this;
    }, n3.add = function(n4, t3) {
      return this.i.Slides.add(n4, t3), this;
    }, n3.remove = function(n4) {
      return this.i.Slides.remove(n4), this;
    }, n3.is = function(n4) {
      return this.n.type === n4;
    }, n3.refresh = function() {
      return this.emit(J), this;
    }, n3.destroy = function(t3) {
      void 0 === t3 && (t3 = true);
      var n4 = this.event, i3 = this.state;
      return i3.is(1) ? Q(this).on("ready", this.destroy.bind(this, t3)) : (w(this.i, function(n5) {
        n5.destroy && n5.destroy(t3);
      }, true), n4.emit(a), n4.destroy(), t3 && D(this.splides), i3.set(7)), this;
    }, Jt(i2, [{ key: "options", get: function() {
      return this.n;
    }, set: function(n4) {
      this.i.Media.set(n4, true, true);
    } }, { key: "length", get: function() {
      return this.i.Slides.getLength(true);
    } }, { key: "index", get: function() {
      return this.i.Controller.getIndex();
    } }]), i2;
  })();
  return t2.defaults = {}, t2.STATES = r2, t2;
}, "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (n = "undefined" != typeof globalThis ? globalThis : n || self).Splide = t();
;
(function(global2, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global2.stickySidebar = mod.exports;
  }
})(this, function(exports2) {
  "use strict";
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var StickySidebar = (function() {
    var EVENT_KEY = ".stickySidebar";
    var VERSION = "1.0.1";
    var DEFAULTS = {
      /**
       * Additional top spacing of the element when it becomes sticky.
       * @type {Numeric|Function}
       */
      topSpacing: 0,
      /**
       * Additional bottom spacing of the element when it becomes sticky.
       * @type {Numeric|Function}
       */
      bottomSpacing: 0,
      /**
       * Container sidebar selector to know what the beginning and end of sticky element.
       * @type {String|False}
       */
      containerSelector: false,
      /**
       * Parent element where the scrolling happens.
       */
      scrollContainer: false,
      /**
       * Inner wrapper selector.
       * @type {String}
       */
      innerWrapperSelector: ".inner-wrapper-sticky",
      /**
       * The name of CSS class to apply to elements when they have become stuck.
       * @type {String|False}
       */
      stickyClass: "is-affixed",
      /**
       * The sidebar returns to its normal position if its width below this value.
       * @type {Numeric}
       */
      minWidth: false
    };
    var StickySidebar2 = (function() {
      function StickySidebar3(sidebar) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        _classCallCheck(this, StickySidebar3);
        this.options = StickySidebar3.extend(DEFAULTS, options);
        this.sidebar = "string" === typeof sidebar ? document.querySelector(sidebar) : sidebar;
        if ("undefined" === typeof this.sidebar) throw new Error("There is no specific sidebar element.");
        this.sidebarInner = false;
        this.container = this.sidebar.parentElement;
        this.affixedType = "STATIC";
        this.direction = "down";
        this.support = {
          transform: false,
          transform3d: false
        };
        this._initialized = false;
        this._reStyle = false;
        this._breakpoint = false;
        this.dimensions = {
          translateY: 0,
          maxTranslateY: 0,
          topSpacing: 0,
          lastTopSpacing: 0,
          bottomSpacing: 0,
          lastBottomSpacing: 0,
          sidebarHeight: 0,
          sidebarWidth: 0,
          containerTop: 0,
          containerHeight: 0,
          viewportHeight: 0,
          viewportTop: 0,
          lastViewportTop: 0
        };
        ["handleEvent"].forEach(function(method) {
          _this[method] = _this[method].bind(_this);
        });
        this.initialize();
      }
      _createClass(StickySidebar3, [{
        key: "initialize",
        value: function initialize() {
          var _this2 = this;
          this._setSupportFeatures();
          if (this.options.innerWrapperSelector) {
            this.sidebarInner = this.sidebar.querySelector(this.options.innerWrapperSelector);
            if (null === this.sidebarInner) this.sidebarInner = false;
          }
          if (!this.sidebarInner) {
            var wrapper = document.createElement("div");
            wrapper.setAttribute("class", "inner-wrapper-sticky");
            this.sidebar.appendChild(wrapper);
            while (this.sidebar.firstChild != wrapper) {
              wrapper.appendChild(this.sidebar.firstChild);
            }
            this.sidebarInner = this.sidebar.querySelector(".inner-wrapper-sticky");
          }
          if (this.options.containerSelector) {
            var containers = document.querySelectorAll(this.options.containerSelector);
            containers = Array.prototype.slice.call(containers);
            containers.forEach(function(container, item) {
              if (!container.contains(_this2.sidebar)) return;
              _this2.container = container;
            });
            if (!containers.length) throw new Error("The container does not contains on the sidebar.");
          }
          this.scrollContainer = this.options.scrollContainer ? document.querySelector(this.options.scrollContainer) : void 0;
          if ("function" !== typeof this.options.topSpacing) this.options.topSpacing = parseInt(this.options.topSpacing) || 0;
          if ("function" !== typeof this.options.bottomSpacing) this.options.bottomSpacing = parseInt(this.options.bottomSpacing) || 0;
          this._widthBreakpoint();
          this.calcDimensions();
          this.stickyPosition();
          this.bindEvents();
          this._initialized = true;
        }
      }, {
        key: "bindEvents",
        value: function bindEvents() {
          var _this3 = this;
          this.eventTarget = this.scrollContainer ? this.scrollContainer : window;
          this.eventTarget.addEventListener("resize", this, { passive: true, capture: false });
          this.eventTarget.addEventListener("scroll", this, { passive: true, capture: false });
          this.sidebar.addEventListener("update" + EVENT_KEY, this);
          if ("undefined" !== typeof ResizeObserver) {
            this.resizeObserver = new ResizeObserver(function() {
              return _this3.handleEvent();
            });
            this.resizeObserver.observe(this.sidebarInner);
            this.resizeObserver.observe(this.container);
          }
        }
      }, {
        key: "handleEvent",
        value: function handleEvent(event) {
          this.updateSticky(event);
        }
      }, {
        key: "calcDimensions",
        value: function calcDimensions() {
          if (this._breakpoint) return;
          var dims = this.dimensions;
          dims.containerTop = StickySidebar3.offsetRelative(this.container).top;
          dims.containerHeight = this.container.clientHeight;
          dims.containerBottom = dims.containerTop + dims.containerHeight;
          dims.sidebarHeight = this.sidebarInner.offsetHeight;
          dims.sidebarWidth = this.sidebarInner.offsetWidth;
          dims.viewportHeight = window.innerHeight;
          dims.maxTranslateY = dims.containerHeight - dims.sidebarHeight;
          this._calcDimensionsWithScroll();
        }
      }, {
        key: "_calcDimensionsWithScroll",
        value: function _calcDimensionsWithScroll() {
          var dims = this.dimensions;
          var lastViewportLeft = dims.viewportLeft;
          dims.sidebarLeft = StickySidebar3.offsetRelative(this.sidebar).left;
          if (this.scrollContainer) {
            dims.viewportTop = this.scrollContainer.scrollTop;
            dims.viewportLeft = this.scrollContainer.scrollLeft;
          } else {
            dims.viewportTop = document.documentElement.scrollTop || document.body.scrollTop;
            dims.viewportLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
          }
          dims.viewportBottom = dims.viewportTop + dims.viewportHeight;
          dims.topSpacing = this.options.topSpacing;
          dims.bottomSpacing = this.options.bottomSpacing;
          if ("function" === typeof dims.topSpacing) dims.topSpacing = parseInt(dims.topSpacing(this.sidebar)) || 0;
          if ("function" === typeof dims.bottomSpacing) dims.bottomSpacing = parseInt(dims.bottomSpacing(this.sidebar)) || 0;
          if ("VIEWPORT-TOP" === this.affixedType) {
            if (dims.topSpacing < dims.lastTopSpacing) {
              dims.translateY += dims.lastTopSpacing - dims.topSpacing;
              this._reStyle = true;
            } else if (lastViewportLeft !== dims.viewportLeft) {
              this._reStyle = true;
            }
          } else if ("VIEWPORT-BOTTOM" === this.affixedType) {
            if (dims.bottomSpacing < dims.lastBottomSpacing) {
              dims.translateY += dims.lastBottomSpacing - dims.bottomSpacing;
              this._reStyle = true;
            } else if (lastViewportLeft !== dims.viewportLeft) {
              this._reStyle = true;
            }
          }
          dims.lastTopSpacing = dims.topSpacing;
          dims.lastBottomSpacing = dims.bottomSpacing;
        }
      }, {
        key: "isSidebarFitsViewport",
        value: function isSidebarFitsViewport() {
          return this.dimensions.viewportHeight >= this.dimensions.lastBottomSpacing + this.dimensions.lastTopSpacing + this.dimensions.sidebarHeight;
        }
      }, {
        key: "observeScrollDir",
        value: function observeScrollDir() {
          var dims = this.dimensions;
          if (dims.lastViewportTop === dims.viewportTop) return;
          var furthest = "down" === this.direction ? Math.min : Math.max;
          if (dims.viewportTop === furthest(dims.viewportTop, dims.lastViewportTop)) this.direction = "down" === this.direction ? "up" : "down";
        }
      }, {
        key: "getAffixType",
        value: function getAffixType() {
          this._calcDimensionsWithScroll();
          var dims = this.dimensions;
          var colliderTop = dims.viewportTop + dims.topSpacing;
          var affixType = this.affixedType;
          if (colliderTop <= dims.containerTop || dims.containerHeight <= dims.sidebarHeight) {
            dims.translateY = 0;
            affixType = "STATIC";
          } else {
            affixType = "up" === this.direction ? this._getAffixTypeScrollingUp() : this._getAffixTypeScrollingDown();
          }
          dims.translateY = Math.max(0, dims.translateY);
          dims.translateY = Math.min(dims.containerHeight, dims.translateY);
          dims.translateY = Math.round(dims.translateY);
          dims.lastViewportTop = dims.viewportTop;
          return affixType;
        }
      }, {
        key: "_getAffixTypeScrollingDown",
        value: function _getAffixTypeScrollingDown() {
          var dims = this.dimensions;
          var sidebarBottom = dims.sidebarHeight + dims.containerTop;
          var colliderTop = dims.viewportTop + dims.topSpacing;
          var colliderBottom = dims.viewportBottom - dims.bottomSpacing;
          var affixType = this.affixedType;
          if (this.isSidebarFitsViewport()) {
            if (dims.sidebarHeight + colliderTop >= dims.containerBottom) {
              dims.translateY = dims.containerBottom - sidebarBottom;
              affixType = "CONTAINER-BOTTOM";
            } else if (colliderTop >= dims.containerTop) {
              dims.translateY = colliderTop - dims.containerTop;
              affixType = "VIEWPORT-TOP";
            }
          } else {
            if (dims.containerBottom <= colliderBottom) {
              dims.translateY = dims.containerBottom - sidebarBottom;
              affixType = "CONTAINER-BOTTOM";
            } else if (sidebarBottom + dims.translateY <= colliderBottom) {
              dims.translateY = colliderBottom - sidebarBottom;
              affixType = "VIEWPORT-BOTTOM";
            } else if (dims.containerTop + dims.translateY <= colliderTop && 0 !== dims.translateY && dims.maxTranslateY !== dims.translateY) {
              affixType = "VIEWPORT-UNBOTTOM";
            }
          }
          return affixType;
        }
      }, {
        key: "_getAffixTypeScrollingUp",
        value: function _getAffixTypeScrollingUp() {
          var dims = this.dimensions;
          var sidebarBottom = dims.sidebarHeight + dims.containerTop;
          var colliderTop = dims.viewportTop + dims.topSpacing;
          var colliderBottom = dims.viewportBottom - dims.bottomSpacing;
          var affixType = this.affixedType;
          if (colliderTop <= dims.translateY + dims.containerTop) {
            dims.translateY = colliderTop - dims.containerTop;
            affixType = "VIEWPORT-TOP";
          } else if (dims.containerBottom <= colliderBottom) {
            dims.translateY = dims.containerBottom - sidebarBottom;
            affixType = "CONTAINER-BOTTOM";
          } else if (!this.isSidebarFitsViewport()) {
            if (dims.containerTop <= colliderTop && 0 !== dims.translateY && dims.maxTranslateY !== dims.translateY) {
              affixType = "VIEWPORT-UNBOTTOM";
            }
          }
          return affixType;
        }
      }, {
        key: "_getStyle",
        value: function _getStyle(affixType) {
          if ("undefined" === typeof affixType) return;
          var style = { inner: {}, outer: {} };
          var dims = this.dimensions;
          switch (affixType) {
            case "VIEWPORT-TOP":
              style.inner = {
                position: "fixed",
                top: dims.topSpacing,
                left: dims.sidebarLeft - dims.viewportLeft,
                width: dims.sidebarWidth
              };
              break;
            case "VIEWPORT-BOTTOM":
              style.inner = {
                position: "fixed",
                top: "auto",
                left: dims.sidebarLeft - dims.viewportLeft,
                bottom: dims.bottomSpacing,
                width: dims.sidebarWidth
              };
              break;
            case "CONTAINER-BOTTOM":
            case "VIEWPORT-UNBOTTOM":
              var translate = this._getTranslate(0, dims.translateY + "px");
              if (translate) style.inner = { transform: translate };
              else style.inner = { position: "absolute", top: dims.translateY, width: dims.sidebarWidth };
              break;
          }
          switch (affixType) {
            case "VIEWPORT-TOP":
            case "VIEWPORT-BOTTOM":
            case "VIEWPORT-UNBOTTOM":
            case "CONTAINER-BOTTOM":
              style.outer = { height: dims.sidebarHeight, position: "relative" };
              break;
          }
          style.outer = StickySidebar3.extend({ height: "", position: "" }, style.outer);
          style.inner = StickySidebar3.extend({
            position: "relative",
            top: "",
            left: "",
            bottom: "",
            width: "",
            transform: ""
          }, style.inner);
          return style;
        }
      }, {
        key: "stickyPosition",
        value: function stickyPosition(force) {
          if (this._breakpoint) return;
          force = this._reStyle || force || false;
          this._reStyle = false;
          var offsetTop = this.options.topSpacing;
          var offsetBottom = this.options.bottomSpacing;
          var affixType = this.getAffixType();
          var style = this._getStyle(affixType);
          if ((this.affixedType != affixType || force) && affixType) {
            var affixEvent = "affix." + affixType.toLowerCase().replace("viewport-", "") + EVENT_KEY;
            StickySidebar3.eventTrigger(this.sidebar, affixEvent);
            if ("STATIC" === affixType) StickySidebar3.removeClass(this.sidebar, this.options.stickyClass);
            else StickySidebar3.addClass(this.sidebar, this.options.stickyClass);
            for (var key in style.outer) {
              var unit = "number" === typeof style.outer[key] ? "px" : "";
              this.sidebar.style[key] = style.outer[key] + unit;
            }
            for (var _key in style.inner) {
              var _unit = "number" === typeof style.inner[_key] ? "px" : "";
              this.sidebarInner.style[_key] = style.inner[_key] + _unit;
            }
            var affixedEvent = "affixed." + affixType.toLowerCase().replace("viewport-", "") + EVENT_KEY;
            StickySidebar3.eventTrigger(this.sidebar, affixedEvent);
          } else {
            if (this._initialized) this.sidebarInner.style.left = style.inner.left;
          }
          this.affixedType = affixType;
        }
      }, {
        key: "_widthBreakpoint",
        value: function _widthBreakpoint() {
          if (window.innerWidth <= this.options.minWidth) {
            this._breakpoint = true;
            this.affixedType = "STATIC";
            this.sidebar.removeAttribute("style");
            StickySidebar3.removeClass(this.sidebar, this.options.stickyClass);
            this.sidebarInner.removeAttribute("style");
          } else {
            this._breakpoint = false;
          }
        }
      }, {
        key: "updateSticky",
        value: function updateSticky() {
          var _this4 = this;
          var event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          if (this._running) return;
          this._running = true;
          (function(eventType) {
            requestAnimationFrame(function() {
              switch (eventType) {
                // When browser is scrolling and re-calculate just dimensions
                // within scroll.
                case "scroll":
                  _this4._calcDimensionsWithScroll();
                  _this4.observeScrollDir();
                  _this4.stickyPosition();
                  break;
                // When browser is resizing or there's no event, observe width
                // breakpoint and re-calculate dimensions.
                case "resize":
                default:
                  _this4._widthBreakpoint();
                  _this4.calcDimensions();
                  _this4.stickyPosition(true);
                  break;
              }
              _this4._running = false;
            });
          })(event.type);
        }
      }, {
        key: "_setSupportFeatures",
        value: function _setSupportFeatures() {
          var support = this.support;
          support.transform = StickySidebar3.supportTransform();
          support.transform3d = StickySidebar3.supportTransform(true);
        }
      }, {
        key: "_getTranslate",
        value: function _getTranslate() {
          var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
          var z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
          if (this.support.transform3d) return "translate3d(" + y + ", " + x + ", " + z + ")";
          else if (this.support.translate) return "translate(" + y + ", " + x + ")";
          else return false;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          window.removeEventListener("resize", this, { capture: false });
          window.removeEventListener("scroll", this, { capture: false });
          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
          }
          this.sidebar.classList.remove(this.options.stickyClass);
          this.sidebar.style.minHeight = "";
          this.sidebar.removeEventListener("update" + EVENT_KEY, this);
          var styleReset = { inner: {}, outer: {} };
          styleReset.inner = { position: "", top: "", left: "", bottom: "", width: "", transform: "" };
          styleReset.outer = { height: "", position: "" };
          for (var key in styleReset.outer) {
            this.sidebar.style[key] = styleReset.outer[key];
          }
          for (var _key2 in styleReset.inner) {
            this.sidebarInner.style[_key2] = styleReset.inner[_key2];
          }
          if (this.options.resizeSensor && "undefined" !== typeof ResizeSensor) {
            ResizeSensor.detach(this.sidebarInner, this.handleEvent);
            ResizeSensor.detach(this.container, this.handleEvent);
          }
        }
      }], [{
        key: "supportTransform",
        value: function supportTransform(transform3d) {
          var result = false, property = transform3d ? "perspective" : "transform", upper = property.charAt(0).toUpperCase() + property.slice(1), prefixes = ["Webkit", "Moz", "O", "ms"], support = document.createElement("support"), style = support.style;
          (property + " " + prefixes.join(upper + " ") + upper).split(" ").forEach(function(property2, i) {
            if (style[property2] !== void 0) {
              result = property2;
              return false;
            }
          });
          return result;
        }
      }, {
        key: "eventTrigger",
        value: function eventTrigger(element, eventName, data) {
          try {
            var event = new CustomEvent(eventName, { detail: data });
          } catch (e) {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent(eventName, true, true, data);
          }
          element.dispatchEvent(event);
        }
      }, {
        key: "extend",
        value: function extend(defaults, options) {
          var results = {};
          for (var key in defaults) {
            if ("undefined" !== typeof options[key]) results[key] = options[key];
            else results[key] = defaults[key];
          }
          return results;
        }
      }, {
        key: "offsetRelative",
        value: function offsetRelative(element) {
          var result = { left: 0, top: 0 };
          do {
            var offsetTop = element.offsetTop;
            var offsetLeft = element.offsetLeft;
            if (!isNaN(offsetTop)) result.top += offsetTop;
            if (!isNaN(offsetLeft)) result.left += offsetLeft;
            element = "BODY" === element.tagName ? element.parentElement : element.offsetParent;
          } while (element);
          return result;
        }
      }, {
        key: "addClass",
        value: function addClass(element, className) {
          if (!StickySidebar3.hasClass(element, className)) {
            if (element.classList) element.classList.add(className);
            else element.className += " " + className;
          }
        }
      }, {
        key: "removeClass",
        value: function removeClass(element, className) {
          if (StickySidebar3.hasClass(element, className)) {
            if (element.classList) element.classList.remove(className);
            else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
          }
        }
      }, {
        key: "hasClass",
        value: function hasClass(element, className) {
          if (element.classList) return element.classList.contains(className);
          else return new RegExp("(^| )" + className + "( |$)", "gi").test(element.className);
        }
      }, {
        key: "defaults",
        get: function() {
          return DEFAULTS;
        }
      }]);
      return StickySidebar3;
    })();
    return StickySidebar2;
  })();
  exports2.default = StickySidebar;
  window.StickySidebar = StickySidebar;
});
;
!(function(t2, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t2 = t2 || self).window = t2.window || {});
})(this, function(e) {
  "use strict";
  function _inheritsLoose(t3, e2) {
    t3.prototype = Object.create(e2.prototype), (t3.prototype.constructor = t3).__proto__ = e2;
  }
  function _assertThisInitialized(t3) {
    if (void 0 === t3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t3;
  }
  function o(t3) {
    return "string" == typeof t3;
  }
  function p(t3) {
    return "function" == typeof t3;
  }
  function q(t3) {
    return "number" == typeof t3;
  }
  function r2(t3) {
    return void 0 === t3;
  }
  function s(t3) {
    return "object" == typeof t3;
  }
  function t2(t3) {
    return false !== t3;
  }
  function u() {
    return "undefined" != typeof window;
  }
  function v(t3) {
    return p(t3) || o(t3);
  }
  function M(t3) {
    return (h = mt(t3, ot)) && he;
  }
  function N(t3, e2) {
    return console.warn("Invalid property", t3, "set to", e2, "Missing plugin? gsap.registerPlugin()");
  }
  function O(t3, e2) {
    return !e2 && console.warn(t3);
  }
  function P(t3, e2) {
    return t3 && (ot[t3] = e2) && h && (h[t3] = e2) || ot;
  }
  function Q() {
    return 0;
  }
  function $(t3) {
    var e2, r3, i2 = t3[0];
    if (s(i2) || p(i2) || (t3 = [t3]), !(e2 = (i2._gsap || {}).harness)) {
      for (r3 = pt.length; r3-- && !pt[r3].targetTest(i2); ) ;
      e2 = pt[r3];
    }
    for (r3 = t3.length; r3--; ) t3[r3] && (t3[r3]._gsap || (t3[r3]._gsap = new Lt(t3[r3], e2))) || t3.splice(r3, 1);
    return t3;
  }
  function _(t3) {
    return t3._gsap || $(xt(t3))[0]._gsap;
  }
  function aa(t3, e2, i2) {
    return (i2 = t3[e2]) && p(i2) ? t3[e2]() : r2(i2) && t3.getAttribute && t3.getAttribute(e2) || i2;
  }
  function ba(t3, e2) {
    return (t3 = t3.split(",")).forEach(e2) || t3;
  }
  function ca(t3) {
    return Math.round(1e5 * t3) / 1e5 || 0;
  }
  function da(t3) {
    return Math.round(1e7 * t3) / 1e7 || 0;
  }
  function ea(t3, e2) {
    var r3 = e2.charAt(0), i2 = parseFloat(e2.substr(2));
    return t3 = parseFloat(t3), "+" === r3 ? t3 + i2 : "-" === r3 ? t3 - i2 : "*" === r3 ? t3 * i2 : t3 / i2;
  }
  function fa(t3, e2) {
    for (var r3 = e2.length, i2 = 0; t3.indexOf(e2[i2]) < 0 && ++i2 < r3; ) ;
    return i2 < r3;
  }
  function ga() {
    var t3, e2, r3 = ht.length, i2 = ht.slice(0);
    for (lt = {}, t3 = ht.length = 0; t3 < r3; t3++) (e2 = i2[t3]) && e2._lazy && (e2.render(e2._lazy[0], e2._lazy[1], true)._lazy = 0);
  }
  function ha(t3, e2, r3, i2) {
    ht.length && ga(), t3.render(e2, r3, i2), ht.length && ga();
  }
  function ia(t3) {
    var e2 = parseFloat(t3);
    return (e2 || 0 === e2) && (t3 + "").match(at).length < 2 ? e2 : o(t3) ? t3.trim() : t3;
  }
  function ja(t3) {
    return t3;
  }
  function ka(t3, e2) {
    for (var r3 in e2) r3 in t3 || (t3[r3] = e2[r3]);
    return t3;
  }
  function na(t3, e2) {
    for (var r3 in e2) "__proto__" !== r3 && "constructor" !== r3 && "prototype" !== r3 && (t3[r3] = s(e2[r3]) ? na(t3[r3] || (t3[r3] = {}), e2[r3]) : e2[r3]);
    return t3;
  }
  function oa(t3, e2) {
    var r3, i2 = {};
    for (r3 in t3) r3 in e2 || (i2[r3] = t3[r3]);
    return i2;
  }
  function pa(e2) {
    var r3 = e2.parent || I, i2 = e2.keyframes ? /* @__PURE__ */ (function _setKeyframeDefaults(i3) {
      return function(t3, e3) {
        for (var r4 in e3) r4 in t3 || "duration" === r4 && i3 || "ease" === r4 || (t3[r4] = e3[r4]);
      };
    })(J(e2.keyframes)) : ka;
    if (t2(e2.inherit)) for (; r3; ) i2(e2, r3.vars.defaults), r3 = r3.parent || r3._dp;
    return e2;
  }
  function ra(t3, e2, r3, i2, n3) {
    void 0 === r3 && (r3 = "_first"), void 0 === i2 && (i2 = "_last");
    var a2, s2 = t3[i2];
    if (n3) for (a2 = e2[n3]; s2 && s2[n3] > a2; ) s2 = s2._prev;
    return s2 ? (e2._next = s2._next, s2._next = e2) : (e2._next = t3[r3], t3[r3] = e2), e2._next ? e2._next._prev = e2 : t3[i2] = e2, e2._prev = s2, e2.parent = e2._dp = t3, e2;
  }
  function sa(t3, e2, r3, i2) {
    void 0 === r3 && (r3 = "_first"), void 0 === i2 && (i2 = "_last");
    var n3 = e2._prev, a2 = e2._next;
    n3 ? n3._next = a2 : t3[r3] === e2 && (t3[r3] = a2), a2 ? a2._prev = n3 : t3[i2] === e2 && (t3[i2] = n3), e2._next = e2._prev = e2.parent = null;
  }
  function ta(t3, e2) {
    !t3.parent || e2 && !t3.parent.autoRemoveChildren || t3.parent.remove(t3), t3._act = 0;
  }
  function ua(t3, e2) {
    if (t3 && (!e2 || e2._end > t3._dur || e2._start < 0)) for (var r3 = t3; r3; ) r3._dirty = 1, r3 = r3.parent;
    return t3;
  }
  function xa(t3) {
    return t3._repeat ? gt(t3._tTime, t3 = t3.duration() + t3._rDelay) * t3 : 0;
  }
  function za(t3, e2) {
    return (t3 - e2._start) * e2._ts + (0 <= e2._ts ? 0 : e2._dirty ? e2.totalDuration() : e2._tDur);
  }
  function Aa(t3) {
    return t3._end = da(t3._start + (t3._tDur / Math.abs(t3._ts || t3._rts || V) || 0));
  }
  function Ba(t3, e2) {
    var r3 = t3._dp;
    return r3 && r3.smoothChildTiming && t3._ts && (t3._start = da(r3._time - (0 < t3._ts ? e2 / t3._ts : ((t3._dirty ? t3.totalDuration() : t3._tDur) - e2) / -t3._ts)), Aa(t3), r3._dirty || ua(r3, t3)), t3;
  }
  function Ca(t3, e2) {
    var r3;
    if ((e2._time || e2._initted && !e2._dur) && (r3 = za(t3.rawTime(), e2), (!e2._dur || bt(0, e2.totalDuration(), r3) - e2._tTime > V) && e2.render(r3, true)), ua(t3, e2)._dp && t3._initted && t3._time >= t3._dur && t3._ts) {
      if (t3._dur < t3.duration()) for (r3 = t3; r3._dp; ) 0 <= r3.rawTime() && r3.totalTime(r3._tTime), r3 = r3._dp;
      t3._zTime = -V;
    }
  }
  function Da(t3, e2, r3, i2) {
    return e2.parent && ta(e2), e2._start = da((q(r3) ? r3 : r3 || t3 !== I ? Tt(t3, r3, e2) : t3._time) + e2._delay), e2._end = da(e2._start + (e2.totalDuration() / Math.abs(e2.timeScale()) || 0)), ra(t3, e2, "_first", "_last", t3._sort ? "_start" : 0), vt(e2) || (t3._recent = e2), i2 || Ca(t3, e2), t3;
  }
  function Ea(t3, e2) {
    return (ot.ScrollTrigger || N("scrollTrigger", e2)) && ot.ScrollTrigger.create(e2, t3);
  }
  function Fa(t3, e2, r3, i2) {
    return Xt(t3, e2), t3._initted ? !r3 && t3._pt && (t3._dur && false !== t3.vars.lazy || !t3._dur && t3.vars.lazy) && f !== Dt.frame ? (ht.push(t3), t3._lazy = [e2, i2], 1) : void 0 : 1;
  }
  function Ka(t3, e2, r3, i2) {
    var n3 = t3._repeat, a2 = da(e2) || 0, s2 = t3._tTime / t3._tDur;
    return s2 && !i2 && (t3._time *= a2 / t3._dur), t3._dur = a2, t3._tDur = n3 ? n3 < 0 ? 1e10 : da(a2 * (n3 + 1) + t3._rDelay * n3) : a2, 0 < s2 && !i2 ? Ba(t3, t3._tTime = t3._tDur * s2) : t3.parent && Aa(t3), r3 || ua(t3.parent, t3), t3;
  }
  function La(t3) {
    return t3 instanceof Ut ? ua(t3) : Ka(t3, t3._dur);
  }
  function Oa(e2, r3, i2) {
    var n3, a2, s2 = q(r3[1]), o2 = (s2 ? 2 : 1) + (e2 < 2 ? 0 : 1), u2 = r3[o2];
    if (s2 && (u2.duration = r3[1]), u2.parent = i2, e2) {
      for (n3 = u2, a2 = i2; a2 && !("immediateRender" in n3); ) n3 = a2.vars.defaults || {}, a2 = t2(a2.vars.inherit) && a2.parent;
      u2.immediateRender = t2(n3.immediateRender), e2 < 2 ? u2.runBackwards = 1 : u2.startAt = r3[o2 - 1];
    }
    return new $t(r3[0], u2, r3[1 + o2]);
  }
  function Pa(t3, e2) {
    return t3 || 0 === t3 ? e2(t3) : e2;
  }
  function Ra(t3, e2) {
    return o(t3) && (e2 = st.exec(t3)) ? e2[1] : "";
  }
  function Ua(t3, e2) {
    return t3 && s(t3) && "length" in t3 && (!e2 && !t3.length || t3.length - 1 in t3 && s(t3[0])) && !t3.nodeType && t3 !== i;
  }
  function Ya(t3) {
    return t3.sort(function() {
      return 0.5 - Math.random();
    });
  }
  function Za(t3) {
    if (p(t3)) return t3;
    var c2 = s(t3) ? t3 : { each: t3 }, m2 = Bt(c2.ease), g2 = c2.from || 0, v2 = parseFloat(c2.base) || 0, y2 = {}, e2 = 0 < g2 && g2 < 1, T2 = isNaN(g2) || e2, b2 = c2.axis, w2 = g2, x2 = g2;
    return o(g2) ? w2 = x2 = { center: 0.5, edges: 0.5, end: 1 }[g2] || 0 : !e2 && T2 && (w2 = g2[0], x2 = g2[1]), function(t4, e3, r3) {
      var i2, n3, a2, s2, o2, u2, h2, l2, f2, d2 = (r3 || c2).length, _2 = y2[d2];
      if (!_2) {
        if (!(f2 = "auto" === c2.grid ? 0 : (c2.grid || [1, Y])[1])) {
          for (h2 = -Y; h2 < (h2 = r3[f2++].getBoundingClientRect().left) && f2 < d2; ) ;
          f2--;
        }
        for (_2 = y2[d2] = [], i2 = T2 ? Math.min(f2, d2) * w2 - 0.5 : g2 % f2, n3 = f2 === Y ? 0 : T2 ? d2 * x2 / f2 - 0.5 : g2 / f2 | 0, l2 = Y, u2 = h2 = 0; u2 < d2; u2++) a2 = u2 % f2 - i2, s2 = n3 - (u2 / f2 | 0), _2[u2] = o2 = b2 ? Math.abs("y" === b2 ? s2 : a2) : G(a2 * a2 + s2 * s2), h2 < o2 && (h2 = o2), o2 < l2 && (l2 = o2);
        "random" === g2 && Ya(_2), _2.max = h2 - l2, _2.min = l2, _2.v = d2 = (parseFloat(c2.amount) || parseFloat(c2.each) * (d2 < f2 ? d2 - 1 : b2 ? "y" === b2 ? d2 / f2 : f2 : Math.max(f2, d2 / f2)) || 0) * ("edges" === g2 ? -1 : 1), _2.b = d2 < 0 ? v2 - d2 : v2, _2.u = Ra(c2.amount || c2.each) || 0, m2 = m2 && d2 < 0 ? Ft(m2) : m2;
      }
      return d2 = (_2[t4] - _2.min) / _2.max || 0, da(_2.b + (m2 ? m2(d2) : d2) * _2.v) + _2.u;
    };
  }
  function $a(r3) {
    var i2 = Math.pow(10, ((r3 + "").split(".")[1] || "").length);
    return function(t3) {
      var e2 = Math.round(parseFloat(t3) / r3) * r3 * i2;
      return (e2 - e2 % 1) / i2 + (q(t3) ? 0 : Ra(t3));
    };
  }
  function _a(u2, t3) {
    var h2, l2, e2 = J(u2);
    return !e2 && s(u2) && (h2 = e2 = u2.radius || Y, u2.values ? (u2 = xt(u2.values), (l2 = !q(u2[0])) && (h2 *= h2)) : u2 = $a(u2.increment)), Pa(t3, e2 ? p(u2) ? function(t4) {
      return l2 = u2(t4), Math.abs(l2 - t4) <= h2 ? l2 : t4;
    } : function(t4) {
      for (var e3, r3, i2 = parseFloat(l2 ? t4.x : t4), n3 = parseFloat(l2 ? t4.y : 0), a2 = Y, s2 = 0, o2 = u2.length; o2--; ) (e3 = l2 ? (e3 = u2[o2].x - i2) * e3 + (r3 = u2[o2].y - n3) * r3 : Math.abs(u2[o2] - i2)) < a2 && (a2 = e3, s2 = o2);
      return s2 = !h2 || a2 <= h2 ? u2[s2] : t4, l2 || s2 === t4 || q(t4) ? s2 : s2 + Ra(t4);
    } : $a(u2));
  }
  function ab(t3, e2, r3, i2) {
    return Pa(J(t3) ? !e2 : true === r3 ? !!(r3 = 0) : !i2, function() {
      return J(t3) ? t3[~~(Math.random() * t3.length)] : (r3 = r3 || 1e-5) && (i2 = r3 < 1 ? Math.pow(10, (r3 + "").length - 2) : 1) && Math.floor(Math.round((t3 - r3 / 2 + Math.random() * (e2 - t3 + 0.99 * r3)) / r3) * r3 * i2) / i2;
    });
  }
  function eb(e2, r3, t3) {
    return Pa(t3, function(t4) {
      return e2[~~r3(t4)];
    });
  }
  function hb(t3) {
    for (var e2, r3, i2, n3, a2 = 0, s2 = ""; ~(e2 = t3.indexOf("random(", a2)); ) i2 = t3.indexOf(")", e2), n3 = "[" === t3.charAt(e2 + 7), r3 = t3.substr(e2 + 7, i2 - e2 - 7).match(n3 ? at : tt), s2 += t3.substr(a2, e2 - a2) + ab(n3 ? r3 : +r3[0], n3 ? 0 : +r3[1], +r3[2] || 1e-5), a2 = i2 + 1;
    return s2 + t3.substr(a2, t3.length - a2);
  }
  function kb(t3, e2, r3) {
    var i2, n3, a2, s2 = t3.labels, o2 = Y;
    for (i2 in s2) (n3 = s2[i2] - e2) < 0 == !!r3 && n3 && o2 > (n3 = Math.abs(n3)) && (a2 = i2, o2 = n3);
    return a2;
  }
  function mb(t3) {
    return ta(t3), t3.scrollTrigger && t3.scrollTrigger.kill(false), t3.progress() < 1 && Ot(t3, "onInterrupt"), t3;
  }
  function rb(t3, e2, r3) {
    return (6 * (t3 += t3 < 0 ? 1 : 1 < t3 ? -1 : 0) < 1 ? e2 + (r3 - e2) * t3 * 6 : t3 < 0.5 ? r3 : 3 * t3 < 2 ? e2 + (r3 - e2) * (2 / 3 - t3) * 6 : e2) * Pt + 0.5 | 0;
  }
  function sb(t3, e2, r3) {
    var i2, n3, a2, s2, o2, u2, h2, l2, f2, d2, _2 = t3 ? q(t3) ? [t3 >> 16, t3 >> 8 & Pt, t3 & Pt] : 0 : Mt.black;
    if (!_2) {
      if ("," === t3.substr(-1) && (t3 = t3.substr(0, t3.length - 1)), Mt[t3]) _2 = Mt[t3];
      else if ("#" === t3.charAt(0)) {
        if (t3.length < 6 && (t3 = "#" + (i2 = t3.charAt(1)) + i2 + (n3 = t3.charAt(2)) + n3 + (a2 = t3.charAt(3)) + a2 + (5 === t3.length ? t3.charAt(4) + t3.charAt(4) : "")), 9 === t3.length) return [(_2 = parseInt(t3.substr(1, 6), 16)) >> 16, _2 >> 8 & Pt, _2 & Pt, parseInt(t3.substr(7), 16) / 255];
        _2 = [(t3 = parseInt(t3.substr(1), 16)) >> 16, t3 >> 8 & Pt, t3 & Pt];
      } else if ("hsl" === t3.substr(0, 3)) if (_2 = d2 = t3.match(tt), e2) {
        if (~t3.indexOf("=")) return _2 = t3.match(et), r3 && _2.length < 4 && (_2[3] = 1), _2;
      } else s2 = +_2[0] % 360 / 360, o2 = _2[1] / 100, i2 = 2 * (u2 = _2[2] / 100) - (n3 = u2 <= 0.5 ? u2 * (o2 + 1) : u2 + o2 - u2 * o2), 3 < _2.length && (_2[3] *= 1), _2[0] = rb(s2 + 1 / 3, i2, n3), _2[1] = rb(s2, i2, n3), _2[2] = rb(s2 - 1 / 3, i2, n3);
      else _2 = t3.match(tt) || Mt.transparent;
      _2 = _2.map(Number);
    }
    return e2 && !d2 && (i2 = _2[0] / Pt, n3 = _2[1] / Pt, a2 = _2[2] / Pt, u2 = ((h2 = Math.max(i2, n3, a2)) + (l2 = Math.min(i2, n3, a2))) / 2, h2 === l2 ? s2 = o2 = 0 : (f2 = h2 - l2, o2 = 0.5 < u2 ? f2 / (2 - h2 - l2) : f2 / (h2 + l2), s2 = h2 === i2 ? (n3 - a2) / f2 + (n3 < a2 ? 6 : 0) : h2 === n3 ? (a2 - i2) / f2 + 2 : (i2 - n3) / f2 + 4, s2 *= 60), _2[0] = ~~(s2 + 0.5), _2[1] = ~~(100 * o2 + 0.5), _2[2] = ~~(100 * u2 + 0.5)), r3 && _2.length < 4 && (_2[3] = 1), _2;
  }
  function tb(t3) {
    var r3 = [], i2 = [], n3 = -1;
    return t3.split(Ct).forEach(function(t4) {
      var e2 = t4.match(rt) || [];
      r3.push.apply(r3, e2), i2.push(n3 += e2.length + 1);
    }), r3.c = i2, r3;
  }
  function ub(t3, e2, r3) {
    var i2, n3, a2, s2, o2 = "", u2 = (t3 + o2).match(Ct), h2 = e2 ? "hsla(" : "rgba(", l2 = 0;
    if (!u2) return t3;
    if (u2 = u2.map(function(t4) {
      return (t4 = sb(t4, e2, 1)) && h2 + (e2 ? t4[0] + "," + t4[1] + "%," + t4[2] + "%," + t4[3] : t4.join(",")) + ")";
    }), r3 && (a2 = tb(t3), (i2 = r3.c).join(o2) !== a2.c.join(o2))) for (s2 = (n3 = t3.replace(Ct, "1").split(rt)).length - 1; l2 < s2; l2++) o2 += n3[l2] + (~i2.indexOf(l2) ? u2.shift() || h2 + "0,0,0,0)" : (a2.length ? a2 : u2.length ? u2 : r3).shift());
    if (!n3) for (s2 = (n3 = t3.split(Ct)).length - 1; l2 < s2; l2++) o2 += n3[l2] + u2[l2];
    return o2 + n3[s2];
  }
  function xb(t3) {
    var e2, r3 = t3.join(" ");
    if (Ct.lastIndex = 0, Ct.test(r3)) return e2 = At.test(r3), t3[1] = ub(t3[1], e2), t3[0] = ub(t3[0], e2, tb(t3[1])), true;
  }
  function Gb(t3) {
    var e2 = (t3 + "").split("("), r3 = zt[e2[0]];
    return r3 && 1 < e2.length && r3.config ? r3.config.apply(null, ~t3.indexOf("{") ? [(function _parseObjectInString(t4) {
      for (var e3, r4, i2, n3 = {}, a2 = t4.substr(1, t4.length - 3).split(":"), s2 = a2[0], o2 = 1, u2 = a2.length; o2 < u2; o2++) r4 = a2[o2], e3 = o2 !== u2 - 1 ? r4.lastIndexOf(",") : r4.length, i2 = r4.substr(0, e3), n3[s2] = isNaN(i2) ? i2.replace(Et, "").trim() : +i2, s2 = r4.substr(e3 + 1).trim();
      return n3;
    })(e2[1])] : (function _valueInParentheses(t4) {
      var e3 = t4.indexOf("(") + 1, r4 = t4.indexOf(")"), i2 = t4.indexOf("(", e3);
      return t4.substring(e3, ~i2 && i2 < r4 ? t4.indexOf(")", r4 + 1) : r4);
    })(t3).split(",").map(ia)) : zt._CE && Rt.test(t3) ? zt._CE("", t3) : r3;
  }
  function Ib(t3, e2) {
    for (var r3, i2 = t3._first; i2; ) i2 instanceof Ut ? Ib(i2, e2) : !i2.vars.yoyoEase || i2._yoyo && i2._repeat || i2._yoyo === e2 || (i2.timeline ? Ib(i2.timeline, e2) : (r3 = i2._ease, i2._ease = i2._yEase, i2._yEase = r3, i2._yoyo = e2)), i2 = i2._next;
  }
  function Kb(t3, e2, r3, i2) {
    void 0 === r3 && (r3 = function easeOut(t4) {
      return 1 - e2(1 - t4);
    }), void 0 === i2 && (i2 = function easeInOut(t4) {
      return t4 < 0.5 ? e2(2 * t4) / 2 : 1 - e2(2 * (1 - t4)) / 2;
    });
    var n3, a2 = { easeIn: e2, easeOut: r3, easeInOut: i2 };
    return ba(t3, function(t4) {
      for (var e3 in zt[t4] = ot[t4] = a2, zt[n3 = t4.toLowerCase()] = r3, a2) zt[n3 + ("easeIn" === e3 ? ".in" : "easeOut" === e3 ? ".out" : ".inOut")] = zt[t4 + "." + e3] = a2[e3];
    }), a2;
  }
  function Lb(e2) {
    return function(t3) {
      return t3 < 0.5 ? (1 - e2(1 - 2 * t3)) / 2 : 0.5 + e2(2 * (t3 - 0.5)) / 2;
    };
  }
  function Mb(r3, t3, e2) {
    function em(t4) {
      return 1 === t4 ? 1 : i2 * Math.pow(2, -10 * t4) * Z((t4 - a2) * n3) + 1;
    }
    var i2 = 1 <= t3 ? t3 : 1, n3 = (e2 || (r3 ? 0.3 : 0.45)) / (t3 < 1 ? t3 : 1), a2 = n3 / X * (Math.asin(1 / i2) || 0), s2 = "out" === r3 ? em : "in" === r3 ? function(t4) {
      return 1 - em(1 - t4);
    } : Lb(em);
    return n3 = X / n3, s2.config = function(t4, e3) {
      return Mb(r3, t4, e3);
    }, s2;
  }
  function Nb(e2, r3) {
    function mm(t4) {
      return t4 ? --t4 * t4 * ((r3 + 1) * t4 + r3) + 1 : 0;
    }
    void 0 === r3 && (r3 = 1.70158);
    var t3 = "out" === e2 ? mm : "in" === e2 ? function(t4) {
      return 1 - mm(1 - t4);
    } : Lb(mm);
    return t3.config = function(t4) {
      return Nb(e2, t4);
    }, t3;
  }
  var B, I, i, n2, a, h, l, f, d, c, m, g, y, T, b, w, x, k, C, A, D, S, z, R, E, F, U = { autoSleep: 120, force3D: "auto", nullTargetWarn: 1, units: { lineHeight: "" } }, L = { duration: 0.5, overwrite: false, delay: 0 }, Y = 1e8, V = 1 / Y, X = 2 * Math.PI, j = X / 4, K = 0, G = Math.sqrt, W = Math.cos, Z = Math.sin, H = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {
  }, J = Array.isArray, tt = /(?:-?\.?\d|\.)+/gi, et = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, rt = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, it = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, nt = /[+-]=-?[.\d]+/, at = /[^,'"\[\]\s]+/gi, st = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, ot = {}, ut = {}, ht = [], lt = {}, ft = {}, dt = {}, _t = 30, pt = [], ct = "", mt = function _merge(t3, e2) {
    for (var r3 in e2) t3[r3] = e2[r3];
    return t3;
  }, gt = function _animationCycle(t3, e2) {
    var r3 = Math.floor(t3 /= e2);
    return t3 && r3 === t3 ? r3 - 1 : r3;
  }, vt = function _isFromOrFromStart(t3) {
    var e2 = t3.data;
    return "isFromStart" === e2 || "isStart" === e2;
  }, yt = { _start: 0, endTime: Q, totalDuration: Q }, Tt = function _parsePosition(t3, e2, r3) {
    var i2, n3, a2, s2 = t3.labels, u2 = t3._recent || yt, h2 = t3.duration() >= Y ? u2.endTime(false) : t3._dur;
    return o(e2) && (isNaN(e2) || e2 in s2) ? (n3 = e2.charAt(0), a2 = "%" === e2.substr(-1), i2 = e2.indexOf("="), "<" === n3 || ">" === n3 ? (0 <= i2 && (e2 = e2.replace(/=/, "")), ("<" === n3 ? u2._start : u2.endTime(0 <= u2._repeat)) + (parseFloat(e2.substr(1)) || 0) * (a2 ? (i2 < 0 ? u2 : r3).totalDuration() / 100 : 1)) : i2 < 0 ? (e2 in s2 || (s2[e2] = h2), s2[e2]) : (n3 = parseFloat(e2.charAt(i2 - 1) + e2.substr(i2 + 1)), a2 && r3 && (n3 = n3 / 100 * (J(r3) ? r3[0] : r3).totalDuration()), 1 < i2 ? _parsePosition(t3, e2.substr(0, i2 - 1), r3) + n3 : h2 + n3)) : null == e2 ? h2 : +e2;
  }, bt = function _clamp(t3, e2, r3) {
    return r3 < t3 ? t3 : e2 < r3 ? e2 : r3;
  }, wt = [].slice, xt = function toArray(t3, e2, r3) {
    return !o(t3) || r3 || !n2 && St() ? J(t3) ? (function _flatten(t4, e3, r4) {
      return void 0 === r4 && (r4 = []), t4.forEach(function(t5) {
        return o(t5) && !e3 || Ua(t5, 1) ? r4.push.apply(r4, xt(t5)) : r4.push(t5);
      }) || r4;
    })(t3, r3) : Ua(t3) ? wt.call(t3, 0) : t3 ? [t3] : [] : wt.call((e2 || a).querySelectorAll(t3), 0);
  }, kt = function mapRange(e2, t3, r3, i2, n3) {
    var a2 = t3 - e2, s2 = i2 - r3;
    return Pa(n3, function(t4) {
      return r3 + ((t4 - e2) / a2 * s2 || 0);
    });
  }, Ot = function _callback(t3, e2, r3) {
    var i2, n3, a2 = t3.vars, s2 = a2[e2];
    if (s2) return i2 = a2[e2 + "Params"], n3 = a2.callbackScope || t3, r3 && ht.length && ga(), i2 ? s2.apply(n3, i2) : s2.call(n3);
  }, Pt = 255, Mt = { aqua: [0, Pt, Pt], lime: [0, Pt, 0], silver: [192, 192, 192], black: [0, 0, 0], maroon: [128, 0, 0], teal: [0, 128, 128], blue: [0, 0, Pt], navy: [0, 0, 128], white: [Pt, Pt, Pt], olive: [128, 128, 0], yellow: [Pt, Pt, 0], orange: [Pt, 165, 0], gray: [128, 128, 128], purple: [128, 0, 128], green: [0, 128, 0], red: [Pt, 0, 0], pink: [Pt, 192, 203], cyan: [0, Pt, Pt], transparent: [Pt, Pt, Pt, 0] }, Ct = (function() {
    var t3, e2 = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
    for (t3 in Mt) e2 += "|" + t3 + "\\b";
    return new RegExp(e2 + ")", "gi");
  })(), At = /hsl[a]?\(/, Dt = (x = Date.now, k = 500, C = 33, A = x(), D = A, z = S = 1e3 / 240, T = { time: 0, frame: 0, tick: function tick() {
    Vk(true);
  }, deltaRatio: function deltaRatio(t3) {
    return b / (1e3 / (t3 || 60));
  }, wake: function wake() {
    l && (!n2 && u() && (i = n2 = window, a = i.document || {}, ot.gsap = he, (i.gsapVersions || (i.gsapVersions = [])).push(he.version), M(h || i.GreenSockGlobals || !i.gsap && i || {}), y = i.requestAnimationFrame), m && T.sleep(), g = y || function(t3) {
      return setTimeout(t3, z - 1e3 * T.time + 1 | 0);
    }, c = 1, Vk(2));
  }, sleep: function sleep() {
    (y ? i.cancelAnimationFrame : clearTimeout)(m), c = 0, g = Q;
  }, lagSmoothing: function lagSmoothing(t3, e2) {
    k = t3 || 1e8, C = Math.min(e2, k, 0);
  }, fps: function fps(t3) {
    S = 1e3 / (t3 || 240), z = 1e3 * T.time + S;
  }, add: function add(n3, t3, e2) {
    var a2 = t3 ? function(t4, e3, r3, i2) {
      n3(t4, e3, r3, i2), T.remove(a2);
    } : n3;
    return T.remove(n3), R[e2 ? "unshift" : "push"](a2), St(), a2;
  }, remove: function remove(t3, e2) {
    ~(e2 = R.indexOf(t3)) && R.splice(e2, 1) && e2 <= w && w--;
  }, _listeners: R = [] }), St = function _wake() {
    return !c && Dt.wake();
  }, zt = {}, Rt = /^[\d.\-M][\d.\-,\s]/, Et = /["']/g, Ft = function _invertEase(e2) {
    return function(t3) {
      return 1 - e2(1 - t3);
    };
  }, Bt = function _parseEase(t3, e2) {
    return t3 && (p(t3) ? t3 : zt[t3] || Gb(t3)) || e2;
  };
  function Vk(t3) {
    var e2, r3, i2, n3, a2 = x() - D, s2 = true === t3;
    if (k < a2 && (A += a2 - C), (0 < (e2 = (i2 = (D += a2) - A) - z) || s2) && (n3 = ++T.frame, b = i2 - 1e3 * T.time, T.time = i2 /= 1e3, z += e2 + (S <= e2 ? 4 : S - e2), r3 = 1), s2 || (m = g(Vk)), r3) for (w = 0; w < R.length; w++) R[w](i2, b, n3, t3);
  }
  function Dm(t3) {
    return t3 < F ? E * t3 * t3 : t3 < 0.7272727272727273 ? E * Math.pow(t3 - 1.5 / 2.75, 2) + 0.75 : t3 < 0.9090909090909092 ? E * (t3 -= 2.25 / 2.75) * t3 + 0.9375 : E * Math.pow(t3 - 2.625 / 2.75, 2) + 0.984375;
  }
  ba("Linear,Quad,Cubic,Quart,Quint,Strong", function(t3, e2) {
    var r3 = e2 < 5 ? e2 + 1 : e2;
    Kb(t3 + ",Power" + (r3 - 1), e2 ? function(t4) {
      return Math.pow(t4, r3);
    } : function(t4) {
      return t4;
    }, function(t4) {
      return 1 - Math.pow(1 - t4, r3);
    }, function(t4) {
      return t4 < 0.5 ? Math.pow(2 * t4, r3) / 2 : 1 - Math.pow(2 * (1 - t4), r3) / 2;
    });
  }), zt.Linear.easeNone = zt.none = zt.Linear.easeIn, Kb("Elastic", Mb("in"), Mb("out"), Mb()), E = 7.5625, F = 1 / 2.75, Kb("Bounce", function(t3) {
    return 1 - Dm(1 - t3);
  }, Dm), Kb("Expo", function(t3) {
    return t3 ? Math.pow(2, 10 * (t3 - 1)) : 0;
  }), Kb("Circ", function(t3) {
    return -(G(1 - t3 * t3) - 1);
  }), Kb("Sine", function(t3) {
    return 1 === t3 ? 1 : 1 - W(t3 * j);
  }), Kb("Back", Nb("in"), Nb("out"), Nb()), zt.SteppedEase = zt.steps = ot.SteppedEase = { config: function config(t3, e2) {
    void 0 === t3 && (t3 = 1);
    var r3 = 1 / t3, i2 = t3 + (e2 ? 0 : 1), n3 = e2 ? 1 : 0;
    return function(t4) {
      return ((i2 * bt(0, 0.99999999, t4) | 0) + n3) * r3;
    };
  } }, L.ease = zt["quad.out"], ba("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t3) {
    return ct += t3 + "," + t3 + "Params,";
  });
  var It, Lt = function GSCache(t3, e2) {
    this.id = K++, (t3._gsap = this).target = t3, this.harness = e2, this.get = e2 ? e2.get : aa, this.set = e2 ? e2.getSetter : Ht;
  }, Nt = ((It = Animation.prototype).delay = function delay(t3) {
    return t3 || 0 === t3 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t3 - this._delay), this._delay = t3, this) : this._delay;
  }, It.duration = function duration(t3) {
    return arguments.length ? this.totalDuration(0 < this._repeat ? t3 + (t3 + this._rDelay) * this._repeat : t3) : this.totalDuration() && this._dur;
  }, It.totalDuration = function totalDuration(t3) {
    return arguments.length ? (this._dirty = 0, Ka(this, this._repeat < 0 ? t3 : (t3 - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, It.totalTime = function totalTime(t3, e2) {
    if (St(), !arguments.length) return this._tTime;
    var r3 = this._dp;
    if (r3 && r3.smoothChildTiming && this._ts) {
      for (Ba(this, t3), !r3._dp || r3.parent || Ca(r3, this); r3 && r3.parent; ) r3.parent._time !== r3._start + (0 <= r3._ts ? r3._tTime / r3._ts : (r3.totalDuration() - r3._tTime) / -r3._ts) && r3.totalTime(r3._tTime, true), r3 = r3.parent;
      !this.parent && this._dp.autoRemoveChildren && (0 < this._ts && t3 < this._tDur || this._ts < 0 && 0 < t3 || !this._tDur && !t3) && Da(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== t3 || !this._dur && !e2 || this._initted && Math.abs(this._zTime) === V || !t3 && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = t3), ha(this, t3, e2)), this;
  }, It.time = function time(t3, e2) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t3 + xa(this)) % (this._dur + this._rDelay) || (t3 ? this._dur : 0), e2) : this._time;
  }, It.totalProgress = function totalProgress(t3, e2) {
    return arguments.length ? this.totalTime(this.totalDuration() * t3, e2) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
  }, It.progress = function progress(t3, e2) {
    return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t3 : 1 - t3) + xa(this), e2) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
  }, It.iteration = function iteration(t3, e2) {
    var r3 = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (t3 - 1) * r3, e2) : this._repeat ? gt(this._tTime, r3) + 1 : 1;
  }, It.timeScale = function timeScale(t3) {
    if (!arguments.length) return this._rts === -V ? 0 : this._rts;
    if (this._rts === t3) return this;
    var e2 = this.parent && this._ts ? za(this.parent._time, this) : this._tTime;
    return this._rts = +t3 || 0, this._ts = this._ps || t3 === -V ? 0 : this._rts, this.totalTime(bt(-this._delay, this._tDur, e2), true), Aa(this), (function _recacheAncestors(t4) {
      for (var e3 = t4.parent; e3 && e3.parent; ) e3._dirty = 1, e3.totalDuration(), e3 = e3.parent;
      return t4;
    })(this);
  }, It.paused = function paused(t3) {
    return arguments.length ? (this._ps !== t3 && ((this._ps = t3) ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (St(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== V && (this._tTime -= V)))), this) : this._ps;
  }, It.startTime = function startTime(t3) {
    if (arguments.length) {
      this._start = t3;
      var e2 = this.parent || this._dp;
      return !e2 || !e2._sort && this.parent || Da(e2, this, t3 - this._delay), this;
    }
    return this._start;
  }, It.endTime = function endTime(e2) {
    return this._start + (t2(e2) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, It.rawTime = function rawTime(t3) {
    var e2 = this.parent || this._dp;
    return e2 ? t3 && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? za(e2.rawTime(t3), this) : this._tTime : this._tTime;
  }, It.globalTime = function globalTime(t3) {
    for (var e2 = this, r3 = arguments.length ? t3 : e2.rawTime(); e2; ) r3 = e2._start + r3 / (e2._ts || 1), e2 = e2._dp;
    return r3;
  }, It.repeat = function repeat(t3) {
    return arguments.length ? (this._repeat = t3 === 1 / 0 ? -2 : t3, La(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
  }, It.repeatDelay = function repeatDelay(t3) {
    if (arguments.length) {
      var e2 = this._time;
      return this._rDelay = t3, La(this), e2 ? this.time(e2) : this;
    }
    return this._rDelay;
  }, It.yoyo = function yoyo(t3) {
    return arguments.length ? (this._yoyo = t3, this) : this._yoyo;
  }, It.seek = function seek(e2, r3) {
    return this.totalTime(Tt(this, e2), t2(r3));
  }, It.restart = function restart(e2, r3) {
    return this.play().totalTime(e2 ? -this._delay : 0, t2(r3));
  }, It.play = function play(t3, e2) {
    return null != t3 && this.seek(t3, e2), this.reversed(false).paused(false);
  }, It.reverse = function reverse(t3, e2) {
    return null != t3 && this.seek(t3 || this.totalDuration(), e2), this.reversed(true).paused(false);
  }, It.pause = function pause(t3, e2) {
    return null != t3 && this.seek(t3, e2), this.paused(true);
  }, It.resume = function resume() {
    return this.paused(false);
  }, It.reversed = function reversed(t3) {
    return arguments.length ? (!!t3 !== this.reversed() && this.timeScale(-this._rts || (t3 ? -V : 0)), this) : this._rts < 0;
  }, It.invalidate = function invalidate() {
    return this._initted = this._act = 0, this._zTime = -V, this;
  }, It.isActive = function isActive() {
    var t3, e2 = this.parent || this._dp, r3 = this._start;
    return !(e2 && !(this._ts && this._initted && e2.isActive() && (t3 = e2.rawTime(true)) >= r3 && t3 < this.endTime(true) - V));
  }, It.eventCallback = function eventCallback(t3, e2, r3) {
    var i2 = this.vars;
    return 1 < arguments.length ? (e2 ? (i2[t3] = e2, r3 && (i2[t3 + "Params"] = r3), "onUpdate" === t3 && (this._onUpdate = e2)) : delete i2[t3], this) : i2[t3];
  }, It.then = function then(t3) {
    var i2 = this;
    return new Promise(function(e2) {
      function Un() {
        var t4 = i2.then;
        i2.then = null, p(r3) && (r3 = r3(i2)) && (r3.then || r3 === i2) && (i2.then = t4), e2(r3), i2.then = t4;
      }
      var r3 = p(t3) ? t3 : ja;
      i2._initted && 1 === i2.totalProgress() && 0 <= i2._ts || !i2._tTime && i2._ts < 0 ? Un() : i2._prom = Un;
    });
  }, It.kill = function kill() {
    mb(this);
  }, Animation);
  function Animation(t3) {
    this.vars = t3, this._delay = +t3.delay || 0, (this._repeat = t3.repeat === 1 / 0 ? -2 : t3.repeat || 0) && (this._rDelay = t3.repeatDelay || 0, this._yoyo = !!t3.yoyo || !!t3.yoyoEase), this._ts = 1, Ka(this, +t3.duration, 1, 1), this.data = t3.data, c || Dt.wake();
  }
  ka(Nt.prototype, { _time: 0, _start: 0, _end: 0, _tTime: 0, _tDur: 0, _dirty: 0, _repeat: 0, _yoyo: false, parent: null, _initted: false, _rDelay: 0, _ts: 1, _dp: 0, ratio: 0, _zTime: -V, _prom: 0, _ps: false, _rts: 1 });
  var Ut = (function(n3) {
    function Timeline(e3, r3) {
      var i2;
      return void 0 === e3 && (e3 = {}), (i2 = n3.call(this, e3) || this).labels = {}, i2.smoothChildTiming = !!e3.smoothChildTiming, i2.autoRemoveChildren = !!e3.autoRemoveChildren, i2._sort = t2(e3.sortChildren), I && Da(e3.parent || I, _assertThisInitialized(i2), r3), e3.reversed && i2.reverse(), e3.paused && i2.paused(true), e3.scrollTrigger && Ea(_assertThisInitialized(i2), e3.scrollTrigger), i2;
    }
    _inheritsLoose(Timeline, n3);
    var e2 = Timeline.prototype;
    return e2.to = function to(t3, e3, r3) {
      return Oa(0, arguments, this), this;
    }, e2.from = function from(t3, e3, r3) {
      return Oa(1, arguments, this), this;
    }, e2.fromTo = function fromTo(t3, e3, r3, i2) {
      return Oa(2, arguments, this), this;
    }, e2.set = function set(t3, e3, r3) {
      return e3.duration = 0, e3.parent = this, pa(e3).repeatDelay || (e3.repeat = 0), e3.immediateRender = !!e3.immediateRender, new $t(t3, e3, Tt(this, r3), 1), this;
    }, e2.call = function call(t3, e3, r3) {
      return Da(this, $t.delayedCall(0, t3, e3), r3);
    }, e2.staggerTo = function staggerTo(t3, e3, r3, i2, n4, a2, s2) {
      return r3.duration = e3, r3.stagger = r3.stagger || i2, r3.onComplete = a2, r3.onCompleteParams = s2, r3.parent = this, new $t(t3, r3, Tt(this, n4)), this;
    }, e2.staggerFrom = function staggerFrom(e3, r3, i2, n4, a2, s2, o2) {
      return i2.runBackwards = 1, pa(i2).immediateRender = t2(i2.immediateRender), this.staggerTo(e3, r3, i2, n4, a2, s2, o2);
    }, e2.staggerFromTo = function staggerFromTo(e3, r3, i2, n4, a2, s2, o2, u2) {
      return n4.startAt = i2, pa(n4).immediateRender = t2(n4.immediateRender), this.staggerTo(e3, r3, n4, a2, s2, o2, u2);
    }, e2.render = function render(t3, e3, r3) {
      var i2, n4, a2, s2, o2, u2, h2, l2, f2, d2, _2, p2, c2 = this._time, m2 = this._dirty ? this.totalDuration() : this._tDur, g2 = this._dur, v2 = t3 <= 0 ? 0 : da(t3), y2 = this._zTime < 0 != t3 < 0 && (this._initted || !g2);
      if (this !== I && m2 < v2 && 0 <= t3 && (v2 = m2), v2 !== this._tTime || r3 || y2) {
        if (c2 !== this._time && g2 && (v2 += this._time - c2, t3 += this._time - c2), i2 = v2, f2 = this._start, u2 = !(l2 = this._ts), y2 && (g2 || (c2 = this._zTime), !t3 && e3 || (this._zTime = t3)), this._repeat) {
          if (_2 = this._yoyo, o2 = g2 + this._rDelay, this._repeat < -1 && t3 < 0) return this.totalTime(100 * o2 + t3, e3, r3);
          if (i2 = da(v2 % o2), v2 === m2 ? (s2 = this._repeat, i2 = g2) : ((s2 = ~~(v2 / o2)) && s2 === v2 / o2 && (i2 = g2, s2--), g2 < i2 && (i2 = g2)), d2 = gt(this._tTime, o2), !c2 && this._tTime && d2 !== s2 && (d2 = s2), _2 && 1 & s2 && (i2 = g2 - i2, p2 = 1), s2 !== d2 && !this._lock) {
            var T2 = _2 && 1 & d2, b2 = T2 === (_2 && 1 & s2);
            if (s2 < d2 && (T2 = !T2), c2 = T2 ? 0 : g2, this._lock = 1, this.render(c2 || (p2 ? 0 : da(s2 * o2)), e3, !g2)._lock = 0, this._tTime = v2, !e3 && this.parent && Ot(this, "onRepeat"), this.vars.repeatRefresh && !p2 && (this.invalidate()._lock = 1), c2 && c2 !== this._time || u2 != !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
            if (g2 = this._dur, m2 = this._tDur, b2 && (this._lock = 2, c2 = T2 ? g2 : -1e-4, this.render(c2, true), this.vars.repeatRefresh && !p2 && this.invalidate()), this._lock = 0, !this._ts && !u2) return this;
            Ib(this, p2);
          }
        }
        if (this._hasPause && !this._forcing && this._lock < 2 && (h2 = (function _findNextPauseTween(t4, e4, r4) {
          var i3;
          if (e4 < r4) for (i3 = t4._first; i3 && i3._start <= r4; ) {
            if ("isPause" === i3.data && i3._start > e4) return i3;
            i3 = i3._next;
          }
          else for (i3 = t4._last; i3 && i3._start >= r4; ) {
            if ("isPause" === i3.data && i3._start < e4) return i3;
            i3 = i3._prev;
          }
        })(this, da(c2), da(i2))) && (v2 -= i2 - (i2 = h2._start)), this._tTime = v2, this._time = i2, this._act = !l2, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = t3, c2 = 0), !c2 && i2 && !e3 && (Ot(this, "onStart"), this._tTime !== v2)) return this;
        if (c2 <= i2 && 0 <= t3) for (n4 = this._first; n4; ) {
          if (a2 = n4._next, (n4._act || i2 >= n4._start) && n4._ts && h2 !== n4) {
            if (n4.parent !== this) return this.render(t3, e3, r3);
            if (n4.render(0 < n4._ts ? (i2 - n4._start) * n4._ts : (n4._dirty ? n4.totalDuration() : n4._tDur) + (i2 - n4._start) * n4._ts, e3, r3), i2 !== this._time || !this._ts && !u2) {
              h2 = 0, a2 && (v2 += this._zTime = -V);
              break;
            }
          }
          n4 = a2;
        }
        else {
          n4 = this._last;
          for (var w2 = t3 < 0 ? t3 : i2; n4; ) {
            if (a2 = n4._prev, (n4._act || w2 <= n4._end) && n4._ts && h2 !== n4) {
              if (n4.parent !== this) return this.render(t3, e3, r3);
              if (n4.render(0 < n4._ts ? (w2 - n4._start) * n4._ts : (n4._dirty ? n4.totalDuration() : n4._tDur) + (w2 - n4._start) * n4._ts, e3, r3), i2 !== this._time || !this._ts && !u2) {
                h2 = 0, a2 && (v2 += this._zTime = w2 ? -V : V);
                break;
              }
            }
            n4 = a2;
          }
        }
        if (h2 && !e3 && (this.pause(), h2.render(c2 <= i2 ? 0 : -V)._zTime = c2 <= i2 ? 1 : -1, this._ts)) return this._start = f2, Aa(this), this.render(t3, e3, r3);
        this._onUpdate && !e3 && Ot(this, "onUpdate", true), (v2 === m2 && this._tTime >= this.totalDuration() || !v2 && c2) && (f2 !== this._start && Math.abs(l2) === Math.abs(this._ts) || this._lock || (!t3 && g2 || !(v2 === m2 && 0 < this._ts || !v2 && this._ts < 0) || ta(this, 1), e3 || t3 < 0 && !c2 || !v2 && !c2 && m2 || (Ot(this, v2 === m2 && 0 <= t3 ? "onComplete" : "onReverseComplete", true), !this._prom || v2 < m2 && 0 < this.timeScale() || this._prom())));
      }
      return this;
    }, e2.add = function add(t3, e3) {
      var r3 = this;
      if (q(e3) || (e3 = Tt(this, e3, t3)), !(t3 instanceof Nt)) {
        if (J(t3)) return t3.forEach(function(t4) {
          return r3.add(t4, e3);
        }), this;
        if (o(t3)) return this.addLabel(t3, e3);
        if (!p(t3)) return this;
        t3 = $t.delayedCall(0, t3);
      }
      return this !== t3 ? Da(this, t3, e3) : this;
    }, e2.getChildren = function getChildren(t3, e3, r3, i2) {
      void 0 === t3 && (t3 = true), void 0 === e3 && (e3 = true), void 0 === r3 && (r3 = true), void 0 === i2 && (i2 = -Y);
      for (var n4 = [], a2 = this._first; a2; ) a2._start >= i2 && (a2 instanceof $t ? e3 && n4.push(a2) : (r3 && n4.push(a2), t3 && n4.push.apply(n4, a2.getChildren(true, e3, r3)))), a2 = a2._next;
      return n4;
    }, e2.getById = function getById(t3) {
      for (var e3 = this.getChildren(1, 1, 1), r3 = e3.length; r3--; ) if (e3[r3].vars.id === t3) return e3[r3];
    }, e2.remove = function remove(t3) {
      return o(t3) ? this.removeLabel(t3) : p(t3) ? this.killTweensOf(t3) : (sa(this, t3), t3 === this._recent && (this._recent = this._last), ua(this));
    }, e2.totalTime = function totalTime(t3, e3) {
      return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = da(Dt.time - (0 < this._ts ? t3 / this._ts : (this.totalDuration() - t3) / -this._ts))), n3.prototype.totalTime.call(this, t3, e3), this._forcing = 0, this) : this._tTime;
    }, e2.addLabel = function addLabel(t3, e3) {
      return this.labels[t3] = Tt(this, e3), this;
    }, e2.removeLabel = function removeLabel(t3) {
      return delete this.labels[t3], this;
    }, e2.addPause = function addPause(t3, e3, r3) {
      var i2 = $t.delayedCall(0, e3 || Q, r3);
      return i2.data = "isPause", this._hasPause = 1, Da(this, i2, Tt(this, t3));
    }, e2.removePause = function removePause(t3) {
      var e3 = this._first;
      for (t3 = Tt(this, t3); e3; ) e3._start === t3 && "isPause" === e3.data && ta(e3), e3 = e3._next;
    }, e2.killTweensOf = function killTweensOf(t3, e3, r3) {
      for (var i2 = this.getTweensOf(t3, r3), n4 = i2.length; n4--; ) Yt !== i2[n4] && i2[n4].kill(t3, e3);
      return this;
    }, e2.getTweensOf = function getTweensOf(t3, e3) {
      for (var r3, i2 = [], n4 = xt(t3), a2 = this._first, s2 = q(e3); a2; ) a2 instanceof $t ? fa(a2._targets, n4) && (s2 ? (!Yt || a2._initted && a2._ts) && a2.globalTime(0) <= e3 && a2.globalTime(a2.totalDuration()) > e3 : !e3 || a2.isActive()) && i2.push(a2) : (r3 = a2.getTweensOf(n4, e3)).length && i2.push.apply(i2, r3), a2 = a2._next;
      return i2;
    }, e2.tweenTo = function tweenTo(t3, e3) {
      e3 = e3 || {};
      var r3, i2 = this, n4 = Tt(i2, t3), a2 = e3.startAt, s2 = e3.onStart, o2 = e3.onStartParams, u2 = e3.immediateRender, h2 = $t.to(i2, ka({ ease: e3.ease || "none", lazy: false, immediateRender: false, time: n4, overwrite: "auto", duration: e3.duration || Math.abs((n4 - (a2 && "time" in a2 ? a2.time : i2._time)) / i2.timeScale()) || V, onStart: function onStart() {
        if (i2.pause(), !r3) {
          var t4 = e3.duration || Math.abs((n4 - (a2 && "time" in a2 ? a2.time : i2._time)) / i2.timeScale());
          h2._dur !== t4 && Ka(h2, t4, 0, 1).render(h2._time, true, true), r3 = 1;
        }
        s2 && s2.apply(h2, o2 || []);
      } }, e3));
      return u2 ? h2.render(0) : h2;
    }, e2.tweenFromTo = function tweenFromTo(t3, e3, r3) {
      return this.tweenTo(e3, ka({ startAt: { time: Tt(this, t3) } }, r3));
    }, e2.recent = function recent() {
      return this._recent;
    }, e2.nextLabel = function nextLabel(t3) {
      return void 0 === t3 && (t3 = this._time), kb(this, Tt(this, t3));
    }, e2.previousLabel = function previousLabel(t3) {
      return void 0 === t3 && (t3 = this._time), kb(this, Tt(this, t3), 1);
    }, e2.currentLabel = function currentLabel(t3) {
      return arguments.length ? this.seek(t3, true) : this.previousLabel(this._time + V);
    }, e2.shiftChildren = function shiftChildren(t3, e3, r3) {
      void 0 === r3 && (r3 = 0);
      for (var i2, n4 = this._first, a2 = this.labels; n4; ) n4._start >= r3 && (n4._start += t3, n4._end += t3), n4 = n4._next;
      if (e3) for (i2 in a2) a2[i2] >= r3 && (a2[i2] += t3);
      return ua(this);
    }, e2.invalidate = function invalidate() {
      var t3 = this._first;
      for (this._lock = 0; t3; ) t3.invalidate(), t3 = t3._next;
      return n3.prototype.invalidate.call(this);
    }, e2.clear = function clear(t3) {
      void 0 === t3 && (t3 = true);
      for (var e3, r3 = this._first; r3; ) e3 = r3._next, this.remove(r3), r3 = e3;
      return this._dp && (this._time = this._tTime = this._pTime = 0), t3 && (this.labels = {}), ua(this);
    }, e2.totalDuration = function totalDuration(t3) {
      var e3, r3, i2, n4 = 0, a2 = this, s2 = a2._last, o2 = Y;
      if (arguments.length) return a2.timeScale((a2._repeat < 0 ? a2.duration() : a2.totalDuration()) / (a2.reversed() ? -t3 : t3));
      if (a2._dirty) {
        for (i2 = a2.parent; s2; ) e3 = s2._prev, s2._dirty && s2.totalDuration(), o2 < (r3 = s2._start) && a2._sort && s2._ts && !a2._lock ? (a2._lock = 1, Da(a2, s2, r3 - s2._delay, 1)._lock = 0) : o2 = r3, r3 < 0 && s2._ts && (n4 -= r3, (!i2 && !a2._dp || i2 && i2.smoothChildTiming) && (a2._start += r3 / a2._ts, a2._time -= r3, a2._tTime -= r3), a2.shiftChildren(-r3, false, -Infinity), o2 = 0), s2._end > n4 && s2._ts && (n4 = s2._end), s2 = e3;
        Ka(a2, a2 === I && a2._time > n4 ? a2._time : n4, 1, 1), a2._dirty = 0;
      }
      return a2._tDur;
    }, Timeline.updateRoot = function updateRoot(t3) {
      if (I._ts && (ha(I, za(t3, I)), f = Dt.frame), Dt.frame >= _t) {
        _t += U.autoSleep || 120;
        var e3 = I._first;
        if ((!e3 || !e3._ts) && U.autoSleep && Dt._listeners.length < 2) {
          for (; e3 && !e3._ts; ) e3 = e3._next;
          e3 || Dt.sleep();
        }
      }
    }, Timeline;
  })(Nt);
  ka(Ut.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
  function Ub(t3, e2, r3, i2, n3, a2) {
    var u2, h2, l2, f2;
    if (ft[t3] && false !== (u2 = new ft[t3]()).init(n3, u2.rawVars ? e2[t3] : (function _processVars(t4, e3, r4, i3, n4) {
      if (p(t4) && (t4 = Qt(t4, n4, e3, r4, i3)), !s(t4) || t4.style && t4.nodeType || J(t4) || H(t4)) return o(t4) ? Qt(t4, n4, e3, r4, i3) : t4;
      var a3, u3 = {};
      for (a3 in t4) u3[a3] = Qt(t4[a3], n4, e3, r4, i3);
      return u3;
    })(e2[t3], i2, n3, a2, r3), r3, i2, a2) && (r3._pt = h2 = new oe(r3._pt, n3, t3, 0, 1, u2.render, u2, 0, u2.priority), r3 !== d)) for (l2 = r3._ptLookup[r3._targets.indexOf(n3)], f2 = u2._props.length; f2--; ) l2[u2._props[f2]] = h2;
    return u2;
  }
  function $b(t3, r3, e2, i2) {
    var n3, a2, s2 = r3.ease || i2 || "power1.inOut";
    if (J(r3)) a2 = e2[t3] || (e2[t3] = []), r3.forEach(function(t4, e3) {
      return a2.push({ t: e3 / (r3.length - 1) * 100, v: t4, e: s2 });
    });
    else for (n3 in r3) a2 = e2[n3] || (e2[n3] = []), "ease" === n3 || a2.push({ t: parseFloat(t3), v: r3[n3], e: s2 });
  }
  var Yt, qt, Vt = function _addPropTween(t3, e2, r3, i2, n3, a2, s2, u2, h2) {
    p(i2) && (i2 = i2(n3 || 0, t3, a2));
    var l2, f2 = t3[e2], d2 = "get" !== r3 ? r3 : p(f2) ? h2 ? t3[e2.indexOf("set") || !p(t3["get" + e2.substr(3)]) ? e2 : "get" + e2.substr(3)](h2) : t3[e2]() : f2, _2 = p(f2) ? h2 ? Zt : Wt : Gt;
    if (o(i2) && (~i2.indexOf("random(") && (i2 = hb(i2)), "=" === i2.charAt(1) && (!(l2 = ea(d2, i2) + (Ra(d2) || 0)) && 0 !== l2 || (i2 = l2))), d2 !== i2 || qt) return isNaN(d2 * i2) || "" === i2 ? (f2 || e2 in t3 || N(e2, i2), function _addComplexStringPropTween(t4, e3, r4, i3, n4, a3, s3) {
      var o2, u3, h3, l3, f3, d3, _3, p2, c2 = new oe(this._pt, t4, e3, 0, 1, ee, null, n4), m2 = 0, g2 = 0;
      for (c2.b = r4, c2.e = i3, r4 += "", (_3 = ~(i3 += "").indexOf("random(")) && (i3 = hb(i3)), a3 && (a3(p2 = [r4, i3], t4, e3), r4 = p2[0], i3 = p2[1]), u3 = r4.match(it) || []; o2 = it.exec(i3); ) l3 = o2[0], f3 = i3.substring(m2, o2.index), h3 ? h3 = (h3 + 1) % 5 : "rgba(" === f3.substr(-5) && (h3 = 1), l3 !== u3[g2++] && (d3 = parseFloat(u3[g2 - 1]) || 0, c2._pt = { _next: c2._pt, p: f3 || 1 === g2 ? f3 : ",", s: d3, c: "=" === l3.charAt(1) ? ea(d3, l3) - d3 : parseFloat(l3) - d3, m: h3 && h3 < 4 ? Math.round : 0 }, m2 = it.lastIndex);
      return c2.c = m2 < i3.length ? i3.substring(m2, i3.length) : "", c2.fp = s3, (nt.test(i3) || _3) && (c2.e = 0), this._pt = c2;
    }.call(this, t3, e2, d2, i2, _2, u2 || U.stringFilter, h2)) : (l2 = new oe(this._pt, t3, e2, +d2 || 0, i2 - (d2 || 0), "boolean" == typeof f2 ? te : Jt2, 0, _2), h2 && (l2.fp = h2), s2 && l2.modifier(s2, this, t3), this._pt = l2);
  }, Xt = function _initTween(e2, r3) {
    var i2, n3, a2, s2, o2, u2, h2, l2, f2, d2, p2, c2, m2, g2 = e2.vars, v2 = g2.ease, y2 = g2.startAt, T2 = g2.immediateRender, b2 = g2.lazy, w2 = g2.onUpdate, x2 = g2.onUpdateParams, k2 = g2.callbackScope, O2 = g2.runBackwards, P2 = g2.yoyoEase, M2 = g2.keyframes, C2 = g2.autoRevert, A2 = e2._dur, D2 = e2._startAt, S2 = e2._targets, z2 = e2.parent, R2 = z2 && "nested" === z2.data ? z2.parent._targets : S2, E2 = "auto" === e2._overwrite && !B, F2 = e2.timeline;
    if (!F2 || M2 && v2 || (v2 = "none"), e2._ease = Bt(v2, L.ease), e2._yEase = P2 ? Ft(Bt(true === P2 ? v2 : P2, L.ease)) : 0, P2 && e2._yoyo && !e2._repeat && (P2 = e2._yEase, e2._yEase = e2._ease, e2._ease = P2), e2._from = !F2 && !!g2.runBackwards, !F2 || M2 && !g2.stagger) {
      if (c2 = (l2 = S2[0] ? _(S2[0]).harness : 0) && g2[l2.prop], i2 = oa(g2, ut), D2 && (ta(D2.render(-1, true)), D2._lazy = 0), y2) if (ta(e2._startAt = $t.set(S2, ka({ data: "isStart", overwrite: false, parent: z2, immediateRender: true, lazy: t2(b2), startAt: null, delay: 0, onUpdate: w2, onUpdateParams: x2, callbackScope: k2, stagger: 0 }, y2))), r3 < 0 && !T2 && !C2 && e2._startAt.render(-1, true), T2) {
        if (0 < r3 && !C2 && (e2._startAt = 0), A2 && r3 <= 0) return void (r3 && (e2._zTime = r3));
      } else false === C2 && (e2._startAt = 0);
      else if (O2 && A2) if (D2) C2 || (e2._startAt = 0);
      else if (r3 && (T2 = false), a2 = ka({ overwrite: false, data: "isFromStart", lazy: T2 && t2(b2), immediateRender: T2, stagger: 0, parent: z2 }, i2), c2 && (a2[l2.prop] = c2), ta(e2._startAt = $t.set(S2, a2)), r3 < 0 && e2._startAt.render(-1, true), e2._zTime = r3, T2) {
        if (!r3) return;
      } else _initTween(e2._startAt, V);
      for (e2._pt = e2._ptCache = 0, b2 = A2 && t2(b2) || b2 && !A2, n3 = 0; n3 < S2.length; n3++) {
        if (h2 = (o2 = S2[n3])._gsap || $(S2)[n3]._gsap, e2._ptLookup[n3] = d2 = {}, lt[h2.id] && ht.length && ga(), p2 = R2 === S2 ? n3 : R2.indexOf(o2), l2 && false !== (f2 = new l2()).init(o2, c2 || i2, e2, p2, R2) && (e2._pt = s2 = new oe(e2._pt, o2, f2.name, 0, 1, f2.render, f2, 0, f2.priority), f2._props.forEach(function(t3) {
          d2[t3] = s2;
        }), f2.priority && (u2 = 1)), !l2 || c2) for (a2 in i2) ft[a2] && (f2 = Ub(a2, i2, e2, p2, o2, R2)) ? f2.priority && (u2 = 1) : d2[a2] = s2 = Vt.call(e2, o2, a2, "get", i2[a2], p2, R2, 0, g2.stringFilter);
        e2._op && e2._op[n3] && e2.kill(o2, e2._op[n3]), E2 && e2._pt && (Yt = e2, I.killTweensOf(o2, d2, e2.globalTime(r3)), m2 = !e2.parent, Yt = 0), e2._pt && b2 && (lt[h2.id] = 1);
      }
      u2 && se(e2), e2._onInit && e2._onInit(e2);
    }
    e2._onUpdate = w2, e2._initted = (!e2._op || e2._pt) && !m2, M2 && r3 <= 0 && F2.render(Y, true, true);
  }, Qt = function _parseFuncOrString(t3, e2, r3, i2, n3) {
    return p(t3) ? t3.call(e2, r3, i2, n3) : o(t3) && ~t3.indexOf("random(") ? hb(t3) : t3;
  }, jt = ct + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Kt = {};
  ba(jt + ",id,stagger,delay,duration,paused,scrollTrigger", function(t3) {
    return Kt[t3] = 1;
  });
  var $t = (function(R2) {
    function Tween(e3, r3, i2, n3) {
      var a2;
      "number" == typeof r3 && (i2.duration = r3, r3 = i2, i2 = null);
      var o2, u2, h2, l2, f2, d2, _2, p2, c2 = (a2 = R2.call(this, n3 ? r3 : pa(r3)) || this).vars, m2 = c2.duration, g2 = c2.delay, y2 = c2.immediateRender, T2 = c2.stagger, b2 = c2.overwrite, w2 = c2.keyframes, x2 = c2.defaults, k2 = c2.scrollTrigger, P2 = c2.yoyoEase, M2 = r3.parent || I, C2 = (J(e3) || H(e3) ? q(e3[0]) : "length" in r3) ? [e3] : xt(e3);
      if (a2._targets = C2.length ? $(C2) : O("GSAP target " + e3 + " not found. https://greensock.com", !U.nullTargetWarn) || [], a2._ptLookup = [], a2._overwrite = b2, w2 || T2 || v(m2) || v(g2)) {
        if (r3 = a2.vars, (o2 = a2.timeline = new Ut({ data: "nested", defaults: x2 || {} })).kill(), o2.parent = o2._dp = _assertThisInitialized(a2), o2._start = 0, T2 || v(m2) || v(g2)) {
          if (l2 = C2.length, _2 = T2 && Za(T2), s(T2)) for (f2 in T2) ~jt.indexOf(f2) && ((p2 = p2 || {})[f2] = T2[f2]);
          for (u2 = 0; u2 < l2; u2++) (h2 = oa(r3, Kt)).stagger = 0, P2 && (h2.yoyoEase = P2), p2 && mt(h2, p2), d2 = C2[u2], h2.duration = +Qt(m2, _assertThisInitialized(a2), u2, d2, C2), h2.delay = (+Qt(g2, _assertThisInitialized(a2), u2, d2, C2) || 0) - a2._delay, !T2 && 1 === l2 && h2.delay && (a2._delay = g2 = h2.delay, a2._start += g2, h2.delay = 0), o2.to(d2, h2, _2 ? _2(u2, d2, C2) : 0), o2._ease = zt.none;
          o2.duration() ? m2 = g2 = 0 : a2.timeline = 0;
        } else if (w2) {
          pa(ka(o2.vars.defaults, { ease: "none" })), o2._ease = Bt(w2.ease || r3.ease || "none");
          var A2, D2, S2, z2 = 0;
          if (J(w2)) w2.forEach(function(t3) {
            return o2.to(C2, t3, ">");
          });
          else {
            for (f2 in h2 = {}, w2) "ease" === f2 || "easeEach" === f2 || $b(f2, w2[f2], h2, w2.easeEach);
            for (f2 in h2) for (A2 = h2[f2].sort(function(t3, e4) {
              return t3.t - e4.t;
            }), u2 = z2 = 0; u2 < A2.length; u2++) (S2 = { ease: (D2 = A2[u2]).e, duration: (D2.t - (u2 ? A2[u2 - 1].t : 0)) / 100 * m2 })[f2] = D2.v, o2.to(C2, S2, z2), z2 += S2.duration;
            o2.duration() < m2 && o2.to({}, { duration: m2 - o2.duration() });
          }
        }
        m2 || a2.duration(m2 = o2.duration());
      } else a2.timeline = 0;
      return true !== b2 || B || (Yt = _assertThisInitialized(a2), I.killTweensOf(C2), Yt = 0), Da(M2, _assertThisInitialized(a2), i2), r3.reversed && a2.reverse(), r3.paused && a2.paused(true), (y2 || !m2 && !w2 && a2._start === da(M2._time) && t2(y2) && (function _hasNoPausedAncestors(t3) {
        return !t3 || t3._ts && _hasNoPausedAncestors(t3.parent);
      })(_assertThisInitialized(a2)) && "nested" !== M2.data) && (a2._tTime = -V, a2.render(Math.max(0, -g2))), k2 && Ea(_assertThisInitialized(a2), k2), a2;
    }
    _inheritsLoose(Tween, R2);
    var e2 = Tween.prototype;
    return e2.render = function render(t3, e3, r3) {
      var i2, n3, a2, s2, o2, u2, h2, l2, f2, d2 = this._time, _2 = this._tDur, p2 = this._dur, c2 = _2 - V < t3 && 0 <= t3 ? _2 : t3 < V ? 0 : t3;
      if (p2) {
        if (c2 !== this._tTime || !t3 || r3 || !this._initted && this._tTime || this._startAt && this._zTime < 0 != t3 < 0) {
          if (i2 = c2, l2 = this.timeline, this._repeat) {
            if (s2 = p2 + this._rDelay, this._repeat < -1 && t3 < 0) return this.totalTime(100 * s2 + t3, e3, r3);
            if (i2 = da(c2 % s2), c2 === _2 ? (a2 = this._repeat, i2 = p2) : ((a2 = ~~(c2 / s2)) && a2 === c2 / s2 && (i2 = p2, a2--), p2 < i2 && (i2 = p2)), (u2 = this._yoyo && 1 & a2) && (f2 = this._yEase, i2 = p2 - i2), o2 = gt(this._tTime, s2), i2 === d2 && !r3 && this._initted) return this._tTime = c2, this;
            a2 !== o2 && (l2 && this._yEase && Ib(l2, u2), !this.vars.repeatRefresh || u2 || this._lock || (this._lock = r3 = 1, this.render(da(s2 * a2), true).invalidate()._lock = 0));
          }
          if (!this._initted) {
            if (Fa(this, t3 < 0 ? t3 : i2, r3, e3)) return this._tTime = 0, this;
            if (d2 !== this._time) return this;
            if (p2 !== this._dur) return this.render(t3, e3, r3);
          }
          if (this._tTime = c2, this._time = i2, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = h2 = (f2 || this._ease)(i2 / p2), this._from && (this.ratio = h2 = 1 - h2), i2 && !d2 && !e3 && (Ot(this, "onStart"), this._tTime !== c2)) return this;
          for (n3 = this._pt; n3; ) n3.r(h2, n3.d), n3 = n3._next;
          l2 && l2.render(t3 < 0 ? t3 : !i2 && u2 ? -V : l2._dur * l2._ease(i2 / this._dur), e3, r3) || this._startAt && (this._zTime = t3), this._onUpdate && !e3 && (t3 < 0 && this._startAt && this._startAt.render(t3, true, r3), Ot(this, "onUpdate")), this._repeat && a2 !== o2 && this.vars.onRepeat && !e3 && this.parent && Ot(this, "onRepeat"), c2 !== this._tDur && c2 || this._tTime !== c2 || (t3 < 0 && this._startAt && !this._onUpdate && this._startAt.render(t3, true, true), !t3 && p2 || !(c2 === this._tDur && 0 < this._ts || !c2 && this._ts < 0) || ta(this, 1), e3 || t3 < 0 && !d2 || !c2 && !d2 || (Ot(this, c2 === _2 ? "onComplete" : "onReverseComplete", true), !this._prom || c2 < _2 && 0 < this.timeScale() || this._prom()));
        }
      } else !(function _renderZeroDurationTween(t4, e4, r4, i3) {
        var n4, a3, s3, o3 = t4.ratio, u3 = e4 < 0 || !e4 && (!t4._start && (function _parentPlayheadIsBeforeStart(t5) {
          var e5 = t5.parent;
          return e5 && e5._ts && e5._initted && !e5._lock && (e5.rawTime() < 0 || _parentPlayheadIsBeforeStart(e5));
        })(t4) && (t4._initted || !vt(t4)) || (t4._ts < 0 || t4._dp._ts < 0) && !vt(t4)) ? 0 : 1, h3 = t4._rDelay, l3 = 0;
        if (h3 && t4._repeat && (l3 = bt(0, t4._tDur, e4), a3 = gt(l3, h3), t4._yoyo && 1 & a3 && (u3 = 1 - u3), a3 !== gt(t4._tTime, h3) && (o3 = 1 - u3, t4.vars.repeatRefresh && t4._initted && t4.invalidate())), u3 !== o3 || i3 || t4._zTime === V || !e4 && t4._zTime) {
          if (!t4._initted && Fa(t4, e4, i3, r4)) return;
          for (s3 = t4._zTime, t4._zTime = e4 || (r4 ? V : 0), r4 = r4 || e4 && !s3, t4.ratio = u3, t4._from && (u3 = 1 - u3), t4._time = 0, t4._tTime = l3, n4 = t4._pt; n4; ) n4.r(u3, n4.d), n4 = n4._next;
          t4._startAt && e4 < 0 && t4._startAt.render(e4, true, true), t4._onUpdate && !r4 && Ot(t4, "onUpdate"), l3 && t4._repeat && !r4 && t4.parent && Ot(t4, "onRepeat"), (e4 >= t4._tDur || e4 < 0) && t4.ratio === u3 && (u3 && ta(t4, 1), r4 || (Ot(t4, u3 ? "onComplete" : "onReverseComplete", true), t4._prom && t4._prom()));
        } else t4._zTime || (t4._zTime = e4);
      })(this, t3, e3, r3);
      return this;
    }, e2.targets = function targets() {
      return this._targets;
    }, e2.invalidate = function invalidate() {
      return this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(), R2.prototype.invalidate.call(this);
    }, e2.resetTo = function resetTo(t3, e3, r3, i2) {
      c || Dt.wake(), this._ts || this.play();
      var n3, a2 = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
      return this._initted || Xt(this, a2), n3 = this._ease(a2 / this._dur), (function _updatePropTweens(t4, e4, r4, i3, n4, a3, s2) {
        var o2, u2, h2, l2 = (t4._pt && t4._ptCache || (t4._ptCache = {}))[e4];
        if (!l2) for (l2 = t4._ptCache[e4] = [], u2 = t4._ptLookup, h2 = t4._targets.length; h2--; ) {
          if ((o2 = u2[h2][e4]) && o2.d && o2.d._pt) for (o2 = o2.d._pt; o2 && o2.p !== e4; ) o2 = o2._next;
          if (!o2) return qt = 1, t4.vars[e4] = "+=0", Xt(t4, s2), qt = 0, 1;
          l2.push(o2);
        }
        for (h2 = l2.length; h2--; ) (o2 = l2[h2]).s = !i3 && 0 !== i3 || n4 ? o2.s + (i3 || 0) + a3 * o2.c : i3, o2.c = r4 - o2.s, o2.e && (o2.e = ca(r4) + Ra(o2.e)), o2.b && (o2.b = o2.s + Ra(o2.b));
      })(this, t3, e3, r3, i2, n3, a2) ? this.resetTo(t3, e3, r3, i2) : (Ba(this, 0), this.parent || ra(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
    }, e2.kill = function kill(t3, e3) {
      if (void 0 === e3 && (e3 = "all"), !(t3 || e3 && "all" !== e3)) return this._lazy = this._pt = 0, this.parent ? mb(this) : this;
      if (this.timeline) {
        var r3 = this.timeline.totalDuration();
        return this.timeline.killTweensOf(t3, e3, Yt && true !== Yt.vars.overwrite)._first || mb(this), this.parent && r3 !== this.timeline.totalDuration() && Ka(this, this._dur * this.timeline._tDur / r3, 0, 1), this;
      }
      var i2, n3, a2, s2, u2, h2, l2, f2 = this._targets, d2 = t3 ? xt(t3) : f2, p2 = this._ptLookup, c2 = this._pt;
      if ((!e3 || "all" === e3) && (function _arraysMatch(t4, e4) {
        for (var r4 = t4.length, i3 = r4 === e4.length; i3 && r4-- && t4[r4] === e4[r4]; ) ;
        return r4 < 0;
      })(f2, d2)) return "all" === e3 && (this._pt = 0), mb(this);
      for (i2 = this._op = this._op || [], "all" !== e3 && (o(e3) && (u2 = {}, ba(e3, function(t4) {
        return u2[t4] = 1;
      }), e3 = u2), e3 = (function _addAliasesToVars(t4, e4) {
        var r4, i3, n4, a3, s3 = t4[0] ? _(t4[0]).harness : 0, o2 = s3 && s3.aliases;
        if (!o2) return e4;
        for (i3 in r4 = mt({}, e4), o2) if (i3 in r4) for (n4 = (a3 = o2[i3].split(",")).length; n4--; ) r4[a3[n4]] = r4[i3];
        return r4;
      })(f2, e3)), l2 = f2.length; l2--; ) if (~d2.indexOf(f2[l2])) for (u2 in n3 = p2[l2], "all" === e3 ? (i2[l2] = e3, s2 = n3, a2 = {}) : (a2 = i2[l2] = i2[l2] || {}, s2 = e3), s2) (h2 = n3 && n3[u2]) && ("kill" in h2.d && true !== h2.d.kill(u2) || sa(this, h2, "_pt"), delete n3[u2]), "all" !== a2 && (a2[u2] = 1);
      return this._initted && !this._pt && c2 && mb(this), this;
    }, Tween.to = function to(t3, e3, r3) {
      return new Tween(t3, e3, r3);
    }, Tween.from = function from(t3, e3) {
      return Oa(1, arguments);
    }, Tween.delayedCall = function delayedCall(t3, e3, r3, i2) {
      return new Tween(e3, 0, { immediateRender: false, lazy: false, overwrite: false, delay: t3, onComplete: e3, onReverseComplete: e3, onCompleteParams: r3, onReverseCompleteParams: r3, callbackScope: i2 });
    }, Tween.fromTo = function fromTo(t3, e3, r3) {
      return Oa(2, arguments);
    }, Tween.set = function set(t3, e3) {
      return e3.duration = 0, e3.repeatDelay || (e3.repeat = 0), new Tween(t3, e3);
    }, Tween.killTweensOf = function killTweensOf(t3, e3, r3) {
      return I.killTweensOf(t3, e3, r3);
    }, Tween;
  })(Nt);
  ka($t.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }), ba("staggerTo,staggerFrom,staggerFromTo", function(r3) {
    $t[r3] = function() {
      var t3 = new Ut(), e2 = wt.call(arguments, 0);
      return e2.splice("staggerFromTo" === r3 ? 5 : 4, 0, 0), t3[r3].apply(t3, e2);
    };
  });
  function gc(t3, e2, r3) {
    return t3.setAttribute(e2, r3);
  }
  function oc(t3, e2, r3, i2) {
    i2.mSet(t3, e2, i2.m.call(i2.tween, r3, i2.mt), i2);
  }
  var Gt = function _setterPlain(t3, e2, r3) {
    return t3[e2] = r3;
  }, Wt = function _setterFunc(t3, e2, r3) {
    return t3[e2](r3);
  }, Zt = function _setterFuncWithParam(t3, e2, r3, i2) {
    return t3[e2](i2.fp, r3);
  }, Ht = function _getSetter(t3, e2) {
    return p(t3[e2]) ? Wt : r2(t3[e2]) && t3.setAttribute ? gc : Gt;
  }, Jt2 = function _renderPlain(t3, e2) {
    return e2.set(e2.t, e2.p, Math.round(1e6 * (e2.s + e2.c * t3)) / 1e6, e2);
  }, te = function _renderBoolean(t3, e2) {
    return e2.set(e2.t, e2.p, !!(e2.s + e2.c * t3), e2);
  }, ee = function _renderComplexString(t3, e2) {
    var r3 = e2._pt, i2 = "";
    if (!t3 && e2.b) i2 = e2.b;
    else if (1 === t3 && e2.e) i2 = e2.e;
    else {
      for (; r3; ) i2 = r3.p + (r3.m ? r3.m(r3.s + r3.c * t3) : Math.round(1e4 * (r3.s + r3.c * t3)) / 1e4) + i2, r3 = r3._next;
      i2 += e2.c;
    }
    e2.set(e2.t, e2.p, i2, e2);
  }, re = function _renderPropTweens(t3, e2) {
    for (var r3 = e2._pt; r3; ) r3.r(t3, r3.d), r3 = r3._next;
  }, ie = function _addPluginModifier(t3, e2, r3, i2) {
    for (var n3, a2 = this._pt; a2; ) n3 = a2._next, a2.p === i2 && a2.modifier(t3, e2, r3), a2 = n3;
  }, ne = function _killPropTweensOf(t3) {
    for (var e2, r3, i2 = this._pt; i2; ) r3 = i2._next, i2.p === t3 && !i2.op || i2.op === t3 ? sa(this, i2, "_pt") : i2.dep || (e2 = 1), i2 = r3;
    return !e2;
  }, se = function _sortPropTweensByPriority(t3) {
    for (var e2, r3, i2, n3, a2 = t3._pt; a2; ) {
      for (e2 = a2._next, r3 = i2; r3 && r3.pr > a2.pr; ) r3 = r3._next;
      (a2._prev = r3 ? r3._prev : n3) ? a2._prev._next = a2 : i2 = a2, (a2._next = r3) ? r3._prev = a2 : n3 = a2, a2 = e2;
    }
    t3._pt = i2;
  }, oe = (PropTween.prototype.modifier = function modifier(t3, e2, r3) {
    this.mSet = this.mSet || this.set, this.set = oc, this.m = t3, this.mt = r3, this.tween = e2;
  }, PropTween);
  function PropTween(t3, e2, r3, i2, n3, a2, s2, o2, u2) {
    this.t = e2, this.s = i2, this.c = n3, this.p = r3, this.r = a2 || Jt2, this.d = s2 || this, this.set = o2 || Gt, this.pr = u2 || 0, (this._next = t3) && (t3._prev = this);
  }
  ba(ct + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t3) {
    return ut[t3] = 1;
  }), ot.TweenMax = ot.TweenLite = $t, ot.TimelineLite = ot.TimelineMax = Ut, I = new Ut({ sortChildren: false, defaults: L, autoRemoveChildren: true, id: "root", smoothChildTiming: true }), U.stringFilter = xb;
  var ue = { registerPlugin: function registerPlugin() {
    for (var t3 = arguments.length, e2 = new Array(t3), r3 = 0; r3 < t3; r3++) e2[r3] = arguments[r3];
    e2.forEach(function(t4) {
      return (function _createPlugin(t5) {
        var e3 = (t5 = !t5.name && t5.default || t5).name, r4 = p(t5), i2 = e3 && !r4 && t5.init ? function() {
          this._props = [];
        } : t5, n3 = { init: Q, render: re, add: Vt, kill: ne, modifier: ie, rawVars: 0 }, a2 = { targetTest: 0, get: 0, getSetter: Ht, aliases: {}, register: 0 };
        if (St(), t5 !== i2) {
          if (ft[e3]) return;
          ka(i2, ka(oa(t5, n3), a2)), mt(i2.prototype, mt(n3, oa(t5, a2))), ft[i2.prop = e3] = i2, t5.targetTest && (pt.push(i2), ut[e3] = 1), e3 = ("css" === e3 ? "CSS" : e3.charAt(0).toUpperCase() + e3.substr(1)) + "Plugin";
        }
        P(e3, i2), t5.register && t5.register(he, i2, oe);
      })(t4);
    });
  }, timeline: function timeline(t3) {
    return new Ut(t3);
  }, getTweensOf: function getTweensOf(t3, e2) {
    return I.getTweensOf(t3, e2);
  }, getProperty: function getProperty(i2, t3, e2, r3) {
    o(i2) && (i2 = xt(i2)[0]);
    var n3 = _(i2 || {}).get, a2 = e2 ? ja : ia;
    return "native" === e2 && (e2 = ""), i2 ? t3 ? a2((ft[t3] && ft[t3].get || n3)(i2, t3, e2, r3)) : function(t4, e3, r4) {
      return a2((ft[t4] && ft[t4].get || n3)(i2, t4, e3, r4));
    } : i2;
  }, quickSetter: function quickSetter(r3, e2, i2) {
    if (1 < (r3 = xt(r3)).length) {
      var n3 = r3.map(function(t3) {
        return he.quickSetter(t3, e2, i2);
      }), a2 = n3.length;
      return function(t3) {
        for (var e3 = a2; e3--; ) n3[e3](t3);
      };
    }
    r3 = r3[0] || {};
    var s2 = ft[e2], o2 = _(r3), u2 = o2.harness && (o2.harness.aliases || {})[e2] || e2, h2 = s2 ? function(t3) {
      var e3 = new s2();
      d._pt = 0, e3.init(r3, i2 ? t3 + i2 : t3, d, 0, [r3]), e3.render(1, e3), d._pt && re(1, d);
    } : o2.set(r3, u2);
    return s2 ? h2 : function(t3) {
      return h2(r3, u2, i2 ? t3 + i2 : t3, o2, 1);
    };
  }, quickTo: function quickTo(t3, i2, e2) {
    function iw(t4, e3, r4) {
      return n3.resetTo(i2, t4, e3, r4);
    }
    var r3, n3 = he.to(t3, mt(((r3 = {})[i2] = "+=0.1", r3.paused = true, r3), e2 || {}));
    return iw.tween = n3, iw;
  }, isTweening: function isTweening(t3) {
    return 0 < I.getTweensOf(t3, true).length;
  }, defaults: function defaults(t3) {
    return t3 && t3.ease && (t3.ease = Bt(t3.ease, L.ease)), na(L, t3 || {});
  }, config: function config(t3) {
    return na(U, t3 || {});
  }, registerEffect: function registerEffect(t3) {
    var i2 = t3.name, n3 = t3.effect, e2 = t3.plugins, a2 = t3.defaults, r3 = t3.extendTimeline;
    (e2 || "").split(",").forEach(function(t4) {
      return t4 && !ft[t4] && !ot[t4] && O(i2 + " effect requires " + t4 + " plugin.");
    }), dt[i2] = function(t4, e3, r4) {
      return n3(xt(t4), ka(e3 || {}, a2), r4);
    }, r3 && (Ut.prototype[i2] = function(t4, e3, r4) {
      return this.add(dt[i2](t4, s(e3) ? e3 : (r4 = e3) && {}, this), r4);
    });
  }, registerEase: function registerEase(t3, e2) {
    zt[t3] = Bt(e2);
  }, parseEase: function parseEase(t3, e2) {
    return arguments.length ? Bt(t3, e2) : zt;
  }, getById: function getById(t3) {
    return I.getById(t3);
  }, exportRoot: function exportRoot(e2, r3) {
    void 0 === e2 && (e2 = {});
    var i2, n3, a2 = new Ut(e2);
    for (a2.smoothChildTiming = t2(e2.smoothChildTiming), I.remove(a2), a2._dp = 0, a2._time = a2._tTime = I._time, i2 = I._first; i2; ) n3 = i2._next, !r3 && !i2._dur && i2 instanceof $t && i2.vars.onComplete === i2._targets[0] || Da(a2, i2, i2._start - i2._delay), i2 = n3;
    return Da(I, a2, 0), a2;
  }, utils: { wrap: function wrap(e2, t3, r3) {
    var i2 = t3 - e2;
    return J(e2) ? eb(e2, wrap(0, e2.length), t3) : Pa(r3, function(t4) {
      return (i2 + (t4 - e2) % i2) % i2 + e2;
    });
  }, wrapYoyo: function wrapYoyo(e2, t3, r3) {
    var i2 = t3 - e2, n3 = 2 * i2;
    return J(e2) ? eb(e2, wrapYoyo(0, e2.length - 1), t3) : Pa(r3, function(t4) {
      return e2 + (i2 < (t4 = (n3 + (t4 - e2) % n3) % n3 || 0) ? n3 - t4 : t4);
    });
  }, distribute: Za, random: ab, snap: _a, normalize: function normalize(t3, e2, r3) {
    return kt(t3, e2, 0, 1, r3);
  }, getUnit: Ra, clamp: function clamp(e2, r3, t3) {
    return Pa(t3, function(t4) {
      return bt(e2, r3, t4);
    });
  }, splitColor: sb, toArray: xt, selector: function selector(r3) {
    return r3 = xt(r3)[0] || O("Invalid scope") || {}, function(t3) {
      var e2 = r3.current || r3.nativeElement || r3;
      return xt(t3, e2.querySelectorAll ? e2 : e2 === r3 ? O("Invalid scope") || a.createElement("div") : r3);
    };
  }, mapRange: kt, pipe: function pipe() {
    for (var t3 = arguments.length, e2 = new Array(t3), r3 = 0; r3 < t3; r3++) e2[r3] = arguments[r3];
    return function(t4) {
      return e2.reduce(function(t5, e3) {
        return e3(t5);
      }, t4);
    };
  }, unitize: function unitize(e2, r3) {
    return function(t3) {
      return e2(parseFloat(t3)) + (r3 || Ra(t3));
    };
  }, interpolate: function interpolate(e2, r3, t3, i2) {
    var n3 = isNaN(e2 + r3) ? 0 : function(t4) {
      return (1 - t4) * e2 + t4 * r3;
    };
    if (!n3) {
      var a2, s2, u2, h2, l2, f2 = o(e2), d2 = {};
      if (true === t3 && (i2 = 1) && (t3 = null), f2) e2 = { p: e2 }, r3 = { p: r3 };
      else if (J(e2) && !J(r3)) {
        for (u2 = [], h2 = e2.length, l2 = h2 - 2, s2 = 1; s2 < h2; s2++) u2.push(interpolate(e2[s2 - 1], e2[s2]));
        h2--, n3 = function func(t4) {
          t4 *= h2;
          var e3 = Math.min(l2, ~~t4);
          return u2[e3](t4 - e3);
        }, t3 = r3;
      } else i2 || (e2 = mt(J(e2) ? [] : {}, e2));
      if (!u2) {
        for (a2 in r3) Vt.call(d2, e2, a2, "get", r3[a2]);
        n3 = function func(t4) {
          return re(t4, d2) || (f2 ? e2.p : e2);
        };
      }
    }
    return Pa(t3, n3);
  }, shuffle: Ya }, install: M, effects: dt, ticker: Dt, updateRoot: Ut.updateRoot, plugins: ft, globalTimeline: I, core: { PropTween: oe, globals: P, Tween: $t, Timeline: Ut, Animation: Nt, getCache: _, _removeLinkedListItem: sa, suppressOverwrites: function suppressOverwrites(t3) {
    return B = t3;
  } } };
  ba("to,from,fromTo,delayedCall,set,killTweensOf", function(t3) {
    return ue[t3] = $t[t3];
  }), Dt.add(Ut.updateRoot), d = ue.to({}, { duration: 0 });
  function sc(t3, e2) {
    for (var r3 = t3._pt; r3 && r3.p !== e2 && r3.op !== e2 && r3.fp !== e2; ) r3 = r3._next;
    return r3;
  }
  function uc(t3, n3) {
    return { name: t3, rawVars: 1, init: function init(t4, i2, e2) {
      e2._onInit = function(t5) {
        var e3, r3;
        if (o(i2) && (e3 = {}, ba(i2, function(t6) {
          return e3[t6] = 1;
        }), i2 = e3), n3) {
          for (r3 in e3 = {}, i2) e3[r3] = n3(i2[r3]);
          i2 = e3;
        }
        !(function _addModifiers(t6, e4) {
          var r4, i3, n4, a2 = t6._targets;
          for (r4 in e4) for (i3 = a2.length; i3--; ) (n4 = (n4 = t6._ptLookup[i3][r4]) && n4.d) && (n4._pt && (n4 = sc(n4, r4)), n4 && n4.modifier && n4.modifier(e4[r4], t6, a2[i3], r4));
        })(t5, i2);
      };
    } };
  }
  var he = ue.registerPlugin({ name: "attr", init: function init(t3, e2, r3, i2, n3) {
    var a2, s2;
    for (a2 in e2) (s2 = this.add(t3, "setAttribute", (t3.getAttribute(a2) || 0) + "", e2[a2], i2, n3, 0, 0, a2)) && (s2.op = a2), this._props.push(a2);
  } }, { name: "endArray", init: function init(t3, e2) {
    for (var r3 = e2.length; r3--; ) this.add(t3, r3, t3[r3] || 0, e2[r3]);
  } }, uc("roundProps", $a), uc("modifiers"), uc("snap", _a)) || ue;
  $t.version = Ut.version = he.version = "3.10.2", l = 1, u() && St();
  function dd(t3, e2) {
    return e2.set(e2.t, e2.p, Math.round(1e4 * (e2.s + e2.c * t3)) / 1e4 + e2.u, e2);
  }
  function ed(t3, e2) {
    return e2.set(e2.t, e2.p, 1 === t3 ? e2.e : Math.round(1e4 * (e2.s + e2.c * t3)) / 1e4 + e2.u, e2);
  }
  function fd(t3, e2) {
    return e2.set(e2.t, e2.p, t3 ? Math.round(1e4 * (e2.s + e2.c * t3)) / 1e4 + e2.u : e2.b, e2);
  }
  function gd(t3, e2) {
    var r3 = e2.s + e2.c * t3;
    e2.set(e2.t, e2.p, ~~(r3 + (r3 < 0 ? -0.5 : 0.5)) + e2.u, e2);
  }
  function hd(t3, e2) {
    return e2.set(e2.t, e2.p, t3 ? e2.e : e2.b, e2);
  }
  function id(t3, e2) {
    return e2.set(e2.t, e2.p, 1 !== t3 ? e2.b : e2.e, e2);
  }
  function jd(t3, e2, r3) {
    return t3.style[e2] = r3;
  }
  function kd(t3, e2, r3) {
    return t3.style.setProperty(e2, r3);
  }
  function ld(t3, e2, r3) {
    return t3._gsap[e2] = r3;
  }
  function md(t3, e2, r3) {
    return t3._gsap.scaleX = t3._gsap.scaleY = r3;
  }
  function nd(t3, e2, r3, i2, n3) {
    var a2 = t3._gsap;
    a2.scaleX = a2.scaleY = r3, a2.renderTransform(n3, a2);
  }
  function od(t3, e2, r3, i2, n3) {
    var a2 = t3._gsap;
    a2[e2] = r3, a2.renderTransform(n3, a2);
  }
  function sd(t3, e2) {
    var r3 = fe.createElementNS ? fe.createElementNS((e2 || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t3) : fe.createElement(t3);
    return r3.style ? r3 : fe.createElement(t3);
  }
  function td(t3, e2, r3) {
    var i2 = getComputedStyle(t3);
    return i2[e2] || i2.getPropertyValue(e2.replace(Ne, "-$1").toLowerCase()) || i2.getPropertyValue(e2) || !r3 && td(t3, je(e2) || e2, 1) || "";
  }
  function wd() {
    /* @__PURE__ */ (function _windowExists() {
      return "undefined" != typeof window;
    })() && window.document && (le = window, fe = le.document, de = fe.documentElement, pe = sd("div") || { style: {} }, sd("div"), Ve = je(Ve), Xe = Ve + "Origin", pe.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", me = !!je("perspective"), _e = 1);
  }
  function xd(t3) {
    var e2, r3 = sd("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), i2 = this.parentNode, n3 = this.nextSibling, a2 = this.style.cssText;
    if (de.appendChild(r3), r3.appendChild(this), this.style.display = "block", t3) try {
      e2 = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = xd;
    } catch (t4) {
    }
    else this._gsapBBox && (e2 = this._gsapBBox());
    return i2 && (n3 ? i2.insertBefore(this, n3) : i2.appendChild(this)), de.removeChild(r3), this.style.cssText = a2, e2;
  }
  function yd(t3, e2) {
    for (var r3 = e2.length; r3--; ) if (t3.hasAttribute(e2[r3])) return t3.getAttribute(e2[r3]);
  }
  function zd(e2) {
    var r3;
    try {
      r3 = e2.getBBox();
    } catch (t3) {
      r3 = xd.call(e2, true);
    }
    return r3 && (r3.width || r3.height) || e2.getBBox === xd || (r3 = xd.call(e2, true)), !r3 || r3.width || r3.x || r3.y ? r3 : { x: +yd(e2, ["x", "cx", "x1"]) || 0, y: +yd(e2, ["y", "cy", "y1"]) || 0, width: 0, height: 0 };
  }
  function Ad(t3) {
    return !(!t3.getCTM || t3.parentNode && !t3.ownerSVGElement || !zd(t3));
  }
  function Bd(t3, e2) {
    if (e2) {
      var r3 = t3.style;
      e2 in Fe && e2 !== Xe && (e2 = Ve), r3.removeProperty ? ("ms" !== e2.substr(0, 2) && "webkit" !== e2.substr(0, 6) || (e2 = "-" + e2), r3.removeProperty(e2.replace(Ne, "-$1").toLowerCase())) : r3.removeAttribute(e2);
    }
  }
  function Cd(t3, e2, r3, i2, n3, a2) {
    var s2 = new oe(t3._pt, e2, r3, 0, 1, a2 ? id : hd);
    return (t3._pt = s2).b = i2, s2.e = n3, t3._props.push(r3), s2;
  }
  function Ed(t3, e2, r3, i2) {
    var n3, a2, s2, o2, u2 = parseFloat(r3) || 0, h2 = (r3 + "").trim().substr((u2 + "").length) || "px", l2 = pe.style, f2 = Ue.test(e2), d2 = "svg" === t3.tagName.toLowerCase(), p2 = (d2 ? "client" : "offset") + (f2 ? "Width" : "Height"), c2 = "px" === i2, m2 = "%" === i2;
    return i2 === h2 || !u2 || Ke[i2] || Ke[h2] ? u2 : ("px" === h2 || c2 || (u2 = Ed(t3, e2, r3, "px")), o2 = t3.getCTM && Ad(t3), !m2 && "%" !== h2 || !Fe[e2] && !~e2.indexOf("adius") ? (l2[f2 ? "width" : "height"] = 100 + (c2 ? h2 : i2), a2 = ~e2.indexOf("adius") || "em" === i2 && t3.appendChild && !d2 ? t3 : t3.parentNode, o2 && (a2 = (t3.ownerSVGElement || {}).parentNode), a2 && a2 !== fe && a2.appendChild || (a2 = fe.body), (s2 = a2._gsap) && m2 && s2.width && f2 && s2.time === Dt.time ? ca(u2 / s2.width * 100) : (!m2 && "%" !== h2 || (l2.position = td(t3, "position")), a2 === t3 && (l2.position = "static"), a2.appendChild(pe), n3 = pe[p2], a2.removeChild(pe), l2.position = "absolute", f2 && m2 && ((s2 = _(a2)).time = Dt.time, s2.width = a2[p2]), ca(c2 ? n3 * u2 / 100 : n3 && u2 ? 100 / n3 * u2 : 0))) : (n3 = o2 ? t3.getBBox()[f2 ? "width" : "height"] : t3[p2], ca(m2 ? u2 / n3 * 100 : u2 / 100 * n3)));
  }
  function Fd(t3, e2, r3, i2) {
    var n3;
    return _e || wd(), e2 in qe && "transform" !== e2 && ~(e2 = qe[e2]).indexOf(",") && (e2 = e2.split(",")[0]), Fe[e2] && "transform" !== e2 ? (n3 = He(t3, i2), n3 = "transformOrigin" !== e2 ? n3[e2] : n3.svg ? n3.origin : Je(td(t3, Xe)) + " " + n3.zOrigin + "px") : (n3 = t3.style[e2]) && "auto" !== n3 && !i2 && !~(n3 + "").indexOf("calc(") || (n3 = Ge[e2] && Ge[e2](t3, e2, r3) || td(t3, e2) || aa(t3, e2) || ("opacity" === e2 ? 1 : 0)), r3 && !~(n3 + "").trim().indexOf(" ") ? Ed(t3, e2, n3, r3) + r3 : n3;
  }
  function Gd(t3, e2, r3, i2) {
    if (!r3 || "none" === r3) {
      var n3 = je(e2, t3, 1), a2 = n3 && td(t3, n3, 1);
      a2 && a2 !== r3 ? (e2 = n3, r3 = a2) : "borderColor" === e2 && (r3 = td(t3, "borderTopColor"));
    }
    var s2, o2, u2, h2, l2, f2, d2, _2, p2, c2, m2, g2 = new oe(this._pt, t3.style, e2, 0, 1, ee), v2 = 0, y2 = 0;
    if (g2.b = r3, g2.e = i2, r3 += "", "auto" === (i2 += "") && (t3.style[e2] = i2, i2 = td(t3, e2) || i2, t3.style[e2] = r3), xb(s2 = [r3, i2]), i2 = s2[1], u2 = (r3 = s2[0]).match(rt) || [], (i2.match(rt) || []).length) {
      for (; o2 = rt.exec(i2); ) d2 = o2[0], p2 = i2.substring(v2, o2.index), l2 ? l2 = (l2 + 1) % 5 : "rgba(" !== p2.substr(-5) && "hsla(" !== p2.substr(-5) || (l2 = 1), d2 !== (f2 = u2[y2++] || "") && (h2 = parseFloat(f2) || 0, m2 = f2.substr((h2 + "").length), "=" === d2.charAt(1) && (d2 = ea(h2, d2) + m2), _2 = parseFloat(d2), c2 = d2.substr((_2 + "").length), v2 = rt.lastIndex - c2.length, c2 || (c2 = c2 || U.units[e2] || m2, v2 === i2.length && (i2 += c2, g2.e += c2)), m2 !== c2 && (h2 = Ed(t3, e2, f2, c2) || 0), g2._pt = { _next: g2._pt, p: p2 || 1 === y2 ? p2 : ",", s: h2, c: _2 - h2, m: l2 && l2 < 4 || "zIndex" === e2 ? Math.round : 0 });
      g2.c = v2 < i2.length ? i2.substring(v2, i2.length) : "";
    } else g2.r = "display" === e2 && "none" === i2 ? id : hd;
    return nt.test(i2) && (g2.e = 0), this._pt = g2;
  }
  function Id(t3) {
    var e2 = t3.split(" "), r3 = e2[0], i2 = e2[1] || "50%";
    return "top" !== r3 && "bottom" !== r3 && "left" !== i2 && "right" !== i2 || (t3 = r3, r3 = i2, i2 = t3), e2[0] = $e[r3] || r3, e2[1] = $e[i2] || i2, e2.join(" ");
  }
  function Jd(t3, e2) {
    if (e2.tween && e2.tween._time === e2.tween._dur) {
      var r3, i2, n3, a2 = e2.t, s2 = a2.style, o2 = e2.u, u2 = a2._gsap;
      if ("all" === o2 || true === o2) s2.cssText = "", i2 = 1;
      else for (n3 = (o2 = o2.split(",")).length; -1 < --n3; ) r3 = o2[n3], Fe[r3] && (i2 = 1, r3 = "transformOrigin" === r3 ? Xe : Ve), Bd(a2, r3);
      i2 && (Bd(a2, Ve), u2 && (u2.svg && a2.removeAttribute("transform"), He(a2, 1), u2.uncache = 1));
    }
  }
  function Nd(t3) {
    return "matrix(1, 0, 0, 1, 0, 0)" === t3 || "none" === t3 || !t3;
  }
  function Od(t3) {
    var e2 = td(t3, Ve);
    return Nd(e2) ? We : e2.substr(7).match(et).map(ca);
  }
  function Pd(t3, e2) {
    var r3, i2, n3, a2, s2 = t3._gsap || _(t3), o2 = t3.style, u2 = Od(t3);
    return s2.svg && t3.getAttribute("transform") ? "1,0,0,1,0,0" === (u2 = [(n3 = t3.transform.baseVal.consolidate().matrix).a, n3.b, n3.c, n3.d, n3.e, n3.f]).join(",") ? We : u2 : (u2 !== We || t3.offsetParent || t3 === de || s2.svg || (n3 = o2.display, o2.display = "block", (r3 = t3.parentNode) && t3.offsetParent || (a2 = 1, i2 = t3.nextSibling, de.appendChild(t3)), u2 = Od(t3), n3 ? o2.display = n3 : Bd(t3, "display"), a2 && (i2 ? r3.insertBefore(t3, i2) : r3 ? r3.appendChild(t3) : de.removeChild(t3))), e2 && 6 < u2.length ? [u2[0], u2[1], u2[4], u2[5], u2[12], u2[13]] : u2);
  }
  function Qd(t3, e2, r3, i2, n3, a2) {
    var s2, o2, u2, h2 = t3._gsap, l2 = n3 || Pd(t3, true), f2 = h2.xOrigin || 0, d2 = h2.yOrigin || 0, _2 = h2.xOffset || 0, p2 = h2.yOffset || 0, c2 = l2[0], m2 = l2[1], g2 = l2[2], v2 = l2[3], y2 = l2[4], T2 = l2[5], b2 = e2.split(" "), w2 = parseFloat(b2[0]) || 0, x2 = parseFloat(b2[1]) || 0;
    r3 ? l2 !== We && (o2 = c2 * v2 - m2 * g2) && (u2 = w2 * (-m2 / o2) + x2 * (c2 / o2) - (c2 * T2 - m2 * y2) / o2, w2 = w2 * (v2 / o2) + x2 * (-g2 / o2) + (g2 * T2 - v2 * y2) / o2, x2 = u2) : (w2 = (s2 = zd(t3)).x + (~b2[0].indexOf("%") ? w2 / 100 * s2.width : w2), x2 = s2.y + (~(b2[1] || b2[0]).indexOf("%") ? x2 / 100 * s2.height : x2)), i2 || false !== i2 && h2.smooth ? (y2 = w2 - f2, T2 = x2 - d2, h2.xOffset = _2 + (y2 * c2 + T2 * g2) - y2, h2.yOffset = p2 + (y2 * m2 + T2 * v2) - T2) : h2.xOffset = h2.yOffset = 0, h2.xOrigin = w2, h2.yOrigin = x2, h2.smooth = !!i2, h2.origin = e2, h2.originIsAbsolute = !!r3, t3.style[Xe] = "0px 0px", a2 && (Cd(a2, h2, "xOrigin", f2, w2), Cd(a2, h2, "yOrigin", d2, x2), Cd(a2, h2, "xOffset", _2, h2.xOffset), Cd(a2, h2, "yOffset", p2, h2.yOffset)), t3.setAttribute("data-svg-origin", w2 + " " + x2);
  }
  function Td(t3, e2, r3) {
    var i2 = Ra(e2);
    return ca(parseFloat(e2) + parseFloat(Ed(t3, "x", r3 + "px", i2))) + i2;
  }
  function $d(t3, e2, r3, i2, n3) {
    var a2, s2, u2 = 360, h2 = o(n3), l2 = parseFloat(n3) * (h2 && ~n3.indexOf("rad") ? Be : 1) - i2, f2 = i2 + l2 + "deg";
    return h2 && ("short" === (a2 = n3.split("_")[1]) && (l2 %= u2) !== l2 % 180 && (l2 += l2 < 0 ? u2 : -u2), "cw" === a2 && l2 < 0 ? l2 = (l2 + 36e9) % u2 - ~~(l2 / u2) * u2 : "ccw" === a2 && 0 < l2 && (l2 = (l2 - 36e9) % u2 - ~~(l2 / u2) * u2)), t3._pt = s2 = new oe(t3._pt, e2, r3, i2, l2, ed), s2.e = f2, s2.u = "deg", t3._props.push(r3), s2;
  }
  function _d(t3, e2) {
    for (var r3 in e2) t3[r3] = e2[r3];
    return t3;
  }
  function ae(t3, e2, r3) {
    var i2, n3, a2, s2, o2, u2, h2, l2 = _d({}, r3._gsap), f2 = r3.style;
    for (n3 in l2.svg ? (a2 = r3.getAttribute("transform"), r3.setAttribute("transform", ""), f2[Ve] = e2, i2 = He(r3, 1), Bd(r3, Ve), r3.setAttribute("transform", a2)) : (a2 = getComputedStyle(r3)[Ve], f2[Ve] = e2, i2 = He(r3, 1), f2[Ve] = a2), Fe) (a2 = l2[n3]) !== (s2 = i2[n3]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(n3) < 0 && (o2 = Ra(a2) !== (h2 = Ra(s2)) ? Ed(r3, n3, a2, h2) : parseFloat(a2), u2 = parseFloat(s2), t3._pt = new oe(t3._pt, i2, n3, o2, u2 - o2, dd), t3._pt.u = h2 || 0, t3._props.push(n3));
    _d(i2, l2);
  }
  var le, fe, de, _e, pe, ce, me, ge = zt.Power0, ve = zt.Power1, ye = zt.Power2, Te = zt.Power3, be = zt.Power4, we = zt.Linear, xe = zt.Quad, ke = zt.Cubic, Oe = zt.Quart, Pe = zt.Quint, Me = zt.Strong, Ce = zt.Elastic, Ae = zt.Back, De = zt.SteppedEase, Se = zt.Bounce, ze = zt.Sine, Re = zt.Expo, Ee = zt.Circ, Fe = {}, Be = 180 / Math.PI, Ie = Math.PI / 180, Le = Math.atan2, Ne = /([A-Z])/g, Ue = /(left|right|width|margin|padding|x)/i, Ye = /[\s,\(]\S/, qe = { autoAlpha: "opacity,visibility", scale: "scaleX,scaleY", alpha: "opacity" }, Ve = "transform", Xe = Ve + "Origin", Qe = "O,Moz,ms,Ms,Webkit".split(","), je = function _checkPropPrefix(t3, e2, r3) {
    var i2 = (e2 || pe).style, n3 = 5;
    if (t3 in i2 && !r3) return t3;
    for (t3 = t3.charAt(0).toUpperCase() + t3.substr(1); n3-- && !(Qe[n3] + t3 in i2); ) ;
    return n3 < 0 ? null : (3 === n3 ? "ms" : 0 <= n3 ? Qe[n3] : "") + t3;
  }, Ke = { deg: 1, rad: 1, turn: 1 }, $e = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" }, Ge = { clearProps: function clearProps(t3, e2, r3, i2, n3) {
    if ("isFromStart" !== n3.data) {
      var a2 = t3._pt = new oe(t3._pt, e2, r3, 0, 0, Jd);
      return a2.u = i2, a2.pr = -10, a2.tween = n3, t3._props.push(r3), 1;
    }
  } }, We = [1, 0, 0, 1, 0, 0], Ze = {}, He = function _parseTransform(t3, e2) {
    var r3 = t3._gsap || new Lt(t3);
    if ("x" in r3 && !e2 && !r3.uncache) return r3;
    var i2, n3, a2, s2, o2, u2, h2, l2, f2, d2, _2, p2, c2, m2, g2, v2, y2, T2, b2, w2, x2, k2, O2, P2, M2, C2, A2, D2, S2, z2, R2, E2, F2 = t3.style, B2 = r3.scaleX < 0, I2 = "deg", L2 = td(t3, Xe) || "0";
    return i2 = n3 = a2 = u2 = h2 = l2 = f2 = d2 = _2 = 0, s2 = o2 = 1, r3.svg = !(!t3.getCTM || !Ad(t3)), m2 = Pd(t3, r3.svg), r3.svg && (P2 = (!r3.uncache || "0px 0px" === L2) && !e2 && t3.getAttribute("data-svg-origin"), Qd(t3, P2 || L2, !!P2 || r3.originIsAbsolute, false !== r3.smooth, m2)), p2 = r3.xOrigin || 0, c2 = r3.yOrigin || 0, m2 !== We && (T2 = m2[0], b2 = m2[1], w2 = m2[2], x2 = m2[3], i2 = k2 = m2[4], n3 = O2 = m2[5], 6 === m2.length ? (s2 = Math.sqrt(T2 * T2 + b2 * b2), o2 = Math.sqrt(x2 * x2 + w2 * w2), u2 = T2 || b2 ? Le(b2, T2) * Be : 0, (f2 = w2 || x2 ? Le(w2, x2) * Be + u2 : 0) && (o2 *= Math.abs(Math.cos(f2 * Ie))), r3.svg && (i2 -= p2 - (p2 * T2 + c2 * w2), n3 -= c2 - (p2 * b2 + c2 * x2))) : (E2 = m2[6], z2 = m2[7], A2 = m2[8], D2 = m2[9], S2 = m2[10], R2 = m2[11], i2 = m2[12], n3 = m2[13], a2 = m2[14], h2 = (g2 = Le(E2, S2)) * Be, g2 && (P2 = k2 * (v2 = Math.cos(-g2)) + A2 * (y2 = Math.sin(-g2)), M2 = O2 * v2 + D2 * y2, C2 = E2 * v2 + S2 * y2, A2 = k2 * -y2 + A2 * v2, D2 = O2 * -y2 + D2 * v2, S2 = E2 * -y2 + S2 * v2, R2 = z2 * -y2 + R2 * v2, k2 = P2, O2 = M2, E2 = C2), l2 = (g2 = Le(-w2, S2)) * Be, g2 && (v2 = Math.cos(-g2), R2 = x2 * (y2 = Math.sin(-g2)) + R2 * v2, T2 = P2 = T2 * v2 - A2 * y2, b2 = M2 = b2 * v2 - D2 * y2, w2 = C2 = w2 * v2 - S2 * y2), u2 = (g2 = Le(b2, T2)) * Be, g2 && (P2 = T2 * (v2 = Math.cos(g2)) + b2 * (y2 = Math.sin(g2)), M2 = k2 * v2 + O2 * y2, b2 = b2 * v2 - T2 * y2, O2 = O2 * v2 - k2 * y2, T2 = P2, k2 = M2), h2 && 359.9 < Math.abs(h2) + Math.abs(u2) && (h2 = u2 = 0, l2 = 180 - l2), s2 = ca(Math.sqrt(T2 * T2 + b2 * b2 + w2 * w2)), o2 = ca(Math.sqrt(O2 * O2 + E2 * E2)), g2 = Le(k2, O2), f2 = 2e-4 < Math.abs(g2) ? g2 * Be : 0, _2 = R2 ? 1 / (R2 < 0 ? -R2 : R2) : 0), r3.svg && (P2 = t3.getAttribute("transform"), r3.forceCSS = t3.setAttribute("transform", "") || !Nd(td(t3, Ve)), P2 && t3.setAttribute("transform", P2))), 90 < Math.abs(f2) && Math.abs(f2) < 270 && (B2 ? (s2 *= -1, f2 += u2 <= 0 ? 180 : -180, u2 += u2 <= 0 ? 180 : -180) : (o2 *= -1, f2 += f2 <= 0 ? 180 : -180)), e2 = e2 || r3.uncache, r3.x = i2 - ((r3.xPercent = i2 && (!e2 && r3.xPercent || (Math.round(t3.offsetWidth / 2) === Math.round(-i2) ? -50 : 0))) ? t3.offsetWidth * r3.xPercent / 100 : 0) + "px", r3.y = n3 - ((r3.yPercent = n3 && (!e2 && r3.yPercent || (Math.round(t3.offsetHeight / 2) === Math.round(-n3) ? -50 : 0))) ? t3.offsetHeight * r3.yPercent / 100 : 0) + "px", r3.z = a2 + "px", r3.scaleX = ca(s2), r3.scaleY = ca(o2), r3.rotation = ca(u2) + I2, r3.rotationX = ca(h2) + I2, r3.rotationY = ca(l2) + I2, r3.skewX = f2 + I2, r3.skewY = d2 + I2, r3.transformPerspective = _2 + "px", (r3.zOrigin = parseFloat(L2.split(" ")[2]) || 0) && (F2[Xe] = Je(L2)), r3.xOffset = r3.yOffset = 0, r3.force3D = U.force3D, r3.renderTransform = r3.svg ? ar : me ? nr : tr, r3.uncache = 0, r3;
  }, Je = function _firstTwoOnly(t3) {
    return (t3 = t3.split(" "))[0] + " " + t3[1];
  }, tr = function _renderNon3DTransforms(t3, e2) {
    e2.z = "0px", e2.rotationY = e2.rotationX = "0deg", e2.force3D = 0, nr(t3, e2);
  }, er = "0deg", rr = "0px", ir = ") ", nr = function _renderCSSTransforms(t3, e2) {
    var r3 = e2 || this, i2 = r3.xPercent, n3 = r3.yPercent, a2 = r3.x, s2 = r3.y, o2 = r3.z, u2 = r3.rotation, h2 = r3.rotationY, l2 = r3.rotationX, f2 = r3.skewX, d2 = r3.skewY, _2 = r3.scaleX, p2 = r3.scaleY, c2 = r3.transformPerspective, m2 = r3.force3D, g2 = r3.target, v2 = r3.zOrigin, y2 = "", T2 = "auto" === m2 && t3 && 1 !== t3 || true === m2;
    if (v2 && (l2 !== er || h2 !== er)) {
      var b2, w2 = parseFloat(h2) * Ie, x2 = Math.sin(w2), k2 = Math.cos(w2);
      w2 = parseFloat(l2) * Ie, b2 = Math.cos(w2), a2 = Td(g2, a2, x2 * b2 * -v2), s2 = Td(g2, s2, -Math.sin(w2) * -v2), o2 = Td(g2, o2, k2 * b2 * -v2 + v2);
    }
    c2 !== rr && (y2 += "perspective(" + c2 + ir), (i2 || n3) && (y2 += "translate(" + i2 + "%, " + n3 + "%) "), !T2 && a2 === rr && s2 === rr && o2 === rr || (y2 += o2 !== rr || T2 ? "translate3d(" + a2 + ", " + s2 + ", " + o2 + ") " : "translate(" + a2 + ", " + s2 + ir), u2 !== er && (y2 += "rotate(" + u2 + ir), h2 !== er && (y2 += "rotateY(" + h2 + ir), l2 !== er && (y2 += "rotateX(" + l2 + ir), f2 === er && d2 === er || (y2 += "skew(" + f2 + ", " + d2 + ir), 1 === _2 && 1 === p2 || (y2 += "scale(" + _2 + ", " + p2 + ir), g2.style[Ve] = y2 || "translate(0, 0)";
  }, ar = function _renderSVGTransforms(t3, e2) {
    var r3, i2, n3, a2, s2, o2 = e2 || this, u2 = o2.xPercent, h2 = o2.yPercent, l2 = o2.x, f2 = o2.y, d2 = o2.rotation, _2 = o2.skewX, p2 = o2.skewY, c2 = o2.scaleX, m2 = o2.scaleY, g2 = o2.target, v2 = o2.xOrigin, y2 = o2.yOrigin, T2 = o2.xOffset, b2 = o2.yOffset, w2 = o2.forceCSS, x2 = parseFloat(l2), k2 = parseFloat(f2);
    d2 = parseFloat(d2), _2 = parseFloat(_2), (p2 = parseFloat(p2)) && (_2 += p2 = parseFloat(p2), d2 += p2), d2 || _2 ? (d2 *= Ie, _2 *= Ie, r3 = Math.cos(d2) * c2, i2 = Math.sin(d2) * c2, n3 = Math.sin(d2 - _2) * -m2, a2 = Math.cos(d2 - _2) * m2, _2 && (p2 *= Ie, s2 = Math.tan(_2 - p2), n3 *= s2 = Math.sqrt(1 + s2 * s2), a2 *= s2, p2 && (s2 = Math.tan(p2), r3 *= s2 = Math.sqrt(1 + s2 * s2), i2 *= s2)), r3 = ca(r3), i2 = ca(i2), n3 = ca(n3), a2 = ca(a2)) : (r3 = c2, a2 = m2, i2 = n3 = 0), (x2 && !~(l2 + "").indexOf("px") || k2 && !~(f2 + "").indexOf("px")) && (x2 = Ed(g2, "x", l2, "px"), k2 = Ed(g2, "y", f2, "px")), (v2 || y2 || T2 || b2) && (x2 = ca(x2 + v2 - (v2 * r3 + y2 * n3) + T2), k2 = ca(k2 + y2 - (v2 * i2 + y2 * a2) + b2)), (u2 || h2) && (s2 = g2.getBBox(), x2 = ca(x2 + u2 / 100 * s2.width), k2 = ca(k2 + h2 / 100 * s2.height)), s2 = "matrix(" + r3 + "," + i2 + "," + n3 + "," + a2 + "," + x2 + "," + k2 + ")", g2.setAttribute("transform", s2), w2 && (g2.style[Ve] = s2);
  };
  ba("padding,margin,Width,Radius", function(e2, r3) {
    var t3 = "Right", i2 = "Bottom", n3 = "Left", o2 = (r3 < 3 ? ["Top", t3, i2, n3] : ["Top" + n3, "Top" + t3, i2 + t3, i2 + n3]).map(function(t4) {
      return r3 < 2 ? e2 + t4 : "border" + t4 + e2;
    });
    Ge[1 < r3 ? "border" + e2 : e2] = function(e3, t4, r4, i3, n4) {
      var a2, s2;
      if (arguments.length < 4) return a2 = o2.map(function(t5) {
        return Fd(e3, t5, r4);
      }), 5 === (s2 = a2.join(" ")).split(a2[0]).length ? a2[0] : s2;
      a2 = (i3 + "").split(" "), s2 = {}, o2.forEach(function(t5, e4) {
        return s2[t5] = a2[e4] = a2[e4] || a2[(e4 - 1) / 2 | 0];
      }), e3.init(t4, s2, n4);
    };
  });
  var sr, or, ur, hr = { name: "css", register: wd, targetTest: function targetTest(t3) {
    return t3.style && t3.nodeType;
  }, init: function init(t3, e2, r3, i2, n3) {
    var a2, s2, u2, h2, l2, f2, d2, _2, p2, c2, m2, g2, v2, y2, T2, b2 = this._props, w2 = t3.style, x2 = r3.vars.startAt;
    for (d2 in _e || wd(), e2) if ("autoRound" !== d2 && (s2 = e2[d2], !ft[d2] || !Ub(d2, e2, r3, i2, t3, n3))) {
      if (l2 = typeof s2, f2 = Ge[d2], "function" === l2 && (l2 = typeof (s2 = s2.call(r3, i2, t3, n3))), "string" === l2 && ~s2.indexOf("random(") && (s2 = hb(s2)), f2) f2(this, t3, d2, s2, r3) && (T2 = 1);
      else if ("--" === d2.substr(0, 2)) a2 = (getComputedStyle(t3).getPropertyValue(d2) + "").trim(), s2 += "", Ct.lastIndex = 0, Ct.test(a2) || (_2 = Ra(a2), p2 = Ra(s2)), p2 ? _2 !== p2 && (a2 = Ed(t3, d2, a2, p2) + p2) : _2 && (s2 += _2), this.add(w2, "setProperty", a2, s2, i2, n3, 0, 0, d2), b2.push(d2);
      else if ("undefined" !== l2) {
        if (x2 && d2 in x2 ? (a2 = "function" == typeof x2[d2] ? x2[d2].call(r3, i2, t3, n3) : x2[d2], o(a2) && ~a2.indexOf("random(") && (a2 = hb(a2)), Ra(a2 + "") || (a2 += U.units[d2] || Ra(Fd(t3, d2)) || ""), "=" === (a2 + "").charAt(1) && (a2 = Fd(t3, d2))) : a2 = Fd(t3, d2), h2 = parseFloat(a2), (c2 = "string" === l2 && "=" === s2.charAt(1) && s2.substr(0, 2)) && (s2 = s2.substr(2)), u2 = parseFloat(s2), d2 in qe && ("autoAlpha" === d2 && (1 === h2 && "hidden" === Fd(t3, "visibility") && u2 && (h2 = 0), Cd(this, w2, "visibility", h2 ? "inherit" : "hidden", u2 ? "inherit" : "hidden", !u2)), "scale" !== d2 && "transform" !== d2 && ~(d2 = qe[d2]).indexOf(",") && (d2 = d2.split(",")[0])), m2 = d2 in Fe) if (g2 || ((v2 = t3._gsap).renderTransform && !e2.parseTransform || He(t3, e2.parseTransform), y2 = false !== e2.smoothOrigin && v2.smooth, (g2 = this._pt = new oe(this._pt, w2, Ve, 0, 1, v2.renderTransform, v2, 0, -1)).dep = 1), "scale" === d2) this._pt = new oe(this._pt, v2, "scaleY", v2.scaleY, (c2 ? ea(v2.scaleY, c2 + u2) : u2) - v2.scaleY || 0), b2.push("scaleY", d2), d2 += "X";
        else {
          if ("transformOrigin" === d2) {
            s2 = Id(s2), v2.svg ? Qd(t3, s2, 0, y2, 0, this) : ((p2 = parseFloat(s2.split(" ")[2]) || 0) !== v2.zOrigin && Cd(this, v2, "zOrigin", v2.zOrigin, p2), Cd(this, w2, d2, Je(a2), Je(s2)));
            continue;
          }
          if ("svgOrigin" === d2) {
            Qd(t3, s2, 1, y2, 0, this);
            continue;
          }
          if (d2 in Ze) {
            $d(this, v2, d2, h2, c2 ? ea(h2, c2 + s2) : s2);
            continue;
          }
          if ("smoothOrigin" === d2) {
            Cd(this, v2, "smooth", v2.smooth, s2);
            continue;
          }
          if ("force3D" === d2) {
            v2[d2] = s2;
            continue;
          }
          if ("transform" === d2) {
            ae(this, s2, t3);
            continue;
          }
        }
        else d2 in w2 || (d2 = je(d2) || d2);
        if (m2 || (u2 || 0 === u2) && (h2 || 0 === h2) && !Ye.test(s2) && d2 in w2) u2 = u2 || 0, (_2 = (a2 + "").substr((h2 + "").length)) !== (p2 = Ra(s2) || (d2 in U.units ? U.units[d2] : _2)) && (h2 = Ed(t3, d2, a2, p2)), this._pt = new oe(this._pt, m2 ? v2 : w2, d2, h2, (c2 ? ea(h2, c2 + u2) : u2) - h2, m2 || "px" !== p2 && "zIndex" !== d2 || false === e2.autoRound ? dd : gd), this._pt.u = p2 || 0, _2 !== p2 && "%" !== p2 && (this._pt.b = a2, this._pt.r = fd);
        else if (d2 in w2) Gd.call(this, t3, d2, a2, c2 ? c2 + s2 : s2);
        else {
          if (!(d2 in t3)) {
            N(d2, s2);
            continue;
          }
          this.add(t3, d2, a2 || t3[d2], c2 ? c2 + s2 : s2, i2, n3);
        }
        b2.push(d2);
      }
    }
    T2 && se(this);
  }, get: Fd, aliases: qe, getSetter: function getSetter(t3, e2, i2) {
    var n3 = qe[e2];
    return n3 && n3.indexOf(",") < 0 && (e2 = n3), e2 in Fe && e2 !== Xe && (t3._gsap.x || Fd(t3, "x")) ? i2 && ce === i2 ? "scale" === e2 ? md : ld : (ce = i2 || {}) && ("scale" === e2 ? nd : od) : t3.style && !r2(t3.style[e2]) ? jd : ~e2.indexOf("-") ? kd : Ht(t3, e2);
  }, core: { _removeProperty: Bd, _getMatrix: Pd } };
  he.utils.checkPrefix = je, ur = ba((sr = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent") + "," + (or = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function(t3) {
    Fe[t3] = 1;
  }), ba(or, function(t3) {
    U.units[t3] = "deg", Ze[t3] = 1;
  }), qe[ur[13]] = sr + "," + or, ba("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function(t3) {
    var e2 = t3.split(":");
    qe[e2[1]] = ur[e2[0]];
  }), ba("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t3) {
    U.units[t3] = "px";
  }), he.registerPlugin(hr);
  var lr = he.registerPlugin(hr) || he, fr = lr.core.Tween;
  e.Back = Ae, e.Bounce = Se, e.CSSPlugin = hr, e.Circ = Ee, e.Cubic = ke, e.Elastic = Ce, e.Expo = Re, e.Linear = we, e.Power0 = ge, e.Power1 = ve, e.Power2 = ye, e.Power3 = Te, e.Power4 = be, e.Quad = xe, e.Quart = Oe, e.Quint = Pe, e.Sine = ze, e.SteppedEase = De, e.Strong = Me, e.TimelineLite = Ut, e.TimelineMax = Ut, e.TweenLite = $t, e.TweenMax = fr, e.default = lr, e.gsap = lr;
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: true });
  } else {
    delete e.default;
  }
});
;
!(function(e, t2) {
  "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e = e || self).window = e.window || {});
})(this, function(e) {
  "use strict";
  function h() {
    return "undefined" != typeof window;
  }
  function i() {
    return t2 || h() && (t2 = window.gsap) && t2.registerPlugin && t2;
  }
  function j() {
    return n2 || (s(), o || console.warn("Please gsap.registerPlugin(CSSPlugin, CSSRulePlugin)")), n2;
  }
  var t2, n2, c, o, s = function _initCore(e2) {
    t2 = e2 || i(), h() && (c = document), t2 && (o = t2.plugins.css) && (n2 = 1);
  }, r2 = { version: "3.10.2", name: "cssRule", init: function init(e2, t3, n3, i2, s2) {
    if (!j() || void 0 === e2.cssText) return false;
    var r3 = e2._gsProxy = e2._gsProxy || c.createElement("div");
    this.ss = e2, this.style = r3.style, r3.style.cssText = e2.cssText, o.prototype.init.call(this, r3, t3, n3, i2, s2);
  }, render: function render(e2, t3) {
    for (var n3, i2 = t3._pt, s2 = t3.style, r3 = t3.ss; i2; ) i2.r(e2, i2.d), i2 = i2._next;
    for (n3 = s2.length; -1 < --n3; ) r3[s2[n3]] = s2[s2[n3]];
  }, getRule: function getRule(e2) {
    j();
    var t3, n3, i2, s2, r3 = c.all ? "rules" : "cssRules", o2 = c.styleSheets, l = o2.length, u = ":" === e2.charAt(0);
    for (e2 = (u ? "" : ",") + e2.split("::").join(":").toLowerCase() + ",", u && (s2 = []); l--; ) {
      try {
        if (!(n3 = o2[l][r3])) continue;
        t3 = n3.length;
      } catch (e3) {
        console.warn(e3);
        continue;
      }
      for (; -1 < --t3; ) if ((i2 = n3[t3]).selectorText && -1 !== ("," + i2.selectorText.split("::").join(":").toLowerCase() + ",").indexOf(e2)) {
        if (!u) return i2.style;
        s2.push(i2.style);
      }
    }
    return s2;
  }, register: s };
  i() && t2.registerPlugin(r2), e.CSSRulePlugin = r2, e.default = r2;
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: true });
  } else {
    delete e.default;
  }
});
;
!(function(e, t2) {
  "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e = e || self).window = e.window || {});
})(this, function(e) {
  "use strict";
  function k() {
    return "undefined" != typeof window;
  }
  function l() {
    return h || k() && (h = window.gsap) && h.registerPlugin && h;
  }
  function m() {
    return r2 || t2 && t2.createjs || t2 || {};
  }
  function n2(e2) {
    return console.warn(e2);
  }
  function o(e2) {
    var t3 = e2.getBounds && e2.getBounds();
    t3 || (t3 = e2.nominalBounds || { x: 0, y: 0, width: 100, height: 100 }, e2.setBounds && e2.setBounds(t3.x, t3.y, t3.width, t3.height)), e2.cache && e2.cache(t3.x, t3.y, t3.width, t3.height), n2("EaselPlugin: for filters to display in EaselJS, you must call the object's cache() method first. GSAP attempted to use the target's getBounds() for the cache but that may not be completely accurate. " + e2);
  }
  function p(e2, t3, r3) {
    (b = b || m().ColorFilter) || n2("EaselPlugin error: The EaselJS ColorFilter JavaScript file wasn't loaded.");
    for (var i2, l2, s, u2, a, f, c = e2.filters || [], d2 = c.length; d2--; ) if (c[d2] instanceof b) {
      l2 = c[d2];
      break;
    }
    if (l2 || (l2 = new b(), c.push(l2), e2.filters = c), s = l2.clone(), null != t3.tint) i2 = h.utils.splitColor(t3.tint), u2 = null != t3.tintAmount ? +t3.tintAmount : 1, s.redOffset = i2[0] * u2, s.greenOffset = i2[1] * u2, s.blueOffset = i2[2] * u2, s.redMultiplier = s.greenMultiplier = s.blueMultiplier = 1 - u2;
    else for (a in t3) "exposure" !== a && "brightness" !== a && (s[a] = +t3[a]);
    for (null != t3.exposure ? (s.redOffset = s.greenOffset = s.blueOffset = 255 * (t3.exposure - 1), s.redMultiplier = s.greenMultiplier = s.blueMultiplier = 1) : null != t3.brightness && (u2 = t3.brightness - 1, s.redOffset = s.greenOffset = s.blueOffset = 0 < u2 ? 255 * u2 : 0, s.redMultiplier = s.greenMultiplier = s.blueMultiplier = 1 - Math.abs(u2)), d2 = 8; d2--; ) l2[a = M[d2]] !== s[a] && (f = r3.add(l2, a, l2[a], s[a])) && (f.op = "easel_colorFilter");
    r3._props.push("easel_colorFilter"), e2.cacheID || o(e2);
  }
  function u(e2, t3) {
    if (!(e2 instanceof Array && t3 instanceof Array)) return t3;
    var r3, i2, n3 = [], l2 = 0, o2 = 0;
    for (r3 = 0; r3 < 4; r3++) {
      for (i2 = 0; i2 < 5; i2++) o2 = 4 === i2 ? e2[l2 + 4] : 0, n3[l2 + i2] = e2[l2] * t3[i2] + e2[l2 + 1] * t3[i2 + 5] + e2[l2 + 2] * t3[i2 + 10] + e2[l2 + 3] * t3[i2 + 15] + o2;
      l2 += 5;
    }
    return n3;
  }
  function z(e2, t3, r3) {
    (d = d || m().ColorMatrixFilter) || n2("EaselPlugin: The EaselJS ColorMatrixFilter JavaScript file wasn't loaded.");
    for (var i2, l2, s, a, f = e2.filters || [], c = f.length; -1 < --c; ) if (f[c] instanceof d) {
      s = f[c];
      break;
    }
    for (s || (s = new d(w.slice()), f.push(s), e2.filters = f), l2 = s.matrix, i2 = w.slice(), null != t3.colorize && (i2 = (function _colorize(e3, t4, r4) {
      isNaN(r4) && (r4 = 1);
      var i3 = h.utils.splitColor(t4), n3 = i3[0] / 255, l3 = i3[1] / 255, o2 = i3[2] / 255, s2 = 1 - r4;
      return u([s2 + r4 * n3 * x, r4 * n3 * y, r4 * n3 * _, 0, 0, r4 * l3 * x, s2 + r4 * l3 * y, r4 * l3 * _, 0, 0, r4 * o2 * x, r4 * o2 * y, s2 + r4 * o2 * _, 0, 0, 0, 0, 0, 1, 0], e3);
    })(i2, t3.colorize, Number(t3.colorizeAmount))), null != t3.contrast && (i2 = (function _setContrast(e3, t4) {
      return isNaN(t4) ? e3 : u([t4 += 0.01, 0, 0, 0, 128 * (1 - t4), 0, t4, 0, 0, 128 * (1 - t4), 0, 0, t4, 0, 128 * (1 - t4), 0, 0, 0, 1, 0], e3);
    })(i2, Number(t3.contrast))), null != t3.hue && (i2 = (function _setHue(e3, t4) {
      if (isNaN(t4)) return e3;
      t4 *= Math.PI / 180;
      var r4 = Math.cos(t4), i3 = Math.sin(t4);
      return u([x + r4 * (1 - x) + i3 * -x, y + r4 * -y + i3 * -y, _ + r4 * -_ + i3 * (1 - _), 0, 0, x + r4 * -x + 0.143 * i3, y + r4 * (1 - y) + 0.14 * i3, _ + r4 * -_ + -0.283 * i3, 0, 0, x + r4 * -x + i3 * -(1 - x), y + r4 * -y + i3 * y, _ + r4 * (1 - _) + i3 * _, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1], e3);
    })(i2, Number(t3.hue))), null != t3.saturation && (i2 = (function _setSaturation(e3, t4) {
      if (isNaN(t4)) return e3;
      var r4 = 1 - t4, i3 = r4 * x, n3 = r4 * y, l3 = r4 * _;
      return u([i3 + t4, n3, l3, 0, 0, i3, n3 + t4, l3, 0, 0, i3, n3, l3 + t4, 0, 0, 0, 0, 0, 1, 0], e3);
    })(i2, Number(t3.saturation))), c = i2.length; -1 < --c; ) i2[c] !== l2[c] && (a = r3.add(l2, c, l2[c], i2[c])) && (a.op = "easel_colorMatrixFilter");
    r3._props.push("easel_colorMatrixFilter"), e2.cacheID || o(), r3._matrix = l2;
  }
  function A(e2) {
    h = e2 || l(), k() && (t2 = window), h && (g = 1);
  }
  var h, g, t2, r2, b, d, M = "redMultiplier,greenMultiplier,blueMultiplier,alphaMultiplier,redOffset,greenOffset,blueOffset,alphaOffset".split(","), w = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], x = 0.212671, y = 0.71516, _ = 0.072169, i = { version: "3.10.2", name: "easel", init: function init(e2, t3, r3, i2, l2) {
    var o2, s, u2, a, f, c, d2;
    for (o2 in g || (A(), h || n2("Please gsap.registerPlugin(EaselPlugin)")), this.target = e2, t3) if (f = t3[o2], "colorFilter" === o2 || "tint" === o2 || "tintAmount" === o2 || "exposure" === o2 || "brightness" === o2) u2 || (p(e2, t3.colorFilter || t3, this), u2 = true);
    else if ("saturation" === o2 || "contrast" === o2 || "hue" === o2 || "colorize" === o2 || "colorizeAmount" === o2) a || (z(e2, t3.colorMatrixFilter || t3, this), a = true);
    else if ("frame" === o2) {
      if ("string" == typeof f && "=" !== f.charAt(1) && (c = e2.labels)) for (d2 = 0; d2 < c.length; d2++) c[d2].label === f && (f = c[d2].position);
      (s = this.add(e2, "gotoAndStop", e2.currentFrame, f, i2, l2, Math.round)) && (s.op = o2);
    } else null != e2[o2] && this.add(e2, o2, "get", f);
  }, render: function render(e2, t3) {
    for (var r3 = t3._pt; r3; ) r3.r(e2, r3.d), r3 = r3._next;
    t3.target.cacheID && t3.target.updateCache();
  }, register: A, registerCreateJS: function(e2) {
    r2 = e2;
  } };
  l() && h.registerPlugin(i), e.EaselPlugin = i, e.default = i;
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: true });
  } else {
    delete e.default;
  }
});
;
!(function(e, n2) {
  "object" == typeof exports && "undefined" != typeof module ? n2(exports) : "function" == typeof define && define.amd ? define(["exports"], n2) : n2((e = e || self).window = e.window || {});
})(this, function(e) {
  "use strict";
  function f() {
    return w || "undefined" != typeof window && (w = window.gsap) && w.registerPlugin && w;
  }
  function g(e2, n3) {
    return !!(void 0 === e2 ? n3 : e2 && !~(e2 + "").indexOf("false"));
  }
  function h(e2) {
    if (w = e2 || f()) {
      r2 = w.registerEase;
      var n3, t2 = w.parseEase(), o = function createConfig(t3) {
        return function(e3) {
          var n4 = 0.5 + e3 / 2;
          t3.config = function(e4) {
            return t3(2 * (1 - e4) * e4 * n4 + e4 * e4);
          };
        };
      };
      for (n3 in t2) t2[n3].config || o(t2[n3]);
      for (n3 in r2("slow", a), r2("expoScale", s), r2("rough", u), c) "version" !== n3 && w.core.globals(n3, c[n3]);
    }
  }
  function i(e2, n3, t2) {
    var o = (e2 = Math.min(1, e2 || 0.7)) < 1 ? n3 || 0 === n3 ? n3 : 0.7 : 0, r3 = (1 - e2) / 2, i2 = r3 + e2, a2 = g(t2);
    return function(e3) {
      var n4 = e3 + (0.5 - e3) * o;
      return e3 < r3 ? a2 ? 1 - (e3 = 1 - e3 / r3) * e3 : n4 - (e3 = 1 - e3 / r3) * e3 * e3 * e3 * n4 : i2 < e3 ? a2 ? 1 === e3 ? 0 : 1 - (e3 = (e3 - i2) / r3) * e3 : n4 + (e3 - n4) * (e3 = (e3 - i2) / r3) * e3 * e3 * e3 : a2 ? 1 : n4;
    };
  }
  function j(n3, e2, t2) {
    var o = Math.log(e2 / n3), r3 = e2 - n3;
    return t2 = t2 && w.parseEase(t2), function(e3) {
      return (n3 * Math.exp(o * (t2 ? t2(e3) : e3)) - n3) / r3;
    };
  }
  function k(e2, n3, t2) {
    this.t = e2, this.v = n3, t2 && (((this.next = t2).prev = this).c = t2.v - n3, this.gap = t2.t - e2);
  }
  function l(e2) {
    "object" != typeof e2 && (e2 = { points: +e2 || 20 });
    for (var n3, t2, o, r3, i2, a2, f2, s2 = e2.taper || "none", u2 = [], c2 = 0, p = 0 | (+e2.points || 20), l2 = p, v = g(e2.randomize, true), d = g(e2.clamp), h2 = w ? w.parseEase(e2.template) : 0, x = 0.4 * (+e2.strength || 1); -1 < --l2; ) n3 = v ? Math.random() : 1 / p * l2, t2 = h2 ? h2(n3) : n3, o = "none" === s2 ? x : "out" === s2 ? (r3 = 1 - n3) * r3 * x : "in" === s2 ? n3 * n3 * x : n3 < 0.5 ? (r3 = 2 * n3) * r3 * 0.5 * x : (r3 = 2 * (1 - n3)) * r3 * 0.5 * x, v ? t2 += Math.random() * o - 0.5 * o : l2 % 2 ? t2 += 0.5 * o : t2 -= 0.5 * o, d && (1 < t2 ? t2 = 1 : t2 < 0 && (t2 = 0)), u2[c2++] = { x: n3, y: t2 };
    for (u2.sort(function(e3, n4) {
      return e3.x - n4.x;
    }), a2 = new k(1, 1, null), l2 = p; l2--; ) i2 = u2[l2], a2 = new k(i2.x, i2.y, a2);
    return f2 = new k(0, 0, a2.t ? a2 : a2.next), function(e3) {
      var n4 = f2;
      if (e3 > n4.t) {
        for (; n4.next && e3 >= n4.t; ) n4 = n4.next;
        n4 = n4.prev;
      } else for (; n4.prev && e3 <= n4.t; ) n4 = n4.prev;
      return (f2 = n4).v + (e3 - n4.t) / n4.gap * n4.c;
    };
  }
  var w, r2, a = i(0.7);
  (a.ease = a).config = i;
  var s = j(1, 2);
  s.config = j;
  var u = l();
  (u.ease = u).config = l;
  var c = { SlowMo: a, RoughEase: u, ExpoScaleEase: s };
  for (var n2 in c) c[n2].register = h, c[n2].version = "3.10.2";
  f() && w.registerPlugin(a), e.EasePack = c, e.ExpoScaleEase = s, e.RoughEase = u, e.SlowMo = a, e.default = c;
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: true });
  } else {
    delete e.default;
  }
});
;
!(function(e, t2) {
  "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e = e || self).window = e.window || {});
})(this, function(pe) {
  "use strict";
  function _defineProperties(e, t3) {
    for (var n3 = 0; n3 < t3.length; n3++) {
      var r3 = t3[n3];
      r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e, r3.key, r3);
    }
  }
  function p() {
    return he || "undefined" != typeof window && (he = window.gsap) && he.registerPlugin && he;
  }
  var he, ve, ye, xe, _e, be, me, we, Oe, t2, Pe, n2 = 1, Me = [];
  pe._scrollers = [], pe._proxies = [];
  function v(e, t3) {
    return ~pe._proxies.indexOf(e) && pe._proxies[pe._proxies.indexOf(e) + 1][t3];
  }
  function w(e) {
    return !!~t2.indexOf(e);
  }
  function x(e, t3, n3, r3) {
    return e.addEventListener(t3, n3, { passive: !r3 });
  }
  function y(e, t3, n3) {
    return e.removeEventListener(t3, n3);
  }
  function B() {
    return Pe && Pe.isPressed || pe._scrollers.cache++;
  }
  function C(t3) {
    return function(e) {
      return e || 0 === e ? (n2 && (ye.history.scrollRestoration = "manual"), t3(e), t3.v = e, t3.c = pe._scrollers.cache, Pe && Pe.isPressed && Xe("ss", e)) : pe._scrollers.cache === t3.c && !Xe("ref") || (t3.c = pe._scrollers.cache, t3.v = t3()), t3.v;
    };
  }
  function F(e) {
    return he.utils.toArray(e)[0] || ("string" == typeof e && false !== he.config().nullTargetWarn ? console.warn("Element not found:", e) : null);
  }
  function G(t3, e) {
    var n3 = e.s, r3 = e.sc, o2 = pe._scrollers.indexOf(t3), i2 = r3 === De.sc ? 1 : 2;
    return ~o2 || (o2 = pe._scrollers.push(t3) - 1), pe._scrollers[o2 + i2] || (pe._scrollers[o2 + i2] = v(t3, n3) || (w(t3) ? r3 : function(e2) {
      return arguments.length ? t3[n3] = e2 : t3[n3];
    }));
  }
  function H(e, t3, o2) {
    function Ea(e2, t4) {
      var n3 = u();
      t4 || r3 < n3 - c ? (s = i2, i2 = e2, a = c, c = n3) : o2 ? i2 += e2 : i2 = s + (e2 - s) / (n3 - a) * (c - a);
    }
    var i2 = e, s = e, c = u(), a = c, r3 = t3 || 50, l = Math.max(500, 3 * r3);
    return { update: Ea, reset: function reset() {
      s = i2 = o2 ? 0 : i2, a = c = 0;
    }, getVelocity: function getVelocity(e2) {
      var t4 = a, n3 = s, r4 = u();
      return !e2 && 0 !== e2 || e2 === i2 || Ea(e2), c === a || l < r4 - a ? 0 : (i2 + (o2 ? n3 : -n3)) / ((o2 ? r4 : c) - t4) * 1e3;
    } };
  }
  function I(e, t3) {
    return t3 && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e;
  }
  function J(e) {
    var t3 = Math.max.apply(Math, e), n3 = Math.min.apply(Math, e);
    return Math.abs(t3) >= Math.abs(n3) ? t3 : n3;
  }
  function K(e) {
    return (he = e || p()) && !ve && "undefined" != typeof document && document.body && (ye = window, _e = (xe = document).documentElement, be = xe.body, t2 = [ye, xe, _e, be], he.utils.clamp, we = "onpointerenter" in be ? "pointer" : "mouse", me = i.isTouch = ye.matchMedia && ye.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in ye || 0 < navigator.maxTouchPoints || 0 < navigator.msMaxTouchPoints ? 2 : 0, setTimeout(function() {
      return n2 = 0;
    }, 500), ve = 1), ve;
  }
  var u = Date.now, Xe = function _bridge(e, t3) {
    return t3;
  }, r2 = "scrollLeft", o = "scrollTop", Ye = { s: r2, p: "left", p2: "Left", os: "right", os2: "Right", d: "width", d2: "Width", a: "x", sc: C(function(e) {
    return arguments.length ? ye.scrollTo(e, De.sc()) : ye.pageXOffset || xe[r2] || _e[r2] || be[r2] || 0;
  }) }, De = { s: o, p: "top", p2: "Top", os: "bottom", os2: "Bottom", d: "height", d2: "Height", a: "y", op: Ye, sc: C(function(e) {
    return arguments.length ? ye.scrollTo(Ye.sc(), e) : ye.pageYOffset || xe[o] || _e[o] || be[o] || 0;
  }) };
  Ye.op = De, pe._scrollers.cache = 0;
  var i = (Observer.prototype.init = function init(e) {
    ve || K(he) || console.warn("Please gsap.registerPlugin(Observer)"), Oe || (Oe = he.core.globals().ScrollTrigger) && Oe.core && (function _integrate() {
      var e2 = Oe.core, n4 = e2.bridge || {}, t4 = e2._scrollers, r4 = e2._proxies;
      t4.push.apply(t4, pe._scrollers), r4.push.apply(r4, pe._proxies), pe._scrollers = t4, pe._proxies = r4, Xe = function _bridge(e3, t5) {
        return n4[e3](t5);
      };
    })();
    var o2 = e.tolerance, s = e.dragMinimum, t3 = e.type, n3 = e.target, r3 = e.lineHeight, i2 = e.debounce, c = e.preventDefault, a = e.onStop, l = e.onStopDelay, u2 = e.ignore, d = e.wheelSpeed, f = e.event, g = e.onDragStart, p2 = e.onDragEnd, h = e.onDrag, v2 = e.onPress, _ = e.onRelease, b = e.onRight, m = e.onLeft, O = e.onUp, P = e.onDown, M = e.onChangeX, X = e.onChangeY, Y = e.onChange, D = e.onToggleX, T = e.onToggleY, E = e.onHover, k = e.onHoverEnd, C2 = e.onMove, S = e.ignoreCheck, Z = e.isNormalizer, j = e.onGestureStart, V = e.onGestureEnd, L = e.onWheel, A = e.onEnable, R = e.onDisable, W = e.onClick, z = e.scrollSpeed;
    function Zb(e2, t4) {
      return (ee.event = e2) && u2 && ~u2.indexOf(e2.target) || t4 && ae && "touch" !== e2.pointerType || S && S(e2);
    }
    function _b() {
      var e2 = ee.deltaX = J(de), t4 = ee.deltaY = J(fe), n4 = Math.abs(e2) >= o2, r4 = Math.abs(t4) >= o2;
      Y && (n4 || r4) && Y(ee, e2, t4, de, fe), n4 && (b && 0 < ee.deltaX && b(ee), m && ee.deltaX < 0 && m(ee), M && M(ee), D && ee.deltaX < 0 != te < 0 && D(ee), te = ee.deltaX, de[0] = de[1] = de[2] = 0), r4 && (P && 0 < ee.deltaY && P(ee), O && ee.deltaY < 0 && O(ee), X && X(ee), T && ee.deltaY < 0 != ne < 0 && T(ee), ne = ee.deltaY, fe[0] = fe[1] = fe[2] = 0), Q && (C2(ee), Q = false), U && (h(ee), U = false), $ && (L(ee), $ = false), q = 0;
    }
    function ac(e2, t4, n4) {
      de[n4] += e2, fe[n4] += t4, ee._vx.update(e2, 2 === n4), ee._vy.update(t4, 2 === n4), i2 ? q = q || requestAnimationFrame(_b) : _b();
    }
    function bc(e2) {
      if (!Zb(e2, 1)) {
        var t4 = (e2 = I(e2, c)).clientX, n4 = e2.clientY, r4 = t4 - ee.x, o3 = n4 - ee.y, i3 = ee.isDragging;
        ee.x = t4, ee.y = n4, (i3 || Math.abs(ee.startX - t4) >= s || Math.abs(ee.startY - n4) >= s) && (h && (U = true), i3 || (ee.isDragging = true), ac(r4, o3, 2), i3 || g && g(ee));
      }
    }
    function dc(e2) {
      if (!Zb(e2, 1)) {
        y(Z ? n3 : ue, ce[1], bc);
        var t4 = ee.isDragging;
        t4 || (ee._vx.reset(), ee._vy.reset()), ee.isDragging = ee.isGesturing = ee.isPressed = false, a && !Z && N.restart(true), p2 && t4 && p2(ee), _ && _(ee, t4);
      }
    }
    function ec(e2) {
      return e2.touches && 1 < e2.touches.length && (ee.isGesturing = true) && j(e2, ee.isDragging);
    }
    function fc() {
      return (ee.isGesturing = false) || V(ee);
    }
    function gc(e2) {
      if (!Zb(e2)) {
        var t4 = re(), n4 = oe();
        ac((t4 - ie) * z, (n4 - se) * z, 1), ie = t4, se = n4, a && N.restart(true);
      }
    }
    function hc(e2) {
      if (!Zb(e2)) {
        e2 = I(e2, c), L && ($ = true);
        var t4 = (1 === e2.deltaMode ? r3 : 2 === e2.deltaMode ? ye.innerHeight : 1) * d;
        ac(e2.deltaX * t4, e2.deltaY * t4, 0), a && !Z && N.restart(true);
      }
    }
    function ic(e2) {
      if (!Zb(e2)) {
        var t4 = e2.clientX, n4 = e2.clientY, r4 = t4 - ee.x, o3 = n4 - ee.y;
        ee.x = t4, ee.y = n4, C2 && (Q = true), (r4 || o3) && ac(r4, o3, 2);
      }
    }
    function jc(e2) {
      ee.event = e2, E(ee);
    }
    function kc(e2) {
      ee.event = e2, k(ee);
    }
    function lc(e2) {
      return Zb(e2) || I(e2, c) && W(ee);
    }
    this.target = n3 = F(n3) || _e, this.vars = e, u2 = u2 && he.utils.toArray(u2), o2 = o2 || 0, s = s || 0, d = d || 1, z = z || 1, t3 = t3 || "wheel,touch,pointer", i2 = false !== i2, r3 = r3 || parseFloat(ye.getComputedStyle(be).lineHeight) || 22;
    var q, N, U, Q, $, ee = this, te = 0, ne = 0, re = G(n3, Ye), oe = G(n3, De), ie = re(), se = oe(), ce = ("ontouchstart" in _e ? "touchstart,touchmove,touchcancel,touchend" : 0 <= t3.indexOf("pointer") && !("onpointerdown" in _e) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(","), ae = ~t3.indexOf("touch") && !~t3.indexOf("pointer") && "pointerdown" === ce[0], le = w(n3), ue = n3.ownerDocument || xe, de = [0, 0, 0], fe = [0, 0, 0], ge = ee.onPress = function(e2) {
      Zb(e2, 1) || (N.pause(), ee.isPressed = true, e2 = I(e2, c), te = ne = 0, ee.startX = ee.x = e2.clientX, ee.startY = ee.y = e2.clientY, ee._vx.reset(), ee._vy.reset(), x(Z ? n3 : ue, ce[1], bc, c), ee.deltaX = ee.deltaY = 0, v2 && v2(ee));
    };
    N = ee._dc = he.delayedCall(l || 0.25, function onStopFunc() {
      ee._vx.reset(), ee._vy.reset(), N.pause(), a && a(ee);
    }).pause(), ee.deltaX = ee.deltaY = 0, ee._vx = H(0, 50, true), ee._vy = H(0, 50, true), ee.scrollX = re, ee.scrollY = oe, ee.isDragging = ee.isGesturing = ee.isPressed = false, ee.enable = function(e2) {
      return ee.isEnabled || (x(le ? ue : n3, "scroll", B), 0 <= t3.indexOf("scroll") && x(le ? ue : n3, "scroll", gc, c), 0 <= t3.indexOf("wheel") && x(n3, "wheel", hc, c), (0 <= t3.indexOf("touch") && me || 0 <= t3.indexOf("pointer")) && (x(n3, ce[0], ge, c), x(ue, ce[2], dc), x(ue, ce[3], dc), W && x(n3, "click", lc), j && x(ue, "gesturestart", ec), V && x(ue, "gestureend", fc), E && x(n3, we + "enter", jc), k && x(n3, we + "leave", kc), C2 && x(n3, we + "move", ic)), ee.isEnabled = true, e2 && e2.type && ge(e2), A && A(ee)), ee;
    }, ee.disable = function() {
      ee.isEnabled && (Me.filter(function(e2) {
        return e2 !== ee && w(e2.target);
      }).length || y(le ? ue : n3, "scroll", B), y(le ? ue : n3, "scroll", gc), y(n3, "wheel", hc), y(n3, ce[0], ge), y(ue, ce[2], dc), y(ue, ce[3], dc), y(n3, "click", lc), y(ue, "gesturestart", ec), y(ue, "gestureend", fc), y(n3, we + "enter", jc), y(n3, we + "leave", kc), y(n3, we + "move", ic), ee.isEnabled = false, R && R(ee));
    }, ee.kill = function() {
      ee.disable();
      var e2 = Me.indexOf(ee);
      0 <= e2 && Me.splice(e2, 1), Pe === ee && (Pe = 0);
    }, Me.push(ee), Z && (Pe = ee), ee.enable(f);
  }, (function _createClass(e, t3, n3) {
    return t3 && _defineProperties(e.prototype, t3), n3 && _defineProperties(e, n3), e;
  })(Observer, [{ key: "velocityX", get: function get() {
    return this._vx.getVelocity();
  } }, { key: "velocityY", get: function get() {
    return this._vy.getVelocity();
  } }]), Observer);
  function Observer(e) {
    this.init(e);
  }
  i.version = "3.10.2", i.create = function(e) {
    return new i(e);
  }, i.register = K, i.getAll = function() {
    return Me.slice();
  }, i.getById = function(t3) {
    return Me.filter(function(e) {
      return e.vars.id === t3;
    })[0];
  }, p() && he.registerPlugin(i), pe.Observer = i, pe._getProxyProp = v, pe._getScrollFunc = G, pe._getTarget = F, pe._getVelocityProp = H, pe._horizontal = Ye, pe._isViewport = w, pe._vertical = De, pe.default = i, Object.defineProperty(pe, "__esModule", { value: true });
});
;
!(function(e, t2) {
  "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e = e || self).window = e.window || {});
})(this, function(e) {
  "use strict";
  function k() {
    return "undefined" != typeof window;
  }
  function l() {
    return u || k() && (u = window.gsap) && u.registerPlugin && u;
  }
  function m(e2) {
    return "string" == typeof e2;
  }
  function n2(e2) {
    return "function" == typeof e2;
  }
  function o(e2, t3) {
    var o2 = "x" === t3 ? "Width" : "Height", n3 = "scroll" + o2, r3 = "client" + o2;
    return e2 === T || e2 === i || e2 === c ? Math.max(i[n3], c[n3]) - (T["inner" + o2] || i[r3] || c[r3]) : e2[n3] - e2["offset" + o2];
  }
  function p(e2, t3) {
    var o2 = "scroll" + ("x" === t3 ? "Left" : "Top");
    return e2 === T && (null != e2.pageXOffset ? o2 = "page" + t3.toUpperCase() + "Offset" : e2 = null != i[o2] ? i : c), function() {
      return e2[o2];
    };
  }
  function r2(e2, t3) {
    if (!(e2 = f(e2)[0]) || !e2.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || { x: 0, y: 0 };
    var o2 = e2.getBoundingClientRect(), n3 = !t3 || t3 === T || t3 === c, r3 = n3 ? { top: i.clientTop - (T.pageYOffset || i.scrollTop || c.scrollTop || 0), left: i.clientLeft - (T.pageXOffset || i.scrollLeft || c.scrollLeft || 0) } : t3.getBoundingClientRect(), l2 = { x: o2.left - r3.left, y: o2.top - r3.top };
    return !n3 && t3 && (l2.x += p(t3, "x")(), l2.y += p(t3, "y")()), l2;
  }
  function s(e2, t3, n3, l2, i2) {
    return isNaN(e2) || "object" == typeof e2 ? m(e2) && "=" === e2.charAt(1) ? parseFloat(e2.substr(2)) * ("-" === e2.charAt(0) ? -1 : 1) + l2 - i2 : "max" === e2 ? o(t3, n3) - i2 : Math.min(o(t3, n3), r2(e2, t3)[n3] - i2) : parseFloat(e2) - i2;
  }
  function t2() {
    u = l(), k() && u && document.body && (T = window, c = document.body, i = document.documentElement, f = u.utils.toArray, u.config({ autoKillThreshold: 7 }), v = u.config(), a = 1);
  }
  var u, a, T, i, c, f, v, y = { version: "3.10.2", name: "scrollTo", rawVars: 1, register: function register(e2) {
    u = e2, t2();
  }, init: function init(e2, o2, r3, l2, i2) {
    a || t2();
    var c2 = this, f2 = u.getProperty(e2, "scrollSnapType");
    c2.isWin = e2 === T, c2.target = e2, c2.tween = r3, o2 = (function _clean(e3, t3, o3, r4) {
      if (n2(e3) && (e3 = e3(t3, o3, r4)), "object" != typeof e3) return m(e3) && "max" !== e3 && "=" !== e3.charAt(1) ? { x: e3, y: e3 } : { y: e3 };
      if (e3.nodeType) return { y: e3, x: e3 };
      var l3, i3 = {};
      for (l3 in e3) i3[l3] = "onAutoKill" !== l3 && n2(e3[l3]) ? e3[l3](t3, o3, r4) : e3[l3];
      return i3;
    })(o2, l2, e2, i2), c2.vars = o2, c2.autoKill = !!o2.autoKill, c2.getX = p(e2, "x"), c2.getY = p(e2, "y"), c2.x = c2.xPrev = c2.getX(), c2.y = c2.yPrev = c2.getY(), f2 && "none" !== f2 && (c2.snap = 1, c2.snapInline = e2.style.scrollSnapType, e2.style.scrollSnapType = "none"), null != o2.x ? (c2.add(c2, "x", c2.x, s(o2.x, e2, "x", c2.x, o2.offsetX || 0), l2, i2), c2._props.push("scrollTo_x")) : c2.skipX = 1, null != o2.y ? (c2.add(c2, "y", c2.y, s(o2.y, e2, "y", c2.y, o2.offsetY || 0), l2, i2), c2._props.push("scrollTo_y")) : c2.skipY = 1;
  }, render: function render(e2, t3) {
    for (var n3, r3, l2, i2, s2, p2 = t3._pt, c2 = t3.target, f2 = t3.tween, u2 = t3.autoKill, a2 = t3.xPrev, y2 = t3.yPrev, d = t3.isWin, x = t3.snap, g = t3.snapInline; p2; ) p2.r(e2, p2.d), p2 = p2._next;
    n3 = d || !t3.skipX ? t3.getX() : a2, l2 = (r3 = d || !t3.skipY ? t3.getY() : y2) - y2, i2 = n3 - a2, s2 = v.autoKillThreshold, t3.x < 0 && (t3.x = 0), t3.y < 0 && (t3.y = 0), u2 && (!t3.skipX && (s2 < i2 || i2 < -s2) && n3 < o(c2, "x") && (t3.skipX = 1), !t3.skipY && (s2 < l2 || l2 < -s2) && r3 < o(c2, "y") && (t3.skipY = 1), t3.skipX && t3.skipY && (f2.kill(), t3.vars.onAutoKill && t3.vars.onAutoKill.apply(f2, t3.vars.onAutoKillParams || []))), d ? T.scrollTo(t3.skipX ? n3 : t3.x, t3.skipY ? r3 : t3.y) : (t3.skipY || (c2.scrollTop = t3.y), t3.skipX || (c2.scrollLeft = t3.x)), !x || 1 !== e2 && 0 !== e2 || (r3 = c2.scrollTop, n3 = c2.scrollLeft, g ? c2.style.scrollSnapType = g : c2.style.removeProperty("scroll-snap-type"), c2.scrollTop = r3 + 1, c2.scrollLeft = n3 + 1, c2.scrollTop = r3, c2.scrollLeft = n3), t3.xPrev = t3.x, t3.yPrev = t3.y;
  }, kill: function kill(e2) {
    var t3 = "scrollTo" === e2;
    !t3 && "scrollTo_x" !== e2 || (this.skipX = 1), !t3 && "scrollTo_y" !== e2 || (this.skipY = 1);
  } };
  y.max = o, y.getOffset = r2, y.buildGetter = p, l() && u.registerPlugin(y), e.ScrollToPlugin = y, e.default = y;
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: true });
  } else {
    delete e.default;
  }
});
;
!(function(e, t2) {
  "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e = e || self).window = e.window || {});
})(this, function(e) {
  "use strict";
  function _defineProperties(e2, t3) {
    for (var r3 = 0; r3 < t3.length; r3++) {
      var n3 = t3[r3];
      n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(e2, n3.key, n3);
    }
  }
  function p() {
    return he || "undefined" != typeof window && (he = window.gsap) && he.registerPlugin && he;
  }
  function x(e2, t3) {
    return ~Ye.indexOf(e2) && Ye[Ye.indexOf(e2) + 1][t3];
  }
  function y(e2) {
    return !!~t2.indexOf(e2);
  }
  function z(e2, t3, r3, n3) {
    return e2.addEventListener(t3, r3, { passive: !n3 });
  }
  function A(e2, t3, r3) {
    return e2.removeEventListener(t3, r3);
  }
  function D() {
    return Pe && Pe.isPressed || ze.cache++;
  }
  function E(t3) {
    return function(e2) {
      return e2 || 0 === e2 ? (r2 && (ve.history.scrollRestoration = "manual"), t3(e2), t3.v = e2, t3.c = ze.cache, Pe && Pe.isPressed && Re("ss", e2)) : ze.cache === t3.c && !Re("ref") || (t3.c = ze.cache, t3.v = t3()), t3.v;
    };
  }
  function H(e2) {
    return he.utils.toArray(e2)[0] || ("string" == typeof e2 && false !== he.config().nullTargetWarn ? console.warn("Element not found:", e2) : null);
  }
  function I(t3, e2) {
    var r3 = e2.s, n3 = e2.sc, i2 = ze.indexOf(t3), o2 = n3 === Xe.sc ? 1 : 2;
    return ~i2 || (i2 = ze.push(t3) - 1), ze[i2 + o2] || (ze[i2 + o2] = x(t3, r3) || (y(t3) ? n3 : function(e3) {
      return arguments.length ? t3[r3] = e3 : t3[r3];
    }));
  }
  function J(e2, t3, i2) {
    function _c(e3, t4) {
      var r3 = u();
      t4 || n3 < r3 - s2 ? (a2 = o2, o2 = e3, l2 = s2, s2 = r3) : i2 ? o2 += e3 : o2 = a2 + (e3 - a2) / (r3 - l2) * (s2 - l2);
    }
    var o2 = e2, a2 = e2, s2 = u(), l2 = s2, n3 = t3 || 50, c2 = Math.max(500, 3 * n3);
    return { update: _c, reset: function reset() {
      a2 = o2 = i2 ? 0 : o2, l2 = s2 = 0;
    }, getVelocity: function getVelocity(e3) {
      var t4 = l2, r3 = a2, n4 = u();
      return !e3 && 0 !== e3 || e3 === o2 || _c(e3), s2 === l2 || c2 < n4 - l2 ? 0 : (o2 + (i2 ? r3 : -r3)) / ((i2 ? n4 : s2) - t4) * 1e3;
    } };
  }
  function K(e2, t3) {
    return t3 && e2.preventDefault(), e2.changedTouches ? e2.changedTouches[0] : e2;
  }
  function L(e2) {
    var t3 = Math.max.apply(Math, e2), r3 = Math.min.apply(Math, e2);
    return Math.abs(t3) >= Math.abs(r3) ? t3 : r3;
  }
  function M(e2) {
    return (he = e2 || p()) && !be && "undefined" != typeof document && document.body && (ve = window, Se = (me = document).documentElement, _e = me.body, t2 = [ve, me, Se, _e], he.utils.clamp, ke = "onpointerenter" in _e ? "pointer" : "mouse", Te = w.isTouch = ve.matchMedia && ve.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in ve || 0 < navigator.maxTouchPoints || 0 < navigator.msMaxTouchPoints ? 2 : 0, setTimeout(function() {
      return r2 = 0;
    }, 500), be = 1), be;
  }
  var he, be, ve, me, Se, _e, Te, ke, Me, t2, Pe, r2 = 1, Oe = [], ze = [], Ye = [], u = Date.now, Re = function _bridge(e2, t3) {
    return t3;
  }, n2 = "scrollLeft", i = "scrollTop", Le = { s: n2, p: "left", p2: "Left", os: "right", os2: "Right", d: "width", d2: "Width", a: "x", sc: E(function(e2) {
    return arguments.length ? ve.scrollTo(e2, Xe.sc()) : ve.pageXOffset || me[n2] || Se[n2] || _e[n2] || 0;
  }) }, Xe = { s: i, p: "top", p2: "Top", os: "bottom", os2: "Bottom", d: "height", d2: "Height", a: "y", op: Le, sc: E(function(e2) {
    return arguments.length ? ve.scrollTo(Le.sc(), e2) : ve.pageYOffset || me[i] || Se[i] || _e[i] || 0;
  }) };
  Le.op = Xe, ze.cache = 0;
  var w = (Observer.prototype.init = function init(e2) {
    be || M(he) || console.warn("Please gsap.registerPlugin(Observer)"), Me || (Me = he.core.globals().ScrollTrigger) && Me.core && (function _integrate() {
      var e3 = Me.core, r4 = e3.bridge || {}, t4 = e3._scrollers, n4 = e3._proxies;
      t4.push.apply(t4, ze), n4.push.apply(n4, Ye), ze = t4, Ye = n4, Re = function _bridge(e4, t5) {
        return r4[e4](t5);
      };
    })();
    var i2 = e2.tolerance, a2 = e2.dragMinimum, t3 = e2.type, r3 = e2.target, n3 = e2.lineHeight, o2 = e2.debounce, s2 = e2.preventDefault, l2 = e2.onStop, c2 = e2.onStopDelay, u2 = e2.ignore, f2 = e2.wheelSpeed, d2 = e2.event, p2 = e2.onDragStart, g2 = e2.onDragEnd, h2 = e2.onDrag, b2 = e2.onPress, v2 = e2.onRelease, m2 = e2.onRight, x2 = e2.onLeft, w2 = e2.onUp, S2 = e2.onDown, _2 = e2.onChangeX, T2 = e2.onChangeY, k2 = e2.onChange, E2 = e2.onToggleX, C2 = e2.onToggleY, P2 = e2.onHover, O2 = e2.onHoverEnd, F2 = e2.onMove, Y2 = e2.ignoreCheck, R2 = e2.isNormalizer, B2 = e2.onGestureStart, X2 = e2.onGestureEnd, j2 = e2.onWheel, V2 = e2.onEnable, G2 = e2.onDisable, N2 = e2.onClick, W2 = e2.scrollSpeed;
    function ue(e3, t4) {
      return (ee2.event = e3) && u2 && ~u2.indexOf(e3.target) || t4 && le && "touch" !== e3.pointerType || Y2 && Y2(e3);
    }
    function we() {
      var e3 = ee2.deltaX = L(de), t4 = ee2.deltaY = L(pe), r4 = Math.abs(e3) >= i2, n4 = Math.abs(t4) >= i2;
      k2 && (r4 || n4) && k2(ee2, e3, t4, de, pe), r4 && (m2 && 0 < ee2.deltaX && m2(ee2), x2 && ee2.deltaX < 0 && x2(ee2), _2 && _2(ee2), E2 && ee2.deltaX < 0 != te2 < 0 && E2(ee2), te2 = ee2.deltaX, de[0] = de[1] = de[2] = 0), n4 && (S2 && 0 < ee2.deltaY && S2(ee2), w2 && ee2.deltaY < 0 && w2(ee2), T2 && T2(ee2), C2 && ee2.deltaY < 0 != re2 < 0 && C2(ee2), re2 = ee2.deltaY, pe[0] = pe[1] = pe[2] = 0), $2 && (F2(ee2), $2 = false), Z2 && (h2(ee2), Z2 = false), Q2 && (j2(ee2), Q2 = false), q2 = 0;
    }
    function xe(e3, t4, r4) {
      de[r4] += e3, pe[r4] += t4, ee2._vx.update(e3, 2 === r4), ee2._vy.update(t4, 2 === r4), o2 ? q2 = q2 || requestAnimationFrame(we) : we();
    }
    function ye(e3) {
      if (!ue(e3, 1)) {
        var t4 = (e3 = K(e3, s2)).clientX, r4 = e3.clientY, n4 = t4 - ee2.x, i3 = r4 - ee2.y, o3 = ee2.isDragging;
        ee2.x = t4, ee2.y = r4, (o3 || Math.abs(ee2.startX - t4) >= a2 || Math.abs(ee2.startY - r4) >= a2) && (h2 && (Z2 = true), o3 || (ee2.isDragging = true), xe(n4, i3, 2), o3 || p2 && p2(ee2));
      }
    }
    function Ae(e3) {
      if (!ue(e3, 1)) {
        A(R2 ? r3 : fe, se[1], ye);
        var t4 = ee2.isDragging;
        t4 || (ee2._vx.reset(), ee2._vy.reset()), ee2.isDragging = ee2.isGesturing = ee2.isPressed = false, l2 && !R2 && U2.restart(true), g2 && t4 && g2(ee2), v2 && v2(ee2, t4);
      }
    }
    function Be(e3) {
      return e3.touches && 1 < e3.touches.length && (ee2.isGesturing = true) && B2(e3, ee2.isDragging);
    }
    function Ce() {
      return (ee2.isGesturing = false) || X2(ee2);
    }
    function De(e3) {
      if (!ue(e3)) {
        var t4 = ne(), r4 = ie();
        xe((t4 - oe) * W2, (r4 - ae) * W2, 1), oe = t4, ae = r4, l2 && U2.restart(true);
      }
    }
    function Ee(e3) {
      if (!ue(e3)) {
        e3 = K(e3, s2), j2 && (Q2 = true);
        var t4 = (1 === e3.deltaMode ? n3 : 2 === e3.deltaMode ? ve.innerHeight : 1) * f2;
        xe(e3.deltaX * t4, e3.deltaY * t4, 0), l2 && !R2 && U2.restart(true);
      }
    }
    function Fe(e3) {
      if (!ue(e3)) {
        var t4 = e3.clientX, r4 = e3.clientY, n4 = t4 - ee2.x, i3 = r4 - ee2.y;
        ee2.x = t4, ee2.y = r4, F2 && ($2 = true), (n4 || i3) && xe(n4, i3, 2);
      }
    }
    function Ge(e3) {
      ee2.event = e3, P2(ee2);
    }
    function He(e3) {
      ee2.event = e3, O2(ee2);
    }
    function Ie(e3) {
      return ue(e3) || K(e3, s2) && N2(ee2);
    }
    this.target = r3 = H(r3) || Se, this.vars = e2, u2 = u2 && he.utils.toArray(u2), i2 = i2 || 0, a2 = a2 || 0, f2 = f2 || 1, W2 = W2 || 1, t3 = t3 || "wheel,touch,pointer", o2 = false !== o2, n3 = n3 || parseFloat(ve.getComputedStyle(_e).lineHeight) || 22;
    var q2, U2, Z2, $2, Q2, ee2 = this, te2 = 0, re2 = 0, ne = I(r3, Le), ie = I(r3, Xe), oe = ne(), ae = ie(), se = ("ontouchstart" in Se ? "touchstart,touchmove,touchcancel,touchend" : 0 <= t3.indexOf("pointer") && !("onpointerdown" in Se) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(","), le = ~t3.indexOf("touch") && !~t3.indexOf("pointer") && "pointerdown" === se[0], ce = y(r3), fe = r3.ownerDocument || me, de = [0, 0, 0], pe = [0, 0, 0], ge = ee2.onPress = function(e3) {
      ue(e3, 1) || (U2.pause(), ee2.isPressed = true, e3 = K(e3, s2), te2 = re2 = 0, ee2.startX = ee2.x = e3.clientX, ee2.startY = ee2.y = e3.clientY, ee2._vx.reset(), ee2._vy.reset(), z(R2 ? r3 : fe, se[1], ye, s2), ee2.deltaX = ee2.deltaY = 0, b2 && b2(ee2));
    };
    U2 = ee2._dc = he.delayedCall(c2 || 0.25, function onStopFunc() {
      ee2._vx.reset(), ee2._vy.reset(), U2.pause(), l2 && l2(ee2);
    }).pause(), ee2.deltaX = ee2.deltaY = 0, ee2._vx = J(0, 50, true), ee2._vy = J(0, 50, true), ee2.scrollX = ne, ee2.scrollY = ie, ee2.isDragging = ee2.isGesturing = ee2.isPressed = false, ee2.enable = function(e3) {
      return ee2.isEnabled || (z(ce ? fe : r3, "scroll", D), 0 <= t3.indexOf("scroll") && z(ce ? fe : r3, "scroll", De, s2), 0 <= t3.indexOf("wheel") && z(r3, "wheel", Ee, s2), (0 <= t3.indexOf("touch") && Te || 0 <= t3.indexOf("pointer")) && (z(r3, se[0], ge, s2), z(fe, se[2], Ae), z(fe, se[3], Ae), N2 && z(r3, "click", Ie), B2 && z(fe, "gesturestart", Be), X2 && z(fe, "gestureend", Ce), P2 && z(r3, ke + "enter", Ge), O2 && z(r3, ke + "leave", He), F2 && z(r3, ke + "move", Fe)), ee2.isEnabled = true, e3 && e3.type && ge(e3), V2 && V2(ee2)), ee2;
    }, ee2.disable = function() {
      ee2.isEnabled && (Oe.filter(function(e3) {
        return e3 !== ee2 && y(e3.target);
      }).length || A(ce ? fe : r3, "scroll", D), A(ce ? fe : r3, "scroll", De), A(r3, "wheel", Ee), A(r3, se[0], ge), A(fe, se[2], Ae), A(fe, se[3], Ae), A(r3, "click", Ie), A(fe, "gesturestart", Be), A(fe, "gestureend", Ce), A(r3, ke + "enter", Ge), A(r3, ke + "leave", He), A(r3, ke + "move", Fe), ee2.isEnabled = false, G2 && G2(ee2));
    }, ee2.kill = function() {
      ee2.disable();
      var e3 = Oe.indexOf(ee2);
      0 <= e3 && Oe.splice(e3, 1), Pe === ee2 && (Pe = 0);
    }, Oe.push(ee2), R2 && (Pe = ee2), ee2.enable(d2);
  }, (function _createClass(e2, t3, r3) {
    return t3 && _defineProperties(e2.prototype, t3), r3 && _defineProperties(e2, r3), e2;
  })(Observer, [{ key: "velocityX", get: function get() {
    return this._vx.getVelocity();
  } }, { key: "velocityY", get: function get() {
    return this._vy.getVelocity();
  } }]), Observer);
  function Observer(e2) {
    this.init(e2);
  }
  w.version = "3.10.2", w.create = function(e2) {
    return new w(e2);
  }, w.register = M, w.getAll = function() {
    return Oe.slice();
  }, w.getById = function(t3) {
    return Oe.filter(function(e2) {
      return e2.vars.id === t3;
    })[0];
  }, p() && he.registerPlugin(w);
  function sa() {
    return $e = 1;
  }
  function ta() {
    return $e = 0;
  }
  function ua(e2) {
    return e2;
  }
  function va(e2) {
    return Math.round(1e5 * e2) / 1e5 || 0;
  }
  function wa() {
    return "undefined" != typeof window;
  }
  function xa() {
    return je || wa() && (je = window.gsap) && je.registerPlugin && je;
  }
  function ya(e2) {
    return !!~a.indexOf(e2);
  }
  function za(e2) {
    return x(e2, "getBoundingClientRect") || (ya(e2) ? function() {
      return Mt.width = Ve.innerWidth, Mt.height = Ve.innerHeight, Mt;
    } : function() {
      return wt(e2);
    });
  }
  function Ca(e2, t3) {
    var r3 = t3.s, n3 = t3.d2, i2 = t3.d, o2 = t3.a;
    return (r3 = "scroll" + n3) && (o2 = x(e2, r3)) ? o2() - za(e2)()[i2] : ya(e2) ? (Ke[r3] || We[r3]) - (Ve["inner" + n3] || Ke["client" + n3] || We["client" + n3]) : e2[r3] - e2["offset" + n3];
  }
  function Da(e2, t3) {
    for (var r3 = 0; r3 < g.length; r3 += 3) t3 && !~t3.indexOf(g[r3 + 1]) || e2(g[r3], g[r3 + 1], g[r3 + 2]);
  }
  function Ea(e2) {
    return "string" == typeof e2;
  }
  function Fa(e2) {
    return "function" == typeof e2;
  }
  function Ga(e2) {
    return "number" == typeof e2;
  }
  function Ha(e2) {
    return "object" == typeof e2;
  }
  function Ia(e2) {
    return Fa(e2) && e2();
  }
  function Ja(r3, n3) {
    return function() {
      var e2 = Ia(r3), t3 = Ia(n3);
      return function() {
        Ia(e2), Ia(t3);
      };
    };
  }
  function Ka(e2, t3, r3) {
    return e2 && e2.progress(t3 ? 0 : 1) && r3 && e2.pause();
  }
  function La(e2, t3) {
    if (e2.enabled) {
      var r3 = t3(e2);
      r3 && r3.totalTime && (e2.callbackAnimation = r3);
    }
  }
  function ab(e2) {
    return Ve.getComputedStyle(e2);
  }
  function cb(e2, t3) {
    for (var r3 in t3) r3 in e2 || (e2[r3] = t3[r3]);
    return e2;
  }
  function eb(e2, t3) {
    var r3 = t3.d2;
    return e2["offset" + r3] || e2["client" + r3] || 0;
  }
  function fb(e2) {
    var t3, r3 = [], n3 = e2.labels, i2 = e2.duration();
    for (t3 in n3) r3.push(n3[t3] / i2);
    return r3;
  }
  function hb(i2) {
    var o2 = je.utils.snap(i2), a2 = Array.isArray(i2) && i2.slice(0).sort(function(e2, t3) {
      return e2 - t3;
    });
    return a2 ? function(e2, t3, r3) {
      var n3;
      if (void 0 === r3 && (r3 = 1e-3), !t3) return o2(e2);
      if (0 < t3) {
        for (e2 -= r3, n3 = 0; n3 < a2.length; n3++) if (a2[n3] >= e2) return a2[n3];
        return a2[n3 - 1];
      }
      for (n3 = a2.length, e2 += r3; n3--; ) if (a2[n3] <= e2) return a2[n3];
      return a2[0];
    } : function(e2, t3, r3) {
      void 0 === r3 && (r3 = 1e-3);
      var n3 = o2(e2);
      return !t3 || Math.abs(n3 - e2) < r3 || n3 - e2 < 0 == t3 < 0 ? n3 : o2(t3 < 0 ? e2 - i2 : e2 + i2);
    };
  }
  function jb(t3, r3, e2, n3) {
    return e2.split(",").forEach(function(e3) {
      return t3(r3, e3, n3);
    });
  }
  function kb(e2, t3, r3, n3) {
    return e2.addEventListener(t3, r3, { passive: !n3 });
  }
  function lb(e2, t3, r3) {
    return e2.removeEventListener(t3, r3);
  }
  function mb(e2, t3, r3) {
    return r3 && r3.wheelHandler && e2(t3, "wheel", r3);
  }
  function qb(e2, t3) {
    if (Ea(e2)) {
      var r3 = e2.indexOf("="), n3 = ~r3 ? (e2.charAt(r3 - 1) + 1) * parseFloat(e2.substr(r3 + 1)) : 0;
      ~r3 && (e2.indexOf("%") > r3 && (n3 *= t3 / 100), e2 = e2.substr(0, r3 - 1)), e2 = n3 + (e2 in F ? F[e2] * t3 : ~e2.indexOf("%") ? parseFloat(e2) * t3 / 100 : parseFloat(e2) || 0);
    }
    return e2;
  }
  function rb(e2, t3, r3, n3, i2, o2, a2, s2) {
    var l2 = i2.startColor, c2 = i2.endColor, u2 = i2.fontSize, f2 = i2.indent, d2 = i2.fontWeight, p2 = Ne.createElement("div"), g2 = ya(r3) || "fixed" === x(r3, "pinType"), h2 = -1 !== e2.indexOf("scroller"), b2 = g2 ? We : r3, v2 = -1 !== e2.indexOf("start"), m2 = v2 ? l2 : c2, y2 = "border-color:" + m2 + ";font-size:" + u2 + ";color:" + m2 + ";font-weight:" + d2 + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    return y2 += "position:" + ((h2 || s2) && g2 ? "fixed;" : "absolute;"), !h2 && !s2 && g2 || (y2 += (n3 === Xe ? C : P) + ":" + (o2 + parseFloat(f2)) + "px;"), a2 && (y2 += "box-sizing:border-box;text-align:left;width:" + a2.offsetWidth + "px;"), p2._isStart = v2, p2.setAttribute("class", "gsap-marker-" + e2 + (t3 ? " marker-" + t3 : "")), p2.style.cssText = y2, p2.innerText = t3 || 0 === t3 ? e2 + "-" + t3 : e2, b2.children[0] ? b2.insertBefore(p2, b2.children[0]) : b2.appendChild(p2), p2._offset = p2["offset" + n3.op.d2], Y(p2, 0, n3, v2), p2;
  }
  function wb() {
    return 34 < st() - lt && Z();
  }
  function xb() {
    b && b.isPressed || (ze.cache++, _ = _ || requestAnimationFrame(Z), lt || j("scrollStart"), lt = st());
  }
  function yb() {
    ze.cache++, Ze || h || Ne.fullscreenElement || v && S === Ve.innerWidth && !(Math.abs(Ve.innerHeight - m) > 0.25 * Ve.innerHeight) || s.restart(true);
  }
  function Eb(e2) {
    var t3, r3 = je.ticker.frame, n3 = [], i2 = 0;
    if (T !== r3 || at) {
      for (N(); i2 < X.length; i2 += 4) (t3 = Ve.matchMedia(X[i2]).matches) !== X[i2 + 3] && ((X[i2 + 3] = t3) ? n3.push(i2) : N(1, X[i2]) || Fa(X[i2 + 2]) && X[i2 + 2]());
      for (G(), i2 = 0; i2 < n3.length; i2++) t3 = n3[i2], nt = X[t3], X[t3 + 2] = X[t3 + 1](e2);
      nt = 0, o && q(0, 1), T = r3, j("matchMedia");
    }
  }
  function Fb() {
    return lb(re, "scrollEnd", Fb) || q(true);
  }
  function Kb() {
    return ze.cache++ && ze.forEach(function(e2) {
      return "function" == typeof e2 && (e2.rec = 0);
    });
  }
  function Vb(e2, t3, r3, n3) {
    if (e2.parentNode !== t3) {
      for (var i2, o2 = $.length, a2 = t3.style, s2 = e2.style; o2--; ) a2[i2 = $[o2]] = r3[i2];
      a2.position = "absolute" === r3.position ? "absolute" : "relative", "inline" === r3.display && (a2.display = "inline-block"), s2[P] = s2[C] = a2.flexBasis = "auto", a2.overflow = "visible", a2.boxSizing = "border-box", a2[ft] = eb(e2, Le) + xt, a2[dt] = eb(e2, Xe) + xt, a2[vt] = s2[mt] = s2.top = s2.left = "0", Ct(n3), s2[ft] = s2.maxWidth = r3[ft], s2[dt] = s2.maxHeight = r3[dt], s2[vt] = r3[vt], e2.parentNode.insertBefore(t3, e2), t3.appendChild(e2);
    }
  }
  function Yb(e2) {
    for (var t3 = Q.length, r3 = e2.style, n3 = [], i2 = 0; i2 < t3; i2++) n3.push(Q[i2], r3[Q[i2]]);
    return n3.t = e2, n3;
  }
  function _b(e2, t3, r3, n3, i2, o2, a2, s2, l2, c2, u2, f2, d2) {
    Fa(e2) && (e2 = e2(s2)), Ea(e2) && "max" === e2.substr(0, 3) && (e2 = f2 + ("=" === e2.charAt(4) ? qb("0" + e2.substr(3), r3) : 0));
    var p2, g2, h2, b2 = d2 ? d2.time() : 0;
    if (d2 && d2.seek(0), Ga(e2)) a2 && Y(a2, r3, n3, true);
    else {
      Fa(t3) && (t3 = t3(s2));
      var v2, m2, y2, x2, w2 = e2.split(" ");
      h2 = H(t3) || We, (v2 = wt(h2) || {}) && (v2.left || v2.top) || "none" !== ab(h2).display || (x2 = h2.style.display, h2.style.display = "block", v2 = wt(h2), x2 ? h2.style.display = x2 : h2.style.removeProperty("display")), m2 = qb(w2[0], v2[n3.d]), y2 = qb(w2[1] || "0", r3), e2 = v2[n3.p] - l2[n3.p] - c2 + m2 + i2 - y2, a2 && Y(a2, y2, n3, r3 - y2 < 20 || a2._isStart && 20 < y2), r3 -= r3 - y2;
    }
    if (o2) {
      var S2 = e2 + r3, _2 = o2._isStart;
      p2 = "scroll" + n3.d2, Y(o2, S2, n3, _2 && 20 < S2 || !_2 && (u2 ? Math.max(We[p2], Ke[p2]) : o2.parentNode[p2]) <= S2 + 1), u2 && (l2 = wt(a2), u2 && (o2.style[n3.op.p] = l2[n3.op.p] - n3.op.m - o2._offset + xt));
    }
    return d2 && h2 && (p2 = wt(h2), d2.seek(f2), g2 = wt(h2), d2._caScrollDist = p2[n3.p] - g2[n3.p], e2 = e2 / d2._caScrollDist * f2), d2 && d2.seek(b2), d2 ? e2 : Math.round(e2);
  }
  function bc(e2, t3, r3, n3) {
    if (e2.parentNode !== t3) {
      var i2, o2, a2 = e2.style;
      if (t3 === We) {
        for (i2 in e2._stOrig = a2.cssText, o2 = ab(e2)) +i2 || te.test(i2) || !o2[i2] || "string" != typeof a2[i2] || "0" === i2 || (a2[i2] = o2[i2]);
        a2.top = r3, a2.left = n3;
      } else a2.cssText = e2._stOrig;
      je.core.getCache(e2).uncache = 1, t3.appendChild(e2);
    }
  }
  function cc(l2, e2) {
    function nj(e3, t3, r3, n3, i2) {
      var o2 = nj.tween, a2 = t3.onComplete, s2 = {};
      return r3 = r3 || f2(), i2 = n3 && i2 || 0, n3 = n3 || e3 - r3, o2 && o2.kill(), c2 = Math.round(r3), t3[d2] = e3, (t3.modifiers = s2)[d2] = function(e4) {
        return (e4 = va(f2())) !== c2 && e4 !== u2 && 2 < Math.abs(e4 - c2) && 2 < Math.abs(e4 - u2) ? (o2.kill(), nj.tween = 0) : e4 = r3 + n3 * o2.ratio + i2 * o2.ratio * o2.ratio, u2 = c2, c2 = va(e4);
      }, t3.onComplete = function() {
        nj.tween = 0, a2 && a2.call(o2);
      }, o2 = nj.tween = je.to(l2, t3);
    }
    var c2, u2, f2 = I(l2, e2), d2 = "_scroll" + e2.p2;
    return (l2[d2] = f2).wheelHandler = function() {
      return nj.tween && nj.tween.kill() && (nj.tween = 0);
    }, kb(l2, "wheel", f2.wheelHandler), nj;
  }
  var je, o, Ve, Ne, Ke, We, a, s, qe, Je, Ue, l, Ze, $e, c, Qe, f, d, g, et, tt, h, b, v, m, S, rt, _, nt, T, it, ot, at = 1, st = Date.now, k = st(), lt = 0, ct = 0, ut = Math.abs, C = "right", P = "bottom", ft = "width", dt = "height", pt = "Right", gt = "Left", ht = "Top", bt = "Bottom", vt = "padding", mt = "margin", yt = "Width", O = "Height", xt = "px", wt = function _getBounds(e2, t3) {
    var r3 = t3 && "matrix(1, 0, 0, 1, 0, 0)" !== ab(e2)[c] && je.to(e2, { x: 0, y: 0, xPercent: 0, yPercent: 0, rotation: 0, rotationX: 0, rotationY: 0, scale: 1, skewX: 0, skewY: 0 }).progress(1), n3 = e2.getBoundingClientRect();
    return r3 && r3.progress(0).kill(), n3;
  }, St = { startColor: "green", endColor: "red", indent: 0, fontSize: "16px", fontWeight: "normal" }, _t = { toggleActions: "play", anticipatePin: 0 }, F = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 }, Y = function _positionMarker(e2, t3, r3, n3) {
    var i2 = { display: "block" }, o2 = r3[n3 ? "os2" : "p2"], a2 = r3[n3 ? "p2" : "os2"];
    e2._isFlipped = n3, i2[r3.a + "Percent"] = n3 ? -100 : 0, i2[r3.a] = n3 ? "1px" : 0, i2["border" + o2 + yt] = 1, i2["border" + a2 + yt] = 0, i2[r3.p] = t3 + "px", je.set(e2, i2);
  }, Tt = [], kt = {}, R = {}, B = [], X = [], j = function _dispatch(e2) {
    return R[e2] && R[e2].map(function(e3) {
      return e3();
    }) || B;
  }, V = [], G = function _revertRecorded(e2) {
    for (var t3 = 0; t3 < V.length; t3 += 5) e2 && V[t3 + 4] !== e2 || (V[t3].style.cssText = V[t3 + 1], V[t3].getBBox && V[t3].setAttribute("transform", V[t3 + 2] || ""), V[t3 + 3].uncache = 1);
  }, N = function _revertAll(e2, t3) {
    var r3;
    for (Qe = 0; Qe < Tt.length; Qe++) r3 = Tt[Qe], t3 && r3.media !== t3 || (e2 ? r3.kill(1) : r3.revert());
    t3 && G(t3), t3 || j("revert");
  }, W = 0, q = function _refreshAll(e2, t3) {
    if (!lt || e2) {
      it = true;
      var r3 = j("refreshInit");
      et && re.sort(), t3 || N(), Tt.slice(0).forEach(function(e3) {
        return e3.refresh();
      }), Tt.forEach(function(e3) {
        return "max" === e3.vars.end && e3.setPositions(e3.start, Ca(e3.scroller, e3._dir));
      }), r3.forEach(function(e3) {
        return e3 && e3.render && e3.render(-1);
      }), Kb(), s.pause(), W++, it = false, j("refresh");
    } else kb(re, "scrollEnd", Fb);
  }, U = 0, Et = 1, Z = function _updateAll() {
    if (!it) {
      ot && ot.update(0), re.isUpdating = true;
      var e2 = Tt.length, t3 = st(), r3 = 50 <= t3 - k, n3 = e2 && Tt[0].scroll();
      if (Et = n3 < U ? -1 : 1, U = n3, r3 && (lt && !$e && 200 < t3 - lt && (lt = 0, j("scrollEnd")), Ue = k, k = t3), Et < 0) {
        for (Qe = e2; 0 < Qe--; ) Tt[Qe] && Tt[Qe].update(0, r3);
        Et = 1;
      } else for (Qe = 0; Qe < e2; Qe++) Tt[Qe] && Tt[Qe].update(0, r3);
      re.isUpdating = false;
    }
    _ = 0;
  }, $ = ["left", "top", P, C, mt + bt, mt + pt, mt + ht, mt + gt, "display", "flexShrink", "float", "zIndex", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "gridArea", "justifySelf", "alignSelf", "placeSelf", "order"], Q = $.concat([ft, dt, "boxSizing", "max" + yt, "max" + O, "position", mt, vt, vt + ht, vt + pt, vt + bt, vt + gt]), ee = /([A-Z])/g, Ct = function _setState(e2) {
    if (e2) {
      var t3, r3, n3 = e2.t.style, i2 = e2.length, o2 = 0;
      for ((e2.t._gsap || je.core.getCache(e2.t)).uncache = 1; o2 < i2; o2 += 2) r3 = e2[o2 + 1], t3 = e2[o2], r3 ? n3[t3] = r3 : n3[t3] && n3.removeProperty(t3.replace(ee, "-$1").toLowerCase());
    }
  }, Mt = { left: 0, top: 0 }, te = /(webkit|moz|length|cssText|inset)/i, re = (ScrollTrigger.prototype.init = function init(_2, T2) {
    if (this.progress = this.start = 0, this.vars && this.kill(true, true), ct) {
      var v2, n3, f2, k2, E2, C2, M2, P2, O2, A2, D2, e2, z2, F2, Y2, R2, L2, t3, B2, m2, X2, j2, y2, V2, w2, S2, r3, G2, N2, K2, i2, d2, W2, q2, J2, U2, Z2, o2, $2 = (_2 = cb(Ea(_2) || Ga(_2) || _2.nodeType ? { trigger: _2 } : _2, _t)).onUpdate, Q2 = _2.toggleClass, a2 = _2.id, ee2 = _2.onToggle, te2 = _2.onRefresh, re2 = _2.scrub, ne = _2.trigger, ie = _2.pin, oe = _2.pinSpacing, ae = _2.invalidateOnRefresh, se = _2.anticipatePin, s2 = _2.onScrubComplete, p2 = _2.onSnapComplete, le = _2.once, ce = _2.snap, ue = _2.pinReparent, l2 = _2.pinSpacer, fe = _2.containerAnimation, de = _2.fastScrollEnd, pe = _2.preventOverlaps, ge = _2.horizontal || _2.containerAnimation && false !== _2.horizontal ? Le : Xe, he2 = !re2 && 0 !== re2, be2 = H(_2.scroller || Ve), c2 = je.core.getCache(be2), ve2 = ya(be2), me2 = "fixed" === ("pinType" in _2 ? _2.pinType : x(be2, "pinType") || ve2 && "fixed"), ye = [_2.onEnter, _2.onLeave, _2.onEnterBack, _2.onLeaveBack], xe = he2 && _2.toggleActions.split(" "), u2 = "markers" in _2 ? _2.markers : _t.markers, we = ve2 ? 0 : parseFloat(ab(be2)["border" + ge.p2 + yt]) || 0, Se2 = this, _e2 = _2.onRefreshInit && function() {
        return _2.onRefreshInit(Se2);
      }, Te2 = (function _getSizeFunc(e3, t4, r4) {
        var n4 = r4.d, i3 = r4.d2, o3 = r4.a;
        return (o3 = x(e3, "getBoundingClientRect")) ? function() {
          return o3()[n4];
        } : function() {
          return (t4 ? Ve["inner" + i3] : e3["client" + i3]) || 0;
        };
      })(be2, ve2, ge), ke2 = (function _getOffsetsFunc(e3, t4) {
        return !t4 || ~Ye.indexOf(e3) ? za(e3) : function() {
          return Mt;
        };
      })(be2, ve2), g2 = 0, Ee = I(be2, ge);
      if (Se2.media = nt, Se2._dir = ge, se *= 45, Se2.scroller = be2, Se2.scroll = fe ? fe.time.bind(fe) : Ee, k2 = Ee(), Se2.vars = _2, T2 = T2 || _2.animation, "refreshPriority" in _2 && (et = 1, -9999 === _2.refreshPriority && (ot = Se2)), c2.tweenScroll = c2.tweenScroll || { top: cc(be2, Xe), left: cc(be2, Le) }, Se2.tweenTo = v2 = c2.tweenScroll[ge.p], Se2.scrubDuration = function(e3) {
        (i2 = Ga(e3) && e3) ? K2 ? K2.duration(e3) : K2 = je.to(T2, { ease: "expo", totalProgress: "+=0.001", duration: i2, paused: true, onComplete: function onComplete() {
          return s2 && s2(Se2);
        } }) : (K2 && K2.progress(1).kill(), K2 = 0);
      }, T2 && (T2.vars.lazy = false, T2._initted || false !== T2.vars.immediateRender && false !== _2.immediateRender && T2.render(0, true, true), Se2.animation = T2.pause(), (T2.scrollTrigger = Se2).scrubDuration(re2), G2 = 0, a2 = a2 || T2.vars.id), Tt.push(Se2), ce && (Ha(ce) && !ce.push || (ce = { snapTo: ce }), "scrollBehavior" in We.style && je.set(ve2 ? [We, Ke] : be2, { scrollBehavior: "auto" }), f2 = Fa(ce.snapTo) ? ce.snapTo : "labels" === ce.snapTo ? /* @__PURE__ */ (function _getClosestLabel(t4) {
        return function(e3) {
          return je.utils.snap(fb(t4), e3);
        };
      })(T2) : "labelsDirectional" === ce.snapTo ? /* @__PURE__ */ (function _getLabelAtDirection(r4) {
        return function(e3, t4) {
          return hb(fb(r4))(e3, t4.direction);
        };
      })(T2) : false !== ce.directional ? function(e3, t4) {
        return hb(ce.snapTo)(e3, Ze ? 0 : t4.direction);
      } : je.utils.snap(ce.snapTo), d2 = ce.duration || { min: 0.1, max: 2 }, d2 = Ha(d2) ? Je(d2.min, d2.max) : Je(d2, d2), W2 = je.delayedCall(ce.delay || i2 / 2 || 0.1, function() {
        if (Math.abs(Se2.getVelocity()) < 10 && !$e && g2 !== Ee()) {
          var e3 = T2 && !he2 ? T2.totalProgress() : Se2.progress, t4 = (e3 - N2) / (st() - Ue) * 1e3 || 0, r4 = je.utils.clamp(-Se2.progress, 1 - Se2.progress, ut(t4 / 2) * t4 / 0.185), n4 = Se2.progress + (false === ce.inertia ? 0 : r4), i3 = Je(0, 1, f2(n4, Se2)), o3 = Ee(), a3 = Math.round(C2 + i3 * z2), s3 = ce.onStart, l3 = ce.onInterrupt, c3 = ce.onComplete, u3 = v2.tween;
          if (o3 <= M2 && C2 <= o3 && a3 !== o3) {
            if (u3 && !u3._initted && u3.data <= ut(a3 - o3)) return;
            false === ce.inertia && (r4 = i3 - Se2.progress), v2(a3, { duration: d2(ut(0.185 * Math.max(ut(n4 - e3), ut(i3 - e3)) / t4 / 0.05 || 0)), ease: ce.ease || "power3", data: ut(a3 - o3), onInterrupt: function onInterrupt() {
              return W2.restart(true) && l3 && l3(Se2);
            }, onComplete: function onComplete() {
              Se2.update(), g2 = Ee(), G2 = N2 = T2 && !he2 ? T2.totalProgress() : Se2.progress, p2 && p2(Se2), c3 && c3(Se2);
            } }, o3, r4 * z2, a3 - o3 - r4 * z2), s3 && s3(Se2, v2.tween);
          }
        } else Se2.isActive && W2.restart(true);
      }).pause()), a2 && (kt[a2] = Se2), o2 = (o2 = (ne = Se2.trigger = H(ne || ie)) && ne._gsap && ne._gsap.stRevert) && o2(Se2), ie = true === ie ? ne : H(ie), Ea(Q2) && (Q2 = { targets: ne, className: Q2 }), ie && (false === oe || oe === mt || (oe = !(!oe && "flex" === ab(ie.parentNode).display) && vt), Se2.pin = ie, false !== _2.force3D && je.set(ie, { force3D: true }), (n3 = je.core.getCache(ie)).spacer ? F2 = n3.pinState : (l2 && ((l2 = H(l2)) && !l2.nodeType && (l2 = l2.current || l2.nativeElement), n3.spacerIsNative = !!l2, l2 && (n3.spacerState = Yb(l2))), n3.spacer = L2 = l2 || Ne.createElement("div"), L2.classList.add("pin-spacer"), a2 && L2.classList.add("pin-spacer-" + a2), n3.pinState = F2 = Yb(ie)), Se2.spacer = L2 = n3.spacer, r3 = ab(ie), y2 = r3[oe + ge.os2], B2 = je.getProperty(ie), m2 = je.quickSetter(ie, ge.a, xt), Vb(ie, L2, r3), R2 = Yb(ie)), u2) {
        e2 = Ha(u2) ? cb(u2, St) : St, A2 = rb("scroller-start", a2, be2, ge, e2, 0), D2 = rb("scroller-end", a2, be2, ge, e2, 0, A2), t3 = A2["offset" + ge.op.d2];
        var h2 = H(x(be2, "content") || be2);
        P2 = this.markerStart = rb("start", a2, h2, ge, e2, t3, 0, fe), O2 = this.markerEnd = rb("end", a2, h2, ge, e2, t3, 0, fe), fe && (Z2 = je.quickSetter([P2, O2], ge.a, xt)), me2 || Ye.length && true === x(be2, "fixedMarkers") || ((function _makePositionable(e3) {
          var t4 = ab(e3).position;
          e3.style.position = "absolute" === t4 || "fixed" === t4 ? t4 : "relative";
        })(ve2 ? We : be2), je.set([A2, D2], { force3D: true }), w2 = je.quickSetter(A2, ge.a, xt), S2 = je.quickSetter(D2, ge.a, xt));
      }
      if (fe) {
        var b2 = fe.vars.onUpdate, Ce = fe.vars.onUpdateParams;
        fe.eventCallback("onUpdate", function() {
          Se2.update(0, 0, 1), b2 && b2.apply(Ce || []);
        });
      }
      Se2.previous = function() {
        return Tt[Tt.indexOf(Se2) - 1];
      }, Se2.next = function() {
        return Tt[Tt.indexOf(Se2) + 1];
      }, Se2.revert = function(e3) {
        var t4 = false !== e3 || !Se2.enabled, r4 = Ze;
        t4 !== Se2.isReverted && (t4 && (!Se2.scroll.rec && Ze && it && (Se2.scroll.rec = Ee()), J2 = Math.max(Ee(), Se2.scroll.rec || 0), q2 = Se2.progress, U2 = T2 && T2.progress()), P2 && [P2, O2, A2, D2].forEach(function(e4) {
          return e4.style.display = t4 ? "none" : "block";
        }), t4 && (Ze = 1), Se2.update(t4), Ze = r4, ie && (t4 ? (function _swapPinOut(e4, t5, r5) {
          Ct(r5);
          var n4 = e4._gsap;
          if (n4.spacerIsNative) Ct(n4.spacerState);
          else if (e4.parentNode === t5) {
            var i3 = t5.parentNode;
            i3 && (i3.insertBefore(e4, t5), i3.removeChild(t5));
          }
        })(ie, L2, F2) : ue && Se2.isActive || Vb(ie, L2, ab(ie), V2)), Se2.isReverted = t4);
      }, Se2.refresh = function(e3, t4) {
        if (!Ze && Se2.enabled || t4) if (ie && e3 && lt) kb(ScrollTrigger, "scrollEnd", Fb);
        else {
          !it && _e2 && _e2(Se2), Ze = 1, K2 && K2.pause(), ae && T2 && T2.time(-0.01, true).invalidate(), Se2.isReverted || Se2.revert();
          for (var r4, n4, i3, o3, a3, s3, l3, c3, u3, f3, d3 = Te2(), p3 = ke2(), g3 = fe ? fe.duration() : Ca(be2, ge), h3 = 0, b3 = 0, v3 = _2.end, m3 = _2.endTrigger || ne, y3 = _2.start || (0 !== _2.start && ne ? ie ? "0 0" : "0 100%" : 0), x2 = Se2.pinnedContainer = _2.pinnedContainer && H(_2.pinnedContainer), w3 = ne && Math.max(0, Tt.indexOf(Se2)) || 0, S3 = w3; S3--; ) (s3 = Tt[S3]).end || s3.refresh(0, 1) || (Ze = 1), !(l3 = s3.pin) || l3 !== ne && l3 !== ie || s3.isReverted || ((f3 = f3 || []).unshift(s3), s3.revert()), s3 !== Tt[S3] && (w3--, S3--);
          for (Fa(y3) && (y3 = y3(Se2)), C2 = _b(y3, ne, d3, ge, Ee(), P2, A2, Se2, p3, we, me2, g3, fe) || (ie ? -1e-3 : 0), Fa(v3) && (v3 = v3(Se2)), Ea(v3) && !v3.indexOf("+=") && (~v3.indexOf(" ") ? v3 = (Ea(y3) ? y3.split(" ")[0] : "") + v3 : (h3 = qb(v3.substr(2), d3), v3 = Ea(y3) ? y3 : C2 + h3, m3 = ne)), M2 = Math.max(C2, _b(v3 || (m3 ? "100% 0" : g3), m3, d3, ge, Ee() + h3, O2, D2, Se2, p3, we, me2, g3, fe)) || -1e-3, z2 = M2 - C2 || (C2 -= 0.01) && 1e-3, h3 = 0, S3 = w3; S3--; ) (l3 = (s3 = Tt[S3]).pin) && s3.start - s3._pinPush < C2 && !fe && 0 < s3.end && (r4 = s3.end - s3.start, l3 !== ne && l3 !== x2 || Ga(y3) || (h3 += r4 * (1 - s3.progress)), l3 === ie && (b3 += r4));
          if (C2 += h3, M2 += h3, Se2._pinPush = b3, P2 && h3 && ((r4 = {})[ge.a] = "+=" + h3, x2 && (r4[ge.p] = "-=" + Ee()), je.set([P2, O2], r4)), ie) r4 = ab(ie), o3 = ge === Xe, i3 = Ee(), X2 = parseFloat(B2(ge.a)) + b3, !g3 && 1 < M2 && ((ve2 ? We : be2).style["overflow-" + ge.a] = "scroll"), Vb(ie, L2, r4), R2 = Yb(ie), n4 = wt(ie, true), c3 = me2 && I(be2, o3 ? Le : Xe)(), oe && ((V2 = [oe + ge.os2, z2 + b3 + xt]).t = L2, (S3 = oe === vt ? eb(ie, ge) + z2 + b3 : 0) && V2.push(ge.d, S3 + xt), Ct(V2), me2 && Ee(J2)), me2 && ((a3 = { top: n4.top + (o3 ? i3 - C2 : c3) + xt, left: n4.left + (o3 ? c3 : i3 - C2) + xt, boxSizing: "border-box", position: "fixed" })[ft] = a3.maxWidth = Math.ceil(n4.width) + xt, a3[dt] = a3.maxHeight = Math.ceil(n4.height) + xt, a3[mt] = a3[mt + ht] = a3[mt + pt] = a3[mt + bt] = a3[mt + gt] = "0", a3[vt] = r4[vt], a3[vt + ht] = r4[vt + ht], a3[vt + pt] = r4[vt + pt], a3[vt + bt] = r4[vt + bt], a3[vt + gt] = r4[vt + gt], Y2 = (function _copyState(e4, t5, r5) {
            for (var n5, i4 = [], o4 = e4.length, a4 = r5 ? 8 : 0; a4 < o4; a4 += 2) n5 = e4[a4], i4.push(n5, n5 in t5 ? t5[n5] : e4[a4 + 1]);
            return i4.t = e4.t, i4;
          })(F2, a3, ue)), T2 ? (u3 = T2._initted, tt(1), T2.render(T2.duration(), true, true), j2 = B2(ge.a) - X2 + z2 + b3, z2 !== j2 && Y2.splice(Y2.length - 2, 2), T2.render(0, true, true), u3 || T2.invalidate(), tt(0)) : j2 = z2;
          else if (ne && Ee() && !fe) for (n4 = ne.parentNode; n4 && n4 !== We; ) n4._pinOffset && (C2 -= n4._pinOffset, M2 -= n4._pinOffset), n4 = n4.parentNode;
          f3 && f3.forEach(function(e4) {
            return e4.revert(false);
          }), Se2.start = C2, Se2.end = M2, k2 = E2 = Ee(), fe || (k2 < J2 && Ee(J2), Se2.scroll.rec = 0), Se2.revert(false), W2 && Se2.isActive && Ee(C2 + z2 * q2), Ze = 0, T2 && he2 && (T2._initted || U2) && T2.progress() !== U2 && T2.progress(U2, true).render(T2.time(), true, true), q2 === Se2.progress && !fe || (T2 && !he2 && T2.totalProgress(q2, true), Se2.progress = q2, Se2.update(0, 0, 1)), ie && oe && (L2._pinOffset = Math.round(Se2.progress * j2)), te2 && te2(Se2);
        }
      }, Se2.getVelocity = function() {
        return (Ee() - E2) / (st() - Ue) * 1e3 || 0;
      }, Se2.endAnimation = function() {
        Ka(Se2.callbackAnimation), T2 && (K2 ? K2.progress(1) : T2.paused() ? he2 || Ka(T2, Se2.direction < 0, 1) : Ka(T2, T2.reversed()));
      }, Se2.labelToScroll = function(e3) {
        return T2 && T2.labels && (C2 || Se2.refresh() || C2) + T2.labels[e3] / T2.duration() * z2 || 0;
      }, Se2.getTrailing = function(t4) {
        var e3 = Tt.indexOf(Se2), r4 = 0 < Se2.direction ? Tt.slice(0, e3).reverse() : Tt.slice(e3 + 1);
        return (Ea(t4) ? r4.filter(function(e4) {
          return e4.vars.preventOverlaps === t4;
        }) : r4).filter(function(e4) {
          return 0 < Se2.direction ? e4.end <= C2 : e4.start >= M2;
        });
      }, Se2.update = function(e3, t4, r4) {
        if (!fe || r4 || e3) {
          var n4, i3, o3, a3, s3, l3, c3, u3 = Se2.scroll(), f3 = e3 ? 0 : (u3 - C2) / z2, d3 = f3 < 0 ? 0 : 1 < f3 ? 1 : f3 || 0, p3 = Se2.progress;
          if (t4 && (E2 = k2, k2 = fe ? Ee() : u3, ce && (N2 = G2, G2 = T2 && !he2 ? T2.totalProgress() : d3)), se && !d3 && ie && !Ze && !at && lt && C2 < u3 + (u3 - E2) / (st() - Ue) * se && (d3 = 1e-4), d3 !== p3 && Se2.enabled) {
            if (a3 = (s3 = (n4 = Se2.isActive = !!d3 && d3 < 1) != (!!p3 && p3 < 1)) || !!d3 != !!p3, Se2.direction = p3 < d3 ? 1 : -1, Se2.progress = d3, a3 && !Ze && (i3 = d3 && !p3 ? 0 : 1 === d3 ? 1 : 1 === p3 ? 2 : 3, he2 && (o3 = !s3 && "none" !== xe[i3 + 1] && xe[i3 + 1] || xe[i3], c3 = T2 && ("complete" === o3 || "reset" === o3 || o3 in T2))), pe && (s3 || c3) && (c3 || re2 || !T2) && (Fa(pe) ? pe(Se2) : Se2.getTrailing(pe).forEach(function(e4) {
              return e4.endAnimation();
            })), he2 || (!K2 || Ze || at ? T2 && T2.totalProgress(d3, !!Ze) : ((fe || ot && ot !== Se2) && K2.render(K2._dp._time - K2._start), K2.resetTo ? K2.resetTo("totalProgress", d3, T2._tTime / T2._tDur) : (K2.vars.totalProgress = d3, K2.invalidate().restart()))), ie) if (e3 && oe && (L2.style[oe + ge.os2] = y2), me2) {
              if (a3) {
                if (l3 = !e3 && p3 < d3 && u3 < M2 + 1 && u3 + 1 >= Ca(be2, ge), ue) if (e3 || !n4 && !l3) bc(ie, L2);
                else {
                  var g3 = wt(ie, true), h3 = u3 - C2;
                  bc(ie, We, g3.top + (ge === Xe ? h3 : 0) + xt, g3.left + (ge === Xe ? 0 : h3) + xt);
                }
                Ct(n4 || l3 ? Y2 : R2), j2 !== z2 && d3 < 1 && n4 || m2(X2 + (1 !== d3 || l3 ? 0 : j2));
              }
            } else m2(va(X2 + j2 * d3));
            !ce || v2.tween || Ze || at || W2.restart(true), Q2 && (s3 || le && d3 && (d3 < 1 || !rt)) && qe(Q2.targets).forEach(function(e4) {
              return e4.classList[n4 || le ? "add" : "remove"](Q2.className);
            }), !$2 || he2 || e3 || $2(Se2), a3 && !Ze ? (he2 && (c3 && ("complete" === o3 ? T2.pause().totalProgress(1) : "reset" === o3 ? T2.restart(true).pause() : "restart" === o3 ? T2.restart(true) : T2[o3]()), $2 && $2(Se2)), !s3 && rt || (ee2 && s3 && La(Se2, ee2), ye[i3] && La(Se2, ye[i3]), le && (1 === d3 ? Se2.kill(false, 1) : ye[i3] = 0), s3 || ye[i3 = 1 === d3 ? 1 : 3] && La(Se2, ye[i3])), de && !n4 && Math.abs(Se2.getVelocity()) > (Ga(de) ? de : 2500) && (Ka(Se2.callbackAnimation), K2 ? K2.progress(1) : Ka(T2, !d3, 1))) : he2 && $2 && !Ze && $2(Se2);
          }
          if (S2) {
            var b3 = fe ? u3 / fe.duration() * (fe._caScrollDist || 0) : u3;
            w2(b3 + (A2._isFlipped ? 1 : 0)), S2(b3);
          }
          Z2 && Z2(-u3 / fe.duration() * (fe._caScrollDist || 0));
        }
      }, Se2.enable = function(e3, t4) {
        Se2.enabled || (Se2.enabled = true, kb(be2, "resize", yb), kb(ve2 ? Ne : be2, "scroll", xb), _e2 && kb(ScrollTrigger, "refreshInit", _e2), false !== e3 && (Se2.progress = q2 = 0, k2 = E2 = g2 = Ee()), false !== t4 && Se2.refresh());
      }, Se2.getTween = function(e3) {
        return e3 && v2 ? v2.tween : K2;
      }, Se2.setPositions = function(e3, t4) {
        ie && (X2 += e3 - C2, j2 += t4 - e3 - z2), Se2.start = C2 = e3, Se2.end = M2 = t4, z2 = t4 - e3, Se2.update();
      }, Se2.disable = function(e3, t4) {
        if (Se2.enabled && (false !== e3 && Se2.revert(), Se2.enabled = Se2.isActive = false, t4 || K2 && K2.pause(), J2 = 0, n3 && (n3.uncache = 1), _e2 && lb(ScrollTrigger, "refreshInit", _e2), W2 && (W2.pause(), v2.tween && v2.tween.kill() && (v2.tween = 0)), !ve2)) {
          for (var r4 = Tt.length; r4--; ) if (Tt[r4].scroller === be2 && Tt[r4] !== Se2) return;
          lb(be2, "resize", yb), lb(be2, "scroll", xb);
        }
      }, Se2.kill = function(e3, t4) {
        Se2.disable(e3, t4), K2 && !t4 && K2.kill(), a2 && delete kt[a2];
        var r4 = Tt.indexOf(Se2);
        0 <= r4 && Tt.splice(r4, 1), r4 === Qe && 0 < Et && Qe--, r4 = 0, Tt.forEach(function(e4) {
          return e4.scroller === Se2.scroller && (r4 = 1);
        }), r4 || (Se2.scroll.rec = 0), T2 && (T2.scrollTrigger = null, e3 && T2.render(-1), t4 || T2.kill()), P2 && [P2, O2, A2, D2].forEach(function(e4) {
          return e4.parentNode && e4.parentNode.removeChild(e4);
        }), ie && (n3 && (n3.uncache = 1), r4 = 0, Tt.forEach(function(e4) {
          return e4.pin === ie && r4++;
        }), r4 || (n3.spacer = 0)), _2.onKill && _2.onKill(Se2);
      }, Se2.enable(false, false), o2 && o2(Se2), T2 && T2.add && !z2 ? je.delayedCall(0.01, function() {
        return C2 || M2 || Se2.refresh();
      }) && (z2 = 0.01) && (C2 = M2 = 0) : Se2.refresh();
    } else this.update = this.refresh = this.kill = ua;
  }, ScrollTrigger.register = function register(e2) {
    return o || (je = e2 || xa(), wa() && window.document && ScrollTrigger.enable(), o = ct), o;
  }, ScrollTrigger.defaults = function defaults(e2) {
    if (e2) for (var t3 in e2) _t[t3] = e2[t3];
    return _t;
  }, ScrollTrigger.disable = function disable(t3, r3) {
    ct = 0, Tt.forEach(function(e3) {
      return e3[r3 ? "kill" : "disable"](t3);
    }), lb(Ve, "wheel", xb), lb(Ne, "scroll", xb), clearInterval(l), lb(Ne, "touchcancel", ua), lb(We, "touchstart", ua), jb(lb, Ne, "pointerdown,touchstart,mousedown", sa), jb(lb, Ne, "pointerup,touchend,mouseup", ta), s.kill(), Da(lb);
    for (var e2 = 0; e2 < ze.length; e2 += 3) mb(lb, ze[e2], ze[e2 + 1]), mb(lb, ze[e2], ze[e2 + 2]);
  }, ScrollTrigger.enable = function enable() {
    if (Ve = window, Ne = document, Ke = Ne.documentElement, We = Ne.body, je && (qe = je.utils.toArray, Je = je.utils.clamp, tt = je.core.suppressOverwrites || ua, je.core.globals("ScrollTrigger", ScrollTrigger), We)) {
      ct = 1, ScrollTrigger.isTouch = Ve.matchMedia && Ve.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in Ve || 0 < navigator.maxTouchPoints || 0 < navigator.msMaxTouchPoints ? 2 : 0, a = [Ve, Ne, Ke, We], m = Ve.innerHeight, S = Ve.innerWidth, w.register(je), kb(Ne, "scroll", xb);
      var e2, t3, r3 = We.style, n3 = r3.borderTopStyle;
      for (r3.borderTopStyle = "solid", e2 = wt(We), Xe.m = Math.round(e2.top + Xe.sc()) || 0, Le.m = Math.round(e2.left + Le.sc()) || 0, n3 ? r3.borderTopStyle = n3 : r3.removeProperty("border-top-style"), l = setInterval(wb, 250), je.delayedCall(0.5, function() {
        return at = 0;
      }), kb(Ne, "touchcancel", ua), kb(We, "touchstart", ua), jb(kb, Ne, "pointerdown,touchstart,mousedown", sa), jb(kb, Ne, "pointerup,touchend,mouseup", ta), c = je.utils.checkPrefix("transform"), Q.push(c), o = st(), s = je.delayedCall(0.2, q).pause(), g = [Ne, "visibilitychange", function() {
        var e3 = Ve.innerWidth, t4 = Ve.innerHeight;
        Ne.hidden ? (f = e3, d = t4) : f === e3 && d === t4 || yb();
      }, Ne, "DOMContentLoaded", q, Ve, "load", q, Ve, "resize", yb], Da(kb), Tt.forEach(function(e3) {
        return e3.enable(0, 1);
      }), t3 = 0; t3 < ze.length; t3 += 3) mb(lb, ze[t3], ze[t3 + 1]), mb(lb, ze[t3], ze[t3 + 2]);
    }
  }, ScrollTrigger.config = function config(e2) {
    "limitCallbacks" in e2 && (rt = !!e2.limitCallbacks);
    var t3 = e2.syncInterval;
    t3 && clearInterval(l) || (l = t3) && setInterval(wb, t3), "ignoreMobileResize" in e2 && (v = 1 === ScrollTrigger.isTouch && e2.ignoreMobileResize), "autoRefreshEvents" in e2 && (Da(lb) || Da(kb, e2.autoRefreshEvents || "none"), h = -1 === (e2.autoRefreshEvents + "").indexOf("resize"));
  }, ScrollTrigger.scrollerProxy = function scrollerProxy(e2, t3) {
    var r3 = H(e2), n3 = ze.indexOf(r3), i2 = ya(r3);
    ~n3 && ze.splice(n3, i2 ? 6 : 2), t3 && (i2 ? Ye.unshift(Ve, t3, We, t3, Ke, t3) : Ye.unshift(r3, t3));
  }, ScrollTrigger.matchMedia = function matchMedia2(e2) {
    var t3, r3, n3, i2, o2;
    for (r3 in e2) n3 = X.indexOf(r3), i2 = e2[r3], "all" === (nt = r3) ? i2() : (t3 = Ve.matchMedia(r3)) && (t3.matches && (o2 = i2()), ~n3 ? (X[n3 + 1] = Ja(X[n3 + 1], i2), X[n3 + 2] = Ja(X[n3 + 2], o2)) : (n3 = X.length, X.push(r3, i2, o2), t3.addListener ? t3.addListener(Eb) : t3.addEventListener("change", Eb)), X[n3 + 3] = t3.matches), nt = 0;
    return X;
  }, ScrollTrigger.clearMatchMedia = function clearMatchMedia(e2) {
    e2 || (X.length = 0), 0 <= (e2 = X.indexOf(e2)) && X.splice(e2, 4);
  }, ScrollTrigger.isInViewport = function isInViewport(e2, t3, r3) {
    var n3 = (Ea(e2) ? H(e2) : e2).getBoundingClientRect(), i2 = n3[r3 ? ft : dt] * t3 || 0;
    return r3 ? 0 < n3.right - i2 && n3.left + i2 < Ve.innerWidth : 0 < n3.bottom - i2 && n3.top + i2 < Ve.innerHeight;
  }, ScrollTrigger.positionInViewport = function positionInViewport(e2, t3, r3) {
    Ea(e2) && (e2 = H(e2));
    var n3 = e2.getBoundingClientRect(), i2 = n3[r3 ? ft : dt], o2 = null == t3 ? i2 / 2 : t3 in F ? F[t3] * i2 : ~t3.indexOf("%") ? parseFloat(t3) * i2 / 100 : parseFloat(t3) || 0;
    return r3 ? (n3.left + o2) / Ve.innerWidth : (n3.top + o2) / Ve.innerHeight;
  }, ScrollTrigger);
  function ScrollTrigger(e2, t3) {
    o || ScrollTrigger.register(je) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), this.init(e2, t3);
  }
  re.version = "3.10.2", re.saveStyles = function(e2) {
    return e2 ? qe(e2).forEach(function(e3) {
      if (e3 && e3.style) {
        var t3 = V.indexOf(e3);
        0 <= t3 && V.splice(t3, 5), V.push(e3, e3.style.cssText, e3.getBBox && e3.getAttribute("transform"), je.core.getCache(e3), nt);
      }
    }) : V;
  }, re.revert = function(e2, t3) {
    return N(!e2, t3);
  }, re.create = function(e2, t3) {
    return new re(e2, t3);
  }, re.refresh = function(e2) {
    return e2 ? yb() : (o || re.register()) && q(true);
  }, re.update = Z, re.clearScrollMemory = Kb, re.maxScroll = function(e2, t3) {
    return Ca(e2, t3 ? Le : Xe);
  }, re.getScrollFunc = function(e2, t3) {
    return I(H(e2), t3 ? Le : Xe);
  }, re.getById = function(e2) {
    return kt[e2];
  }, re.getAll = function() {
    return Tt.filter(function(e2) {
      return "ScrollSmoother" !== e2.vars.id;
    });
  }, re.isScrolling = function() {
    return !!lt;
  }, re.snapDirectional = hb, re.addEventListener = function(e2, t3) {
    var r3 = R[e2] || (R[e2] = []);
    ~r3.indexOf(t3) || r3.push(t3);
  }, re.removeEventListener = function(e2, t3) {
    var r3 = R[e2], n3 = r3 && r3.indexOf(t3);
    0 <= n3 && r3.splice(n3, 1);
  }, re.batch = function(e2, t3) {
    function On(e3, t4) {
      var r4 = [], n4 = [], i3 = je.delayedCall(o2, function() {
        t4(r4, n4), r4 = [], n4 = [];
      }).pause();
      return function(e4) {
        r4.length || i3.restart(true), r4.push(e4.trigger), n4.push(e4), a2 <= r4.length && i3.progress(1);
      };
    }
    var r3, n3 = [], i2 = {}, o2 = t3.interval || 0.016, a2 = t3.batchMax || 1e9;
    for (r3 in t3) i2[r3] = "on" === r3.substr(0, 2) && Fa(t3[r3]) && "onRefreshInit" !== r3 ? On(0, t3[r3]) : t3[r3];
    return Fa(a2) && (a2 = a2(), kb(re, "refresh", function() {
      return a2 = t3.batchMax();
    })), qe(e2).forEach(function(e3) {
      var t4 = {};
      for (r3 in i2) t4[r3] = i2[r3];
      t4.trigger = e3, n3.push(re.create(t4));
    }), n3;
  };
  function ec(e2, t3, r3, n3) {
    return n3 < t3 ? e2(n3) : t3 < 0 && e2(0), n3 < r3 ? (n3 - t3) / (r3 - t3) : r3 < 0 ? t3 / (t3 - r3) : 1;
  }
  function fc(e2) {
    true === e2 ? (We.style.removeProperty("touch-action"), Ke.style.removeProperty("touch-action")) : We.style.touchAction = Ke.style.touchAction = e2 ? "pan-" + e2 : "none";
  }
  function gc(e2) {
    function po() {
      return d2 = st();
    }
    function qo() {
      return n3 = false;
    }
    function to() {
      r3 = Ca(Ke, Xe), m2 = Je(0, r3), f2 && (v2 = Je(0, Ca(Ke, Le))), o2 = W;
    }
    function Bo() {
      to(), s2.isActive() && s2.vars.scrollY > r3 && s2.resetTo("scrollY", Ca(Ke, Xe));
    }
    Ha(e2) || (e2 = {}), e2.preventDefault = e2.isNormalizer = true, e2.type || (e2.type = "wheel,touch"), e2.debounce = !!e2.debounce, e2.id = e2.id || "normalizer";
    var t3, r3, n3, o2, s2, a2, l2, c2, u2, f2 = e2.normalizeScrollX, i2 = e2.momentum, d2 = 0, p2 = I(Ke, Xe), g2 = I(Ke, Le), h2 = 1, b2 = Fa(i2) ? function() {
      return i2(t3);
    } : function() {
      return i2 || 2.8;
    }, v2 = ua, m2 = ua, y2 = re.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent);
    return e2.ignoreCheck = function(e3) {
      return y2 && "touchmove" === e3.type && (function ignoreDrag() {
        if (n3) return requestAnimationFrame(qo), true;
        n3 = true;
      })() || 1 < h2 || t3.isGesturing || e3.touches && 1 < e3.touches.length;
    }, e2.onPress = function() {
      var e3 = h2;
      h2 = Ve.visualViewport && Ve.visualViewport.scale || 1, s2.pause(), e3 !== h2 && fc(1 < h2 || !f2 && "x"), n3 = false, a2 = g2(), l2 = p2(), to(), o2 = W;
    }, e2.onRelease = e2.onGestureStart = function(e3, t4) {
      var r4 = e3.event, n4 = r4.changedTouches ? r4.changedTouches[0] : r4;
      if (!t4 || Math.abs(e3.x - e3.startX) <= 3 && Math.abs(e3.y - e3.startY) <= 3) je.delayedCall(0.05, function() {
        if (300 < st() - d2 && !r4.defaultPrevented) {
          if (r4.target.click) r4.target.click();
          else if (c2.createEvent) {
            var e4 = c2.createEvent("MouseEvents");
            e4.initMouseEvent("click", true, true, Ve, 1, n4.screenX, n4.screenY, n4.clientX, n4.clientY, false, false, false, false, 0, null), r4.target.dispatchEvent(e4);
          }
        }
      }), u2.restart(true);
      else {
        var i3, o3, a3 = b2();
        f2 && (o3 = (i3 = g2()) + 0.05 * a3 * -e3.velocityX / 0.227 / h2, a3 *= ec(g2, i3, o3, Ca(Ke, Le)), s2.vars.scrollX = v2(o3)), o3 = (i3 = p2()) + 0.05 * a3 * -e3.velocityY / 0.227 / h2, a3 *= ec(p2, i3, o3, Ca(Ke, Xe)), s2.vars.scrollY = m2(o3), s2.invalidate().duration(a3).play(0.01);
      }
    }, e2.onWheel = function() {
      return s2._ts && s2.pause();
    }, e2.onChange = function(e3, t4, r4, n4, i3) {
      W !== o2 && to(), t4 && f2 && g2(v2(n4[2] === t4 ? a2 + (e3.startX - e3.x) / h2 : g2() + t4 - n4[1])), r4 && p2(m2(i3[2] === r4 ? l2 + (e3.startY - e3.y) / h2 : p2() + r4 - i3[1])), Z();
    }, e2.onEnable = function(e3) {
      fc(!f2 && "x"), kb(Ve, "resize", Bo), e3.target.addEventListener("click", po, { capture: true });
    }, e2.onDisable = function(e3) {
      fc(true), lb(Ve, "resize", Bo), lb(e3.target, "click", po);
    }, t3 = new w(e2), c2 = t3.target.ownerDocument || Ne, u2 = t3._dc, s2 = je.to(t3, { ease: "power4", paused: true, scrollX: f2 ? "+=0.1" : "+=0", scrollY: "+=0.1", onComplete: u2.vars.onComplete }), t3;
  }
  re.sort = function(e2) {
    return Tt.sort(e2 || function(e3, t3) {
      return -1e6 * (e3.vars.refreshPriority || 0) + e3.start - (t3.start + -1e6 * (t3.vars.refreshPriority || 0));
    });
  }, re.observe = function(e2) {
    return new w(e2);
  }, re.normalizeScroll = function(e2) {
    if (void 0 === e2) return b;
    if (true === e2 && b) return b.enable();
    var t3 = e2 instanceof w;
    return b && (false === e2 || t3 && e2 !== b) && b.kill(), e2 && !t3 && (e2 = gc(e2)), b = e2 && e2.enable();
  }, re.core = { _getVelocityProp: J, _scrollers: ze, _proxies: Ye, bridge: { ss: function ss() {
    lt || j("scrollStart"), lt = st();
  }, ref: function ref() {
    return Ze;
  } } }, xa() && je.registerPlugin(re), e.ScrollTrigger = re, e.default = re;
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: true });
  } else {
    delete e.default;
  }
});
